typeof navigator === "object" && (function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define('Plyr', factory) :
  (global.Plyr = factory());
}(this, (function () { 'use strict';

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }

    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }

  function _asyncToGenerator(fn) {
    return function () {
      var self = this,
          args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self, args);

        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
        }

        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
        }

        _next(undefined);
      });
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

      return arr2;
    }
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  // ==========================================================================
  // Plyr default config
  // ==========================================================================
  var defaults = {
    // Disable
    enabled: true,
    // Custom media title
    title: '',
    // Logging to console
    debug: false,
    // Auto play (if supported)
    autoplay: false,
    // Only allow one media playing at once (vimeo only)
    autopause: true,
    // Allow inline playback on iOS (this effects YouTube/Vimeo - HTML5 requires the attribute present)
    // TODO: Remove iosNative fullscreen option in favour of this (logic needs work)
    playsinline: true,
    // Default time to skip when rewind/fast forward
    seekTime: 10,
    // Default volume
    volume: 1,
    muted: false,
    // Pass a custom duration
    duration: null,
    // Display the media duration on load in the current time position
    // If you have opted to display both duration and currentTime, this is ignored
    displayDuration: true,
    // Invert the current time to be a countdown
    invertTime: true,
    // Clicking the currentTime inverts it's value to show time left rather than elapsed
    toggleInvert: true,
    // Aspect ratio (for embeds)
    ratio: '16:9',
    // Click video container to play/pause
    clickToPlay: true,
    // Auto hide the controls
    hideControls: true,
    // Reset to start when playback ended
    resetOnEnd: false,
    // Disable the standard context menu
    disableContextMenu: true,
    // Sprite (for icons)
    loadSprite: true,
    iconPrefix: 'plyr',
    iconUrl: 'https://cdn.plyr.io/3.5.2/plyr.svg',
    // Blank video (used to prevent errors on source change)
    blankVideo: 'https://cdn.plyr.io/static/blank.mp4',
    // Quality default
    quality: {
      default: 576,
      options: [4320, 2880, 2160, 1440, 1080, 720, 576, 480, 360, 240]
    },
    // Set loops
    loop: {
      active: false // start: null,
      // end: null,

    },
    // Speed default and options to display
    speed: {
      selected: 1,
      options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2]
    },
    // Keyboard shortcut settings
    keyboard: {
      focused: true,
      global: false
    },
    // Display tooltips
    tooltips: {
      controls: false,
      seek: true
    },
    // Captions settings
    captions: {
      active: false,
      language: 'auto',
      // Listen to new tracks added after Plyr is initialized.
      // This is needed for streaming captions, but may result in unselectable options
      update: false
    },
    // Fullscreen settings
    fullscreen: {
      enabled: true,
      // Allow fullscreen?
      fallback: true,
      // Fallback using full viewport/window
      iosNative: false // Use the native fullscreen in iOS (disables custom controls)

    },
    // Local storage
    storage: {
      enabled: true,
      key: 'plyr'
    },
    // Default controls
    controls: ['play-large', // 'restart',
    // 'rewind',
    'play', // 'fast-forward',
    'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', // 'download',
    'fullscreen'],
    settings: ['captions', 'quality', 'speed'],
    // Localisation
    i18n: {
      restart: 'Restart',
      rewind: 'Rewind {seektime}s',
      play: 'Play',
      pause: 'Pause',
      fastForward: 'Forward {seektime}s',
      seek: 'Seek',
      seekLabel: '{currentTime} of {duration}',
      played: 'Played',
      buffered: 'Buffered',
      currentTime: 'Current time',
      duration: 'Duration',
      volume: 'Volume',
      mute: 'Mute',
      unmute: 'Unmute',
      enableCaptions: 'Enable captions',
      disableCaptions: 'Disable captions',
      download: 'Download',
      enterFullscreen: 'Enter fullscreen',
      exitFullscreen: 'Exit fullscreen',
      frameTitle: 'Player for {title}',
      captions: 'Captions',
      settings: 'Settings',
      menuBack: 'Go back to previous menu',
      speed: 'Speed',
      normal: 'Normal',
      quality: 'Quality',
      loop: 'Loop',
      start: 'Start',
      end: 'End',
      all: 'All',
      reset: 'Reset',
      disabled: 'Disabled',
      enabled: 'Enabled',
      advertisement: 'Ad',
      qualityBadge: {
        2160: '4K',
        1440: 'HD',
        1080: 'HD',
        720: 'HD',
        576: 'SD',
        480: 'SD'
      }
    },
    // URLs
    urls: {
      download: null,
      vimeo: {
        sdk: 'https://player.vimeo.com/api/player.js',
        iframe: 'https://player.vimeo.com/video/{0}?{1}',
        api: 'https://vimeo.com/api/v2/video/{0}.json'
      },
      youtube: {
        sdk: 'https://www.youtube.com/iframe_api',
        api: 'https://www.googleapis.com/youtube/v3/videos?id={0}&key={1}&fields=items(snippet(title))&part=snippet'
      },
      googleIMA: {
        sdk: 'https://imasdk.googleapis.com/js/sdkloader/ima3.js'
      }
    },
    // Custom control listeners
    listeners: {
      seek: null,
      play: null,
      pause: null,
      restart: null,
      rewind: null,
      fastForward: null,
      mute: null,
      volume: null,
      captions: null,
      download: null,
      fullscreen: null,
      pip: null,
      airplay: null,
      speed: null,
      quality: null,
      loop: null,
      language: null
    },
    // Events to watch and bubble
    events: [// Events to watch on HTML5 media elements and bubble
    // https://developer.mozilla.org/en/docs/Web/Guide/Events/Media_events
    'ended', 'progress', 'stalled', 'playing', 'waiting', 'canplay', 'canplaythrough', 'loadstart', 'loadeddata', 'loadedmetadata', 'timeupdate', 'volumechange', 'play', 'pause', 'error', 'seeking', 'seeked', 'emptied', 'ratechange', 'cuechange', // Custom events
    'download', 'enterfullscreen', 'exitfullscreen', 'captionsenabled', 'captionsdisabled', 'languagechange', 'controlshidden', 'controlsshown', 'ready', // YouTube
    'statechange', // Quality
    'qualitychange', // Ads
    'adsloaded', 'adscontentpause', 'adscontentresume', 'adstarted', 'adsmidpoint', 'adscomplete', 'adsallcomplete', 'adsimpression', 'adsclick'],
    // Selectors
    // Change these to match your template if using custom HTML
    selectors: {
      editable: 'input, textarea, select, [contenteditable]',
      container: '.plyr',
      controls: {
        container: null,
        wrapper: '.plyr__controls'
      },
      labels: '[data-plyr]',
      buttons: {
        play: '[data-plyr="play"]',
        pause: '[data-plyr="pause"]',
        restart: '[data-plyr="restart"]',
        rewind: '[data-plyr="rewind"]',
        fastForward: '[data-plyr="fast-forward"]',
        mute: '[data-plyr="mute"]',
        captions: '[data-plyr="captions"]',
        download: '[data-plyr="download"]',
        fullscreen: '[data-plyr="fullscreen"]',
        pip: '[data-plyr="pip"]',
        airplay: '[data-plyr="airplay"]',
        settings: '[data-plyr="settings"]',
        loop: '[data-plyr="loop"]'
      },
      inputs: {
        seek: '[data-plyr="seek"]',
        volume: '[data-plyr="volume"]',
        speed: '[data-plyr="speed"]',
        language: '[data-plyr="language"]',
        quality: '[data-plyr="quality"]'
      },
      display: {
        currentTime: '.plyr__time--current',
        duration: '.plyr__time--duration',
        buffer: '.plyr__progress__buffer',
        loop: '.plyr__progress__loop',
        // Used later
        volume: '.plyr__volume--display'
      },
      progress: '.plyr__progress',
      captions: '.plyr__captions',
      caption: '.plyr__caption',
      menu: {
        quality: '.js-plyr__menu__list--quality'
      }
    },
    // Class hooks added to the player in different states
    classNames: {
      type: 'plyr--{0}',
      provider: 'plyr--{0}',
      video: 'plyr__video-wrapper',
      embed: 'plyr__video-embed',
      embedContainer: 'plyr__video-embed__container',
      poster: 'plyr__poster',
      posterEnabled: 'plyr__poster-enabled',
      ads: 'plyr__ads',
      control: 'plyr__control',
      controlPressed: 'plyr__control--pressed',
      playing: 'plyr--playing',
      paused: 'plyr--paused',
      stopped: 'plyr--stopped',
      loading: 'plyr--loading',
      hover: 'plyr--hover',
      tooltip: 'plyr__tooltip',
      cues: 'plyr__cues',
      hidden: 'plyr__sr-only',
      hideControls: 'plyr--hide-controls',
      isIos: 'plyr--is-ios',
      isTouch: 'plyr--is-touch',
      uiSupported: 'plyr--full-ui',
      noTransition: 'plyr--no-transition',
      display: {
        time: 'plyr__time'
      },
      menu: {
        value: 'plyr__menu__value',
        badge: 'plyr__badge',
        open: 'plyr--menu-open'
      },
      captions: {
        enabled: 'plyr--captions-enabled',
        active: 'plyr--captions-active'
      },
      fullscreen: {
        enabled: 'plyr--fullscreen-enabled',
        fallback: 'plyr--fullscreen-fallback'
      },
      pip: {
        supported: 'plyr--pip-supported',
        active: 'plyr--pip-active'
      },
      airplay: {
        supported: 'plyr--airplay-supported',
        active: 'plyr--airplay-active'
      },
      tabFocus: 'plyr__tab-focus',
      previewThumbnails: {
        // Tooltip thumbs
        thumbContainer: 'plyr__preview-thumb',
        thumbContainerShown: 'plyr__preview-thumb--is-shown',
        imageContainer: 'plyr__preview-thumb__image-container',
        timeContainer: 'plyr__preview-thumb__time-container',
        // Scrubbing
        scrubbingContainer: 'plyr__preview-scrubbing',
        scrubbingContainerShown: 'plyr__preview-scrubbing--is-shown'
      }
    },
    // Embed attributes
    attributes: {
      embed: {
        provider: 'data-plyr-provider',
        id: 'data-plyr-embed-id'
      }
    },
    // API keys
    keys: {
      google: null
    },
    // Advertisements plugin
    // Register for an account here: http://vi.ai/publisher-video-monetization/?aid=plyrio
    ads: {
      enabled: false,
      publisherId: '',
      tagUrl: ''
    },
    // Preview Thumbnails plugin
    previewThumbnails: {
      enabled: false,
      src: ''
    },
    // Vimeo plugin
    vimeo: {
      byline: false,
      portrait: false,
      title: false,
      speed: true,
      transparent: false
    },
    // YouTube plugin
    youtube: {
      noCookie: false,
      // Whether to use an alternative version of YouTube without cookies
      rel: 0,
      // No related vids
      showinfo: 0,
      // Hide info
      iv_load_policy: 3,
      // Hide annotations
      modestbranding: 1 // Hide logos as much as possible (they still show one in the corner when paused)

    }
  };

  var configs = _objectSpread({}, defaults, {
    // Default time to skip the opening
    openingSeekTime: 85,
    // Buffer
    buffer: {
      type: 1,
      exec: null
    },
    // Quality
    quality: {
      default: 1080,
      options: [0, 1080, 720, 480, 360, 240, 144]
    },
    // Height
    previewHeight: 100,
    // Controls
    controls: [].concat(_toConsumableArray(defaults.controls), ['skip-opening', 'p2p']),
    // Localisation
    i18n: _objectSpread({}, defaults.i18n, {
      restart: 'Повторить',
      rewind: 'Назад на {seektime}с',
      play: 'Продолжить (k)',
      pause: 'Пауза (k)',
      fastForward: 'Вперёд на {seektime}с',
      seek: 'Перемотать',
      played: 'Воспроизведено',
      buffered: 'Буферизировано',
      currentTime: 'Текущее время',
      duration: 'Длительность',
      volume: 'Громкость',
      skipOpening: 'Пропустить опенинг',
      mute: 'Отключить звук (m)',
      unmute: 'Включить звук (m)',
      enableCaptions: 'Включить субтитры (c)',
      disableCaptions: 'Отключить субтитры (c)',
      download: 'Скачать',
      enterFullscreen: 'Во весь экран (f)',
      exitFullscreen: 'Выход из полноэкранного режима (f)',
      frameTitle: 'Плеер для {title}',
      captions: 'Субтитры',
      settings: 'Настройки',
      menuBack: 'Вернуться в предыдущее меню',
      speed: 'Скорость',
      normal: 'Нормальная',
      quality: 'Качество',
      loop: 'Повтор',
      start: 'Начать',
      end: 'Конец',
      all: 'Всё',
      p2p: 'P2P',
      auto: 'По умолчанию',
      reset: 'Сбросить',
      disabled: 'Отключено',
      enabled: 'Включено',
      advertisement: 'Реклама',
      adexplanation: 'Ваш бесплатный просмотр спонсируется',
      qualityBadge: _objectSpread({}, defaults.i18n.qualityBadge, {
        'auto': 'AUTO'
      })
    }),
    // Custom control listeners
    listeners: _objectSpread({}, defaults.listeners, {
      skipOpening: null,
      p2p: null
    }),
    // Events to watch and bubble
    events: [].concat(_toConsumableArray(defaults.events.filter(function (x) {
      return x.substr(0, 2) !== 'ad';
    })), [// Ads
    'adsloaded', 'adscontentloaded', 'adstarted', 'adserror', 'adsblocked', 'adscomplete']),
    // Selectors
    // Change these to match your template if using custom HTML
    selectors: _objectSpread({}, defaults.selectors, {
      buttons: _objectSpread({}, defaults.selectors.buttons, {
        skipOpening: '[data-plyr="skip-opening"]',
        p2p: '[data-plyr="p2p"]'
      })
    }),
    // Ads
    ads: {
      enabled: false,
      timeout: 5000,
      sources: []
    },
    // Quality
    availableQuality: []
  });

  var defaults$1 = {
    addCSS: true,
    // Add CSS to the element to improve usability (required here or in your CSS!)
    thumbWidth: 15,
    // The width of the thumb handle
    watch: true // Watch for new elements that match a string target

  };

  // Element matches a selector
  function matches(element, selector) {

    function match() {
      return Array.from(document.querySelectorAll(selector)).includes(this);
    }

    var matches = match;
    return matches.call(element, selector);
  }

  // Trigger event
  function trigger(element, type) {
    if (!element || !type) {
      return;
    } // Create and dispatch the event


    var event = new Event(type); // Dispatch the event

    element.dispatchEvent(event);
  }

  // ==========================================================================
  // Type checking utils
  // ==========================================================================
  var getConstructor = function getConstructor(input) {
    return input !== null && typeof input !== 'undefined' ? input.constructor : null;
  };

  var instanceOf = function instanceOf(input, constructor) {
    return Boolean(input && constructor && input instanceof constructor);
  };

  var isNullOrUndefined = function isNullOrUndefined(input) {
    return input === null || typeof input === 'undefined';
  };

  var isObject = function isObject(input) {
    return getConstructor(input) === Object;
  };

  var isNumber = function isNumber(input) {
    return getConstructor(input) === Number && !Number.isNaN(input);
  };

  var isString = function isString(input) {
    return getConstructor(input) === String;
  };

  var isBoolean = function isBoolean(input) {
    return getConstructor(input) === Boolean;
  };

  var isFunction = function isFunction(input) {
    return getConstructor(input) === Function;
  };

  var isArray = function isArray(input) {
    return Array.isArray(input);
  };

  var isNodeList = function isNodeList(input) {
    return instanceOf(input, NodeList);
  };

  var isElement = function isElement(input) {
    return instanceOf(input, Element);
  };

  var isEvent = function isEvent(input) {
    return instanceOf(input, Event);
  };

  var isEmpty = function isEmpty(input) {
    return isNullOrUndefined(input) || (isString(input) || isArray(input) || isNodeList(input)) && !input.length || isObject(input) && !Object.keys(input).length;
  };

  var is = {
    nullOrUndefined: isNullOrUndefined,
    object: isObject,
    number: isNumber,
    string: isString,
    boolean: isBoolean,
    function: isFunction,
    array: isArray,
    nodeList: isNodeList,
    element: isElement,
    event: isEvent,
    empty: isEmpty
  };

  // Get the number of decimal places
  function getDecimalPlaces(value) {
    var match = "".concat(value).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);

    if (!match) {
      return 0;
    }

    return Math.max(0, // Number of digits right of decimal point.
    (match[1] ? match[1].length : 0) - ( // Adjust for scientific notation.
    match[2] ? +match[2] : 0));
  } // Round to the nearest step

  function round(number, step) {
    if (step < 1) {
      var places = getDecimalPlaces(step);
      return parseFloat(number.toFixed(places));
    }

    return Math.round(number / step) * step;
  }

  var RangeTouch =
  /*#__PURE__*/
  function () {
    /**
     * Setup a new instance
     * @param {String|Element} target
     * @param {Object} options
     */
    function RangeTouch(target, options) {
      _classCallCheck(this, RangeTouch);

      if (is.element(target)) {
        // An Element is passed, use it directly
        this.element = target;
      } else if (is.string(target)) {
        // A CSS Selector is passed, fetch it from the DOM
        this.element = document.querySelector(target);
      }

      if (!is.element(this.element) || !is.empty(this.element.rangeTouch)) {
        return;
      }

      this.config = Object.assign({}, defaults$1, options);
      this.init();
    }

    _createClass(RangeTouch, [{
      key: "init",
      value: function init() {
        // Bail if not a touch enabled device
        if (!RangeTouch.enabled) {
          return;
        } // Add useful CSS


        if (this.config.addCSS) {
          // TODO: Restore original values on destroy
          this.element.style.userSelect = 'none';
          this.element.style.webKitUserSelect = 'none';
          this.element.style.touchAction = 'manipulation';
        }

        this.listeners(true);
        this.element.rangeTouch = this;
      }
    }, {
      key: "destroy",
      value: function destroy() {
        // Bail if not a touch enabled device
        if (!RangeTouch.enabled) {
          return;
        }

        this.listeners(false);
        this.element.rangeTouch = null;
      }
    }, {
      key: "listeners",
      value: function listeners(toggle) {
        var _this = this;

        var method = toggle ? 'addEventListener' : 'removeEventListener'; // Listen for events

        ['touchstart', 'touchmove', 'touchend'].forEach(function (type) {
          _this.element[method](type, function (event) {
            return _this.set(event);
          }, false);
        });
      }
      /**
       * Get the value based on touch position
       * @param {Event} event
       */

    }, {
      key: "get",
      value: function get(event) {
        if (!RangeTouch.enabled || !is.event(event)) {
          return null;
        }

        var input = event.target;
        var touch = event.changedTouches[0];
        var min = parseFloat(input.getAttribute('min')) || 0;
        var max = parseFloat(input.getAttribute('max')) || 100;
        var step = parseFloat(input.getAttribute('step')) || 1;
        var delta = max - min; // Calculate percentage

        var percent;
        var clientRect = input.getBoundingClientRect();
        var thumbWidth = 100 / clientRect.width * (this.config.thumbWidth / 2) / 100; // Determine left percentage

        percent = 100 / clientRect.width * (touch.clientX - clientRect.left); // Don't allow outside bounds

        if (percent < 0) {
          percent = 0;
        } else if (percent > 100) {
          percent = 100;
        } // Factor in the thumb offset


        if (percent < 50) {
          percent -= (100 - percent * 2) * thumbWidth;
        } else if (percent > 50) {
          percent += (percent - 50) * 2 * thumbWidth;
        } // Find the closest step to the mouse position


        return min + round(delta * (percent / 100), step);
      }
      /**
       * Update range value based on position
       * @param {Event} event
       */

    }, {
      key: "set",
      value: function set(event) {
        if (!RangeTouch.enabled || !is.event(event) || event.target.disabled) {
          return;
        } // Prevent text highlight on iOS


        event.preventDefault(); // Set value

        event.target.value = this.get(event); // Trigger event

        trigger(event.target, event.type === 'touchend' ? 'change' : 'input');
      }
    }], [{
      key: "setup",

      /**
       * Setup multiple instances
       * @param {String|Element|NodeList|Array} target
       * @param {Object} options
       */
      value: function setup(target) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var targets = null;

        if (is.empty(target) || is.string(target)) {
          targets = Array.from(document.querySelectorAll(is.string(target) ? target : 'input[type="range"]'));
        } else if (is.element(target)) {
          targets = [target];
        } else if (is.nodeList(target)) {
          targets = Array.from(target);
        } else if (is.array(target)) {
          targets = target.filter(is.element);
        }

        if (is.empty(targets)) {
          return null;
        }

        var config = Object.assign({}, defaults$1, options);

        if (is.string(target) && config.watch) {
          // Create an observer instance
          var observer = new MutationObserver(function (mutations) {
            Array.from(mutations).forEach(function (mutation) {
              Array.from(mutation.addedNodes).forEach(function (node) {
                if (!is.element(node) || !matches(node, target)) {
                  return;
                } // eslint-disable-next-line no-unused-vars


                var range = new RangeTouch(node, config);
              });
            });
          }); // Pass in the target node, as well as the observer options

          observer.observe(document.body, {
            childList: true,
            subtree: true
          });
        }

        return targets.map(function (t) {
          return new RangeTouch(t, options);
        });
      }
    }, {
      key: "enabled",
      get: function get() {
        return 'ontouchstart' in document.documentElement;
      }
    }]);

    return RangeTouch;
  }();

  // ==========================================================================
  // Type checking utils
  // ==========================================================================
  var getConstructor$1 = function getConstructor(input) {
    return input !== null && typeof input !== 'undefined' ? input.constructor : null;
  };

  var instanceOf$1 = function instanceOf(input, constructor) {
    return Boolean(input && constructor && input instanceof constructor);
  };

  var isNullOrUndefined$1 = function isNullOrUndefined(input) {
    return input === null || typeof input === 'undefined';
  };

  var isObject$1 = function isObject(input) {
    return getConstructor$1(input) === Object;
  };

  var isNumber$1 = function isNumber(input) {
    return getConstructor$1(input) === Number && !Number.isNaN(input);
  };

  var isString$1 = function isString(input) {
    return getConstructor$1(input) === String;
  };

  var isBoolean$1 = function isBoolean(input) {
    return getConstructor$1(input) === Boolean;
  };

  var isFunction$1 = function isFunction(input) {
    return getConstructor$1(input) === Function;
  };

  var isArray$1 = function isArray(input) {
    return Array.isArray(input);
  };

  var isWeakMap = function isWeakMap(input) {
    return instanceOf$1(input, WeakMap);
  };

  var isNodeList$1 = function isNodeList(input) {
    return instanceOf$1(input, NodeList);
  };

  var isElement$1 = function isElement(input) {
    return instanceOf$1(input, Element);
  };

  var isTextNode = function isTextNode(input) {
    return getConstructor$1(input) === Text;
  };

  var isEvent$1 = function isEvent(input) {
    return instanceOf$1(input, Event);
  };

  var isKeyboardEvent = function isKeyboardEvent(input) {
    return instanceOf$1(input, KeyboardEvent);
  };

  var isCue = function isCue(input) {
    return instanceOf$1(input, window.TextTrackCue) || instanceOf$1(input, window.VTTCue);
  };

  var isTrack = function isTrack(input) {
    return instanceOf$1(input, TextTrack) || !isNullOrUndefined$1(input) && isString$1(input.kind);
  };

  var isPromise = function isPromise(input) {
    return instanceOf$1(input, Promise);
  };

  var isEmpty$1 = function isEmpty(input) {
    return isNullOrUndefined$1(input) || (isString$1(input) || isArray$1(input) || isNodeList$1(input)) && !input.length || isObject$1(input) && !Object.keys(input).length;
  };

  var isUrl = function isUrl(input) {
    // Accept a URL object
    if (instanceOf$1(input, window.URL)) {
      return true;
    } // Must be string from here


    if (!isString$1(input)) {
      return false;
    } // Add the protocol if required


    var string = input;

    if (!input.startsWith('http://') || !input.startsWith('https://')) {
      string = "http://".concat(input);
    }

    try {
      return !isEmpty$1(new URL(string).hostname);
    } catch (e) {
      return false;
    }
  };

  var is$1 = {
    nullOrUndefined: isNullOrUndefined$1,
    object: isObject$1,
    number: isNumber$1,
    string: isString$1,
    boolean: isBoolean$1,
    function: isFunction$1,
    array: isArray$1,
    weakMap: isWeakMap,
    nodeList: isNodeList$1,
    element: isElement$1,
    textNode: isTextNode,
    event: isEvent$1,
    keyboardEvent: isKeyboardEvent,
    cue: isCue,
    track: isTrack,
    promise: isPromise,
    url: isUrl,
    empty: isEmpty$1
  };

  // ==========================================================================
  // https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
  // https://www.youtube.com/watch?v=NPM6172J22g

  var supportsPassiveListeners = function () {
    // Test via a getter in the options object to see if the passive property is accessed
    var supported = false;

    try {
      var options = Object.defineProperty({}, 'passive', {
        get: function get() {
          supported = true;
          return null;
        }
      });
      window.addEventListener('test', null, options);
      window.removeEventListener('test', null, options);
    } catch (e) {// Do nothing
    }

    return supported;
  }(); // Toggle event listener


  function toggleListener(element, event, callback) {
    var _this = this;

    var toggle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var passive = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var capture = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    // Bail if no element, event, or callback
    if (!element || !('addEventListener' in element) || is$1.empty(event) || !is$1.function(callback)) {
      return;
    } // Allow multiple events


    var events = event.split(' '); // Build options
    // Default to just the capture boolean for browsers with no passive listener support

    var options = capture; // If passive events listeners are supported

    if (supportsPassiveListeners) {
      options = {
        // Whether the listener can be passive (i.e. default never prevented)
        passive: passive,
        // Whether the listener is a capturing listener or not
        capture: capture
      };
    } // If a single node is passed, bind the event listener


    events.forEach(function (type) {
      if (_this && _this.eventListeners && toggle) {
        // Cache event listener
        _this.eventListeners.push({
          element: element,
          type: type,
          callback: callback,
          options: options
        });
      }

      element[toggle ? 'addEventListener' : 'removeEventListener'](type, callback, options);
    });
  } // Bind event handler

  function on(element) {
    var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var callback = arguments.length > 2 ? arguments[2] : undefined;
    var passive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var capture = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    toggleListener.call(this, element, events, callback, true, passive, capture);
  } // Unbind event handler

  function off(element) {
    var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var callback = arguments.length > 2 ? arguments[2] : undefined;
    var passive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var capture = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    toggleListener.call(this, element, events, callback, false, passive, capture);
  } // Bind once-only event handler

  function once(element) {
    var _this2 = this;

    var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var callback = arguments.length > 2 ? arguments[2] : undefined;
    var passive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var capture = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    var onceCallback = function onceCallback() {
      off(element, events, onceCallback, passive, capture);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      callback.apply(_this2, args);
    };

    toggleListener.call(this, element, events, onceCallback, true, passive, capture);
  } // Trigger event

  function triggerEvent(element) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var bubbles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var detail = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    // Bail if no element
    if (!is$1.element(element) || is$1.empty(type)) {
      return;
    } // Create and dispatch the event


    var event = new CustomEvent(type, {
      bubbles: bubbles,
      detail: Object.assign({}, detail, {
        plyr: this
      })
    }); // Dispatch the event

    element.dispatchEvent(event);
  } // Unbind all cached event listeners

  function unbindListeners() {
    if (this && this.eventListeners) {
      this.eventListeners.forEach(function (item) {
        var element = item.element,
            type = item.type,
            callback = item.callback,
            options = item.options;
        element.removeEventListener(type, callback, options);
      });
      this.eventListeners = [];
    }
  } // Run method when / if player is ready

  function ready() {
    var _this3 = this;

    return new Promise(function (resolve) {
      return _this3.ready ? setTimeout(resolve, 0) : on.call(_this3, _this3.elements.container, 'ready', resolve);
    }).then(function () {});
  }

  function wrap(elements, wrapper) {
    // Convert `elements` to an array, if necessary.
    var targets = elements.length ? elements : [elements]; // Loops backwards to prevent having to clone the wrapper on the
    // first element (see `child` below).

    Array.from(targets).reverse().forEach(function (element, index) {
      var child = index > 0 ? wrapper.cloneNode(true) : wrapper; // Cache the current parent and sibling.

      var parent = element.parentNode;
      var sibling = element.nextSibling; // Wrap the element (is automatically removed from its current
      // parent).

      child.appendChild(element); // If the element had a sibling, insert the wrapper before
      // the sibling to maintain the HTML structure; otherwise, just
      // append it to the parent.

      if (sibling) {
        parent.insertBefore(child, sibling);
      } else {
        parent.appendChild(child);
      }
    });
  } // Set attributes

  function setAttributes(element, attributes) {
    if (!is$1.element(element) || is$1.empty(attributes)) {
      return;
    } // Assume null and undefined attributes should be left out,
    // Setting them would otherwise convert them to "null" and "undefined"


    Object.entries(attributes).filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          value = _ref2[1];

      return !is$1.nullOrUndefined(value);
    }).forEach(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];

      return element.setAttribute(key, value);
    });
  } // Create a DocumentFragment

  function createElement(type, attributes, text) {
    // Create a new <element>
    var element = document.createElement(type); // Set all passed attributes

    if (is$1.object(attributes)) {
      setAttributes(element, attributes);
    } // Add text node


    if (is$1.string(text)) {
      element.innerText = text;
    } // Return built element


    return element;
  } // Inaert an element after another

  function insertAfter(element, target) {
    if (!is$1.element(element) || !is$1.element(target)) {
      return;
    }

    target.parentNode.insertBefore(element, target.nextSibling);
  } // Insert a DocumentFragment

  function insertElement(type, parent, attributes, text) {
    if (!is$1.element(parent)) {
      return;
    }

    parent.appendChild(createElement(type, attributes, text));
  } // Remove element(s)

  function removeElement(element) {
    if (is$1.nodeList(element) || is$1.array(element)) {
      Array.from(element).forEach(removeElement);
      return;
    }

    if (!is$1.element(element) || !is$1.element(element.parentNode)) {
      return;
    }

    element.parentNode.removeChild(element);
  } // Remove all child elements

  function emptyElement(element) {
    if (!is$1.element(element)) {
      return;
    }

    var length = element.childNodes.length;

    while (length > 0) {
      element.removeChild(element.lastChild);
      length -= 1;
    }
  } // Replace element

  function replaceElement(newChild, oldChild) {
    if (!is$1.element(oldChild) || !is$1.element(oldChild.parentNode) || !is$1.element(newChild)) {
      return null;
    }

    oldChild.parentNode.replaceChild(newChild, oldChild);
    return newChild;
  } // Get an attribute object from a string selector

  function getAttributesFromSelector(sel, existingAttributes) {
    // For example:
    // '.test' to { class: 'test' }
    // '#test' to { id: 'test' }
    // '[data-test="test"]' to { 'data-test': 'test' }
    if (!is$1.string(sel) || is$1.empty(sel)) {
      return {};
    }

    var attributes = {};
    var existing = existingAttributes;
    sel.split(',').forEach(function (s) {
      // Remove whitespace
      var selector = s.trim();
      var className = selector.replace('.', '');
      var stripped = selector.replace(/[[\]]/g, ''); // Get the parts and value

      var parts = stripped.split('=');
      var key = parts[0];
      var value = parts.length > 1 ? parts[1].replace(/["']/g, '') : ''; // Get the first character

      var start = selector.charAt(0);

      switch (start) {
        case '.':
          // Add to existing classname
          if (is$1.object(existing) && is$1.string(existing.class)) {
            existing.class += " ".concat(className);
          }

          attributes.class = className;
          break;

        case '#':
          // ID selector
          attributes.id = selector.replace('#', '');
          break;

        case '[':
          // Attribute selector
          attributes[key] = value;
          break;

        default:
          break;
      }
    });
    return attributes;
  } // Toggle hidden

  function toggleHidden(element, hidden) {
    if (!is$1.element(element)) {
      return;
    }

    var hide = hidden;

    if (!is$1.boolean(hide)) {
      hide = !element.hidden;
    }

    if (hide) {
      element.setAttribute('hidden', '');
    } else {
      element.removeAttribute('hidden');
    }
  } // Mirror Element.classList.toggle, with IE compatibility for "force" argument

  function toggleClass(element, className, force) {
    if (is$1.nodeList(element)) {
      return Array.from(element).map(function (e) {
        return toggleClass(e, className, force);
      });
    }

    if (is$1.element(element)) {
      var method = 'toggle';

      if (typeof force !== 'undefined') {
        method = force ? 'add' : 'remove';
      }

      element.classList[method](className);
      return element.classList.contains(className);
    }

    return false;
  } // Has class name

  function hasClass(element, className) {
    return is$1.element(element) && element.classList.contains(className);
  } // Element matches selector

  function matches$1(element, selector) {

    function match() {
      return Array.from(document.querySelectorAll(selector)).includes(this);
    }

    var matches = match;
    return matches.call(element, selector);
  } // Find all elements

  function getElements(selector) {
    return this.elements.container.querySelectorAll(selector);
  } // Find a single element

  function getElement(selector) {
    return this.elements.container.querySelector(selector);
  } // Trap focus inside container

  function trapFocus() {
    var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var toggle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!is$1.element(element)) {
      return;
    }

    var focusable = getElements.call(this, 'button:not(:disabled), input:not(:disabled), [tabindex]');
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    var trap = function trap(event) {
      // Bail if not tab key or not fullscreen
      if (event.key !== 'Tab' || event.keyCode !== 9) {
        return;
      } // Get the current focused element


      var focused = document.activeElement;

      if (focused === last && !event.shiftKey) {
        // Move focus to first element that can be tabbed if Shift isn't used
        first.focus();
        event.preventDefault();
      } else if (focused === first && event.shiftKey) {
        // Move focus to last element that can be tabbed if Shift is used
        last.focus();
        event.preventDefault();
      }
    };

    toggleListener.call(this, this.elements.container, 'keydown', trap, toggle, false);
  } // Set focus and tab focus class

  function setFocus() {
    var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var tabFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!is$1.element(element)) {
      return;
    } // Set regular focus


    element.focus({
      preventScroll: true
    }); // If we want to mimic keyboard focus via tab

    if (tabFocus) {
      toggleClass(element, this.config.classNames.tabFocus);
    }
  }

  // ==========================================================================
  var transitionEndEvent = function () {
    var element = document.createElement('span');
    var events = {
      WebkitTransition: 'webkitTransitionEnd',
      MozTransition: 'transitionend',
      OTransition: 'oTransitionEnd otransitionend',
      transition: 'transitionend'
    };
    var type = Object.keys(events).find(function (event) {
      return element.style[event] !== undefined;
    });
    return is$1.string(type) ? events[type] : false;
  }(); // Force repaint of element

  function repaint(element) {
    setTimeout(function () {
      try {
        toggleHidden(element, true);
        element.offsetHeight; // eslint-disable-line

        toggleHidden(element, false);
      } catch (e) {// Do nothing
      }
    }, 0);
  }

  // ==========================================================================
  // Browser sniffing
  // Unfortunately, due to mixed support, UA sniffing is required
  // ==========================================================================
  var browser = {
    isIE:
    /* @cc_on!@ */
    !!document.documentMode,
    isEdge: window.navigator.userAgent.includes('Edge'),
    isWebkit: 'WebkitAppearance' in document.documentElement.style && !/Edge/.test(navigator.userAgent),
    isIPhone: /(iPhone|iPod)/gi.test(navigator.platform),
    isIos: /(iPad|iPhone|iPod)/gi.test(navigator.platform)
  };

  var defaultCodecs = {
    'audio/ogg': 'vorbis',
    'audio/wav': '1',
    'video/webm': 'vp8, vorbis',
    'video/mp4': 'avc1.42E01E, mp4a.40.2',
    'video/ogg': 'theora'
  }; // Check for feature support

  var support = {
    // Basic support
    audio: 'canPlayType' in document.createElement('audio'),
    video: 'canPlayType' in document.createElement('video'),
    // Check for support
    // Basic functionality vs full UI
    check: function check(type, provider, playsinline) {
      var canPlayInline = browser.isIPhone && playsinline && support.playsinline;
      var api = support[type] || provider !== 'html5';
      var ui = api && support.rangeInput && (type !== 'video' || !browser.isIPhone || canPlayInline);
      return {
        api: api,
        ui: ui
      };
    },
    // Picture-in-picture support
    // Safari & Chrome only currently
    pip: function () {
      if (browser.isIPhone) {
        return false;
      } // Safari
      // https://developer.apple.com/documentation/webkitjs/adding_picture_in_picture_to_your_safari_media_controls


      if (is$1.function(createElement('video').webkitSetPresentationMode)) {
        return true;
      } // Chrome
      // https://developers.google.com/web/updates/2018/10/watch-video-using-picture-in-picture


      if (document.pictureInPictureEnabled && !createElement('video').disablePictureInPicture) {
        return true;
      }

      return false;
    }(),
    // Airplay support
    // Safari only currently
    airplay: is$1.function(window.WebKitPlaybackTargetAvailabilityEvent),
    // Inline playback support
    // https://webkit.org/blog/6784/new-video-policies-for-ios/
    playsinline: 'playsInline' in document.createElement('video'),
    // Check for mime type support against a player instance
    // Credits: http://diveintohtml5.info/everything.html
    // Related: http://www.leanbackplayer.com/test/h5mt.html
    mime: function mime(input) {
      if (is$1.empty(input)) {
        return false;
      }

      var _input$split = input.split('/'),
          _input$split2 = _slicedToArray(_input$split, 1),
          mediaType = _input$split2[0];

      var type = input; // Verify we're using HTML5 and there's no media type mismatch

      if (!this.isHTML5 || mediaType !== this.type) {
        return false;
      } // Add codec if required


      if (Object.keys(defaultCodecs).includes(type)) {
        type += "; codecs=\"".concat(defaultCodecs[input], "\"");
      }

      try {
        return Boolean(type && this.media.canPlayType(type).replace(/no/, ''));
      } catch (e) {
        return false;
      }
    },
    // Check for textTracks support
    textTracks: 'textTracks' in document.createElement('video'),
    // <input type="range"> Sliders
    rangeInput: function () {
      var range = document.createElement('input');
      range.type = 'range';
      return range.type === 'range';
    }(),
    // Touch
    // NOTE: Remember a device can be mouse + touch enabled so we check on first touch event
    touch: 'ontouchstart' in document.documentElement,
    // Detect transitions support
    transitions: transitionEndEvent !== false,
    // Reduced motion iOS & MacOS setting
    // https://webkit.org/blog/7551/responsive-design-for-motion/
    reducedMotion: 'matchMedia' in window && window.matchMedia('(prefers-reduced-motion)').matches
  };

  // ==========================================================================
  var html5 = {
    getSources: function getSources() {
      var _this = this;

      if (!this.isHTML5) {
        return [];
      }

      var sources = Array.from(this.media.querySelectorAll('source')); // Filter out unsupported sources (if type is specified)

      return sources.filter(function (source) {
        var type = source.getAttribute('type');

        if (is$1.empty(type)) {
          return true;
        }

        return support.mime.call(_this, type);
      });
    },
    // Get quality levels
    getQualityOptions: function getQualityOptions() {
      // Get sizes from <source> elements
      return html5.getSources.call(this).map(function (source) {
        return Number(source.getAttribute('size'));
      }).filter(Boolean);
    },
    extend: function extend() {
      if (!this.isHTML5) {
        return;
      }

      var player = this; // Quality

      Object.defineProperty(player.media, 'quality', {
        get: function get() {
          // Get sources
          var sources = html5.getSources.call(player);
          var source = sources.find(function (source) {
            return source.getAttribute('src') === player.source;
          }); // Return size, if match is found

          return source && Number(source.getAttribute('size'));
        },
        set: function set(input) {
          // Get sources
          var sources = html5.getSources.call(player); // Get first match for requested size

          var source = sources.find(function (source) {
            return Number(source.getAttribute('size')) === input;
          }); // No matching source found

          if (!source) {
            return;
          } // Get current state


          var _player$media = player.media,
              currentTime = _player$media.currentTime,
              paused = _player$media.paused,
              preload = _player$media.preload,
              readyState = _player$media.readyState; // Set new source

          player.media.src = source.getAttribute('src'); // Prevent loading if preload="none" and the current source isn't loaded (#1044)

          if (preload !== 'none' || readyState) {
            // Restore time
            player.once('loadedmetadata', function () {
              player.currentTime = currentTime; // Resume playing

              if (!paused) {
                player.play();
              }
            }); // Load new source

            player.media.load();
          } // Trigger change event


          triggerEvent.call(player, player.media, 'qualitychange', false, {
            quality: input
          });
        }
      });
    },
    // Cancel current network requests
    // See https://github.com/sampotts/plyr/issues/174
    cancelRequests: function cancelRequests() {
      if (!this.isHTML5) {
        return;
      } // Remove child sources


      removeElement(html5.getSources.call(this)); // Set blank video src attribute
      // This is to prevent a MEDIA_ERR_SRC_NOT_SUPPORTED error
      // Info: http://stackoverflow.com/questions/32231579/how-to-properly-dispose-of-an-html5-video-and-close-socket-or-connection

      this.media.setAttribute('src', this.config.blankVideo); // Load the new empty source
      // This will cancel existing requests
      // See https://github.com/sampotts/plyr/issues/174

      this.media.load(); // Debugging

      this.debug.log('Cancelled network requests');
    }
  };

  // ==========================================================================

  function dedupe(array) {
    if (!is$1.array(array)) {
      return array;
    }

    return array.filter(function (item, index) {
      return array.indexOf(item) === index;
    });
  } // Get the closest value in an array

  function closest(array, value) {
    if (!is$1.array(array) || !array.length) {
      return null;
    }

    return array.reduce(function (prev, curr) {
      return Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev;
    });
  }

  function cloneDeep(object) {
    return JSON.parse(JSON.stringify(object));
  } // Get a nested value in an object

  function getDeep(object, path) {
    return path.split('.').reduce(function (obj, key) {
      return obj && obj[key];
    }, object);
  } // Deep extend destination object with N more objects

  function extend() {
    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      sources[_key - 1] = arguments[_key];
    }

    if (!sources.length) {
      return target;
    }

    var source = sources.shift();

    if (!is$1.object(source)) {
      return target;
    }

    Object.keys(source).forEach(function (key) {
      if (is$1.object(source[key])) {
        if (!Object.keys(target).includes(key)) {
          Object.assign(target, _defineProperty({}, key, {}));
        }

        extend(target[key], source[key]);
      } else {
        Object.assign(target, _defineProperty({}, key, source[key]));
      }
    });
    return extend.apply(void 0, [target].concat(sources));
  }

  // ==========================================================================

  function generateId(prefix) {
    return "".concat(prefix, "-").concat(Math.floor(Math.random() * 10000));
  } // Format string

  function format(input) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (is$1.empty(input)) {
      return input;
    }

    return input.toString().replace(/{(\d+)}/g, function (match, i) {
      return args[i].toString();
    });
  } // Get percentage

  function getPercentage(current, max) {
    if (current === 0 || max === 0 || Number.isNaN(current) || Number.isNaN(max)) {
      return 0;
    }

    return (current / max * 100).toFixed(2);
  } // Replace all occurances of a string in a string

  function replaceAll() {
    var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var find = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var replace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return input.replace(new RegExp(find.toString().replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1'), 'g'), replace.toString());
  } // Convert to title case

  function toTitleCase() {
    var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return input.toString().replace(/\w\S*/g, function (text) {
      return text.charAt(0).toUpperCase() + text.substr(1).toLowerCase();
    });
  } // Convert string to pascalCase

  function toPascalCase() {
    var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var string = input.toString(); // Convert kebab case

    string = replaceAll(string, '-', ' '); // Convert snake case

    string = replaceAll(string, '_', ' '); // Convert to title case

    string = toTitleCase(string); // Convert to pascal case

    return replaceAll(string, ' ', '');
  } // Convert string to pascalCase

  function toCamelCase() {
    var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var string = input.toString(); // Convert to pascal case

    string = toPascalCase(string); // Convert first character to lowercase

    return string.charAt(0).toLowerCase() + string.slice(1);
  } // Remove HTML from a string

  function stripHTML(source) {
    var fragment = document.createDocumentFragment();
    var element = document.createElement('div');
    fragment.appendChild(element);
    element.innerHTML = source;
    return fragment.firstChild.innerText;
  } // Like outerHTML, but also works for DocumentFragment

  function getHTML(element) {
    var wrapper = document.createElement('div');
    wrapper.appendChild(element);
    return wrapper.innerHTML;
  }

  var resources = {
    pip: 'PIP',
    airplay: 'AirPlay',
    html5: 'HTML5',
    vimeo: 'Vimeo',
    youtube: 'YouTube'
  };
  var i18n = {
    get: function get() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (is$1.empty(key) || is$1.empty(config)) {
        return '';
      }

      var string = getDeep(config.i18n, key);

      if (is$1.empty(string)) {
        if (Object.keys(resources).includes(key)) {
          return resources[key];
        }

        return '';
      }

      var replace = {
        '{seektime}': config.seekTime,
        '{title}': config.title
      };
      Object.entries(replace).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        string = replaceAll(string, key, value);
      });
      return string;
    }
  };

  var Storage =
  /*#__PURE__*/
  function () {
    function Storage(player) {
      _classCallCheck(this, Storage);

      this.enabled = player.config.storage.enabled;
      this.key = player.config.storage.key;
    } // Check for actual support (see if we can use it)


    _createClass(Storage, [{
      key: "get",
      value: function get(key) {
        if (!Storage.supported || !this.enabled) {
          return null;
        }

        var store = window.localStorage.getItem(this.key);

        if (is$1.empty(store)) {
          return null;
        }

        var json = JSON.parse(store);
        return is$1.string(key) && key.length ? json[key] : json;
      }
    }, {
      key: "set",
      value: function set(object) {
        // Bail if we don't have localStorage support or it's disabled
        if (!Storage.supported || !this.enabled) {
          return;
        } // Can only store objectst


        if (!is$1.object(object)) {
          return;
        } // Get current storage


        var storage = this.get(); // Default to empty object

        if (is$1.empty(storage)) {
          storage = {};
        } // Update the working copy of the values


        extend(storage, object); // Update storage

        window.localStorage.setItem(this.key, JSON.stringify(storage));
      }
    }], [{
      key: "supported",
      get: function get() {
        try {
          if (!('localStorage' in window)) {
            return false;
          }

          var test = '___test'; // Try to use it (it might be disabled, e.g. user is in private mode)
          // see: https://github.com/sampotts/plyr/issues/131

          window.localStorage.setItem(test, test);
          window.localStorage.removeItem(test);
          return true;
        } catch (e) {
          return false;
        }
      }
    }]);

    return Storage;
  }();

  // ==========================================================================
  // Fetch wrapper
  // Using XHR to avoid issues with older browsers
  // ==========================================================================
  function fetch$1(url) {
    var responseType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'text';
    return new Promise(function (resolve, reject) {
      try {
        var request = new XMLHttpRequest(); // Check for CORS support

        if (!('withCredentials' in request)) {
          return;
        }

        request.addEventListener('load', function () {
          if (responseType === 'text') {
            try {
              resolve(JSON.parse(request.responseText));
            } catch (e) {
              resolve(request.responseText);
            }
          } else {
            resolve(request.response);
          }
        });
        request.addEventListener('error', function () {
          throw new Error(request.status);
        });
        request.open('GET', url, true); // Set the required response type

        request.responseType = responseType;
        request.send();
      } catch (e) {
        reject(e);
      }
    });
  }

  // ==========================================================================

  function loadSprite(url, id) {
    if (!is$1.string(url)) {
      return;
    }

    var prefix = 'cache';
    var hasId = is$1.string(id);
    var isCached = false;

    var exists = function exists() {
      return document.getElementById(id) !== null;
    };

    var update = function update(container, data) {
      container.innerHTML = data; // Check again incase of race condition

      if (hasId && exists()) {
        return;
      } // Inject the SVG to the body


      document.body.insertAdjacentElement('afterbegin', container);
    }; // Only load once if ID set


    if (!hasId || !exists()) {
      var useStorage = Storage.supported; // Create container

      var container = document.createElement('div');
      container.setAttribute('hidden', '');

      if (hasId) {
        container.setAttribute('id', id);
      } // Check in cache


      if (useStorage) {
        var cached = window.localStorage.getItem("".concat(prefix, "-").concat(id));
        isCached = cached !== null;

        if (isCached) {
          var data = JSON.parse(cached);
          update(container, data.content);
        }
      } // Get the sprite


      fetch$1(url).then(function (result) {
        if (is$1.empty(result)) {
          return;
        }

        if (useStorage) {
          window.localStorage.setItem("".concat(prefix, "-").concat(id), JSON.stringify({
            content: result
          }));
        }

        update(container, result);
      }).catch(function () {});
    }
  }

  // ==========================================================================

  var getHours = function getHours(value) {
    return Math.trunc(value / 60 / 60 % 60, 10);
  };
  var getMinutes = function getMinutes(value) {
    return Math.trunc(value / 60 % 60, 10);
  };
  var getSeconds = function getSeconds(value) {
    return Math.trunc(value % 60, 10);
  }; // Format time to UI friendly string

  function formatTime() {
    var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var displayHours = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var inverted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    // Bail if the value isn't a number
    if (!is$1.number(time)) {
      return formatTime(null, displayHours, inverted);
    } // Format time component to add leading zero


    var format = function format(value) {
      return "0".concat(value).slice(-2);
    }; // Breakdown to hours, mins, secs


    var hours = getHours(time);
    var mins = getMinutes(time);
    var secs = getSeconds(time); // Do we need to display hours?

    if (displayHours || hours > 0) {
      hours = "".concat(hours, ":");
    } else {
      hours = '';
    } // Render


    return "".concat(inverted && time > 0 ? '-' : '').concat(hours).concat(format(mins), ":").concat(format(secs));
  }

  var controls = {
    // Get icon URL
    getIconUrl: function getIconUrl() {
      var url = new URL(this.config.iconUrl, window.location);
      var cors = url.host !== window.location.host || browser.isIE && !window.svg4everybody;
      return {
        url: this.config.iconUrl,
        cors: cors
      };
    },
    // Find the UI controls
    findElements: function findElements() {
      try {
        this.elements.controls = getElement.call(this, this.config.selectors.controls.wrapper); // Buttons

        this.elements.buttons = {
          play: getElements.call(this, this.config.selectors.buttons.play),
          pause: getElement.call(this, this.config.selectors.buttons.pause),
          restart: getElement.call(this, this.config.selectors.buttons.restart),
          rewind: getElement.call(this, this.config.selectors.buttons.rewind),
          skipOpening: getElement.call(this, this.config.selectors.buttons.skipOpening),
          fastForward: getElement.call(this, this.config.selectors.buttons.fastForward),
          mute: getElement.call(this, this.config.selectors.buttons.mute),
          pip: getElement.call(this, this.config.selectors.buttons.pip),
          airplay: getElement.call(this, this.config.selectors.buttons.airplay),
          p2p: getElement.call(this, this.config.selectors.buttons.p2p),
          settings: getElement.call(this, this.config.selectors.buttons.settings),
          captions: getElement.call(this, this.config.selectors.buttons.captions),
          fullscreen: getElement.call(this, this.config.selectors.buttons.fullscreen)
        }; // Progress

        this.elements.progress = getElement.call(this, this.config.selectors.progress); // Inputs

        this.elements.inputs = {
          seek: getElement.call(this, this.config.selectors.inputs.seek),
          volume: getElement.call(this, this.config.selectors.inputs.volume)
        }; // Display

        this.elements.display = {
          buffer: getElement.call(this, this.config.selectors.display.buffer),
          currentTime: getElement.call(this, this.config.selectors.display.currentTime),
          duration: getElement.call(this, this.config.selectors.display.duration)
        }; // Seek tooltip

        if (is$1.element(this.elements.progress)) {
          this.elements.display.seekTooltip = this.elements.progress.querySelector(".".concat(this.config.classNames.tooltip));
        }

        return true;
      } catch (error) {
        // Log it
        this.debug.warn('It looks like there is a problem with your custom controls HTML', error); // Restore native video controls

        this.toggleNativeControls(true);
        return false;
      }
    },
    // Create <svg> icon
    createIcon: function createIcon(type, attributes) {
      var namespace = 'http://www.w3.org/2000/svg';
      var iconUrl = controls.getIconUrl.call(this);
      var iconPath = "".concat(!iconUrl.cors ? iconUrl.url : '', "#").concat(this.config.iconPrefix); // Create <svg>

      var icon = document.createElementNS(namespace, 'svg');
      setAttributes(icon, extend(attributes, {
        role: 'presentation',
        focusable: 'false'
      })); // Create the <use> to reference sprite

      var use = document.createElementNS(namespace, 'use');
      var path = "".concat(iconPath, "-").concat(type); // Set `href` attributes
      // https://github.com/sampotts/plyr/issues/460
      // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/xlink:href

      if ('href' in use) {
        use.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);
      } // Always set the older attribute even though it's "deprecated" (it'll be around for ages)


      use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', path); // Add <use> to <svg>

      icon.appendChild(use);
      return icon;
    },
    // Create hidden text label
    createLabel: function createLabel(key) {
      var attr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var text = i18n.get(key, this.config);
      var attributes = Object.assign({}, attr, {
        class: [attr.class, this.config.classNames.hidden].filter(Boolean).join(' ')
      });
      return createElement('span', attributes, text);
    },
    // Create a badge
    createBadge: function createBadge(text) {
      if (is$1.empty(text)) {
        return null;
      }

      var badge = createElement('span', {
        class: this.config.classNames.menu.value
      });
      badge.appendChild(createElement('span', {
        class: this.config.classNames.menu.badge
      }, text));
      return badge;
    },
    // Create a <button>
    createButton: function createButton(buttonType, attr) {
      var attributes = Object.assign({}, attr);
      var type = toCamelCase(buttonType);
      var props = {
        element: 'button',
        toggle: false,
        label: null,
        icon: null,
        labelPressed: null,
        iconPressed: null
      };
      ['element', 'icon', 'label'].forEach(function (key) {
        if (Object.keys(attributes).includes(key)) {
          props[key] = attributes[key];
          delete attributes[key];
        }
      }); // Default to 'button' type to prevent form submission

      if (props.element === 'button' && !Object.keys(attributes).includes('type')) {
        attributes.type = 'button';
      } // Set class name


      if (Object.keys(attributes).includes('class')) {
        if (!attributes.class.includes(this.config.classNames.control)) {
          attributes.class += " ".concat(this.config.classNames.control);
        }
      } else {
        attributes.class = this.config.classNames.control;
      } // Large play button


      switch (buttonType) {
        case 'play':
          props.toggle = true;
          props.label = 'play';
          props.labelPressed = 'pause';
          props.icon = 'play';
          props.iconPressed = 'pause';
          break;

        case 'mute':
          props.toggle = true;
          props.label = 'mute';
          props.labelPressed = 'unmute';
          props.icon = 'volume';
          props.iconPressed = 'muted';
          break;

        case 'captions':
          props.toggle = true;
          props.label = 'enableCaptions';
          props.labelPressed = 'disableCaptions';
          props.icon = 'captions-off';
          props.iconPressed = 'captions-on';
          break;

        case 'fullscreen':
          props.toggle = true;
          props.label = 'enterFullscreen';
          props.labelPressed = 'exitFullscreen';
          props.icon = 'enter-fullscreen';
          props.iconPressed = 'exit-fullscreen';
          break;

        case 'play-large':
          attributes.class += " ".concat(this.config.classNames.control, "--overlaid");
          type = 'play';
          props.label = 'play';
          props.icon = 'play';
          break;

        default:
          if (is$1.empty(props.label)) {
            props.label = type;
          }

          if (is$1.empty(props.icon)) {
            props.icon = buttonType;
          }

      }

      var button = createElement(props.element); // Setup toggle icon and labels

      if (props.toggle) {
        // Icon
        button.appendChild(controls.createIcon.call(this, props.iconPressed, {
          class: 'icon--pressed'
        }));
        button.appendChild(controls.createIcon.call(this, props.icon, {
          class: 'icon--not-pressed'
        })); // Label/Tooltip

        button.appendChild(controls.createLabel.call(this, props.labelPressed, {
          class: 'label--pressed'
        }));
        button.appendChild(controls.createLabel.call(this, props.label, {
          class: 'label--not-pressed'
        }));
      } else {
        button.appendChild(controls.createIcon.call(this, props.icon));
        button.appendChild(controls.createLabel.call(this, props.label));
      } // Merge and set attributes


      extend(attributes, getAttributesFromSelector(this.config.selectors.buttons[type], attributes));
      setAttributes(button, attributes); // We have multiple play buttons

      if (type === 'play') {
        if (!is$1.array(this.elements.buttons[type])) {
          this.elements.buttons[type] = [];
        }

        this.elements.buttons[type].push(button);
      } else {
        this.elements.buttons[type] = button;
      }

      return button;
    },
    // Create an <input type='range'>
    createRange: function createRange(type, attributes) {
      // Seek input
      var input = createElement('input', extend(getAttributesFromSelector(this.config.selectors.inputs[type]), {
        type: 'range',
        min: 0,
        max: 100,
        step: 0.01,
        value: 0,
        autocomplete: 'off',
        // A11y fixes for https://github.com/sampotts/plyr/issues/905
        role: 'slider',
        'aria-label': i18n.get(type, this.config),
        'aria-valuemin': 0,
        'aria-valuemax': 100,
        'aria-valuenow': 0
      }, attributes));
      this.elements.inputs[type] = input; // Set the fill for webkit now

      controls.updateRangeFill.call(this, input); // Improve support on touch devices

      RangeTouch.setup(input);
      return input;
    },
    // Create a <progress>
    createProgress: function createProgress(type, attributes) {
      var progress = createElement('progress', extend(getAttributesFromSelector(this.config.selectors.display[type]), {
        min: 0,
        max: 100,
        value: 0,
        role: 'progressbar',
        'aria-hidden': true
      }, attributes)); // Create the label inside

      if (type !== 'volume') {
        progress.appendChild(createElement('span', null, '0'));
        var suffixKey = {
          played: 'played',
          buffer: 'buffered'
        }[type];
        var suffix = suffixKey ? i18n.get(suffixKey, this.config) : '';
        progress.innerText = "% ".concat(suffix.toLowerCase());
      }

      this.elements.display[type] = progress;
      return progress;
    },
    // Create time display
    createTime: function createTime(type) {
      var attributes = getAttributesFromSelector(this.config.selectors.display[type]);
      var container = createElement('div', extend(attributes, {
        class: "".concat(this.config.classNames.display.time, " ").concat(attributes.class ? attributes.class : '').trim(),
        'aria-label': i18n.get(type, this.config)
      }), '00:00'); // Reference for updates

      this.elements.display[type] = container;
      return container;
    },
    // Bind keyboard shortcuts for a menu item
    // We have to bind to keyup otherwise Firefox triggers a click when a keydown event handler shifts focus
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1220143
    bindMenuItemShortcuts: function bindMenuItemShortcuts(menuItem, type) {
      var _this = this;

      // Navigate through menus via arrow keys and space
      on(menuItem, 'keydown keyup', function (event) {
        // We only care about space and ⬆️ ⬇️️ ➡️
        if (![32, 38, 39, 40].includes(event.which)) {
          return;
        } // Prevent play / seek


        event.preventDefault();
        event.stopPropagation(); // We're just here to prevent the keydown bubbling

        if (event.type === 'keydown') {
          return;
        }

        var isRadioButton = matches$1(menuItem, '[role="menuitemradio"]'); // Show the respective menu

        if (!isRadioButton && [32, 39].includes(event.which)) {
          controls.showMenuPanel.call(_this, type, true);
        } else {
          var target;

          if (event.which !== 32) {
            if (event.which === 40 || isRadioButton && event.which === 39) {
              target = menuItem.nextElementSibling;

              if (!is$1.element(target)) {
                target = menuItem.parentNode.firstElementChild;
              }
            } else {
              target = menuItem.previousElementSibling;

              if (!is$1.element(target)) {
                target = menuItem.parentNode.lastElementChild;
              }
            }

            setFocus.call(_this, target, true);
          }
        }
      }, false); // Enter will fire a `click` event but we still need to manage focus
      // So we bind to keyup which fires after and set focus here

      on(menuItem, 'keyup', function (event) {
        if (event.which !== 13) {
          return;
        }

        controls.focusFirstMenuItem.call(_this, null, true);
      });
    },
    // Create a settings menu item
    createMenuItem: function createMenuItem(_ref) {
      var _this2 = this;

      var value = _ref.value,
          list = _ref.list,
          type = _ref.type,
          title = _ref.title,
          _ref$badge = _ref.badge,
          badge = _ref$badge === void 0 ? null : _ref$badge,
          _ref$checked = _ref.checked,
          checked = _ref$checked === void 0 ? false : _ref$checked;
      var attributes = getAttributesFromSelector(this.config.selectors.inputs[type]);
      var menuItem = createElement('button', extend(attributes, {
        type: 'button',
        role: 'menuitemradio',
        class: "".concat(this.config.classNames.control, " ").concat(attributes.class ? attributes.class : '').trim(),
        'aria-checked': checked,
        value: value
      }));
      var flex = createElement('span'); // We have to set as HTML incase of special characters

      flex.innerHTML = title;

      if (is$1.element(badge)) {
        flex.appendChild(badge);
      }

      menuItem.appendChild(flex); // Replicate radio button behaviour

      Object.defineProperty(menuItem, 'checked', {
        enumerable: true,
        get: function get() {
          return menuItem.getAttribute('aria-checked') === 'true';
        },
        set: function set(checked) {
          // Ensure exclusivity
          if (checked) {
            Array.from(menuItem.parentNode.children).filter(function (node) {
              return matches$1(node, '[role="menuitemradio"]');
            }).forEach(function (node) {
              return node.setAttribute('aria-checked', 'false');
            });
          }

          menuItem.setAttribute('aria-checked', checked ? 'true' : 'false');
        }
      });
      this.listeners.bind(menuItem, 'click keyup', function (event) {
        if (is$1.keyboardEvent(event) && event.which !== 32) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        menuItem.checked = true;

        switch (type) {
          case 'language':
            _this2.currentTrack = Number(value);
            break;

          case 'quality':
            _this2.quality = value;
            break;

          case 'speed':
            _this2.speed = parseFloat(value);
            break;

          default:
            break;
        }

        controls.showMenuPanel.call(_this2, 'home', is$1.keyboardEvent(event));
      }, type, false);
      controls.bindMenuItemShortcuts.call(this, menuItem, type);
      list.appendChild(menuItem);
    },
    // Format a time for display
    formatTime: function formatTime$$1() {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var inverted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      // Bail if the value isn't a number
      if (!is$1.number(time)) {
        return time;
      } // Always display hours if duration is over an hour


      var forceHours = getHours(this.duration) > 0;
      return formatTime(time, forceHours, inverted);
    },
    // Update the displayed time
    updateTimeDisplay: function updateTimeDisplay() {
      var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var inverted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      // Bail if there's no element to display or the value isn't a number
      if (!is$1.element(target) || !is$1.number(time)) {
        return;
      } // eslint-disable-next-line no-param-reassign


      target.innerText = controls.formatTime(time, inverted);
    },
    // Update volume UI and storage
    updateVolume: function updateVolume() {
      if (!this.supported.ui) {
        return;
      } // Update range


      if (is$1.element(this.elements.inputs.volume)) {
        controls.setRange.call(this, this.elements.inputs.volume, this.muted ? 0 : this.volume);
      } // Update mute state


      if (is$1.element(this.elements.buttons.mute)) {
        this.elements.buttons.mute.pressed = this.muted || this.volume === 0;
      }
    },
    // Update seek value and lower fill
    setRange: function setRange(target) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (!is$1.element(target)) {
        return;
      } // eslint-disable-next-line


      target.value = value; // Webkit range fill

      controls.updateRangeFill.call(this, target);
    },
    // Update <progress> elements
    updateProgress: function updateProgress(event) {
      var _this3 = this;

      if (!this.supported.ui || !is$1.event(event)) {
        return;
      }

      var value = 0;

      var setProgress = function setProgress(target, input) {
        var value = is$1.number(input) ? input : 0;
        var progress = is$1.element(target) ? target : _this3.elements.display.buffer; // Update value and label

        if (is$1.element(progress)) {
          progress.value = value; // Update text label inside

          var label = progress.getElementsByTagName('span')[0];

          if (is$1.element(label)) {
            label.childNodes[0].nodeValue = value;
          }
        }
      };

      if (event) {
        switch (event.type) {
          // Video playing
          case 'timeupdate':
          case 'seeking':
          case 'seeked':
            value = getPercentage(this.currentTime, this.duration); // Set seek range value only if it's a 'natural' time event

            if (event.type === 'timeupdate') {
              controls.setRange.call(this, this.elements.inputs.seek, value);
            }

            break;
          // Check buffer status

          case 'playing':
          case 'progress':
            setProgress(this.elements.display.buffer, this.buffered * 100);
            break;

          default:
            break;
        }
      }
    },
    // Webkit polyfill for lower fill range
    updateRangeFill: function updateRangeFill(target) {
      // Get range from event if event passed
      var range = is$1.event(target) ? target.target : target; // Needs to be a valid <input type='range'>

      if (!is$1.element(range) || range.getAttribute('type') !== 'range') {
        return;
      } // Set aria values for https://github.com/sampotts/plyr/issues/905


      if (matches$1(range, this.config.selectors.inputs.seek)) {
        range.setAttribute('aria-valuenow', this.currentTime);
        var currentTime = controls.formatTime(this.currentTime);
        var duration = controls.formatTime(this.duration);
        var format$$1 = i18n.get('seekLabel', this.config);
        range.setAttribute('aria-valuetext', format$$1.replace('{currentTime}', currentTime).replace('{duration}', duration));
      } else if (matches$1(range, this.config.selectors.inputs.volume)) {
        var percent = range.value * 100;
        range.setAttribute('aria-valuenow', percent);
        range.setAttribute('aria-valuetext', "".concat(percent.toFixed(1), "%"));
      } else {
        range.setAttribute('aria-valuenow', range.value);
      } // WebKit only


      if (!browser.isWebkit) {
        return;
      } // Set CSS custom property


      range.style.setProperty('--value', "".concat(range.value / range.max * 100, "%"));
    },
    // Update hover tooltip for seeking
    updateSeekTooltip: function updateSeekTooltip(event) {
      var _this4 = this;

      // Bail if setting not true
      if (!this.config.tooltips.seek || !is$1.element(this.elements.inputs.seek) || !is$1.element(this.elements.display.seekTooltip) || this.duration === 0) {
        return;
      } // Calculate percentage


      var percent = 0;
      var clientRect = this.elements.progress.getBoundingClientRect();
      var visible = "".concat(this.config.classNames.tooltip, "--visible");

      var toggle = function toggle(_toggle) {
        toggleClass(_this4.elements.display.seekTooltip, visible, _toggle);
      }; // Hide on touch


      if (this.touch) {
        toggle(false);
        return;
      } // Determine percentage, if already visible


      if (is$1.event(event)) {
        percent = 100 / clientRect.width * (event.pageX - clientRect.left);
      } else if (hasClass(this.elements.display.seekTooltip, visible)) {
        percent = parseFloat(this.elements.display.seekTooltip.style.left, 10);
      } else {
        return;
      } // Set bounds


      if (percent < 0) {
        percent = 0;
      } else if (percent > 100) {
        percent = 100;
      } // Display the time a click would seek to


      controls.updateTimeDisplay.call(this, this.elements.display.seekTooltip, this.duration / 100 * percent); // Set position

      this.elements.display.seekTooltip.style.left = "".concat(percent, "%"); // Show/hide the tooltip
      // If the event is a moues in/out and percentage is inside bounds

      if (is$1.event(event) && ['mouseenter', 'mouseleave'].includes(event.type)) {
        toggle(event.type === 'mouseenter');
      }
    },
    // Handle time change event
    timeUpdate: function timeUpdate(event) {
      // Only invert if only one time element is displayed and used for both duration and currentTime
      var invert = !is$1.element(this.elements.display.duration) && this.config.invertTime; // Duration

      controls.updateTimeDisplay.call(this, this.elements.display.currentTime, invert ? this.duration - this.currentTime : this.currentTime, invert); // Ignore updates while seeking

      if (event && event.type === 'timeupdate' && this.media.seeking) {
        return;
      } // Playing progress


      controls.updateProgress.call(this, event);
    },
    // Show the duration on metadataloaded or durationchange events
    durationUpdate: function durationUpdate() {
      // Bail if no UI or durationchange event triggered after playing/seek when invertTime is false
      if (!this.supported.ui || !this.config.invertTime && this.currentTime) {
        return;
      } // If duration is the 2**32 (shaka), Infinity (HLS), DASH-IF (Number.MAX_SAFE_INTEGER || Number.MAX_VALUE) indicating live we hide the currentTime and progressbar.
      // https://github.com/video-dev/hls.js/blob/5820d29d3c4c8a46e8b75f1e3afa3e68c1a9a2db/src/controller/buffer-controller.js#L415
      // https://github.com/google/shaka-player/blob/4d889054631f4e1cf0fbd80ddd2b71887c02e232/lib/media/streaming_engine.js#L1062
      // https://github.com/Dash-Industry-Forum/dash.js/blob/69859f51b969645b234666800d4cb596d89c602d/src/dash/models/DashManifestModel.js#L338


      if (this.duration >= Math.pow(2, 32)) {
        toggleHidden(this.elements.display.currentTime, true);
        toggleHidden(this.elements.progress, true);
        return;
      } // Update ARIA values


      if (is$1.element(this.elements.inputs.seek)) {
        this.elements.inputs.seek.setAttribute('aria-valuemax', this.duration);
      } // If there's a spot to display duration


      var hasDuration = is$1.element(this.elements.display.duration); // If there's only one time display, display duration there

      if (!hasDuration && this.config.displayDuration && this.paused) {
        controls.updateTimeDisplay.call(this, this.elements.display.currentTime, this.duration);
      } // If there's a duration element, update content


      if (hasDuration) {
        controls.updateTimeDisplay.call(this, this.elements.display.duration, this.duration);
      } // Update the tooltip (if visible)


      controls.updateSeekTooltip.call(this);
    },
    // Hide/show a tab
    toggleMenuButton: function toggleMenuButton(setting, toggle) {
      toggleHidden(this.elements.settings.buttons[setting], !toggle);
    },
    // Update the selected setting
    updateSetting: function updateSetting(setting, container, input) {
      var pane = this.elements.settings.panels[setting];
      var value = null;
      var list = container;

      if (setting === 'captions') {
        value = this.currentTrack;
      } else {
        value = !is$1.empty(input) ? input : this[setting]; // Get default

        if (is$1.empty(value)) {
          value = this.config[setting].default;
        } // Unsupported value


        if (!is$1.empty(this.options[setting]) && !this.options[setting].includes(value)) {
          this.debug.warn("Unsupported value of '".concat(value, "' for ").concat(setting));
          return;
        } // Disabled value


        if (!this.config[setting].options.includes(value)) {
          this.debug.warn("Disabled value of '".concat(value, "' for ").concat(setting));
          return;
        }
      } // Get the list if we need to


      if (!is$1.element(list)) {
        list = pane && pane.querySelector('[role="menu"]');
      } // If there's no list it means it's not been rendered...


      if (!is$1.element(list)) {
        return;
      } // Update the label


      var label = this.elements.settings.buttons[setting].querySelector(".".concat(this.config.classNames.menu.value));
      label.innerHTML = controls.getLabel.call(this, setting, value); // Find the radio option and check it

      var target = list && list.querySelector("[value=\"".concat(value, "\"]"));

      if (is$1.element(target)) {
        target.checked = true;
      }
    },
    // Translate a value into a nice label
    getLabel: function getLabel(setting, value) {
      switch (setting) {
        case 'speed':
          return value === 1 ? i18n.get('normal', this.config) : "".concat(value, "&times;");

        case 'quality':
          if (is$1.number(value)) {
            if (value === 0) {
              return i18n.get('auto', this.config);
            }

            var label = i18n.get("qualityLabel.".concat(value), this.config);

            if (!label.length) {
              return "".concat(value, "p");
            }

            return label;
          }

          return toTitleCase(value);

        case 'captions':
          return captions.getLabel.call(this);

        default:
          return null;
      }
    },
    // Set the quality menu
    setQualityMenu: function setQualityMenu(options) {
      var _this5 = this;

      // Menu required
      if (!is$1.element(this.elements.settings.panels.quality)) {
        return;
      }

      var type = 'quality';
      var list = this.elements.settings.panels.quality.querySelector('[role="menu"]'); // Set options if passed and filter based on uniqueness and config

      if (is$1.array(options)) {
        this.options.quality = dedupe(options).filter(function (quality) {
          return _this5.config.quality.options.includes(quality);
        });
      } // Toggle the pane and tab


      var toggle = !is$1.empty(this.options.quality) && this.options.quality.length > 1;
      controls.toggleMenuButton.call(this, type, toggle); // Empty the menu

      emptyElement(list); // Check if we need to toggle the parent

      controls.checkMenu.call(this); // If we're hiding, nothing more to do

      if (!toggle) {
        return;
      } // Get the badge HTML for HD, 4K etc


      var getBadge = function getBadge(quality) {
        var label = i18n.get("qualityBadge.".concat(quality), _this5.config);

        if (!label.length) {
          return null;
        }

        return controls.createBadge.call(_this5, label);
      }; // Sort options by the config and then render options


      this.options.quality.sort(function (a, b) {
        var sorting = _this5.config.quality.options;
        return sorting.indexOf(a) > sorting.indexOf(b) ? 1 : -1;
      }).forEach(function (quality) {
        controls.createMenuItem.call(_this5, {
          value: quality,
          list: list,
          type: type,
          title: controls.getLabel.call(_this5, 'quality', quality),
          badge: getBadge(quality === 0 ? 'auto' : quality)
        });
      });
      controls.updateSetting.call(this, type, list);
    },
    // Set the looping options

    /* setLoopMenu() {
        // Menu required
        if (!is.element(this.elements.settings.panels.loop)) {
            return;
        }
         const options = ['start', 'end', 'all', 'reset'];
        const list = this.elements.settings.panels.loop.querySelector('[role="menu"]');
         // Show the pane and tab
        toggleHidden(this.elements.settings.buttons.loop, false);
        toggleHidden(this.elements.settings.panels.loop, false);
         // Toggle the pane and tab
        const toggle = !is.empty(this.loop.options);
        controls.toggleMenuButton.call(this, 'loop', toggle);
         // Empty the menu
        emptyElement(list);
         options.forEach(option => {
            const item = createElement('li');
             const button = createElement(
                'button',
                extend(getAttributesFromSelector(this.config.selectors.buttons.loop), {
                    type: 'button',
                    class: this.config.classNames.control,
                    'data-plyr-loop-action': option,
                }),
                i18n.get(option, this.config)
            );
             if (['start', 'end'].includes(option)) {
                const badge = controls.createBadge.call(this, '00:00');
                button.appendChild(badge);
            }
             item.appendChild(button);
            list.appendChild(item);
        });
    }, */
    // Get current selected caption language
    // TODO: rework this to user the getter in the API?
    // Set a list of available captions languages
    setCaptionsMenu: function setCaptionsMenu() {
      var _this6 = this;

      // Menu required
      if (!is$1.element(this.elements.settings.panels.captions)) {
        return;
      } // TODO: Captions or language? Currently it's mixed


      var type = 'captions';
      var list = this.elements.settings.panels.captions.querySelector('[role="menu"]');
      var tracks = captions.getTracks.call(this);
      var toggle = Boolean(tracks.length); // Toggle the pane and tab

      controls.toggleMenuButton.call(this, type, toggle); // Empty the menu

      emptyElement(list); // Check if we need to toggle the parent

      controls.checkMenu.call(this); // If there's no captions, bail

      if (!toggle) {
        return;
      } // Generate options data


      var options = tracks.map(function (track, value) {
        return {
          value: value,
          checked: _this6.captions.toggled && _this6.currentTrack === value,
          title: captions.getLabel.call(_this6, track),
          badge: track.language && controls.createBadge.call(_this6, track.language.toUpperCase()),
          list: list,
          type: 'language'
        };
      }); // Add the "Disabled" option to turn off captions

      options.unshift({
        value: -1,
        checked: !this.captions.toggled,
        title: i18n.get('disabled', this.config),
        list: list,
        type: 'language'
      }); // Generate options

      options.forEach(controls.createMenuItem.bind(this));
      controls.updateSetting.call(this, type, list);
    },
    // Set a list of available captions languages
    setSpeedMenu: function setSpeedMenu(options) {
      var _this7 = this;

      // Menu required
      if (!is$1.element(this.elements.settings.panels.speed)) {
        return;
      }

      var type = 'speed';
      var list = this.elements.settings.panels.speed.querySelector('[role="menu"]'); // Set the speed options

      if (is$1.array(options)) {
        this.options.speed = options;
      } else if (this.isHTML5 || this.isVimeo) {
        this.options.speed = [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];
      } // Set options if passed and filter based on config


      this.options.speed = this.options.speed.filter(function (speed) {
        return _this7.config.speed.options.includes(speed);
      }); // Toggle the pane and tab

      var toggle = !is$1.empty(this.options.speed) && this.options.speed.length > 1;
      controls.toggleMenuButton.call(this, type, toggle); // Empty the menu

      emptyElement(list); // Check if we need to toggle the parent

      controls.checkMenu.call(this); // If we're hiding, nothing more to do

      if (!toggle) {
        return;
      } // Create items


      this.options.speed.forEach(function (speed) {
        controls.createMenuItem.call(_this7, {
          value: speed,
          list: list,
          type: type,
          title: controls.getLabel.call(_this7, 'speed', speed)
        });
      });
      controls.updateSetting.call(this, type, list);
    },
    // Check if we need to hide/show the settings menu
    checkMenu: function checkMenu() {
      var buttons = this.elements.settings.buttons;
      var visible = !is$1.empty(buttons) && Object.values(buttons).some(function (button) {
        return !button.hidden;
      });
      toggleHidden(this.elements.settings.menu, !visible);
    },
    // Focus the first menu item in a given (or visible) menu
    focusFirstMenuItem: function focusFirstMenuItem(pane) {
      var tabFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.elements.settings.popup.hidden) {
        return;
      }

      var target = pane;

      if (!is$1.element(target)) {
        target = Object.values(this.elements.settings.panels).find(function (pane) {
          return !pane.hidden;
        });
      }

      var firstItem = target.querySelector('[role^="menuitem"]');
      setFocus.call(this, firstItem, tabFocus);
    },
    // Show/hide menu
    toggleMenu: function toggleMenu(input) {
      var popup = this.elements.settings.popup;
      var button = this.elements.buttons.settings; // Menu and button are required

      if (!is$1.element(popup) || !is$1.element(button)) {
        return;
      } // True toggle by default


      var hidden = popup.hidden;
      var show = hidden;

      if (is$1.boolean(input)) {
        show = input;
      } else if (is$1.keyboardEvent(input) && input.which === 27) {
        show = false;
      } else if (is$1.event(input)) {
        var isMenuItem = popup.contains(input.target); // If the click was inside the menu or if the click
        // wasn't the button or menu item and we're trying to
        // show the menu (a doc click shouldn't show the menu)

        if (isMenuItem || !isMenuItem && input.target !== button && show) {
          return;
        }
      } // Set button attributes


      button.setAttribute('aria-expanded', show); // Show the actual popup

      toggleHidden(popup, !show); // Add class hook

      toggleClass(this.elements.container, this.config.classNames.menu.open, show); // Focus the first item if key interaction

      if (show && is$1.keyboardEvent(input)) {
        controls.focusFirstMenuItem.call(this, null, true);
      } else if (!show && !hidden) {
        // If closing, re-focus the button
        setFocus.call(this, button, is$1.keyboardEvent(input));
      }
    },
    // Get the natural size of a menu panel
    getMenuSize: function getMenuSize(tab) {
      var clone = tab.cloneNode(true);
      clone.style.position = 'absolute';
      clone.style.opacity = 0;
      clone.removeAttribute('hidden'); // Append to parent so we get the "real" size

      tab.parentNode.appendChild(clone); // Get the sizes before we remove

      var width = clone.scrollWidth;
      var height = clone.scrollHeight; // Remove from the DOM

      removeElement(clone);
      return {
        width: width,
        height: height
      };
    },
    // Show a panel in the menu
    showMenuPanel: function showMenuPanel() {
      var _this8 = this;

      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var tabFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var target = document.getElementById("plyr-settings-".concat(this.id, "-").concat(type)); // Nothing to show, bail

      if (!is$1.element(target)) {
        return;
      } // Hide all other panels


      var container = target.parentNode;
      var current = Array.from(container.children).find(function (node) {
        return !node.hidden;
      }); // If we can do fancy animations, we'll animate the height/width

      if (support.transitions && !support.reducedMotion) {
        // Set the current width as a base
        container.style.width = "".concat(current.scrollWidth, "px");
        container.style.height = "".concat(current.scrollHeight, "px"); // Get potential sizes

        var size = controls.getMenuSize.call(this, target); // Restore auto height/width

        var restore = function restore(event) {
          // We're only bothered about height and width on the container
          if (event.target !== container || !['width', 'height'].includes(event.propertyName)) {
            return;
          } // Revert back to auto


          container.style.width = '';
          container.style.height = ''; // Only listen once

          off.call(_this8, container, transitionEndEvent, restore);
        }; // Listen for the transition finishing and restore auto height/width


        on.call(this, container, transitionEndEvent, restore); // Set dimensions to target

        container.style.width = "".concat(size.width, "px");
        container.style.height = "".concat(size.height, "px");
      } // Set attributes on current tab


      toggleHidden(current, true); // Set attributes on target

      toggleHidden(target, false); // Focus the first item

      controls.focusFirstMenuItem.call(this, target, tabFocus);
    },
    // Set the download link
    setDownloadLink: function setDownloadLink() {
      var button = this.elements.buttons.download; // Bail if no button

      if (!is$1.element(button)) {
        return;
      } // Set download link


      button.setAttribute('href', this.download);
    },
    // Build the default HTML
    // TODO: Set order based on order in the config.controls array?
    create: function create(data) {
      var _this9 = this;

      // Create the container
      var container = createElement('div', getAttributesFromSelector(this.config.selectors.controls.wrapper)); // Restart button

      if (this.config.controls.includes('restart')) {
        container.appendChild(controls.createButton.call(this, 'restart'));
      } // Rewind button


      if (this.config.controls.includes('rewind')) {
        container.appendChild(controls.createButton.call(this, 'rewind'));
      } // Play/Pause button


      if (this.config.controls.includes('play')) {
        container.appendChild(controls.createButton.call(this, 'play'));
      } // Fast forward button


      if (this.config.controls.includes('fast-forward')) {
        container.appendChild(controls.createButton.call(this, 'fast-forward'));
      } // Skip opening button


      if (this.config.controls.includes('skip-opening')) {
        container.appendChild(controls.createButton.call(this, 'skip-opening'));
      } // Progress


      if (this.config.controls.includes('progress')) {
        var progress = createElement('div', getAttributesFromSelector(this.config.selectors.progress)); // Seek range slider

        progress.appendChild(controls.createRange.call(this, 'seek', {
          id: "plyr-seek-".concat(data.id)
        })); // Buffer progress

        progress.appendChild(controls.createProgress.call(this, 'buffer')); // TODO: Add loop display indicator
        // Seek tooltip

        if (this.config.tooltips.seek) {
          var tooltip = createElement('span', {
            class: this.config.classNames.tooltip
          }, '00:00');
          progress.appendChild(tooltip);
          this.elements.display.seekTooltip = tooltip;
        }

        this.elements.progress = progress;
        container.appendChild(this.elements.progress);
      } // Media current time display


      if (this.config.controls.includes('current-time')) {
        container.appendChild(controls.createTime.call(this, 'currentTime'));
      } // Media duration display


      if (this.config.controls.includes('duration')) {
        container.appendChild(controls.createTime.call(this, 'duration'));
      } // Volume controls


      if (this.config.controls.includes('mute') || this.config.controls.includes('volume')) {
        var volume = createElement('div', {
          class: 'plyr__volume'
        }); // Toggle mute button

        if (this.config.controls.includes('mute')) {
          volume.appendChild(controls.createButton.call(this, 'mute'));
        } // Volume range control


        if (this.config.controls.includes('volume')) {
          // Set the attributes
          var attributes = {
            max: 1,
            step: 0.05,
            value: this.config.volume
          }; // Create the volume range slider

          volume.appendChild(controls.createRange.call(this, 'volume', extend(attributes, {
            id: "plyr-volume-".concat(data.id)
          })));
          this.elements.volume = volume;
        }

        container.appendChild(volume);
      } // Toggle captions button


      if (this.config.controls.includes('captions')) {
        container.appendChild(controls.createButton.call(this, 'captions'));
      } // P2P button


      if (this.config.controls.includes('p2p') && this.config.listeners.p2p !== null) {
        container.appendChild(controls.createButton.call(this, 'p2p'));
      } // Settings button / menu


      if (this.config.controls.includes('settings') && !is$1.empty(this.config.settings)) {
        var control = createElement('div', {
          class: 'plyr__menu',
          hidden: ''
        });
        control.appendChild(controls.createButton.call(this, 'settings', {
          'aria-haspopup': true,
          'aria-controls': "plyr-settings-".concat(data.id),
          'aria-expanded': false
        }));
        var popup = createElement('div', {
          class: 'plyr__menu__container',
          id: "plyr-settings-".concat(data.id),
          hidden: ''
        });
        var inner = createElement('div');
        var home = createElement('div', {
          id: "plyr-settings-".concat(data.id, "-home")
        }); // Create the menu

        var menu = createElement('div', {
          role: 'menu'
        });
        home.appendChild(menu);
        inner.appendChild(home);
        this.elements.settings.panels.home = home; // Build the menu items

        this.config.settings.forEach(function (type) {
          // TODO: bundle this with the createMenuItem helper and bindings
          var menuItem = createElement('button', extend(getAttributesFromSelector(_this9.config.selectors.buttons.settings), {
            type: 'button',
            class: "".concat(_this9.config.classNames.control, " ").concat(_this9.config.classNames.control, "--forward"),
            role: 'menuitem',
            'aria-haspopup': true,
            hidden: ''
          })); // Bind menu shortcuts for keyboard users

          controls.bindMenuItemShortcuts.call(_this9, menuItem, type); // Show menu on click

          on(menuItem, 'click', function () {
            controls.showMenuPanel.call(_this9, type, false);
          });
          var flex = createElement('span', null, i18n.get(type, _this9.config));
          var value = createElement('span', {
            class: _this9.config.classNames.menu.value
          }); // Speed contains HTML entities

          value.innerHTML = data[type];
          flex.appendChild(value);
          menuItem.appendChild(flex);
          menu.appendChild(menuItem); // Build the panes

          var pane = createElement('div', {
            id: "plyr-settings-".concat(data.id, "-").concat(type),
            hidden: ''
          }); // Back button

          var backButton = createElement('button', {
            type: 'button',
            class: "".concat(_this9.config.classNames.control, " ").concat(_this9.config.classNames.control, "--back")
          }); // Visible label

          backButton.appendChild(createElement('span', {
            'aria-hidden': true
          }, i18n.get(type, _this9.config))); // Screen reader label

          backButton.appendChild(createElement('span', {
            class: _this9.config.classNames.hidden
          }, i18n.get('menuBack', _this9.config))); // Go back via keyboard

          on(pane, 'keydown', function (event) {
            // We only care about <-
            if (event.which !== 37) {
              return;
            } // Prevent seek


            event.preventDefault();
            event.stopPropagation(); // Show the respective menu

            controls.showMenuPanel.call(_this9, 'home', true);
          }, false); // Go back via button click

          on(backButton, 'click', function () {
            controls.showMenuPanel.call(_this9, 'home', false);
          }); // Add to pane

          pane.appendChild(backButton); // Menu

          pane.appendChild(createElement('div', {
            role: 'menu'
          }));
          inner.appendChild(pane);
          _this9.elements.settings.buttons[type] = menuItem;
          _this9.elements.settings.panels[type] = pane;
        });
        popup.appendChild(inner);
        control.appendChild(popup);
        container.appendChild(control);
        this.elements.settings.popup = popup;
        this.elements.settings.menu = control;
      } // Picture in picture button


      if (this.config.controls.includes('pip') && support.pip) {
        container.appendChild(controls.createButton.call(this, 'pip'));
      } // Airplay button


      if (this.config.controls.includes('airplay') && support.airplay) {
        container.appendChild(controls.createButton.call(this, 'airplay'));
      } // Download button


      if (this.config.controls.includes('download')) {
        var _attributes = {
          element: 'a',
          href: this.download,
          target: '_blank'
        };
        var download = this.config.urls.download;

        if (!is$1.url(download) && this.isEmbed) {
          extend(_attributes, {
            icon: "logo-".concat(this.provider),
            label: this.provider
          });
        }

        container.appendChild(controls.createButton.call(this, 'download', _attributes));
      } // Toggle fullscreen button


      if (this.config.controls.includes('fullscreen')) {
        container.appendChild(controls.createButton.call(this, 'fullscreen'));
      } // Larger overlaid play button


      if (this.config.controls.includes('play-large')) {
        this.elements.container.appendChild(controls.createButton.call(this, 'play-large'));
      }

      this.elements.controls = container; // Set available quality levels

      if (this.isHTML5) {
        controls.setQualityMenu.call(this, html5.getQualityOptions.call(this));
      }

      controls.setSpeedMenu.call(this);
      return container;
    },
    // Insert controls
    inject: function inject() {
      var _this10 = this;

      // Sprite
      if (this.config.loadSprite) {
        var icon = controls.getIconUrl.call(this); // Only load external sprite using AJAX

        if (icon.cors) {
          loadSprite(icon.url, 'sprite-plyr');
        }
      } // Create a unique ID


      this.id = Math.floor(Math.random() * 10000); // Null by default

      var container = null;
      this.elements.controls = null; // Set template properties

      var props = {
        id: this.id,
        seektime: this.config.seekTime,
        title: this.config.title
      };
      var update = true; // If function, run it and use output

      if (is$1.function(this.config.controls)) {
        this.config.controls = this.config.controls.call(this, props);
      } // Convert falsy controls to empty array (primarily for empty strings)


      if (!this.config.controls) {
        this.config.controls = [];
      }

      if (is$1.element(this.config.controls) || is$1.string(this.config.controls)) {
        // HTMLElement or Non-empty string passed as the option
        container = this.config.controls;
      } else {
        // Create controls
        container = controls.create.call(this, {
          id: this.id,
          seektime: this.config.seekTime,
          speed: this.speed,
          quality: this.quality,
          captions: captions.getLabel.call(this) // TODO: Looping
          // loop: 'None',

        });
        update = false;
      } // Replace props with their value


      var replace = function replace(input) {
        var result = input;
        Object.entries(props).forEach(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              key = _ref3[0],
              value = _ref3[1];

          result = replaceAll(result, "{".concat(key, "}"), value);
        });
        return result;
      }; // Update markup


      if (update) {
        if (is$1.string(this.config.controls)) {
          container = replace(container);
        } else if (is$1.element(container)) {
          container.innerHTML = replace(container.innerHTML);
        }
      } // Controls container


      var target; // Inject to custom location

      if (is$1.string(this.config.selectors.controls.container)) {
        target = document.querySelector(this.config.selectors.controls.container);
      } // Inject into the container by default


      if (!is$1.element(target)) {
        target = this.elements.container;
      } // Inject controls HTML (needs to be before captions, hence "afterbegin")


      var insertMethod = is$1.element(container) ? 'insertAdjacentElement' : 'insertAdjacentHTML';
      target[insertMethod]('afterbegin', container); // Find the elements if need be

      if (!is$1.element(this.elements.controls)) {
        controls.findElements.call(this);
      } // Add pressed property to buttons


      if (!is$1.empty(this.elements.buttons)) {
        var addProperty = function addProperty(button) {
          var className = _this10.config.classNames.controlPressed;
          Object.defineProperty(button, 'pressed', {
            enumerable: true,
            get: function get() {
              return hasClass(button, className);
            },
            set: function set() {
              var pressed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              toggleClass(button, className, pressed);
            }
          });
        }; // Toggle classname when pressed property is set


        Object.values(this.elements.buttons).filter(Boolean).forEach(function (button) {
          if (is$1.array(button) || is$1.nodeList(button)) {
            Array.from(button).filter(Boolean).forEach(addProperty);
          } else {
            addProperty(button);
          }
        });
      } // Edge sometimes doesn't finish the paint so force a repaint


      if (browser.isEdge) {
        repaint(target);
      } // Setup tooltips


      if (this.config.tooltips.controls) {
        var _this$config = this.config,
            classNames = _this$config.classNames,
            selectors = _this$config.selectors;
        var selector = "".concat(selectors.controls.wrapper, " ").concat(selectors.labels, " .").concat(classNames.hidden);
        var labels = getElements.call(this, selector);
        Array.from(labels).forEach(function (label) {
          toggleClass(label, _this10.config.classNames.hidden, false);
          toggleClass(label, _this10.config.classNames.tooltip, true);
        });
      }
    }
  };

  /**
   * Parse a string to a URL object
   * @param {String} input - the URL to be parsed
   * @param {Boolean} safe - failsafe parsing
   */

  function parseUrl(input) {
    var safe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var url = input;

    if (safe) {
      var parser = document.createElement('a');
      parser.href = url;
      url = parser.href;
    }

    try {
      return new URL(url);
    } catch (e) {
      return null;
    }
  } // Convert object to URLSearchParams

  function buildUrlParams(input) {
    var params = new URLSearchParams();

    if (is$1.object(input)) {
      Object.entries(input).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        params.set(key, value);
      });
    }

    return params;
  }

  var captions = {
    // Setup captions
    setup: function setup() {
      // Requires UI support
      if (!this.supported.ui) {
        return;
      } // Only Vimeo and HTML5 video supported at this point


      if (!this.isVideo || this.isYouTube || this.isHTML5 && !support.textTracks) {
        // Clear menu and hide
        if (is$1.array(this.config.controls) && this.config.controls.includes('settings') && this.config.settings.includes('captions')) {
          controls.setCaptionsMenu.call(this);
        }

        return;
      } // Inject the container


      if (!is$1.element(this.elements.captions)) {
        this.elements.captions = createElement('div', getAttributesFromSelector(this.config.selectors.captions));
        insertAfter(this.elements.captions, this.elements.wrapper);
      } // Fix IE captions if CORS is used
      // Fetch captions and inject as blobs instead (data URIs not supported!)


      if (browser.isIE && window.URL) {
        var elements = this.media.querySelectorAll('track');
        Array.from(elements).forEach(function (track) {
          var src = track.getAttribute('src');
          var url = parseUrl(src);

          if (url !== null && url.hostname !== window.location.href.hostname && ['http:', 'https:'].includes(url.protocol)) {
            fetch$1(src, 'blob').then(function (blob) {
              track.setAttribute('src', window.URL.createObjectURL(blob));
            }).catch(function () {
              removeElement(track);
            });
          }
        });
      } // Get and set initial data
      // The "preferred" options are not realized unless / until the wanted language has a match
      // * languages: Array of user's browser languages.
      // * language:  The language preferred by user settings or config
      // * active:    The state preferred by user settings or config
      // * toggled:   The real captions state


      var browserLanguages = navigator.languages || [navigator.language || navigator.userLanguage || 'en'];
      var languages = dedupe(browserLanguages.map(function (language) {
        return language.split('-')[0];
      }));
      var language = (this.storage.get('language') || this.config.captions.language || 'auto').toLowerCase(); // Use first browser language when language is 'auto'

      if (language === 'auto') {
        var _languages = _slicedToArray(languages, 1);

        language = _languages[0];
      }

      var active = this.storage.get('captions');

      if (!is$1.boolean(active)) {
        active = this.config.captions.active;
      }

      Object.assign(this.captions, {
        toggled: false,
        active: active,
        language: language,
        languages: languages
      }); // Watch changes to textTracks and update captions menu

      if (this.isHTML5) {
        var trackEvents = this.config.captions.update ? 'addtrack removetrack' : 'removetrack';
        on.call(this, this.media.textTracks, trackEvents, captions.update.bind(this));
      } // Update available languages in list next tick (the event must not be triggered before the listeners)


      setTimeout(captions.update.bind(this), 0);
    },
    // Update available language options in settings based on tracks
    update: function update() {
      var _this = this;

      var tracks = captions.getTracks.call(this, true); // Get the wanted language

      var _this$captions = this.captions,
          active = _this$captions.active,
          language = _this$captions.language,
          meta = _this$captions.meta,
          currentTrackNode = _this$captions.currentTrackNode;
      var languageExists = Boolean(tracks.find(function (track) {
        return track.language === language;
      })); // Handle tracks (add event listener and "pseudo"-default)

      if (this.isHTML5 && this.isVideo) {
        tracks.filter(function (track) {
          return !meta.get(track);
        }).forEach(function (track) {
          _this.debug.log('Track added', track); // Attempt to store if the original dom element was "default"


          meta.set(track, {
            default: track.mode === 'showing'
          }); // Turn off native caption rendering to avoid double captions

          track.mode = 'hidden'; // Add event listener for cue changes

          on.call(_this, track, 'cuechange', function () {
            return captions.updateCues.call(_this);
          });
        });
      } // Update language first time it matches, or if the previous matching track was removed


      if (languageExists && this.language !== language || !tracks.includes(currentTrackNode)) {
        captions.setLanguage.call(this, language);
        captions.toggle.call(this, active && languageExists);
      } // Enable or disable captions based on track length


      toggleClass(this.elements.container, this.config.classNames.captions.enabled, !is$1.empty(tracks)); // Update available languages in list

      if ((this.config.controls || []).includes('settings') && this.config.settings.includes('captions')) {
        controls.setCaptionsMenu.call(this);
      }
    },
    // Toggle captions display
    // Used internally for the toggleCaptions method, with the passive option forced to false
    toggle: function toggle(input) {
      var passive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      // If there's no full support
      if (!this.supported.ui) {
        return;
      }

      var toggled = this.captions.toggled; // Current state

      var activeClass = this.config.classNames.captions.active; // Get the next state
      // If the method is called without parameter, toggle based on current value

      var active = is$1.nullOrUndefined(input) ? !toggled : input; // Update state and trigger event

      if (active !== toggled) {
        // When passive, don't override user preferences
        if (!passive) {
          this.captions.active = active;
          this.storage.set({
            captions: active
          });
        } // Force language if the call isn't passive and there is no matching language to toggle to


        if (!this.language && active && !passive) {
          var tracks = captions.getTracks.call(this);
          var track = captions.findTrack.call(this, [this.captions.language].concat(_toConsumableArray(this.captions.languages)), true); // Override user preferences to avoid switching languages if a matching track is added

          this.captions.language = track.language; // Set caption, but don't store in localStorage as user preference

          captions.set.call(this, tracks.indexOf(track));
          return;
        } // Toggle button if it's enabled


        if (this.elements.buttons.captions) {
          this.elements.buttons.captions.pressed = active;
        } // Add class hook


        toggleClass(this.elements.container, activeClass, active);
        this.captions.toggled = active; // Update settings menu

        controls.updateSetting.call(this, 'captions'); // Trigger event (not used internally)

        triggerEvent.call(this, this.media, active ? 'captionsenabled' : 'captionsdisabled');
      }
    },
    // Set captions by track index
    // Used internally for the currentTrack setter with the passive option forced to false
    set: function set(index) {
      var passive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var tracks = captions.getTracks.call(this); // Disable captions if setting to -1

      if (index === -1) {
        captions.toggle.call(this, false, passive);
        return;
      }

      if (!is$1.number(index)) {
        this.debug.warn('Invalid caption argument', index);
        return;
      }

      if (!(index in tracks)) {
        this.debug.warn('Track not found', index);
        return;
      }

      if (this.captions.currentTrack !== index) {
        this.captions.currentTrack = index;
        var track = tracks[index];

        var _ref = track || {},
            language = _ref.language; // Store reference to node for invalidation on remove


        this.captions.currentTrackNode = track; // Update settings menu

        controls.updateSetting.call(this, 'captions'); // When passive, don't override user preferences

        if (!passive) {
          this.captions.language = language;
          this.storage.set({
            language: language
          });
        } // Handle Vimeo captions


        if (this.isVimeo) {
          this.embed.enableTextTrack(language);
        } // Trigger event


        triggerEvent.call(this, this.media, 'languagechange');
      } // Show captions


      captions.toggle.call(this, true, passive);

      if (this.isHTML5 && this.isVideo) {
        // If we change the active track while a cue is already displayed we need to update it
        captions.updateCues.call(this);
      }
    },
    // Set captions by language
    // Used internally for the language setter with the passive option forced to false
    setLanguage: function setLanguage(input) {
      var passive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (!is$1.string(input)) {
        this.debug.warn('Invalid language argument', input);
        return;
      } // Normalize


      var language = input.toLowerCase();
      this.captions.language = language; // Set currentTrack

      var tracks = captions.getTracks.call(this);
      var track = captions.findTrack.call(this, [language]);
      captions.set.call(this, tracks.indexOf(track), passive);
    },
    // Get current valid caption tracks
    // If update is false it will also ignore tracks without metadata
    // This is used to "freeze" the language options when captions.update is false
    getTracks: function getTracks() {
      var _this2 = this;

      var update = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      // Handle media or textTracks missing or null
      var tracks = Array.from((this.media || {}).textTracks || []); // For HTML5, use cache instead of current tracks when it exists (if captions.update is false)
      // Filter out removed tracks and tracks that aren't captions/subtitles (for example metadata)

      return tracks.filter(function (track) {
        return !_this2.isHTML5 || update || _this2.captions.meta.has(track);
      }).filter(function (track) {
        return ['captions', 'subtitles'].includes(track.kind);
      });
    },
    // Match tracks based on languages and get the first
    findTrack: function findTrack(languages) {
      var _this3 = this;

      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var tracks = captions.getTracks.call(this);

      var sortIsDefault = function sortIsDefault(track) {
        return Number((_this3.captions.meta.get(track) || {}).default);
      };

      var sorted = Array.from(tracks).sort(function (a, b) {
        return sortIsDefault(b) - sortIsDefault(a);
      });
      var track;
      languages.every(function (language) {
        track = sorted.find(function (track) {
          return track.language === language;
        });
        return !track; // Break iteration if there is a match
      }); // If no match is found but is required, get first

      return track || (force ? sorted[0] : undefined);
    },
    // Get the current track
    getCurrentTrack: function getCurrentTrack() {
      return captions.getTracks.call(this)[this.currentTrack];
    },
    // Get UI label for track
    getLabel: function getLabel(track) {
      var currentTrack = track;

      if (!is$1.track(currentTrack) && support.textTracks && this.captions.toggled) {
        currentTrack = captions.getCurrentTrack.call(this);
      }

      if (is$1.track(currentTrack)) {
        if (!is$1.empty(currentTrack.label)) {
          return currentTrack.label;
        }

        if (!is$1.empty(currentTrack.language)) {
          return track.language.toUpperCase();
        }

        return i18n.get('enabled', this.config);
      }

      return i18n.get('disabled', this.config);
    },
    // Update captions using current track's active cues
    // Also optional array argument in case there isn't any track (ex: vimeo)
    updateCues: function updateCues(input) {
      // Requires UI
      if (!this.supported.ui) {
        return;
      }

      if (!is$1.element(this.elements.captions)) {
        this.debug.warn('No captions element to render to');
        return;
      } // Only accept array or empty input


      if (!is$1.nullOrUndefined(input) && !Array.isArray(input)) {
        this.debug.warn('updateCues: Invalid input', input);
        return;
      }

      var cues = input; // Get cues from track

      if (!cues) {
        var track = captions.getCurrentTrack.call(this);
        cues = Array.from((track || {}).activeCues || []).map(function (cue) {
          return cue.getCueAsHTML();
        }).map(getHTML);
      } // Set new caption text


      var content = cues.map(function (cueText) {
        return cueText.trim();
      }).join('\n');
      var changed = content !== this.elements.captions.innerHTML;

      if (changed) {
        // Empty the container and create a new child element
        emptyElement(this.elements.captions);
        var caption = createElement('span', getAttributesFromSelector(this.config.selectors.caption));
        caption.innerHTML = content;
        this.elements.captions.appendChild(caption); // Trigger event

        triggerEvent.call(this, this.media, 'cuechange');
      }
    }
  };

  // ==========================================================================
  // Plyr states
  // ==========================================================================
  var pip = {
    active: 'picture-in-picture',
    inactive: 'inline'
  };

  // ==========================================================================
  // Plyr supported types and providers
  // ==========================================================================
  var providers = {
    html5: 'html5',
    youtube: 'youtube',
    vimeo: 'vimeo'
  };
  var types = {
    audio: 'audio',
    video: 'video'
  };
  /**
   * Get provider by URL
   * @param {String} url
   */

  function getProviderByUrl(url) {
    // YouTube
    if (/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(url)) {
      return providers.youtube;
    } // Vimeo


    if (/^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(url)) {
      return providers.vimeo;
    }

    return null;
  }

  var Console =
  /*#__PURE__*/
  function () {
    function Console() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      _classCallCheck(this, Console);

      this.enabled = window.console && enabled;

      if (this.enabled) {
        this.log('Debugging enabled');
      }
    }

    _createClass(Console, [{
      key: "log",
      value: function log() {
        if (this.enabled) {
          var _console;

          for (var _len = arguments.length, any = new Array(_len), _key = 0; _key < _len; _key++) {
            any[_key] = arguments[_key];
          }

          // eslint-disable-next-line no-console
          (_console = console).log.apply(_console, _toConsumableArray(this.format('debug', any)));
        }
      }
    }, {
      key: "warn",
      value: function warn() {
        if (this.enabled) {
          var _console2;

          for (var _len2 = arguments.length, any = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            any[_key2] = arguments[_key2];
          }

          // eslint-disable-next-line no-console
          (_console2 = console).warn.apply(_console2, _toConsumableArray(this.format('warn', any)));
        }
      }
    }, {
      key: "error",
      value: function error() {
        if (this.enabled) {
          var _console3;

          for (var _len3 = arguments.length, any = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            any[_key3] = arguments[_key3];
          }

          // eslint-disable-next-line no-console
          (_console3 = console).error.apply(_console3, _toConsumableArray(this.format('error', any)));
        }
      } // eslint-disable-next-line class-methods-use-this

    }, {
      key: "format",
      value: function format(level, any) {
        return ["".concat(new Date().toISOString(), " Player [").concat(level.toUpperCase(), "]:")].concat(_toConsumableArray(any));
      }
    }]);

    return Console;
  }();

  function onChange() {
    if (!this.enabled) {
      return;
    } // Update toggle button


    var button = this.player.elements.buttons.fullscreen;

    if (is$1.element(button)) {
      button.pressed = this.active;
    } // Trigger an event


    triggerEvent.call(this.player, this.target, this.active ? 'enterfullscreen' : 'exitfullscreen', true); // Trap focus in container

    if (!browser.isIos) {
      trapFocus.call(this.player, this.target, this.active);
    }
  }

  function toggleFallback() {
    var _this = this;

    var toggle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    // Store or restore scroll position
    if (toggle) {
      this.scrollPosition = {
        x: window.scrollX || 0,
        y: window.scrollY || 0
      };
    } else {
      window.scrollTo(this.scrollPosition.x, this.scrollPosition.y);
    } // Toggle scroll


    document.body.style.overflow = toggle ? 'hidden' : ''; // Toggle class hook

    toggleClass(this.target, this.player.config.classNames.fullscreen.fallback, toggle); // Force full viewport on iPhone X+

    if (browser.isIos) {
      var viewport = document.head.querySelector('meta[name="viewport"]');
      var property = 'viewport-fit=cover'; // Inject the viewport meta if required

      if (!viewport) {
        viewport = document.createElement('meta');
        viewport.setAttribute('name', 'viewport');
      } // Check if the property already exists


      var hasProperty = is$1.string(viewport.content) && viewport.content.includes(property);

      if (toggle) {
        this.cleanupViewport = !hasProperty;

        if (!hasProperty) {
          viewport.content += ",".concat(property);
        }
      } else if (this.cleanupViewport) {
        viewport.content = viewport.content.split(',').filter(function (part) {
          return part.trim() !== property;
        }).join(',');
      } // Force a repaint as sometimes Safari doesn't want to fill the screen


      setTimeout(function () {
        return repaint(_this.target);
      }, 100);
    } // Toggle button and fire events


    onChange.call(this);
  }

  var Fullscreen =
  /*#__PURE__*/
  function () {
    function Fullscreen(player) {
      var _this2 = this;

      _classCallCheck(this, Fullscreen);

      // Keep reference to parent
      this.player = player; // Get prefix

      this.prefix = Fullscreen.prefix;
      this.property = Fullscreen.property; // Scroll position

      this.scrollPosition = {
        x: 0,
        y: 0
      }; // Force the use of 'full window/browser' rather than fullscreen

      this.forceFallback = player.config.fullscreen.fallback === 'force'; // Register event listeners
      // Handle event (incase user presses escape etc)

      on.call(this.player, document, this.prefix === 'ms' ? 'MSFullscreenChange' : "".concat(this.prefix, "fullscreenchange"), function () {
        // TODO: Filter for target??
        onChange.call(_this2);
      }); // Fullscreen toggle on double click

      on.call(this.player, this.player.elements.container, 'dblclick', function (event) {
        // Ignore double click in controls
        if (is$1.element(_this2.player.elements.controls) && _this2.player.elements.controls.contains(event.target)) {
          return;
        }

        _this2.toggle();
      }); // Update the UI

      this.update();
    } // Determine if native supported


    _createClass(Fullscreen, [{
      key: "update",
      // Update UI
      value: function update() {
        if (this.enabled) {
          var mode;

          if (this.forceFallback) {
            mode = 'Fallback (forced)';
          } else if (Fullscreen.native) {
            mode = 'Native';
          } else {
            mode = 'Fallback';
          }

          this.player.debug.log("".concat(mode, " fullscreen enabled"));
        } else {
          this.player.debug.log('Fullscreen not supported and fallback disabled');
        } // Add styling hook to show button


        toggleClass(this.player.elements.container, this.player.config.classNames.fullscreen.enabled, this.enabled);
      } // Make an element fullscreen

    }, {
      key: "enter",
      value: function enter() {
        if (!this.enabled) {
          return;
        } // iOS native fullscreen doesn't need the request step


        if (browser.isIos && this.player.config.fullscreen.iosNative) {
          this.target.webkitEnterFullscreen();
        } else if (!Fullscreen.native || this.forceFallback) {
          toggleFallback.call(this, true);
        } else if (!this.prefix) {
          this.target.requestFullscreen();
        } else if (!is$1.empty(this.prefix)) {
          this.target["".concat(this.prefix, "Request").concat(this.property)]();
        }
      } // Bail from fullscreen

    }, {
      key: "exit",
      value: function exit() {
        if (!this.enabled) {
          return;
        } // iOS native fullscreen


        if (browser.isIos && this.player.config.fullscreen.iosNative) {
          this.target.webkitExitFullscreen();
          this.player.play();
        } else if (!Fullscreen.native || this.forceFallback) {
          toggleFallback.call(this, false);
        } else if (!this.prefix) {
          (document.cancelFullScreen || document.exitFullscreen).call(document);
        } else if (!is$1.empty(this.prefix)) {
          var action = this.prefix === 'moz' ? 'Cancel' : 'Exit';
          document["".concat(this.prefix).concat(action).concat(this.property)]();
        }
      } // Toggle state

    }, {
      key: "toggle",
      value: function toggle() {
        if (!this.active) {
          this.enter();
        } else {
          this.exit();
        } // Blur active element


        document.activeElement.blur();
      }
    }, {
      key: "usingNative",
      // If we're actually using native
      get: function get() {
        return Fullscreen.native && !this.forceFallback;
      } // Get the prefix for handlers

    }, {
      key: "enabled",
      // Determine if fullscreen is enabled
      get: function get() {
        return (Fullscreen.native || this.player.config.fullscreen.fallback) && this.player.config.fullscreen.enabled && this.player.supported.ui && this.player.isVideo;
      } // Get active state

    }, {
      key: "active",
      get: function get() {
        if (!this.enabled) {
          return false;
        } // Fallback using classname


        if (!Fullscreen.native || this.forceFallback) {
          return hasClass(this.target, this.player.config.classNames.fullscreen.fallback);
        }

        var element = !this.prefix ? document.fullscreenElement : document["".concat(this.prefix).concat(this.property, "Element")];
        return element === this.target;
      } // Get target element

    }, {
      key: "target",
      get: function get() {
        return browser.isIos && this.player.config.fullscreen.iosNative ? this.player.media : this.player.elements.container;
      }
    }], [{
      key: "native",
      get: function get() {
        return !!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled);
      }
    }, {
      key: "prefix",
      get: function get() {
        // No prefix
        if (is$1.function(document.exitFullscreen)) {
          return '';
        } // Check for fullscreen support by vendor prefix


        var value = '';
        var prefixes = ['webkit', 'moz', 'ms'];
        prefixes.some(function (pre) {
          if (is$1.function(document["".concat(pre, "ExitFullscreen")]) || is$1.function(document["".concat(pre, "CancelFullScreen")])) {
            value = pre;
            return true;
          }

          return false;
        });
        return value;
      }
    }, {
      key: "property",
      get: function get() {
        return this.prefix === 'moz' ? 'FullScreen' : 'Fullscreen';
      }
    }]);

    return Fullscreen;
  }();

  // ==========================================================================
  // Load image avoiding xhr/fetch CORS issues
  // Server status can't be obtained this way unfortunately, so this uses "naturalWidth" to determine if the image has loaded
  // By default it checks if it is at least 1px, but you can add a second argument to change this
  // ==========================================================================
  function loadImage(src) {
    var minWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return new Promise(function (resolve, reject) {
      var image = new Image();

      var handler = function handler() {
        delete image.onload;
        delete image.onerror;
        (image.naturalWidth >= minWidth ? resolve : reject)(image);
      };

      Object.assign(image, {
        onload: handler,
        onerror: handler,
        src: src
      });
    });
  }

  // ==========================================================================
  var ui = {
    addStyleHook: function addStyleHook() {
      toggleClass(this.elements.container, this.config.selectors.container.replace('.', ''), true);
      toggleClass(this.elements.container, this.config.classNames.uiSupported, this.supported.ui);
    },
    // Toggle native HTML5 media controls
    toggleNativeControls: function toggleNativeControls() {
      var toggle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (toggle && this.isHTML5) {
        this.media.setAttribute('controls', '');
      } else {
        this.media.removeAttribute('controls');
      }
    },
    // Setup the UI
    build: function build() {
      var _this = this;

      // Re-attach media element listeners
      // TODO: Use event bubbling?
      this.listeners.media(); // Don't setup interface if no support

      if (!this.supported.ui) {
        this.debug.warn("Basic support only for ".concat(this.provider, " ").concat(this.type)); // Restore native controls

        ui.toggleNativeControls.call(this, true); // Bail

        return;
      } // Inject custom controls if not present


      if (!is$1.element(this.elements.controls)) {
        // Inject custom controls
        controls.inject.call(this); // Re-attach control listeners

        this.listeners.controls();
      } // Remove native controls


      ui.toggleNativeControls.call(this); // Setup captions for HTML5

      if (this.isHTML5) {
        captions.setup.call(this);
      } // Reset volume


      this.volume = null; // Reset mute state

      this.muted = null; // Reset speed

      this.speed = null; // Reset loop state

      this.loop = null; // Reset quality setting

      this.quality = null; // Reset volume display

      controls.updateVolume.call(this); // Reset time display

      controls.timeUpdate.call(this); // Update the UI

      ui.checkPlaying.call(this); // Check for picture-in-picture support

      toggleClass(this.elements.container, this.config.classNames.pip.supported, support.pip && this.isHTML5 && this.isVideo); // Check for airplay support

      toggleClass(this.elements.container, this.config.classNames.airplay.supported, support.airplay && this.isHTML5); // Add iOS class

      toggleClass(this.elements.container, this.config.classNames.isIos, browser.isIos); // Add touch class

      toggleClass(this.elements.container, this.config.classNames.isTouch, this.touch); // Ready for API calls

      this.ready = true; // Ready event at end of execution stack

      setTimeout(function () {
        triggerEvent.call(_this, _this.media, 'ready');
      }, 0); // Set the title

      ui.setTitle.call(this); // Assure the poster image is set, if the property was added before the element was created

      if (this.poster) {
        ui.setPoster.call(this, this.poster, false).catch(function () {});
      } // Manually set the duration if user has overridden it.
      // The event listeners for it doesn't get called if preload is disabled (#701)


      if (this.config.duration) {
        controls.durationUpdate.call(this);
      }
    },
    // Setup aria attribute for play and iframe title
    setTitle: function setTitle() {
      // Find the current text
      var label = i18n.get('play', this.config); // If there's a media title set, use that for the label

      if (is$1.string(this.config.title) && !is$1.empty(this.config.title)) {
        label += ", ".concat(this.config.title);
      } // If there's a play button, set label


      Array.from(this.elements.buttons.play || []).forEach(function (button) {
        button.setAttribute('aria-label', label);
      }); // Set iframe title
      // https://github.com/sampotts/plyr/issues/124

      if (this.isEmbed) {
        var iframe = getElement.call(this, 'iframe');

        if (!is$1.element(iframe)) {
          return;
        } // Default to media type


        var title = !is$1.empty(this.config.title) ? this.config.title : 'video';
        var format = i18n.get('frameTitle', this.config);
        iframe.setAttribute('title', format.replace('{title}', title));
      }
    },
    // Toggle poster
    togglePoster: function togglePoster(enable) {
      toggleClass(this.elements.container, this.config.classNames.posterEnabled, enable);
    },
    // Set the poster image (async)
    // Used internally for the poster setter, with the passive option forced to false
    setPoster: function setPoster(poster) {
      var _this2 = this;

      var passive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      // Don't override if call is passive
      if (passive && this.poster) {
        return Promise.reject(new Error('Poster already set'));
      } // Set property synchronously to respect the call order


      this.media.setAttribute('poster', poster); // Wait until ui is ready

      return ready.call(this) // Load image
      .then(function () {
        return loadImage(poster);
      }).catch(function (err) {
        // Hide poster on error unless it's been set by another call
        if (poster === _this2.poster) {
          ui.togglePoster.call(_this2, false);
        } // Rethrow


        throw err;
      }).then(function () {
        // Prevent race conditions
        if (poster !== _this2.poster) {
          throw new Error('setPoster cancelled by later call to setPoster');
        }
      }).then(function () {
        Object.assign(_this2.elements.poster.style, {
          backgroundImage: "url('".concat(poster, "')"),
          // Reset backgroundSize as well (since it can be set to "cover" for padded thumbnails for youtube)
          backgroundSize: ''
        });
        ui.togglePoster.call(_this2, true);
        return poster;
      });
    },
    // Check playing state
    checkPlaying: function checkPlaying(event) {
      var _this3 = this;

      // Class hooks
      toggleClass(this.elements.container, this.config.classNames.playing, this.playing);
      toggleClass(this.elements.container, this.config.classNames.paused, this.paused);
      toggleClass(this.elements.container, this.config.classNames.stopped, this.stopped); // Set state

      Array.from(this.elements.buttons.play || []).forEach(function (target) {
        target.pressed = _this3.playing;
      }); // Only update controls on non timeupdate events

      if (is$1.event(event) && event.type === 'timeupdate') {
        return;
      } // Toggle controls


      ui.toggleControls.call(this);
    },
    // Check if media is loading
    checkLoading: function checkLoading(event) {
      var _this4 = this;

      this.loading = ['stalled', 'waiting'].includes(event.type); // Clear timer

      clearTimeout(this.timers.loading); // Timer to prevent flicker when seeking

      this.timers.loading = setTimeout(function () {
        // Update progress bar loading class state
        toggleClass(_this4.elements.container, _this4.config.classNames.loading, _this4.loading); // Update controls visibility

        ui.toggleControls.call(_this4);
      }, this.loading ? 250 : 0);
    },
    // Toggle controls based on state and `force` argument
    toggleControls: function toggleControls(force) {
      var controls$$1 = this.elements.controls;

      if (controls$$1 && this.config.hideControls) {
        // Don't hide controls if a touch-device user recently seeked. (Must be limited to touch devices, or it occasionally prevents desktop controls from hiding.)
        var recentTouchSeek = this.touch && this.lastSeekTime + 2000 > Date.now(); // Show controls if force, loading, paused, button interaction, or recent seek, otherwise hide

        this.toggleControls(Boolean(force || this.loading || this.paused || controls$$1.pressed || controls$$1.hover || recentTouchSeek));
      }
    }
  };

  /* function reduceAspectRatio(width, height) {
      const getRatio = (w, h) => (h === 0 ? w : getRatio(h, w % h));
      const ratio = getRatio(width, height);
      return `${width / ratio}:${height / ratio}`;
  } */
  // Set aspect ratio for responsive container

  function setAspectRatio(input) {
    var ratio = input;

    if (!is$1.string(ratio) && !is$1.nullOrUndefined(this.embed)) {
      ratio = this.embed.ratio;
    }

    if (!is$1.string(ratio)) {
      ratio = this.config.ratio;
    }

    var _ratio$split$map = ratio.split(':').map(Number),
        _ratio$split$map2 = _slicedToArray(_ratio$split$map, 2),
        x = _ratio$split$map2[0],
        y = _ratio$split$map2[1];

    var padding = 100 / x * y;
    this.elements.wrapper.style.paddingBottom = "".concat(padding, "%"); // For Vimeo we have an extra <div> to hide the standard controls and UI

    if (this.isVimeo && this.supported.ui) {
      var height = 240;
      var offset = (height - padding) / (height / 50);
      this.media.style.transform = "translateY(-".concat(offset, "%)");
    }

    return {
      padding: padding,
      ratio: ratio
    };
  }

  var Listeners =
  /*#__PURE__*/
  function () {
    function Listeners(player) {
      _classCallCheck(this, Listeners);

      this.player = player;
      this.lastKey = null;
      this.focusTimer = null;
      this.lastKeyDown = null;
      this.handleKey = this.handleKey.bind(this);
      this.toggleMenu = this.toggleMenu.bind(this);
      this.setTabFocus = this.setTabFocus.bind(this);
      this.firstTouch = this.firstTouch.bind(this);
    } // Handle key presses


    _createClass(Listeners, [{
      key: "handleKey",
      value: function handleKey(event) {
        var player = this.player;
        var elements = player.elements;
        var code = event.keyCode ? event.keyCode : event.which;
        var pressed = event.type === 'keydown';
        var repeat = pressed && code === this.lastKey; // Bail if a modifier key is set

        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) {
          return;
        } // If the event is bubbled from the media element
        // Firefox doesn't get the keycode for whatever reason


        if (!is$1.number(code)) {
          return;
        } // Seek by the number keys


        var seekByKey = function seekByKey() {
          // Divide the max duration into 10th's and times by the number value
          player.currentTime = player.duration / 10 * (code - 48);
        }; // Handle the key on keydown
        // Reset on keyup


        if (pressed) {
          // Check focused element
          // and if the focused element is not editable (e.g. text input)
          // and any that accept key input http://webaim.org/techniques/keyboard/
          var focused = document.activeElement;

          if (is$1.element(focused)) {
            var editable = player.config.selectors.editable;
            var seek = elements.inputs.seek;

            if (focused !== seek && matches$1(focused, editable)) {
              return;
            }

            if (event.which === 32 && matches$1(focused, 'button, [role^="menuitem"]')) {
              return;
            }
          } // Which keycodes should we prevent default


          var preventDefault = [32, 37, 38, 39, 40, 48, 49, 50, 51, 52, 53, 54, 56, 57, 67, 70, 73, 75, 76, 77, 79]; // If the code is found prevent default (e.g. prevent scrolling for arrows)

          if (preventDefault.includes(code)) {
            event.preventDefault();
            event.stopPropagation();
          }

          switch (code) {
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
              // 0-9
              if (!repeat) {
                seekByKey();
              }

              break;

            case 32:
            case 75:
              // Space and K key
              if (!repeat) {
                player.togglePlay();
              }

              break;

            case 38:
              // Arrow up
              player.increaseVolume(0.1);
              break;

            case 40:
              // Arrow down
              player.decreaseVolume(0.1);
              break;

            case 77:
              // M key
              if (!repeat) {
                player.muted = !player.muted;
              }

              break;

            case 39:
              // Arrow forward
              player.forward();
              break;

            case 37:
              // Arrow back
              player.rewind();
              break;

            case 70:
              // F key
              player.fullscreen.toggle();
              break;

            case 67:
              // C key
              if (!repeat) {
                player.toggleCaptions();
              }

              break;

            case 76:
              // L key
              player.loop = !player.loop;
              break;

            /* case 73:
            this.setLoop('start');
            break;
            case 76:
            this.setLoop();
            break;
            case 79:
            this.setLoop('end');
            break; */

            default:
              break;
          } // Escape is handle natively when in full screen
          // So we only need to worry about non native


          if (code === 27 && !player.fullscreen.usingNative && player.fullscreen.active) {
            player.fullscreen.toggle();
          } // Store last code for next cycle


          this.lastKey = code;
        } else {
          this.lastKey = null;
        }
      } // Toggle menu

    }, {
      key: "toggleMenu",
      value: function toggleMenu(event) {
        controls.toggleMenu.call(this.player, event);
      } // Device is touch enabled

    }, {
      key: "firstTouch",
      value: function firstTouch() {
        var player = this.player;
        var elements = player.elements;
        player.touch = true; // Add touch class

        toggleClass(elements.container, player.config.classNames.isTouch, true);
      }
    }, {
      key: "setTabFocus",
      value: function setTabFocus(event) {
        var player = this.player;
        var elements = player.elements;
        clearTimeout(this.focusTimer); // Ignore any key other than tab

        if (event.type === 'keydown' && event.which !== 9) {
          return;
        } // Store reference to event timeStamp


        if (event.type === 'keydown') {
          this.lastKeyDown = event.timeStamp;
        } // Remove current classes


        var removeCurrent = function removeCurrent() {
          var className = player.config.classNames.tabFocus;
          var current = getElements.call(player, ".".concat(className));
          toggleClass(current, className, false);
        }; // Determine if a key was pressed to trigger this event


        var wasKeyDown = event.timeStamp - this.lastKeyDown <= 20; // Ignore focus events if a key was pressed prior

        if (event.type === 'focus' && !wasKeyDown) {
          return;
        } // Remove all current


        removeCurrent(); // Delay the adding of classname until the focus has changed
        // This event fires before the focusin event

        this.focusTimer = setTimeout(function () {
          var focused = document.activeElement; // Ignore if current focus element isn't inside the player

          if (!elements.container.contains(focused)) {
            return;
          }

          toggleClass(document.activeElement, player.config.classNames.tabFocus, true);
        }, 10);
      } // Global window & document listeners

    }, {
      key: "global",
      value: function global() {
        var toggle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var player = this.player; // Keyboard shortcuts

        if (player.config.keyboard.global) {
          toggleListener.call(player, window, 'keydown keyup', this.handleKey, toggle, false);
        } // Click anywhere closes menu


        toggleListener.call(player, document.body, 'click', this.toggleMenu, toggle); // Detect touch by events

        once.call(player, document.body, 'touchstart', this.firstTouch); // Tab focus detection

        toggleListener.call(player, document.body, 'keydown focus blur', this.setTabFocus, toggle, false, true);
      } // Container listeners

    }, {
      key: "container",
      value: function container() {
        var player = this.player;
        var config = player.config,
            elements = player.elements,
            timers = player.timers; // Keyboard shortcuts

        if (!config.keyboard.global && config.keyboard.focused) {
          on.call(player, elements.container, 'keydown keyup', this.handleKey, false);
        } // Toggle controls on mouse events and entering fullscreen


        on.call(player, elements.container, 'mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen', function (event) {
          var controls$$1 = elements.controls; // Remove button states for fullscreen

          if (controls$$1 && event.type === 'enterfullscreen') {
            controls$$1.pressed = false;
            controls$$1.hover = false;
          } // Show, then hide after a timeout unless another control event occurs


          var show = ['touchstart', 'touchmove', 'mousemove'].includes(event.type);
          var delay = 0;

          if (show) {
            ui.toggleControls.call(player, true); // Use longer timeout for touch devices

            delay = player.touch ? 3000 : 2000;
          } // Clear timer


          clearTimeout(timers.controls); // Set new timer to prevent flicker when seeking

          timers.controls = setTimeout(function () {
            return ui.toggleControls.call(player, false);
          }, delay);
        }); // Force edge to repaint on exit fullscreen
        // TODO: Fix weird bug where Edge doesn't re-draw when exiting fullscreen

        /* if (browser.isEdge) {
            on.call(player, elements.container, 'exitfullscreen', () => {
                setTimeout(() => repaint(elements.container), 100);
            });
        } */
        // Set a gutter for Vimeo

        var setGutter = function setGutter(ratio, padding, toggle) {
          if (!player.isVimeo) {
            return;
          }

          var target = player.elements.wrapper.firstChild;

          var _ratio$split$map = ratio.split(':').map(Number),
              _ratio$split$map2 = _slicedToArray(_ratio$split$map, 2),
              height = _ratio$split$map2[1];

          var _player$embed$ratio$s = player.embed.ratio.split(':').map(Number),
              _player$embed$ratio$s2 = _slicedToArray(_player$embed$ratio$s, 2),
              videoWidth = _player$embed$ratio$s2[0],
              videoHeight = _player$embed$ratio$s2[1];

          target.style.maxWidth = toggle ? "".concat(height / videoHeight * videoWidth, "px") : null;
          target.style.margin = toggle ? '0 auto' : null;
        }; // Resize on fullscreen change


        var setPlayerSize = function setPlayerSize(measure) {
          // If we don't need to measure the viewport
          if (!measure) {
            return setAspectRatio.call(player);
          }

          var rect = elements.container.getBoundingClientRect();
          var width = rect.width,
              height = rect.height;
          return setAspectRatio.call(player, "".concat(width, ":").concat(height));
        };

        var resized = function resized() {
          window.clearTimeout(timers.resized);
          timers.resized = window.setTimeout(setPlayerSize, 50);
        };

        on.call(player, elements.container, 'enterfullscreen exitfullscreen', function (event) {
          var _player$fullscreen = player.fullscreen,
              target = _player$fullscreen.target,
              usingNative = _player$fullscreen.usingNative; // Ignore for iOS native

          if (!player.isEmbed || target !== elements.container) {
            return;
          }

          var isEnter = event.type === 'enterfullscreen'; // Set the player size when entering fullscreen to viewport size

          var _setPlayerSize = setPlayerSize(isEnter),
              padding = _setPlayerSize.padding,
              ratio = _setPlayerSize.ratio; // Set Vimeo gutter


          setGutter(ratio, padding, isEnter); // If not using native fullscreen, we need to check for resizes of viewport

          if (!usingNative) {
            if (isEnter) {
              on.call(player, window, 'resize', resized);
            } else {
              off.call(player, window, 'resize', resized);
            }
          }
        });
      } // Listen for media events

    }, {
      key: "media",
      value: function media() {
        var _this = this;

        var player = this.player;
        var elements = player.elements; // Time change on media

        on.call(player, player.media, 'timeupdate seeking seeked', function (event) {
          return controls.timeUpdate.call(player, event);
        }); // Display duration

        on.call(player, player.media, 'durationchange loadeddata loadedmetadata', function (event) {
          return controls.durationUpdate.call(player, event);
        }); // Check for audio tracks on load
        // We can't use `loadedmetadata` as it doesn't seem to have audio tracks at that point

        on.call(player, player.media, 'canplay loadeddata', function () {
          toggleHidden(elements.volume, !player.hasAudio);
          toggleHidden(elements.buttons.mute, !player.hasAudio);
        }); // Handle the media finishing

        on.call(player, player.media, 'ended', function () {
          // Show poster on end
          if (player.isHTML5 && player.isVideo && player.config.resetOnEnd) {
            // Restart
            player.restart();
          }
        }); // Check for buffer progress

        on.call(player, player.media, 'progress playing seeking seeked', function (event) {
          return controls.updateProgress.call(player, event);
        }); // Handle volume changes

        on.call(player, player.media, 'volumechange', function (event) {
          return controls.updateVolume.call(player, event);
        }); // Handle play/pause

        on.call(player, player.media, 'playing play pause ended emptied timeupdate', function (event) {
          return ui.checkPlaying.call(player, event);
        }); // Loading state

        on.call(player, player.media, 'waiting canplay seeked playing', function (event) {
          return ui.checkLoading.call(player, event);
        }); // Click video

        if (player.supported.ui && player.config.clickToPlay && !player.isAudio) {
          // Re-fetch the wrapper
          var wrapper = getElement.call(player, ".".concat(player.config.classNames.video)); // Bail if there's no wrapper (this should never happen)

          if (!is$1.element(wrapper)) {
            return;
          } // On click play, pause or restart


          on.call(player, elements.container, 'click', function (event) {
            var targets = [elements.container, wrapper]; // Ignore if click if not container or in video wrapper

            if (!targets.includes(event.target) && !wrapper.contains(event.target)) {
              return;
            } // Touch devices will just show controls (if hidden)


            if (player.touch && player.config.hideControls) {
              return;
            }

            if (player.ended) {
              _this.proxy(event, player.restart, 'restart');

              _this.proxy(event, player.play, 'play');
            } else {
              _this.proxy(event, player.togglePlay, 'play');
            }
          });
        } // Disable right click


        if (player.supported.ui && player.config.disableContextMenu) {
          on.call(player, elements.wrapper, 'contextmenu', function (event) {
            event.preventDefault();
          }, false);
        } // Volume change


        on.call(player, player.media, 'volumechange', function () {
          // Save to storage
          player.storage.set({
            volume: player.volume,
            muted: player.muted
          });
        }); // Speed change

        on.call(player, player.media, 'ratechange', function () {
          // Update UI
          controls.updateSetting.call(player, 'speed'); // Save to storage


          player.storage.set({
            speed: player.speed
          });
        }); // Quality change

        on.call(player, player.media, 'qualitychange', function (event) {
          // Update UI
          controls.updateSetting.call(player, 'quality', null, event.detail.quality);
        }); // Update download link when ready and if quality changes

        on.call(player, player.media, 'ready qualitychange', function () {
          controls.setDownloadLink.call(player);
        }); // Proxy events to container
        // Bubble up key events for Edge

        var proxyEvents = player.config.events.concat(['keyup', 'keydown']).join(' ');
        on.call(player, player.media, proxyEvents, function (event) {
          var _event$detail = event.detail,
              detail = _event$detail === void 0 ? {} : _event$detail; // Get error details from media

          if (event.type === 'error') {
            detail = player.media.error;
          }

          triggerEvent.call(player, elements.container, event.type, true, detail);
        });
      } // Run default and custom handlers

    }, {
      key: "proxy",
      value: function proxy(event, defaultHandler, customHandlerKey) {
        var player = this.player;
        var customHandler = player.config.listeners[customHandlerKey];
        var hasCustomHandler = is$1.function(customHandler);
        var returned = true; // Execute custom handler

        if (hasCustomHandler) {
          returned = customHandler.call(player, event);
        } // Only call default handler if not prevented in custom handler


        if (returned && is$1.function(defaultHandler)) {
          defaultHandler.call(player, event);
        }
      } // Trigger custom and default handlers

    }, {
      key: "bind",
      value: function bind(element, type, defaultHandler, customHandlerKey) {
        var _this2 = this;

        var passive = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
        var player = this.player;
        var customHandler = player.config.listeners[customHandlerKey];
        var hasCustomHandler = is$1.function(customHandler);
        on.call(player, element, type, function (event) {
          return _this2.proxy(event, defaultHandler, customHandlerKey);
        }, passive && !hasCustomHandler);
      } // Listen for control events

    }, {
      key: "controls",
      value: function controls$$1() {
        var _this3 = this;

        var player = this.player;
        var elements = player.elements; // IE doesn't support input event, so we fallback to change

        var inputEvent = browser.isIE ? 'change' : 'input'; // Play/pause toggle

        if (elements.buttons.play) {
          Array.from(elements.buttons.play).forEach(function (button) {
            _this3.bind(button, 'click', player.togglePlay, 'play');
          });
        } // Pause


        this.bind(elements.buttons.restart, 'click', player.restart, 'restart'); // Rewind

        this.bind(elements.buttons.rewind, 'click', player.rewind, 'rewind'); // Rewind

        this.bind(elements.buttons.fastForward, 'click', player.forward, 'fastForward'); // P2P button

        this.bind(elements.buttons.p2p, 'click', player.config.listeners.p2p, 'p2p'); // Skip opening

        this.bind(elements.buttons.skipOpening, 'click', player.skipOpening, 'skip-opening'); // auto hide skip button after 5 m

        setInterval(function () {
          elements.buttons.skipOpening.style.display = player.currentTime >= 180 ? 'none' : '';
        }, 1000); // Mute toggle

        this.bind(elements.buttons.mute, 'click', function () {
          player.muted = !player.muted;
        }, 'mute'); // Captions toggle

        this.bind(elements.buttons.captions, 'click', function () {
          return player.toggleCaptions();
        }); // Download

        this.bind(elements.buttons.download, 'click', function () {
          triggerEvent.call(player, player.media, 'download');
        }, 'download'); // Fullscreen toggle

        this.bind(elements.buttons.fullscreen, 'click', function () {
          player.fullscreen.toggle();
        }, 'fullscreen'); // Picture-in-Picture

        this.bind(elements.buttons.pip, 'click', function () {
          player.pip = 'toggle';
        }, 'pip'); // Airplay

        this.bind(elements.buttons.airplay, 'click', player.airplay, 'airplay'); // Settings menu - click toggle

        this.bind(elements.buttons.settings, 'click', function (event) {
          // Prevent the document click listener closing the menu
          event.stopPropagation();

          controls.toggleMenu.call(player, event);
        }); // Settings menu - keyboard toggle
        // We have to bind to keyup otherwise Firefox triggers a click when a keydown event handler shifts focus
        // https://bugzilla.mozilla.org/show_bug.cgi?id=1220143

        this.bind(elements.buttons.settings, 'keyup', function (event) {
          var code = event.which; // We only care about space and return

          if (![13, 32].includes(code)) {
            return;
          } // Because return triggers a click anyway, all we need to do is set focus


          if (code === 13) {
            controls.focusFirstMenuItem.call(player, null, true);

            return;
          } // Prevent scroll


          event.preventDefault(); // Prevent playing video (Firefox)

          event.stopPropagation(); // Toggle menu

          controls.toggleMenu.call(player, event);
        }, null, false // Can't be passive as we're preventing default
        ); // Escape closes menu

        this.bind(elements.settings.menu, 'keydown', function (event) {
          if (event.which === 27) {
            controls.toggleMenu.call(player, event);
          }
        }); // Set range input alternative "value", which matches the tooltip time (#954)

        this.bind(elements.inputs.seek, 'mousedown mousemove', function (event) {
          var rect = elements.progress.getBoundingClientRect();
          var percent = 100 / rect.width * (event.pageX - rect.left);
          event.currentTarget.setAttribute('seek-value', percent);
        }); // Pause while seeking

        this.bind(elements.inputs.seek, 'mousedown mouseup keydown keyup touchstart touchend', function (event) {
          var seek = event.currentTarget;
          var code = event.keyCode ? event.keyCode : event.which;
          var attribute = 'play-on-seeked';

          if (is$1.keyboardEvent(event) && code !== 39 && code !== 37) {
            return;
          } // Record seek time so we can prevent hiding controls for a few seconds after seek


          player.lastSeekTime = Date.now(); // Was playing before?

          var play = seek.hasAttribute(attribute); // Done seeking

          var done = ['mouseup', 'touchend', 'keyup'].includes(event.type); // If we're done seeking and it was playing, resume playback

          if (play && done) {
            seek.removeAttribute(attribute);
            player.play();
          } else if (!done && player.playing) {
            seek.setAttribute(attribute, '');
            player.pause();
          }
        }); // Fix range inputs on iOS
        // Super weird iOS bug where after you interact with an <input type="range">,
        // it takes over further interactions on the page. This is a hack

        if (browser.isIos) {
          var inputs = getElements.call(player, 'input[type="range"]');
          Array.from(inputs).forEach(function (input) {
            return _this3.bind(input, inputEvent, function (event) {
              return repaint(event.target);
            });
          });
        } // Seek


        this.bind(elements.inputs.seek, inputEvent, function (event) {
          var seek = event.currentTarget; // If it exists, use seek-value instead of "value" for consistency with tooltip time (#954)

          var seekTo = seek.getAttribute('seek-value');

          if (is$1.empty(seekTo)) {
            seekTo = seek.value;
          }

          seek.removeAttribute('seek-value');
          player.currentTime = seekTo / seek.max * player.duration;
        }, 'seek'); // Seek tooltip

        this.bind(elements.progress, 'mouseenter mouseleave mousemove', function (event) {
          return controls.updateSeekTooltip.call(player, event);
        }); // Preview thumbnails plugin
        // TODO: Really need to work on some sort of plug-in wide event bus or pub-sub for this

        this.bind(elements.progress, 'mousemove touchmove', function (event) {
          var previewThumbnails = player.previewThumbnails;

          if (previewThumbnails && previewThumbnails.loaded) {
            previewThumbnails.startMove(event);
          }
        }); // Hide thumbnail preview - on mouse click, mouse leave, and video play/seek. All four are required, e.g., for buffering

        this.bind(elements.progress, 'mouseleave click', function () {
          var previewThumbnails = player.previewThumbnails;

          if (previewThumbnails && previewThumbnails.loaded) {
            previewThumbnails.endMove(false, true);
          }
        }); // Show scrubbing preview

        this.bind(elements.progress, 'mousedown touchstart', function (event) {
          var previewThumbnails = player.previewThumbnails;

          if (previewThumbnails && previewThumbnails.loaded) {
            previewThumbnails.startScrubbing(event);
          }
        });
        this.bind(elements.progress, 'mouseup touchend', function (event) {
          var previewThumbnails = player.previewThumbnails;

          if (previewThumbnails && previewThumbnails.loaded) {
            previewThumbnails.endScrubbing(event);
          }
        }); // Polyfill for lower fill in <input type="range"> for webkit

        if (browser.isWebkit) {
          Array.from(getElements.call(player, 'input[type="range"]')).forEach(function (element) {
            _this3.bind(element, 'input', function (event) {
              return controls.updateRangeFill.call(player, event.target);
            });
          });
        } // Current time invert
        // Only if one time element is used for both currentTime and duration


        if (player.config.toggleInvert && !is$1.element(elements.display.duration)) {
          this.bind(elements.display.currentTime, 'click', function () {
            // Do nothing if we're at the start
            if (player.currentTime === 0) {
              return;
            }

            player.config.invertTime = !player.config.invertTime;

            controls.timeUpdate.call(player);
          });
        } // Volume


        this.bind(elements.inputs.volume, inputEvent, function (event) {
          player.volume = event.target.value;
        }, 'volume'); // Update controls.hover state (used for ui.toggleControls to avoid hiding when interacting)

        this.bind(elements.controls, 'mouseenter mouseleave', function (event) {
          elements.controls.hover = !player.touch && event.type === 'mouseenter';
        }); // Update controls.pressed state (used for ui.toggleControls to avoid hiding when interacting)

        this.bind(elements.controls, 'mousedown mouseup touchstart touchend touchcancel', function (event) {
          elements.controls.pressed = ['mousedown', 'touchstart'].includes(event.type);
        }); // Show controls when they receive focus (e.g., when using keyboard tab key)

        this.bind(elements.controls, 'focusin', function () {
          var config = player.config,
              elements = player.elements,
              timers = player.timers; // Skip transition to prevent focus from scrolling the parent element

          toggleClass(elements.controls, config.classNames.noTransition, true); // Toggle

          ui.toggleControls.call(player, true); // Restore transition

          setTimeout(function () {
            toggleClass(elements.controls, config.classNames.noTransition, false);
          }, 0); // Delay a little more for mouse users

          var delay = _this3.touch ? 3000 : 4000; // Clear timer

          clearTimeout(timers.controls); // Hide again after delay

          timers.controls = setTimeout(function () {
            return ui.toggleControls.call(player, false);
          }, delay);
        }); // Mouse wheel for volume

        this.bind(elements.inputs.volume, 'wheel', function (event) {
          // Detect "natural" scroll - suppored on OS X Safari only
          // Other browsers on OS X will be inverted until support improves
          var inverted = event.webkitDirectionInvertedFromDevice; // Get delta from event. Invert if `inverted` is true

          var _map = [event.deltaX, -event.deltaY].map(function (value) {
            return inverted ? -value : value;
          }),
              _map2 = _slicedToArray(_map, 2),
              x = _map2[0],
              y = _map2[1]; // Using the biggest delta, normalize to 1 or -1 (or 0 if no delta)


          var direction = Math.sign(Math.abs(x) > Math.abs(y) ? x : y); // Change the volume by 2%

          player.increaseVolume(direction / 50); // Don't break page scrolling at max and min

          var volume = player.media.volume;

          if (direction === 1 && volume < 1 || direction === -1 && volume > 0) {
            event.preventDefault();
          }
        }, 'volume', false);
      }
    }]);

    return Listeners;
  }();

  var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var loadjs_umd = createCommonjsModule(function (module, exports) {
    (function (root, factory) {
      {
        module.exports = factory();
      }
    })(commonjsGlobal, function () {
      /**
       * Global dependencies.
       * @global {Object} document - DOM
       */
      var devnull = function devnull() {},
          bundleIdCache = {},
          bundleResultCache = {},
          bundleCallbackQueue = {};
      /**
       * Subscribe to bundle load event.
       * @param {string[]} bundleIds - Bundle ids
       * @param {Function} callbackFn - The callback function
       */


      function subscribe(bundleIds, callbackFn) {
        // listify
        bundleIds = bundleIds.push ? bundleIds : [bundleIds];
        var depsNotFound = [],
            i = bundleIds.length,
            numWaiting = i,
            fn,
            bundleId,
            r,
            q; // define callback function

        fn = function fn(bundleId, pathsNotFound) {
          if (pathsNotFound.length) depsNotFound.push(bundleId);
          numWaiting--;
          if (!numWaiting) callbackFn(depsNotFound);
        }; // register callback


        while (i--) {
          bundleId = bundleIds[i]; // execute callback if in result cache

          r = bundleResultCache[bundleId];

          if (r) {
            fn(bundleId, r);
            continue;
          } // add to callback queue


          q = bundleCallbackQueue[bundleId] = bundleCallbackQueue[bundleId] || [];
          q.push(fn);
        }
      }
      /**
       * Publish bundle load event.
       * @param {string} bundleId - Bundle id
       * @param {string[]} pathsNotFound - List of files not found
       */


      function publish(bundleId, pathsNotFound) {
        // exit if id isn't defined
        if (!bundleId) return;
        var q = bundleCallbackQueue[bundleId]; // cache result

        bundleResultCache[bundleId] = pathsNotFound; // exit if queue is empty

        if (!q) return; // empty callback queue

        while (q.length) {
          q[0](bundleId, pathsNotFound);
          q.splice(0, 1);
        }
      }
      /**
       * Execute callbacks.
       * @param {Object or Function} args - The callback args
       * @param {string[]} depsNotFound - List of dependencies not found
       */


      function executeCallbacks(args, depsNotFound) {
        // accept function as argument
        if (args.call) args = {
          success: args
        }; // success and error callbacks

        if (depsNotFound.length) (args.error || devnull)(depsNotFound);else (args.success || devnull)(args);
      }
      /**
       * Load individual file.
       * @param {string} path - The file path
       * @param {Function} callbackFn - The callback function
       */


      function loadFile(path, callbackFn, args, numTries) {
        var doc = document,
            async = args.async,
            maxTries = (args.numRetries || 0) + 1,
            beforeCallbackFn = args.before || devnull,
            pathStripped = path.replace(/^(css|img)!/, ''),
            isCss,
            e;
        numTries = numTries || 0;

        if (/(^css!|\.css$)/.test(path)) {
          isCss = true; // css

          e = doc.createElement('link');
          e.rel = 'stylesheet';
          e.href = pathStripped; //.replace(/^css!/, '');  // remove "css!" prefix
        } else if (/(^img!|\.(png|gif|jpg|svg)$)/.test(path)) {
          // image
          e = doc.createElement('img');
          e.src = pathStripped;
        } else {
          // javascript
          e = doc.createElement('script');
          e.src = path;
          e.async = async === undefined ? true : async;
        }

        e.onload = e.onerror = e.onbeforeload = function (ev) {
          var result = ev.type[0]; // Note: The following code isolates IE using `hideFocus` and treats empty
          // stylesheets as failures to get around lack of onerror support

          if (isCss && 'hideFocus' in e) {
            try {
              if (!e.sheet.cssText.length) result = 'e';
            } catch (x) {
              // sheets objects created from load errors don't allow access to
              // `cssText` (unless error is Code:18 SecurityError)
              if (x.code != 18) result = 'e';
            }
          } // handle retries in case of load failure


          if (result == 'e') {
            // increment counter
            numTries += 1; // exit function and try again

            if (numTries < maxTries) {
              return loadFile(path, callbackFn, args, numTries);
            }
          } // execute callback


          callbackFn(path, result, ev.defaultPrevented);
        }; // add to document (unless callback returns `false`)


        if (beforeCallbackFn(path, e) !== false) doc.head.appendChild(e);
      }
      /**
       * Load multiple files.
       * @param {string[]} paths - The file paths
       * @param {Function} callbackFn - The callback function
       */


      function loadFiles(paths, callbackFn, args) {
        // listify paths
        paths = paths.push ? paths : [paths];
        var numWaiting = paths.length,
            x = numWaiting,
            pathsNotFound = [],
            fn,
            i; // define callback function

        fn = function fn(path, result, defaultPrevented) {
          // handle error
          if (result == 'e') pathsNotFound.push(path); // handle beforeload event. If defaultPrevented then that means the load
          // will be blocked (ex. Ghostery/ABP on Safari)

          if (result == 'b') {
            if (defaultPrevented) pathsNotFound.push(path);else return;
          }

          numWaiting--;
          if (!numWaiting) callbackFn(pathsNotFound);
        }; // load scripts


        for (i = 0; i < x; i++) {
          loadFile(paths[i], fn, args);
        }
      }
      /**
       * Initiate script load and register bundle.
       * @param {(string|string[])} paths - The file paths
       * @param {(string|Function)} [arg1] - The bundleId or success callback
       * @param {Function} [arg2] - The success or error callback
       * @param {Function} [arg3] - The error callback
       */


      function loadjs(paths, arg1, arg2) {
        var bundleId, args; // bundleId (if string)

        if (arg1 && arg1.trim) bundleId = arg1; // args (default is {})

        args = (bundleId ? arg2 : arg1) || {}; // throw error if bundle is already defined

        if (bundleId) {
          if (bundleId in bundleIdCache) {
            throw "LoadJS";
          } else {
            bundleIdCache[bundleId] = true;
          }
        } // load scripts


        loadFiles(paths, function (pathsNotFound) {
          // execute callbacks
          executeCallbacks(args, pathsNotFound); // publish bundle load event

          publish(bundleId, pathsNotFound);
        }, args);
      }
      /**
       * Execute callbacks when dependencies have been satisfied.
       * @param {(string|string[])} deps - List of bundle ids
       * @param {Object} args - success/error arguments
       */


      loadjs.ready = function ready(deps, args) {
        // subscribe to bundle load event
        subscribe(deps, function (depsNotFound) {
          // execute callbacks
          executeCallbacks(args, depsNotFound);
        });
        return loadjs;
      };
      /**
       * Manually satisfy bundle dependencies.
       * @param {string} bundleId - The bundle id
       */


      loadjs.done = function done(bundleId) {
        publish(bundleId, []);
      };
      /**
       * Reset loadjs dependencies statuses
       */


      loadjs.reset = function reset() {
        bundleIdCache = {};
        bundleResultCache = {};
        bundleCallbackQueue = {};
      };
      /**
       * Determine if bundle has already been defined
       * @param String} bundleId - The bundle id
       */


      loadjs.isDefined = function isDefined(bundleId) {
        return bundleId in bundleIdCache;
      }; // export


      return loadjs;
    });
  });

  // ==========================================================================
  function loadScript(url) {
    return new Promise(function (resolve, reject) {
      loadjs_umd(url, {
        success: resolve,
        error: reject
      });
    });
  }

  function parseId(url) {
    if (is$1.empty(url)) {
      return null;
    }

    if (is$1.number(Number(url))) {
      return url;
    }

    var regex = /^.*(vimeo.com\/|video\/)(\d+).*/;
    return url.match(regex) ? RegExp.$2 : url;
  } // Set playback state and trigger change (only on actual change)


  function assurePlaybackState(play) {
    if (play && !this.embed.hasPlayed) {
      this.embed.hasPlayed = true;
    }

    if (this.media.paused === play) {
      this.media.paused = !play;
      triggerEvent.call(this, this.media, play ? 'play' : 'pause');
    }
  }

  var vimeo = {
    setup: function setup() {
      var _this = this;

      // Add embed class for responsive
      toggleClass(this.elements.wrapper, this.config.classNames.embed, true); // Set intial ratio

      setAspectRatio.call(this); // Load the API if not already

      if (!is$1.object(window.Vimeo)) {
        loadScript(this.config.urls.vimeo.sdk).then(function () {
          vimeo.ready.call(_this);
        }).catch(function (error) {
          _this.debug.warn('Vimeo API failed to load', error);
        });
      } else {
        vimeo.ready.call(this);
      }
    },
    // API Ready
    ready: function ready$$1() {
      var _this2 = this;

      var player = this;
      var config = player.config.vimeo; // Get Vimeo params for the iframe

      var params = buildUrlParams(extend({}, {
        loop: player.config.loop.active,
        autoplay: player.autoplay,
        muted: player.muted,
        gesture: 'media',
        playsinline: !this.config.fullscreen.iosNative
      }, config)); // Get the source URL or ID

      var source = player.media.getAttribute('src'); // Get from <div> if needed

      if (is$1.empty(source)) {
        source = player.media.getAttribute(player.config.attributes.embed.id);
      }

      var id = parseId(source); // Build an iframe

      var iframe = createElement('iframe');
      var src = format(player.config.urls.vimeo.iframe, id, params);
      iframe.setAttribute('src', src);
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('allowtransparency', '');
      iframe.setAttribute('allow', 'autoplay'); // Get poster, if already set

      var poster = player.poster; // Inject the package

      var wrapper = createElement('div', {
        poster: poster,
        class: player.config.classNames.embedContainer
      });
      wrapper.appendChild(iframe);
      player.media = replaceElement(wrapper, player.media); // Get poster image

      fetch$1(format(player.config.urls.vimeo.api, id), 'json').then(function (response) {
        if (is$1.empty(response)) {
          return;
        } // Get the URL for thumbnail


        var url = new URL(response[0].thumbnail_large); // Get original image

        url.pathname = "".concat(url.pathname.split('_')[0], ".jpg"); // Set and show poster

        ui.setPoster.call(player, url.href).catch(function () {});
      }); // Setup instance
      // https://github.com/vimeo/player.js

      player.embed = new window.Vimeo.Player(iframe, {
        autopause: player.config.autopause,
        muted: player.muted
      });
      player.media.paused = true;
      player.media.currentTime = 0; // Disable native text track rendering

      if (player.supported.ui) {
        player.embed.disableTextTrack();
      } // Create a faux HTML5 API using the Vimeo API


      player.media.play = function () {
        assurePlaybackState.call(player, true);
        return player.embed.play();
      };

      player.media.pause = function () {
        assurePlaybackState.call(player, false);
        return player.embed.pause();
      };

      player.media.stop = function () {
        player.pause();
        player.currentTime = 0;
      }; // Seeking


      var currentTime = player.media.currentTime;
      Object.defineProperty(player.media, 'currentTime', {
        get: function get() {
          return currentTime;
        },
        set: function set(time) {
          // Vimeo will automatically play on seek if the video hasn't been played before
          // Get current paused state and volume etc
          var embed = player.embed,
              media = player.media,
              paused = player.paused,
              volume = player.volume;
          var restorePause = paused && !embed.hasPlayed; // Set seeking state and trigger event

          media.seeking = true;
          triggerEvent.call(player, media, 'seeking'); // If paused, mute until seek is complete

          Promise.resolve(restorePause && embed.setVolume(0)) // Seek
          .then(function () {
            return embed.setCurrentTime(time);
          }) // Restore paused
          .then(function () {
            return restorePause && embed.pause();
          }) // Restore volume
          .then(function () {
            return restorePause && embed.setVolume(volume);
          }).catch(function () {// Do nothing
          });
        }
      }); // Playback speed

      var speed = player.config.speed.selected;
      Object.defineProperty(player.media, 'playbackRate', {
        get: function get() {
          return speed;
        },
        set: function set(input) {
          player.embed.setPlaybackRate(input).then(function () {
            speed = input;
            triggerEvent.call(player, player.media, 'ratechange');
          }).catch(function (error) {
            // Hide menu item (and menu if empty)
            if (error.name === 'Error') {
              controls.setSpeedMenu.call(player, []);
            }
          });
        }
      }); // Volume

      var volume = player.config.volume;
      Object.defineProperty(player.media, 'volume', {
        get: function get() {
          return volume;
        },
        set: function set(input) {
          player.embed.setVolume(input).then(function () {
            volume = input;
            triggerEvent.call(player, player.media, 'volumechange');
          });
        }
      }); // Muted

      var muted = player.config.muted;
      Object.defineProperty(player.media, 'muted', {
        get: function get() {
          return muted;
        },
        set: function set(input) {
          var toggle = is$1.boolean(input) ? input : false;
          player.embed.setVolume(toggle ? 0 : player.config.volume).then(function () {
            muted = toggle;
            triggerEvent.call(player, player.media, 'volumechange');
          });
        }
      }); // Loop

      var loop = player.config.loop;
      Object.defineProperty(player.media, 'loop', {
        get: function get() {
          return loop;
        },
        set: function set(input) {
          var toggle = is$1.boolean(input) ? input : player.config.loop.active;
          player.embed.setLoop(toggle).then(function () {
            loop = toggle;
          });
        }
      }); // Source

      var currentSrc;
      player.embed.getVideoUrl().then(function (value) {
        currentSrc = value;
        controls.setDownloadLink.call(player);
      }).catch(function (error) {
        _this2.debug.warn(error);
      });
      Object.defineProperty(player.media, 'currentSrc', {
        get: function get() {
          return currentSrc;
        }
      }); // Ended

      Object.defineProperty(player.media, 'ended', {
        get: function get() {
          return player.currentTime === player.duration;
        }
      }); // Set aspect ratio based on video size

      Promise.all([player.embed.getVideoWidth(), player.embed.getVideoHeight()]).then(function (dimensions) {
        var _dimensions = _slicedToArray(dimensions, 2),
            width = _dimensions[0],
            height = _dimensions[1];

        player.embed.ratio = "".concat(width, ":").concat(height);
        setAspectRatio.call(_this2, player.embed.ratio);
      }); // Set autopause

      player.embed.setAutopause(player.config.autopause).then(function (state) {
        player.config.autopause = state;
      }); // Get title

      player.embed.getVideoTitle().then(function (title) {
        player.config.title = title;
        ui.setTitle.call(_this2);
      }); // Get current time

      player.embed.getCurrentTime().then(function (value) {
        currentTime = value;
        triggerEvent.call(player, player.media, 'timeupdate');
      }); // Get duration

      player.embed.getDuration().then(function (value) {
        player.media.duration = value;
        triggerEvent.call(player, player.media, 'durationchange');
      }); // Get captions

      player.embed.getTextTracks().then(function (tracks) {
        player.media.textTracks = tracks;
        captions.setup.call(player);
      });
      player.embed.on('cuechange', function (_ref) {
        var _ref$cues = _ref.cues,
            cues = _ref$cues === void 0 ? [] : _ref$cues;
        var strippedCues = cues.map(function (cue) {
          return stripHTML(cue.text);
        });
        captions.updateCues.call(player, strippedCues);
      });
      player.embed.on('loaded', function () {
        // Assure state and events are updated on autoplay
        player.embed.getPaused().then(function (paused) {
          assurePlaybackState.call(player, !paused);

          if (!paused) {
            triggerEvent.call(player, player.media, 'playing');
          }
        });

        if (is$1.element(player.embed.element) && player.supported.ui) {
          var frame = player.embed.element; // Fix keyboard focus issues
          // https://github.com/sampotts/plyr/issues/317

          frame.setAttribute('tabindex', -1);
        }
      });
      player.embed.on('play', function () {
        assurePlaybackState.call(player, true);
        triggerEvent.call(player, player.media, 'playing');
      });
      player.embed.on('pause', function () {
        assurePlaybackState.call(player, false);
      });
      player.embed.on('timeupdate', function (data) {
        player.media.seeking = false;
        currentTime = data.seconds;
        triggerEvent.call(player, player.media, 'timeupdate');
      });
      player.embed.on('progress', function (data) {
        player.media.buffered = data.percent;
        triggerEvent.call(player, player.media, 'progress'); // Check all loaded

        if (parseInt(data.percent, 10) === 1) {
          triggerEvent.call(player, player.media, 'canplaythrough');
        } // Get duration as if we do it before load, it gives an incorrect value
        // https://github.com/sampotts/plyr/issues/891


        player.embed.getDuration().then(function (value) {
          if (value !== player.media.duration) {
            player.media.duration = value;
            triggerEvent.call(player, player.media, 'durationchange');
          }
        });
      });
      player.embed.on('seeked', function () {
        player.media.seeking = false;
        triggerEvent.call(player, player.media, 'seeked');
      });
      player.embed.on('ended', function () {
        player.media.paused = true;
        triggerEvent.call(player, player.media, 'ended');
      });
      player.embed.on('error', function (detail) {
        player.media.error = detail;
        triggerEvent.call(player, player.media, 'error');
      }); // Rebuild UI

      setTimeout(function () {
        return ui.build.call(player);
      }, 0);
    }
  };

  // ==========================================================================

  function parseId$1(url) {
    if (is$1.empty(url)) {
      return null;
    }

    var regex = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    return url.match(regex) ? RegExp.$2 : url;
  } // Set playback state and trigger change (only on actual change)


  function assurePlaybackState$1(play) {
    if (play && !this.embed.hasPlayed) {
      this.embed.hasPlayed = true;
    }

    if (this.media.paused === play) {
      this.media.paused = !play;
      triggerEvent.call(this, this.media, play ? 'play' : 'pause');
    }
  }

  var youtube = {
    setup: function setup() {
      var _this = this;

      // Add embed class for responsive
      toggleClass(this.elements.wrapper, this.config.classNames.embed, true); // Set aspect ratio

      setAspectRatio.call(this); // Setup API

      if (is$1.object(window.YT) && is$1.function(window.YT.Player)) {
        youtube.ready.call(this);
      } else {
        // Load the API
        loadScript(this.config.urls.youtube.sdk).catch(function (error) {
          _this.debug.warn('YouTube API failed to load', error);
        }); // Setup callback for the API
        // YouTube has it's own system of course...

        window.onYouTubeReadyCallbacks = window.onYouTubeReadyCallbacks || []; // Add to queue

        window.onYouTubeReadyCallbacks.push(function () {
          youtube.ready.call(_this);
        }); // Set callback to process queue

        window.onYouTubeIframeAPIReady = function () {
          window.onYouTubeReadyCallbacks.forEach(function (callback) {
            callback();
          });
        };
      }
    },
    // Get the media title
    getTitle: function getTitle(videoId) {
      var _this2 = this;

      // Try via undocumented API method first
      // This method disappears now and then though...
      // https://github.com/sampotts/plyr/issues/709
      if (is$1.function(this.embed.getVideoData)) {
        var _this$embed$getVideoD = this.embed.getVideoData(),
            title = _this$embed$getVideoD.title;

        if (is$1.empty(title)) {
          this.config.title = title;
          ui.setTitle.call(this);
          return;
        }
      } // Or via Google API


      var key = this.config.keys.google;

      if (is$1.string(key) && !is$1.empty(key)) {
        var url = format(this.config.urls.youtube.api, videoId, key);
        fetch$1(url).then(function (result) {
          if (is$1.object(result)) {
            _this2.config.title = result.items[0].snippet.title;
            ui.setTitle.call(_this2);
          }
        }).catch(function () {});
      }
    },
    // API ready
    ready: function ready$$1() {
      var player = this; // Ignore already setup (race condition)

      var currentId = player.media.getAttribute('id');

      if (!is$1.empty(currentId) && currentId.startsWith('youtube-')) {
        return;
      } // Get the source URL or ID


      var source = player.media.getAttribute('src'); // Get from <div> if needed

      if (is$1.empty(source)) {
        source = player.media.getAttribute(this.config.attributes.embed.id);
      } // Replace the <iframe> with a <div> due to YouTube API issues


      var videoId = parseId$1(source);
      var id = generateId(player.provider); // Get poster, if already set

      var poster = player.poster; // Replace media element

      var container = createElement('div', {
        id: id,
        poster: poster
      });
      player.media = replaceElement(container, player.media); // Id to poster wrapper

      var posterSrc = function posterSrc(format$$1) {
        return "https://img.youtube.com/vi/".concat(videoId, "/").concat(format$$1, "default.jpg");
      }; // Check thumbnail images in order of quality, but reject fallback thumbnails (120px wide)


      loadImage(posterSrc('maxres'), 121) // Higest quality and unpadded
      .catch(function () {
        return loadImage(posterSrc('sd'), 121);
      }) // 480p padded 4:3
      .catch(function () {
        return loadImage(posterSrc('hq'));
      }) // 360p padded 4:3. Always exists
      .then(function (image) {
        return ui.setPoster.call(player, image.src);
      }).then(function (posterSrc) {
        // If the image is padded, use background-size "cover" instead (like youtube does too with their posters)
        if (!posterSrc.includes('maxres')) {
          player.elements.poster.style.backgroundSize = 'cover';
        }
      }).catch(function () {});
      var config = player.config.youtube; // Setup instance
      // https://developers.google.com/youtube/iframe_api_reference

      player.embed = new window.YT.Player(id, {
        videoId: videoId,
        host: config.noCookie ? 'https://www.youtube-nocookie.com' : undefined,
        playerVars: extend({}, {
          autoplay: player.config.autoplay ? 1 : 0,
          // Autoplay
          hl: player.config.hl,
          // iframe interface language
          controls: player.supported.ui ? 0 : 1,
          // Only show controls if not fully supported
          disablekb: 1,
          // Disable keyboard as we handle it
          playsinline: !player.config.fullscreen.iosNative ? 1 : 0,
          // Allow iOS inline playback
          // Captions are flaky on YouTube
          cc_load_policy: player.captions.active ? 1 : 0,
          cc_lang_pref: player.config.captions.language,
          // Tracking for stats
          widget_referrer: window ? window.location.href : null
        }, config),
        events: {
          onError: function onError(event) {
            // YouTube may fire onError twice, so only handle it once
            if (!player.media.error) {
              var code = event.data; // Messages copied from https://developers.google.com/youtube/iframe_api_reference#onError

              var message = {
                2: 'The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.',
                5: 'The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.',
                100: 'The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.',
                101: 'The owner of the requested video does not allow it to be played in embedded players.',
                150: 'The owner of the requested video does not allow it to be played in embedded players.'
              }[code] || 'An unknown error occured';
              player.media.error = {
                code: code,
                message: message
              };
              triggerEvent.call(player, player.media, 'error');
            }
          },
          onPlaybackRateChange: function onPlaybackRateChange(event) {
            // Get the instance
            var instance = event.target; // Get current speed

            player.media.playbackRate = instance.getPlaybackRate();
            triggerEvent.call(player, player.media, 'ratechange');
          },
          onReady: function onReady(event) {
            // Bail if onReady has already been called. See issue #1108
            if (is$1.function(player.media.play)) {
              return;
            } // Get the instance


            var instance = event.target; // Get the title

            youtube.getTitle.call(player, videoId); // Create a faux HTML5 API using the YouTube API

            player.media.play = function () {
              assurePlaybackState$1.call(player, true);
              instance.playVideo();
            };

            player.media.pause = function () {
              assurePlaybackState$1.call(player, false);
              instance.pauseVideo();
            };

            player.media.stop = function () {
              instance.stopVideo();
            };

            player.media.duration = instance.getDuration();
            player.media.paused = true; // Seeking

            player.media.currentTime = 0;
            Object.defineProperty(player.media, 'currentTime', {
              get: function get() {
                return Number(instance.getCurrentTime());
              },
              set: function set(time) {
                // If paused and never played, mute audio preventively (YouTube starts playing on seek if the video hasn't been played yet).
                if (player.paused && !player.embed.hasPlayed) {
                  player.embed.mute();
                } // Set seeking state and trigger event


                player.media.seeking = true;
                triggerEvent.call(player, player.media, 'seeking'); // Seek after events sent

                instance.seekTo(time);
              }
            }); // Playback speed

            Object.defineProperty(player.media, 'playbackRate', {
              get: function get() {
                return instance.getPlaybackRate();
              },
              set: function set(input) {
                instance.setPlaybackRate(input);
              }
            }); // Volume

            var volume = player.config.volume;
            Object.defineProperty(player.media, 'volume', {
              get: function get() {
                return volume;
              },
              set: function set(input) {
                volume = input;
                instance.setVolume(volume * 100);
                triggerEvent.call(player, player.media, 'volumechange');
              }
            }); // Muted

            var muted = player.config.muted;
            Object.defineProperty(player.media, 'muted', {
              get: function get() {
                return muted;
              },
              set: function set(input) {
                var toggle = is$1.boolean(input) ? input : muted;
                muted = toggle;
                instance[toggle ? 'mute' : 'unMute']();
                triggerEvent.call(player, player.media, 'volumechange');
              }
            }); // Source

            Object.defineProperty(player.media, 'currentSrc', {
              get: function get() {
                return instance.getVideoUrl();
              }
            }); // Ended

            Object.defineProperty(player.media, 'ended', {
              get: function get() {
                return player.currentTime === player.duration;
              }
            }); // Get available speeds

            player.options.speed = instance.getAvailablePlaybackRates(); // Set the tabindex to avoid focus entering iframe

            if (player.supported.ui) {
              player.media.setAttribute('tabindex', -1);
            }

            triggerEvent.call(player, player.media, 'timeupdate');
            triggerEvent.call(player, player.media, 'durationchange'); // Reset timer

            clearInterval(player.timers.buffering); // Setup buffering

            player.timers.buffering = setInterval(function () {
              // Get loaded % from YouTube
              player.media.buffered = instance.getVideoLoadedFraction(); // Trigger progress only when we actually buffer something

              if (player.media.lastBuffered === null || player.media.lastBuffered < player.media.buffered) {
                triggerEvent.call(player, player.media, 'progress');
              } // Set last buffer point


              player.media.lastBuffered = player.media.buffered; // Bail if we're at 100%

              if (player.media.buffered === 1) {
                clearInterval(player.timers.buffering); // Trigger event

                triggerEvent.call(player, player.media, 'canplaythrough');
              }
            }, 200); // Rebuild UI

            setTimeout(function () {
              return ui.build.call(player);
            }, 50);
          },
          onStateChange: function onStateChange(event) {
            // Get the instance
            var instance = event.target; // Reset timer

            clearInterval(player.timers.playing);
            var seeked = player.media.seeking && [1, 2].includes(event.data);

            if (seeked) {
              // Unset seeking and fire seeked event
              player.media.seeking = false;
              triggerEvent.call(player, player.media, 'seeked');
            } // Handle events
            // -1   Unstarted
            // 0    Ended
            // 1    Playing
            // 2    Paused
            // 3    Buffering
            // 5    Video cued


            switch (event.data) {
              case -1:
                // Update scrubber
                triggerEvent.call(player, player.media, 'timeupdate'); // Get loaded % from YouTube

                player.media.buffered = instance.getVideoLoadedFraction();
                triggerEvent.call(player, player.media, 'progress');
                break;

              case 0:
                assurePlaybackState$1.call(player, false); // YouTube doesn't support loop for a single video, so mimick it.

                if (player.media.loop) {
                  // YouTube needs a call to `stopVideo` before playing again
                  instance.stopVideo();
                  instance.playVideo();
                } else {
                  triggerEvent.call(player, player.media, 'ended');
                }

                break;

              case 1:
                // Restore paused state (YouTube starts playing on seek if the video hasn't been played yet)
                if (player.media.paused && !player.embed.hasPlayed) {
                  player.media.pause();
                } else {
                  assurePlaybackState$1.call(player, true);
                  triggerEvent.call(player, player.media, 'playing'); // Poll to get playback progress

                  player.timers.playing = setInterval(function () {
                    triggerEvent.call(player, player.media, 'timeupdate');
                  }, 50); // Check duration again due to YouTube bug
                  // https://github.com/sampotts/plyr/issues/374
                  // https://code.google.com/p/gdata-issues/issues/detail?id=8690

                  if (player.media.duration !== instance.getDuration()) {
                    player.media.duration = instance.getDuration();
                    triggerEvent.call(player, player.media, 'durationchange');
                  }
                }

                break;

              case 2:
                // Restore audio (YouTube starts playing on seek if the video hasn't been played yet)
                if (!player.muted) {
                  player.embed.unMute();
                }

                assurePlaybackState$1.call(player, false);
                break;

              default:
                break;
            }

            triggerEvent.call(player, player.elements.container, 'statechange', false, {
              code: event.data
            });
          }
        }
      });
    }
  };

  // ==========================================================================
  var media = {
    // Setup media
    setup: function setup() {
      // If there's no media, bail
      if (!this.media) {
        this.debug.warn('No media element found!');
        return;
      } // Add type class


      toggleClass(this.elements.container, this.config.classNames.type.replace('{0}', this.type), true); // Add provider class

      toggleClass(this.elements.container, this.config.classNames.provider.replace('{0}', this.provider), true); // Add video class for embeds
      // This will require changes if audio embeds are added

      if (this.isEmbed) {
        toggleClass(this.elements.container, this.config.classNames.type.replace('{0}', 'video'), true);
      } // Inject the player wrapper


      if (this.isVideo) {
        // Create the wrapper div
        this.elements.wrapper = createElement('div', {
          class: this.config.classNames.video
        }); // Wrap the video in a container

        wrap(this.media, this.elements.wrapper); // Faux poster container

        this.elements.poster = createElement('div', {
          class: this.config.classNames.poster
        });
        this.elements.wrapper.appendChild(this.elements.poster);
      }

      if (this.isHTML5) {
        html5.extend.call(this);
      } else if (this.isYouTube) {
        youtube.setup.call(this);
      } else if (this.isVimeo) {
        vimeo.setup.call(this);
      }
    }
  };

  var commonjsGlobal$1 = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function createCommonjsModule$1(fn, module) {
    return module = {
      exports: {}
    }, fn(module, module.exports), module.exports;
  }

  var runtime = createCommonjsModule$1(function (module) {
    /**
     * Copyright (c) 2014-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    !function (global) {
      var Op = Object.prototype;
      var hasOwn = Op.hasOwnProperty;
      var undefined; // More compressible than void 0.

      var $Symbol = typeof Symbol === "function" ? Symbol : {};
      var iteratorSymbol = $Symbol.iterator || "@@iterator";
      var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
      var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
      var runtime = global.regeneratorRuntime;

      if (runtime) {
        {
          // If regeneratorRuntime is defined globally and we're in a module,
          // make the exports object identical to regeneratorRuntime.
          module.exports = runtime;
        } // Don't bother evaluating the rest of this file if the runtime was
        // already defined globally.

        return;
      } // Define the runtime globally (as expected by generated code) as either
      // module.exports (if we're in a module) or a new, empty object.


      runtime = global.regeneratorRuntime = module.exports;

      function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.

        generator._invoke = makeInvokeMethod(innerFn, self, context);
        return generator;
      }

      runtime.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
      // record like context.tryEntries[i].completion. This interface could
      // have been (and was previously) designed to take a closure to be
      // invoked without arguments, but in all the cases we care about we
      // already have an existing method we want to call, so there's no need
      // to create a new function object. We can even get away with assuming
      // the method takes exactly one argument, since that happens to be true
      // in every case, so we don't have to touch the arguments object. The
      // only additional allocation required is the completion record, which
      // has a stable shape and so hopefully should be cheap to allocate.

      function tryCatch(fn, obj, arg) {
        try {
          return {
            type: "normal",
            arg: fn.call(obj, arg)
          };
        } catch (err) {
          return {
            type: "throw",
            arg: err
          };
        }
      }

      var GenStateSuspendedStart = "suspendedStart";
      var GenStateSuspendedYield = "suspendedYield";
      var GenStateExecuting = "executing";
      var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
      // breaking out of the dispatch switch statement.

      var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
      // .constructor.prototype properties for functions that return Generator
      // objects. For full spec compliance, you may wish to configure your
      // minifier not to mangle the names of these two functions.

      function Generator() {}

      function GeneratorFunction() {}

      function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
      // don't natively support it.


      var IteratorPrototype = {};

      IteratorPrototype[iteratorSymbol] = function () {
        return this;
      };

      var getProto = Object.getPrototypeOf;
      var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

      if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
        // This environment has a native %IteratorPrototype%; use it instead
        // of the polyfill.
        IteratorPrototype = NativeIteratorPrototype;
      }

      var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
      GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
      GeneratorFunctionPrototype.constructor = GeneratorFunction;
      GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
      // Iterator interface in terms of a single ._invoke method.

      function defineIteratorMethods(prototype) {
        ["next", "throw", "return"].forEach(function (method) {
          prototype[method] = function (arg) {
            return this._invoke(method, arg);
          };
        });
      }

      runtime.isGeneratorFunction = function (genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
      };

      runtime.mark = function (genFun) {
        if (Object.setPrototypeOf) {
          Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        } else {
          genFun.__proto__ = GeneratorFunctionPrototype;

          if (!(toStringTagSymbol in genFun)) {
            genFun[toStringTagSymbol] = "GeneratorFunction";
          }
        }

        genFun.prototype = Object.create(Gp);
        return genFun;
      }; // Within the body of any async function, `await x` is transformed to
      // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
      // `hasOwn.call(value, "__await")` to determine if the yielded value is
      // meant to be awaited.


      runtime.awrap = function (arg) {
        return {
          __await: arg
        };
      };

      function AsyncIterator(generator) {
        function invoke(method, arg, resolve, reject) {
          var record = tryCatch(generator[method], generator, arg);

          if (record.type === "throw") {
            reject(record.arg);
          } else {
            var result = record.arg;
            var value = result.value;

            if (value && _typeof(value) === "object" && hasOwn.call(value, "__await")) {
              return Promise.resolve(value.__await).then(function (value) {
                invoke("next", value, resolve, reject);
              }, function (err) {
                invoke("throw", err, resolve, reject);
              });
            }

            return Promise.resolve(value).then(function (unwrapped) {
              // When a yielded Promise is resolved, its final value becomes
              // the .value of the Promise<{value,done}> result for the
              // current iteration. If the Promise is rejected, however, the
              // result for this iteration will be rejected with the same
              // reason. Note that rejections of yielded Promises are not
              // thrown back into the generator function, as is the case
              // when an awaited Promise is rejected. This difference in
              // behavior between yield and await is important, because it
              // allows the consumer to decide what to do with the yielded
              // rejection (swallow it and continue, manually .throw it back
              // into the generator, abandon iteration, whatever). With
              // await, by contrast, there is no opportunity to examine the
              // rejection reason outside the generator function, so the
              // only option is to throw it from the await expression, and
              // let the generator function handle the exception.
              result.value = unwrapped;
              resolve(result);
            }, reject);
          }
        }

        var previousPromise;

        function enqueue(method, arg) {
          function callInvokeWithMethodAndArg() {
            return new Promise(function (resolve, reject) {
              invoke(method, arg, resolve, reject);
            });
          }

          return previousPromise = // If enqueue has been called before, then we want to wait until
          // all previous Promises have been resolved before calling invoke,
          // so that results are always delivered in the correct order. If
          // enqueue has not been called before, then it is important to
          // call invoke immediately, without waiting on a callback to fire,
          // so that the async generator function has the opportunity to do
          // any necessary setup in a predictable way. This predictability
          // is why the Promise constructor synchronously invokes its
          // executor callback, and why async functions synchronously
          // execute code before the first await. Since we implement simple
          // async functions in terms of async generators, it is especially
          // important to get this right, even though it requires care.
          previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        } // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).


        this._invoke = enqueue;
      }

      defineIteratorMethods(AsyncIterator.prototype);

      AsyncIterator.prototype[asyncIteratorSymbol] = function () {
        return this;
      };

      runtime.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
      // AsyncIterator objects; they just return a Promise for the value of
      // the final result produced by the iterator.

      runtime.async = function (innerFn, outerFn, self, tryLocsList) {
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
        return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
        : iter.next().then(function (result) {
          return result.done ? result.value : iter.next();
        });
      };

      function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
          if (state === GenStateExecuting) {
            throw new Error("Generator is already running");
          }

          if (state === GenStateCompleted) {
            if (method === "throw") {
              throw arg;
            } // Be forgiving, per 25.3.3.3.3 of the spec:
            // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


            return doneResult();
          }

          context.method = method;
          context.arg = arg;

          while (true) {
            var delegate = context.delegate;

            if (delegate) {
              var delegateResult = maybeInvokeDelegate(delegate, context);

              if (delegateResult) {
                if (delegateResult === ContinueSentinel) continue;
                return delegateResult;
              }
            }

            if (context.method === "next") {
              // Setting context._sent for legacy support of Babel's
              // function.sent implementation.
              context.sent = context._sent = context.arg;
            } else if (context.method === "throw") {
              if (state === GenStateSuspendedStart) {
                state = GenStateCompleted;
                throw context.arg;
              }

              context.dispatchException(context.arg);
            } else if (context.method === "return") {
              context.abrupt("return", context.arg);
            }

            state = GenStateExecuting;
            var record = tryCatch(innerFn, self, context);

            if (record.type === "normal") {
              // If an exception is thrown from innerFn, we leave state ===
              // GenStateExecuting and loop back for another invocation.
              state = context.done ? GenStateCompleted : GenStateSuspendedYield;

              if (record.arg === ContinueSentinel) {
                continue;
              }

              return {
                value: record.arg,
                done: context.done
              };
            } else if (record.type === "throw") {
              state = GenStateCompleted; // Dispatch the exception by looping back around to the
              // context.dispatchException(context.arg) call above.

              context.method = "throw";
              context.arg = record.arg;
            }
          }
        };
      } // Call delegate.iterator[context.method](context.arg) and handle the
      // result, either by returning a { value, done } result from the
      // delegate iterator, or by modifying context.method and context.arg,
      // setting context.delegate to null, and returning the ContinueSentinel.


      function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];

        if (method === undefined) {
          // A .throw or .return when the delegate iterator has no .throw
          // method always terminates the yield* loop.
          context.delegate = null;

          if (context.method === "throw") {
            if (delegate.iterator.return) {
              // If the delegate iterator has a return method, give it a
              // chance to clean up.
              context.method = "return";
              context.arg = undefined;
              maybeInvokeDelegate(delegate, context);

              if (context.method === "throw") {
                // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
              }
            }

            context.method = "throw";
            context.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return ContinueSentinel;
        }

        var record = tryCatch(method, delegate.iterator, context.arg);

        if (record.type === "throw") {
          context.method = "throw";
          context.arg = record.arg;
          context.delegate = null;
          return ContinueSentinel;
        }

        var info = record.arg;

        if (!info) {
          context.method = "throw";
          context.arg = new TypeError("iterator result is not an object");
          context.delegate = null;
          return ContinueSentinel;
        }

        if (info.done) {
          // Assign the result of the finished delegate to the temporary
          // variable specified by delegate.resultName (see delegateYield).
          context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

          context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
          // exception, let the outer generator proceed normally. If
          // context.method was "next", forget context.arg since it has been
          // "consumed" by the delegate iterator. If context.method was
          // "return", allow the original .return call to continue in the
          // outer generator.

          if (context.method !== "return") {
            context.method = "next";
            context.arg = undefined;
          }
        } else {
          // Re-yield the result returned by the delegate method.
          return info;
        } // The delegate iterator is finished, so forget it and continue with
        // the outer generator.


        context.delegate = null;
        return ContinueSentinel;
      } // Define Generator.prototype.{next,throw,return} in terms of the
      // unified ._invoke helper method.


      defineIteratorMethods(Gp);
      Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
      // @@iterator function is called on it. Some browsers' implementations of the
      // iterator prototype chain incorrectly implement this, causing the Generator
      // object to not be returned from this call. This ensures that doesn't happen.
      // See https://github.com/facebook/regenerator/issues/274 for more details.

      Gp[iteratorSymbol] = function () {
        return this;
      };

      Gp.toString = function () {
        return "[object Generator]";
      };

      function pushTryEntry(locs) {
        var entry = {
          tryLoc: locs[0]
        };

        if (1 in locs) {
          entry.catchLoc = locs[1];
        }

        if (2 in locs) {
          entry.finallyLoc = locs[2];
          entry.afterLoc = locs[3];
        }

        this.tryEntries.push(entry);
      }

      function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
      }

      function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [{
          tryLoc: "root"
        }];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
      }

      runtime.keys = function (object) {
        var keys = [];

        for (var key in object) {
          keys.push(key);
        }

        keys.reverse(); // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.

        return function next() {
          while (keys.length) {
            var key = keys.pop();

            if (key in object) {
              next.value = key;
              next.done = false;
              return next;
            }
          } // To avoid creating an additional object, we just hang the .value
          // and .done properties off the next function object itself. This
          // also ensures that the minifier will not anonymize the function.


          next.done = true;
          return next;
        };
      };

      function values(iterable) {
        if (iterable) {
          var iteratorMethod = iterable[iteratorSymbol];

          if (iteratorMethod) {
            return iteratorMethod.call(iterable);
          }

          if (typeof iterable.next === "function") {
            return iterable;
          }

          if (!isNaN(iterable.length)) {
            var i = -1,
                next = function next() {
              while (++i < iterable.length) {
                if (hasOwn.call(iterable, i)) {
                  next.value = iterable[i];
                  next.done = false;
                  return next;
                }
              }

              next.value = undefined;
              next.done = true;
              return next;
            };

            return next.next = next;
          }
        } // Return an iterator with no values.


        return {
          next: doneResult
        };
      }

      runtime.values = values;

      function doneResult() {
        return {
          value: undefined,
          done: true
        };
      }

      Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
          this.prev = 0;
          this.next = 0; // Resetting context._sent for legacy support of Babel's
          // function.sent implementation.

          this.sent = this._sent = undefined;
          this.done = false;
          this.delegate = null;
          this.method = "next";
          this.arg = undefined;
          this.tryEntries.forEach(resetTryEntry);

          if (!skipTempReset) {
            for (var name in this) {
              // Not sure about the optimal order of these conditions:
              if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                this[name] = undefined;
              }
            }
          }
        },
        stop: function stop() {
          this.done = true;
          var rootEntry = this.tryEntries[0];
          var rootRecord = rootEntry.completion;

          if (rootRecord.type === "throw") {
            throw rootRecord.arg;
          }

          return this.rval;
        },
        dispatchException: function dispatchException(exception) {
          if (this.done) {
            throw exception;
          }

          var context = this;

          function handle(loc, caught) {
            record.type = "throw";
            record.arg = exception;
            context.next = loc;

            if (caught) {
              // If the dispatched exception was caught by a catch block,
              // then let that catch block handle the exception normally.
              context.method = "next";
              context.arg = undefined;
            }

            return !!caught;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            var record = entry.completion;

            if (entry.tryLoc === "root") {
              // Exception thrown outside of any try block that could handle
              // it, so set the completion value of the entire function to
              // throw the exception.
              return handle("end");
            }

            if (entry.tryLoc <= this.prev) {
              var hasCatch = hasOwn.call(entry, "catchLoc");
              var hasFinally = hasOwn.call(entry, "finallyLoc");

              if (hasCatch && hasFinally) {
                if (this.prev < entry.catchLoc) {
                  return handle(entry.catchLoc, true);
                } else if (this.prev < entry.finallyLoc) {
                  return handle(entry.finallyLoc);
                }
              } else if (hasCatch) {
                if (this.prev < entry.catchLoc) {
                  return handle(entry.catchLoc, true);
                }
              } else if (hasFinally) {
                if (this.prev < entry.finallyLoc) {
                  return handle(entry.finallyLoc);
                }
              } else {
                throw new Error("try statement without catch or finally");
              }
            }
          }
        },
        abrupt: function abrupt(type, arg) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];

            if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
              var finallyEntry = entry;
              break;
            }
          }

          if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
            // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
          }

          var record = finallyEntry ? finallyEntry.completion : {};
          record.type = type;
          record.arg = arg;

          if (finallyEntry) {
            this.method = "next";
            this.next = finallyEntry.finallyLoc;
            return ContinueSentinel;
          }

          return this.complete(record);
        },
        complete: function complete(record, afterLoc) {
          if (record.type === "throw") {
            throw record.arg;
          }

          if (record.type === "break" || record.type === "continue") {
            this.next = record.arg;
          } else if (record.type === "return") {
            this.rval = this.arg = record.arg;
            this.method = "return";
            this.next = "end";
          } else if (record.type === "normal" && afterLoc) {
            this.next = afterLoc;
          }

          return ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];

            if (entry.finallyLoc === finallyLoc) {
              this.complete(entry.completion, entry.afterLoc);
              resetTryEntry(entry);
              return ContinueSentinel;
            }
          }
        },
        "catch": function _catch(tryLoc) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];

            if (entry.tryLoc === tryLoc) {
              var record = entry.completion;

              if (record.type === "throw") {
                var thrown = record.arg;
                resetTryEntry(entry);
              }

              return thrown;
            }
          } // The context.catch method must only be called with a location
          // argument that corresponds to a known catch block.


          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
          this.delegate = {
            iterator: values(iterable),
            resultName: resultName,
            nextLoc: nextLoc
          };

          if (this.method === "next") {
            // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
          }

          return ContinueSentinel;
        }
      };
    }( // In sloppy mode, unbound `this` refers to the global object, fallback to
    // Function constructor if we're in global strict mode. That is sadly a form
    // of indirect eval which violates Content Security Policy.
    function () {
      return this;
    }() || Function("return this")());
  });
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  // This method of obtaining a reference to the global object needs to be
  // kept identical to the way it is obtained in runtime.js

  var g = function () {
    return this;
  }() || Function("return this")(); // Use `getOwnPropertyNames` because not all browsers support calling
  // `hasOwnProperty` on the global `self` object in a worker. See #183.


  var hadRuntime = g.regeneratorRuntime && Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0; // Save the old regeneratorRuntime in case it needs to be restored later.

  var oldRuntime = hadRuntime && g.regeneratorRuntime; // Force reevalutation of runtime.js.

  g.regeneratorRuntime = undefined;
  var runtimeModule = runtime;

  if (hadRuntime) {
    // Restore the original runtime.
    g.regeneratorRuntime = oldRuntime;
  } else {
    // Remove the global property added by runtime.js.
    try {
      delete g.regeneratorRuntime;
    } catch (e) {
      g.regeneratorRuntime = undefined;
    }
  }

  var regenerator = runtimeModule;
  /**
   * Interface for classes that may emit linear VAST events.
   *
   * @interface LinearEvents
   */

  /**
   * Fires when the the creative was played to the end at normal speed so that 100% of the creative was played.
   *
   * @event LinearEvents#complete
   */

  var complete = 'complete';
  /**
   * Fires when a user clicks the ad.
   *
   * @event LinearEvents#clickThrough
   */

  var clickThrough = 'clickThrough';
  /**
   * Fires when there was an error with the linear creative.
   *
   * @event LinearEvents#error
   */

  var error = 'error';
  /**
   * Fires when the creative played continuously for at least 25% of the total duration at normal speed.
   *
   * @event LinearEvents#firstQuartile
   */

  var firstQuartile = 'firstQuartile';
  /**
   * Fires when there was an impression of the linear creative.
   *
   * @event LinearEvents#impression
   */

  var impression = 'impression';
  /**
   * Fires when the creative played continuously for at least 50% of the total duration at normal speed.
   *
   * @event LinearEvents#midpoint
   */

  var midpoint = 'midpoint';
  /**
   * Fires when the user activated the mute control and muted the creative.
   *
   * @event LinearEvents#mute
   */

  var mute = 'mute';
  /**
   * Optional metric that can capture all other user interactions under one metric such a s hover-overs, or custom clicks. It should NOT replace clickthrough events or other existing events like mute, unmute, pause, etc.
   *
   * @event LinearEvents#otherAdInteraction
   */

  var otherAdInteraction = 'otherAdInteraction';
  /**
   * Fires when the user clicked the pause control and stopped the creative.
   *
   * @event LinearEvents#pause
   */

  var pause = 'pause';
  /**
   * Fires when the user activated a control to reduce player to a smaller size. This event replaces the exitFullscreen event per the 2014 Digital Video In-Stream Ad Metric Definitions.
   *
   * @event LinearEvents#playerCollapse
   */

  var playerCollapse = 'playerCollapse';
  /**
   * Fires when the user activated a control to reduce player to a smaller size.
   *
   * @event LinearEvents#exitFullscreen
   */

  var exitFullscreen = 'exitFullscreen';
  /**
   * Fires when the user activated a control to extend the player to a larger size. This event replaces the fullscreen event per the 2014 Digital Video In-Stream Ad Metric Definitions.
   *
   * @event LinearEvents#playerExpand
   */

  var playerExpand = 'playerExpand';
  /**
   * Fires when the user activated a control to extend the player to a larger size. Only for VAST 3.
   *
   * @event LinearEvents#fullscreen
   */

  var fullscreen = 'fullscreen';
  /**
   * Fires when the creative played for a duration at normal speed that is equal to or greater than the value provided in an additional offset attribute for the <Tracking> element under Linear ads. Values can be time in the format HH:MM:SS or HH:MM:SS.mmm or a percentage value in the format n%.
   *
   * @event LinearEvents#progress
   */

  var progress = 'progress';
  /**
   * Fires when the user activated the resume control after the creative had been stopped or paused.
   *
   * @event LinearEvents#resume
   */

  var resume = 'resume';
  /**
   * Fires when the user activated the rewind control to access a previous point in the creative timeline.
   *
   * @event LinearEvents#rewind
   */

  var rewind = 'rewind';
  /**
   * Fires when the user activated a skip control to skip the creative.
   *
   * @event LinearEvents#skip
   */

  var skip = 'skip';
  /**
   * This event is used to indicate that an individual creative within the ad was loaded and playback began. As with creativeView, this event is another way of tracking creative playback.
   *
   * @event LinearEvents#start
   */

  var start = 'start';
  /**
   * Fires when the creative played continuously for at least 75% of the duration at normal speed.
   *
   * @event LinearEvents#thirdQuartile
   */

  var thirdQuartile = 'thirdQuartile';
  /**
   * Amount of video viewed at normal speed in seconds or other appropriate time-based units. If a rewind event occurs during play, time spent viewing may be calculated on total amount of video viewed at normal speed, which may include additional amounts of video viewed after rewinding. The offset attribute for the <Tracking> element under Linear ads may be used to track when time spent viewing meets the threshold. Otherwise, a macro may be provided so that the player may return a time value. VAST does not provide a standard macro for this value, so the involved parties must establish these parameters if this metric is to be used.
   *
   * @event LinearEvents#timeSpentViewing
   */

  var timeSpentViewing = 'timeSpentViewing';
  /**
   * Fires when the user activated the mute control and unmuted the creative.
   *
   * @event LinearEvents#unmute
   */

  var unmute = 'unmute';
  /**
   * Fires when the user clicked the creative icon.
   *
   * @event LinearEvents#iconClick
   */

  var iconClick = 'iconClick';
  /**
   * Fires when the user viewed the creative icon.
   *
   * @event LinearEvents#iconView
   */

  var iconView = 'iconView';
  /**
   * The viewer has chosen to close the linear ad unit. This is currently inuse by some of the largest mobile SDKs to mark the dismissal of the end card companion that follows the video, as well as a close of the video itself, if applicable
   *
   * @event LinearEvents#closeLinear
   */

  var closeLinear = 'closeLinear';
  var linearEvents = {
    clickThrough: clickThrough,
    closeLinear: closeLinear,
    complete: complete,
    error: error,
    exitFullscreen: exitFullscreen,
    firstQuartile: firstQuartile,
    fullscreen: fullscreen,
    iconClick: iconClick,
    iconView: iconView,
    impression: impression,
    midpoint: midpoint,
    mute: mute,
    otherAdInteraction: otherAdInteraction,
    pause: pause,
    playerCollapse: playerCollapse,
    playerExpand: playerExpand,
    progress: progress,
    resume: resume,
    rewind: rewind,
    skip: skip,
    start: start,
    thirdQuartile: thirdQuartile,
    timeSpentViewing: timeSpentViewing,
    unmute: unmute
  };
  /**
   * Interface for classes that may emit non linear VAST events.
   *
   * @interface NonLinearEvents
   */

  /**
   * Fires when the user clicked or otherwise activated a control used to pause streaming content, which either expands the ad within the player’s viewable area or “takes-over” the streaming content area by launching an additional portion of the ad.
   *
   * @event NonLinearEvents#acceptInvitation
   */

  var acceptInvitation = 'acceptInvitation';
  /**
   * Fires when the user clicked or otherwise activated a control used to pause streaming content, which either expands the ad within the player’s viewable area or “takes-over” the streaming content area by launching an additional portion of the ad.
   *
   * @event NonLinearEvents#adCollapse
   */

  var adCollapse = 'adCollapse';
  /**
   * Not to be confused with an impression, this event indicates that an individual creative portion of the ad was viewed.
   *
   * @event NonLinearEvents#creativeView
   */

  var creativeView = 'creativeView';
  /**
   * Fires when the user clicked or otherwise activated a control for removing the ad.
   *
   * @event NonLinearEvents#close
   */

  var close = 'close';
  var nonLinearEvents = {
    acceptInvitation: acceptInvitation,
    adCollapse: adCollapse,
    close: close,
    creativeView: creativeView
  };

  var innerXML = function innerXML(node) {
    var s = new XMLSerializer();
    return Array.prototype.map.call(node.childNodes, function (node) {
      return s.serializeToString(node);
    }).join('');
  };

  var getParseError = function getParseError(doc) {
    // Firefox
    if (doc.documentElement.tagName === 'parsererror' && doc.documentElement.namespaceURI === 'http://www.mozilla.org/newlayout/xml/parsererror.xml') {
      return doc.documentElement;
    } // Chrome, Safari


    if ((doc.documentElement.tagName === 'xml' || doc.documentElement.tagName === 'html') && doc.documentElement.childNodes && doc.documentElement.childNodes.length > 0 && doc.documentElement.childNodes[0].nodeName === 'parsererror') {
      return doc.documentElement.childNodes[0];
    } // PhantomJS


    if (doc.documentElement.tagName === 'html' && doc.documentElement.childNodes && doc.documentElement.childNodes.length > 0 && doc.documentElement.childNodes[0].nodeName === 'body' && doc.documentElement.childNodes[0].childNodes && doc.documentElement.childNodes[0].childNodes.length && doc.documentElement.childNodes[0].childNodes[0].nodeName === 'parsererror') {
      return doc.documentElement.childNodes[0].childNodes[0];
    }

    return undefined;
  };

  var errorMessagePatterns = [// Chrome, Safari, PhantomJS
  new RegExp('^<h3[^>]*>This page contains the following errors:<\/h3><div[^>]*>(.+?)\n?<\/div>'), // Firefox
  new RegExp('^(.+)\n')];

  var extractParseError = function extractParseError(errorNode) {
    var content = innerXML(errorNode);
    var i, match;

    for (i = 0; i < errorMessagePatterns.length; i++) {
      match = errorMessagePatterns[i].exec(content);

      if (match) {
        return match[1];
      }
    }

    return undefined;
  };

  var failOnParseError = function failOnParseError(doc) {
    var errorMessage;

    if (doc === null) {
      throw new Error('Parse error');
    }

    var parseError = getParseError(doc);

    if (parseError !== undefined) {
      errorMessage = extractParseError(parseError) || 'Parse error';
      throw new Error(errorMessage);
    }
  };

  var failOnParseError_1 = function failOnParseError_1(doc) {
    failOnParseError(doc);
    return doc;
  };

  var saneDomparserError = {
    failOnParseError: failOnParseError_1
  };
  var TYPE = {
    CDATA: 'cdata',
    DOCUMENT: 'document',
    ELEMENT: 'element',
    TEXT: 'text'
  };

  var nodeType = function nodeType(node) {
    if (node.nodeType === 1) {
      return TYPE.ELEMENT;
    }

    if (node.nodeType === 3 || node.nodeType === 4) {
      return TYPE.TEXT;
    }

    if (node.nodeType === 9) {
      return TYPE.DOCUMENT;
    }

    throw new Error('Unsupported element type');
  };

  var xmlToJson = function xmlToJson(node) {
    var type = nodeType(node);
    var obj = {
      type: type
    };

    if (type === TYPE.ELEMENT) {
      obj.name = node.nodeName.toLowerCase();

      if (node.attributes.length > 0) {
        obj.attributes = {};
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = Array.from(node.attributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var attribute = _step.value;
            obj.attributes[attribute.nodeName] = attribute.nodeValue;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    } else if (type === TYPE.TEXT) {
      obj.text = node.nodeValue.replace('<![CDATA[', '').replace(']]>', '').trim();
    } // do children


    if (node.hasChildNodes()) {
      var childNodes = Array.from(node.childNodes).filter(function (childNode) {
        return [1, 3, 4].includes(childNode.nodeType);
      });
      var elements = [];
      obj.elements = elements;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = childNodes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var childNode = _step2.value;
          var childObj = xmlToJson(childNode);

          if (childObj.type !== TYPE.TEXT || childObj.text.length > 0) {
            elements.push(childObj);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }

    return obj;
  };
  /* eslint-disable filenames/match-regex, id-match */


  var xml2js = function xml2js(parser, xmlText) {
    var xmlDom = parser.parseFromString(xmlText, 'application/xml');
    saneDomparserError.failOnParseError(xmlDom);
    return xmlToJson(xmlDom);
  };

  var getChildren = function getChildren() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$elements = _ref.elements,
        elements = _ref$elements === undefined ? [] : _ref$elements;

    return elements;
  };

  var findChildByName = function findChildByName(element, childName) {
    return getChildren(element).find(function (_ref2) {
      var _ref2$name = _ref2.name,
          name = _ref2$name === undefined ? '' : _ref2$name;
      return name.toUpperCase() === childName.toUpperCase();
    });
  };

  var filterChildrenByName = function filterChildrenByName(element, childrenName) {
    return getChildren(element).filter(function (_ref3) {
      var _ref3$name = _ref3.name,
          name = _ref3$name === undefined ? '' : _ref3$name;
      return name.toUpperCase() === childrenName.toUpperCase();
    });
  };
  /**
   * Get the first child element from the passed parsed xml element.
   *
   * @memberof module:@mailonline/vast-xml2js
   * @param {Object} element - Parsed xml element object.
   * @param {string} childName - Child element name
   * @returns {Object|undefined} - the first child element with the passed name or undefined if not found.
   */


  var get = findChildByName;
  /**
   * Get all the children elements of the passed parsed xml element filtered by the passed child name if passed.
   *
   * @memberof module:@mailonline/vast-xml2js
   * @param {Object} element - Parsed xml element object.
   * @param {string} [childName] - Child element name.
   * @returns {Array} - Array of child elements or an empty array.
   */

  var getAll = function getAll(element, childName) {
    if (typeof childName === 'string') {
      return filterChildrenByName(element, childName);
    }

    return getChildren(element);
  };
  /**
   * Get the first child element from the passed parsed xml element.
   *
   * @memberof module:@mailonline/vast-xml2js
   * @returns {Object|null} - the first child element or undefined if there are non.
   */


  var getFirstChild = function getFirstChild(element) {
    return getChildren(element)[0] || null;
  };
  /**
   * Get the text value of the passed parsed xml element or null if there is non.
   *
   * @memberof module:@mailonline/vast-xml2js
   * @returns {string|null} - text of the element or null.
   */


  var getText = function getText(element) {
    var firstChild = element && getFirstChild(element);
    return firstChild && firstChild.text || null;
  };
  /**
   * Get all the attributes of the passed parsed xml element.
   *
   * @memberof module:@mailonline/vast-xml2js
   * @returns {Object} - Object with the element attributes.
   */


  var getAttributes = function getAttributes() {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref4$attributes = _ref4.attributes,
        attributes = _ref4$attributes === undefined ? {} : _ref4$attributes;

    return attributes;
  };
  /**
   * Get the attribute with the passed name of the passed parsed xml element.
   *
   * @memberof module:@mailonline/vast-xml2js
   * @returns {number|string|undefined} - Attribute value or undefined.
   */


  var getAttribute = function getAttribute(element, attributeName) {
    return getAttributes(element)[attributeName];
  };

  var parser = new DOMParser();
  /**
   * Parses the passed xml text.
   *
   * @global
   * @typedef parseXml
   * @throws if there is an error parsing the xml.
   * @param {string} xmlText - XML text to be parsed.
   * @returns {Object} - Returns the parsed xml document as a js object.
   * @static
   */

  var parseXml = function parseXml(xmlText) {
    return xml2js(parser, xmlText);
  };

  var parseHoursToMs = function parseHoursToMs(hourStr) {
    return parseInt(hourStr, 10) * 60 * 60 * 1000;
  };

  var parseMinToMs = function parseMinToMs(minStr) {
    return parseInt(minStr, 10) * 60 * 1000;
  };

  var parseSecToMs = function parseSecToMs(secStr) {
    return parseInt(secStr, 10) * 1000;
  };

  var parseTime = function parseTime(durationStr) {
    if (typeof durationStr === 'string') {
      var durationRegex = /(\d\d):(\d\d):(\d\d)(\.(\d\d\d))?/;
      var match = durationStr.match(durationRegex);

      if (match) {
        var durationInMs = parseHoursToMs(match[1]) + parseMinToMs(match[2]) + parseSecToMs(match[3]) + parseInt(match[5] || 0, 10);

        if (!isNaN(durationInMs)) {
          return durationInMs;
        }
      }
    }

    return null;
  };

  var isPercentage = function isPercentage(offset) {
    var percentageRegex = /^\d+(\.\d+)?%$/g;
    return percentageRegex.test(offset);
  };

  var parseOffset = function parseOffset(offset) {
    if (isPercentage(offset)) {
      return offset;
    }

    return parseTime(offset);
  };

  var getLinearCreative = function getLinearCreative(ad) {
    var adTypeElement = getFirstChild(ad);
    var creativesElement = adTypeElement && get(adTypeElement, 'creatives');

    var hasLinear = function hasLinear(creative) {
      return get(creative, 'linear');
    };

    return creativesElement && getAll(creativesElement).find(hasLinear) || null;
  };

  var getLinearTrackingEvents = function getLinearTrackingEvents(ad, eventName) {
    var creativeElement = ad && getLinearCreative(ad);

    if (creativeElement) {
      var linearElement = get(creativeElement, 'Linear');
      var trackingEventsElement = linearElement && get(linearElement, 'TrackingEvents');
      var trackingEventElements = trackingEventsElement && getAll(trackingEventsElement, 'Tracking');

      if (trackingEventElements && trackingEventElements.length > 0) {
        var trackingEvents = trackingEventElements.map(function (trackingEventElement) {
          var _getAttributes = getAttributes(trackingEventElement),
              event = _getAttributes.event,
              offset = _getAttributes.offset;

          var uri = getText(trackingEventElement);
          return {
            event: event,
            offset: offset && parseOffset(offset),
            uri: uri
          };
        });

        if (eventName) {
          var filteredEvents = trackingEvents.filter(function (_ref) {
            var event = _ref.event;
            return event === eventName;
          });

          if (filteredEvents.length > 0) {
            return filteredEvents;
          }
        } else {
          return trackingEvents;
        }
      }
    }

    return null;
  };

  var getNonLinearTrackingEvents = function getNonLinearTrackingEvents(ad, eventName) {
    var creativeElement = ad && getLinearCreative(ad);

    if (creativeElement) {
      var NonLinearAdsElement = get(creativeElement, 'NonLinearAds');
      var trackingEventsElement = NonLinearAdsElement && get(NonLinearAdsElement, 'TrackingEvents');
      var trackingEventElements = trackingEventsElement && getAll(trackingEventsElement, 'Tracking');

      if (trackingEventElements && trackingEventElements.length > 0) {
        var trackingEvents = trackingEventElements.map(function (trackingEventElement) {
          var _getAttributes = getAttributes(trackingEventElement),
              event = _getAttributes.event;

          var uri = getText(trackingEventElement);
          return {
            event: event,
            uri: uri
          };
        });

        if (eventName) {
          var filteredEvents = trackingEvents.filter(function (_ref) {
            var event = _ref.event;
            return event === eventName;
          });

          if (filteredEvents.length > 0) {
            return filteredEvents;
          }
        } else {
          return trackingEvents;
        }
      }
    }

    return null;
  };

  var asyncToGenerator = function asyncToGenerator(fn) {
    return function () {
      var gen = fn.apply(this, arguments);
      return new Promise(function (resolve, reject) {
        function step(key, arg) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }

          if (info.done) {
            resolve(value);
          } else {
            return Promise.resolve(value).then(function (value) {
              step("next", value);
            }, function (err) {
              step("throw", err);
            });
          }
        }

        return step("next");
      });
    };
  };

  var classCallCheck = function classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  var createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var defineProperty = function defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  };

  var _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var get$1 = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);

    if (desc === undefined) {
      var parent = Object.getPrototypeOf(object);

      if (parent === null) {
        return undefined;
      } else {
        return get(parent, property, receiver);
      }
    } else if ("value" in desc) {
      return desc.value;
    } else {
      var getter = desc.get;

      if (getter === undefined) {
        return undefined;
      }

      return getter.call(receiver);
    }
  };

  var inherits = function inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  };

  var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  };

  var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
  };

  var toConsumableArray = function toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return Array.from(arr);
    }
  };

  var formatSize = function formatSize(size) {
    var match = ('' + size).match(/\d+/g);
    return parseInt(match[0], 10);
  };

  var formatPosition = function formatPosition(position) {
    var isNumberString = /\d+/.test(position);

    if (isNumberString) {
      return formatSize(position);
    }

    return position;
  };

  var getIconAttributes = function getIconAttributes(iconElement) {
    var _getAttributes = getAttributes(iconElement),
        duration = _getAttributes.duration,
        height = _getAttributes.height,
        offset = _getAttributes.offset,
        program = _getAttributes.program,
        pxratio = _getAttributes.pxratio,
        width = _getAttributes.width,
        _getAttributes$xPosit = _getAttributes.xPosition,
        xPosition = _getAttributes$xPosit === undefined ? 'right' : _getAttributes$xPosit,
        _getAttributes$yPosit = _getAttributes.yPosition,
        yPosition = _getAttributes$yPosit === undefined ? 'top' : _getAttributes$yPosit;

    return {
      duration: duration && parseTime(duration),
      height: height && formatSize(height),
      offset: offset && parseTime(offset),
      program: program,
      pxratio: pxratio && parseInt(pxratio, 10),
      width: width && formatSize(width),
      xPosition: xPosition && formatPosition(xPosition),
      yPosition: yPosition && formatPosition(yPosition)
    };
  };

  var getIconResource = function getIconResource(iconElement) {
    var staticResourceElement = get(iconElement, 'StaticResource');
    var htmlResourceElement = get(iconElement, 'HTMLResource');
    var iFrameResourceElement = get(iconElement, 'IFrameResource');

    if (staticResourceElement) {
      return {
        staticResource: getText(staticResourceElement)
      };
    }

    if (htmlResourceElement) {
      return {
        htmlResource: getText(htmlResourceElement)
      };
    }

    if (iFrameResourceElement) {
      return {
        iFrameResource: getText(iFrameResourceElement)
      };
    }

    return {
      staticResource: getText(iconElement)
    };
  };

  var getIconViewTracking = function getIconViewTracking(iconElement) {
    var iconTrackingElements = getAll(iconElement, 'IconViewTracking').map(function (iconViewTrackingElement) {
      return getText(iconViewTrackingElement);
    });

    if (iconTrackingElements.length === 0) {
      return {};
    }

    return {
      iconViewTracking: iconTrackingElements
    };
  };

  var getIconClicks = function getIconClicks(iconElement) {
    var iconClicksElement = get(iconElement, 'IconClicks');
    var iconClickThroughElement = iconClicksElement && get(iconClicksElement, 'IconClickThrough');
    var iconClickTrackingElements = iconClicksElement && getAll(iconClicksElement, 'IconClickTracking').map(function (iconClickTrackingElement) {
      return getText(iconClickTrackingElement);
    });
    return {
      iconClickThrough: iconClickThroughElement && getText(iconClickThroughElement),
      iconClickTracking: iconClickTrackingElements && iconClickTrackingElements.length > 0 ? iconClickTrackingElements : undefined
    };
  };

  var getIcons = function getIcons(ad) {
    var linearCreativeElement = ad && getLinearCreative(ad);
    var linearElement = linearCreativeElement && get(linearCreativeElement, 'linear');
    var iconsElement = linearElement && get(linearElement, 'Icons');
    var iconElements = iconsElement && getAll(iconsElement, 'Icon');

    if (iconElements && iconElements.length > 0) {
      return iconElements.map(function (iconElement) {
        return _extends$1({}, getIconAttributes(iconElement), getIconResource(iconElement), getIconViewTracking(iconElement), getIconClicks(iconElement));
      });
    }

    return null;
  };
  /**
   * @memberof module:@mailonline/video-ad-sdk
   * @description Published as part of {@link module:@mailonline/video-ad-sdk}
   * @module vastSelectors
   */


  var getBooleanValue = function getBooleanValue(val) {
    if (typeof val === 'string') {
      return val === 'true';
    }

    return Boolean(val);
  };

  var compareBySequence = function compareBySequence(itemA, itemB) {
    var itemASequence = parseInt(getAttribute(itemA, 'sequence'), 10);
    var itemBSequence = parseInt(getAttribute(itemB, 'sequence'), 10);

    if (itemASequence < itemBSequence) {
      return -1;
    }

    if (itemASequence > itemBSequence) {
      return 1;
    }

    return 0;
  };
  /**
   * Selects the ads of the passed VAST.
   *
   * @function
   * @param {ParsedVast} parsedVAST - Parsed VAST xml.
   * @returns {?Array} - Array of ads or empty array.
   * @static
   */


  var getAds = function getAds(parsedVAST) {
    var vastElement = parsedVAST && get(parsedVAST, 'VAST');
    var ads = vastElement && getAll(vastElement, 'Ad');

    if (ads && ads.length > 0) {
      return ads;
    }

    return [];
  };
  /**
   * Gets the Error URI of the passed parsed VAST xml.
   *
   * @function
   * @param {ParsedVast} parsedVAST - Parsed VAST xml.
   * @returns {?VAST-macro} - Vast Error URI or `null` otherwise.
   * @static
   */


  var getVastErrorURI = function getVastErrorURI(parsedVAST) {
    var vastElement = parsedVAST && get(parsedVAST, 'VAST');

    if (vastElement) {
      var error = get(vastElement, 'Error');

      if (error) {
        return getText(error);
      }
    }

    return null;
  };
  /**
   * Gets the sequence of the pod ad.
   *
   * @function
   * @param {ParsedAd} ad - Parsed ad definition object.
   * @returns {?number} - The pod ad sequence number or `null`.
   * @static
   */


  var getPodAdSequence = function getPodAdSequence(ad) {
    var sequence = parseInt(getAttribute(ad, 'sequence'), 10);

    if (typeof sequence === 'number' && !isNaN(sequence)) {
      return sequence;
    }

    return null;
  };
  /**
   * Checks if the passed ad definition is a pod ad.
   *
   * @function
   * @param {ParsedAd} ad - Parsed ad definition object.
   * @returns {?boolean} - Returns true if there the ad is a pod ad and false otherwise.
   * @static
   */


  var isPodAd = function isPodAd(ad) {
    return Boolean(getPodAdSequence(ad));
  };
  /**
   * Checks if the passed array of ads have an ad pod.
   *
   * @function
   * @param {ParsedVAST} parsedVAST - Parsed VAST xml.
   * @returns {?boolean} - Returns true if there is an ad pod in the array and false otherwise.
   * @static
   */


  var hasAdPod = function hasAdPod(parsedVAST) {
    var ads = getAds(parsedVAST);
    return Array.isArray(ads) && ads.filter(isPodAd).length > 1;
  };
  /**
   * Returns true if the passed VastChain has an ad pod or false otherwise.
   *
   * @function
   * @param {Array} VastChain - Array of VAST responses. See `load` or `requestAd` for more info.
   *
   * @returns {boolean} - True if the VastChain contains an ad pod and false otherwise.
   * @static
   */


  var isAdPod = function isAdPod() {
    var VastChain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return VastChain.map(function (_ref) {
      var parsedXML = _ref.parsedXML;
      return parsedXML;
    }).some(hasAdPod);
  };
  /**
   * Selects the first ad of the passed VAST. If the passed VAST response contains an ad pod it will return the first ad in the ad pod sequence.
   *
   * @function
   * @param {ParsedVAST} parsedVAST - Parsed VAST xml.
   * @returns {?ParsedAd} - First ad of the VAST xml or `null`.
   * @static
   */


  var getFirstAd = function getFirstAd(parsedVAST) {
    var ads = getAds(parsedVAST);

    if (Array.isArray(ads) && ads.length > 0) {
      if (hasAdPod(parsedVAST)) {
        return ads.filter(isPodAd).sort(compareBySequence)[0];
      }

      return ads[0];
    }

    return null;
  };
  /**
   * Checks if the passed ad is a Wrapper.
   *
   * @function
   * @param {ParsedAd} ad - VAST ad object.
   * @returns {boolean} - `true` if the ad contains a wrapper and `false` otherwise.
   * @static
   */


  var isWrapper = function isWrapper() {
    var ad = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Boolean(get(ad || {}, 'Wrapper'));
  };
  /**
   * Checks if the passed ad is an Inline.
   *
   * @function
   * @param {ParsedAd} ad - VAST ad object.
   * @returns {boolean} - Returns `true` if the ad contains an Inline or `false` otherwise.
   * @static
   */


  var isInline = function isInline(ad) {
    return Boolean(get(ad || {}, 'Inline'));
  };
  /**
   * Returns the VASTAdTagURI from the wrapper ad.
   *
   * @function
   * @param {ParsedAd} ad - VAST ad object.
   * @returns {?string} - Returns the VASTAdTagURI from the wrapper ad or `null` otherwise.
   * @static
   */


  var getVASTAdTagURI = function getVASTAdTagURI(ad) {
    var wrapperElement = get(ad, 'Wrapper');
    var vastAdTagURIElement = wrapperElement && get(wrapperElement, 'VastAdTagUri');

    if (vastAdTagURIElement) {
      return getText(vastAdTagURIElement) || null;
    }

    return null;
  };
  /**
   * Returns the options from the wrapper ad.
   *
   * @function
   * @param {Object} ad - VAST ad object.
   * @returns {WrapperOptions} - Returns the options from the wrapper ad.
   * @static
   */


  var getWrapperOptions = function getWrapperOptions(ad) {
    var _getAttributes = getAttributes(get(ad, 'Wrapper')),
        allowMultipleAds = _getAttributes.allowMultipleAds,
        fallbackOnNoAd = _getAttributes.fallbackOnNoAd,
        followAdditionalWrappers = _getAttributes.followAdditionalWrappers;

    var opts = {};

    if (allowMultipleAds) {
      opts.allowMultipleAds = getBooleanValue(allowMultipleAds);
    }

    if (fallbackOnNoAd) {
      opts.fallbackOnNoAd = getBooleanValue(fallbackOnNoAd);
    }

    if (followAdditionalWrappers) {
      opts.followAdditionalWrappers = getBooleanValue(followAdditionalWrappers);
    }

    return opts;
  };
  /**
   * Gets the Error URI of the passed ad.
   *
   * @function
   * @param {ParsedAd} ad - VAST ad object.
   * @returns {?string} - Vast ad Error URI or `null` otherwise.
   * @static
   */


  var getAdErrorURI = function getAdErrorURI(ad) {
    var adTypeElement = ad && getFirstChild(ad);

    if (adTypeElement) {
      var error = get(adTypeElement, 'Error');

      if (error) {
        return getText(error);
      }
    }

    return null;
  };
  /**
   * Gets the Impression URI of the passed ad.
   *
   * @function
   * @param {ParsedAd} ad - VAST ad object.
   * @returns {?string} - Vast ad Impression URI or `null` otherwise.
   * @static
   */


  var getImpressionUri = function getImpressionUri(ad) {
    var adTypeElement = ad && getFirstChild(ad);

    if (adTypeElement) {
      var impression = get(adTypeElement, 'Impression');

      if (impression) {
        return getText(impression);
      }
    }

    return null;
  };
  /**
   * Gets the ad's MediaFiles.
   *
   * @function
   * @param {ParsedAd} ad - VAST ad object.
   * @returns {?Array.<MediaFile>} - array of media files or null
   * @static
   */


  var getMediaFiles = function getMediaFiles(ad) {
    var creativeElement = ad && getLinearCreative(ad);

    if (creativeElement) {
      var universalAdIdElement = get(creativeElement, 'UniversalAdId');
      var universalAdId = universalAdIdElement && getText(universalAdIdElement) || null;
      var linearElement = get(creativeElement, 'Linear');
      var mediaFilesElement = get(linearElement, 'MediaFiles');
      var mediaFileElements = mediaFilesElement && getAll(mediaFilesElement, 'MediaFile');

      if (mediaFileElements && mediaFileElements.length > 0) {
        return mediaFileElements.map(function (mediaFileElement) {
          var src = getText(mediaFileElement);

          var _getAttributes2 = getAttributes(mediaFileElement),
              apiFramework = _getAttributes2.apiFramework,
              bitrate = _getAttributes2.bitrate,
              codec = _getAttributes2.codec,
              delivery = _getAttributes2.delivery,
              height = _getAttributes2.height,
              id = _getAttributes2.id,
              maintainAspectRatio = _getAttributes2.maintainAspectRatio,
              maxBitrate = _getAttributes2.maxBitrate,
              minBitrate = _getAttributes2.minBitrate,
              scalable = _getAttributes2.scalable,
              type = _getAttributes2.type,
              width = _getAttributes2.width;

          return {
            apiFramework: apiFramework,
            bitrate: bitrate,
            codec: codec,
            delivery: delivery,
            height: height,
            id: id,
            maintainAspectRatio: maintainAspectRatio,
            maxBitrate: maxBitrate,
            minBitrate: minBitrate,
            scalable: scalable,
            src: src,
            type: type,
            universalAdId: universalAdId,
            width: width
          };
        });
      }
    }

    return null;
  };
  /**
   * Gets the ad's InteractiveFiles. That were added with the `InteractiveCreativeFile` tag.
   *
   * @function
   * @param {ParsedAd} ad - VAST ad object.
   * @returns {?Array.<InteractiveFile>} - array of media files or null
   * @static
   */


  var getInteractiveCreativeFiles = function getInteractiveCreativeFiles(ad) {
    var creativeElement = ad && getLinearCreative(ad);

    if (creativeElement) {
      var linearElement = get(creativeElement, 'Linear');
      var mediaFilesElement = get(linearElement, 'MediaFiles');
      var interactiveElements = mediaFilesElement && getAll(mediaFilesElement, 'InteractiveCreativeFile');

      if (interactiveElements && interactiveElements.length > 0) {
        return interactiveElements.map(function (interactiveElement) {
          var _getAttributes3 = getAttributes(interactiveElement),
              apiFramework = _getAttributes3.apiFramework,
              type = _getAttributes3.type;

          var src = getText(interactiveElement);
          return {
            apiFramework: apiFramework,
            src: src,
            type: type
          };
        });
      }
    }

    return null;
  };
  /**
   * Gets all the ad's InteractiveFiles.
   *
   * @function
   * @param {ParsedAd} ad - VAST ad object.
   * @returns {?Array.<InteractiveFile>} - array of media files or null
   * @static
   */


  var getInteractiveFiles = function getInteractiveFiles(ad) {
    var interactiveFiles = getInteractiveCreativeFiles(ad);

    if (interactiveFiles) {
      return interactiveFiles;
    }

    var mediaFiles = getMediaFiles(ad);

    if (mediaFiles) {
      interactiveFiles = mediaFiles.filter(function (_ref2) {
        var _ref2$apiFramework = _ref2.apiFramework,
            apiFramework = _ref2$apiFramework === undefined ? '' : _ref2$apiFramework;
        return apiFramework.toLowerCase() === 'vpaid';
      }).map(function (_ref3) {
        var apiFramework = _ref3.apiFramework,
            src = _ref3.src,
            type = _ref3.type;
        return {
          apiFramework: apiFramework,
          src: src,
          type: type
        };
      });

      if (interactiveFiles.length > 0) {
        return interactiveFiles;
      }
    }

    return null;
  };

  var getVideoClicksElement = function getVideoClicksElement(ad) {
    var creativeElement = ad && getLinearCreative(ad);
    var linearElement = creativeElement && get(creativeElement, 'Linear');
    var videoClicksElement = linearElement && get(linearElement, 'VideoClicks');

    if (videoClicksElement) {
      return videoClicksElement;
    }

    return null;
  };
  /**
   * Gets the click through {@link VAST-macro}.
   *
   * @function
   * @param {ParsedAd} ad - VAST ad object.
   * @returns {?VAST-macro} - clickthrough macro
   * @static
   */


  var getClickThrough = function getClickThrough(ad) {
    var videoClicksElement = getVideoClicksElement(ad);
    var clickThroughElement = videoClicksElement && get(videoClicksElement, 'ClickThrough');

    if (clickThroughElement) {
      return getText(clickThroughElement);
    }

    return null;
  };
  /**
   * Gets the click through {@link VAST-macro}.
   *
   * @function
   * @param {ParsedAd} ad - VAST ad object.
   * @returns {?Array.<VAST-macro>} - click tracking macro
   * @static
   */


  var getClickTracking = function getClickTracking(ad) {
    var videoClicksElement = getVideoClicksElement(ad);
    var clickTrackingElements = videoClicksElement && getAll(videoClicksElement, 'ClickTracking');

    if (clickTrackingElements && clickTrackingElements.length > 0) {
      return clickTrackingElements.map(function (element) {
        return getText(element);
      });
    }

    return null;
  };
  /**
   * Gets the custom click {@link VAST-macro}.
   *
   * @function
   * @param {ParsedAd} ad - VAST ad object.
   * @returns {?Array.<VAST-macro>} - click tracking macro
   * @static
   */


  var getCustomClick = function getCustomClick(ad) {
    var videoClicksElement = getVideoClicksElement(ad);
    var customClickElements = videoClicksElement && getAll(videoClicksElement, 'CustomClick');

    if (customClickElements && customClickElements.length > 0) {
      return customClickElements.map(function (element) {
        return getText(element);
      });
    }

    return null;
  };
  /**
   * Gets the skipoffset.
   *
   * @function
   * @param {Object} ad - VAST ad object.
   * @returns {?ParsedOffset} - the time offset in milliseconds or a string with the percentage or null
   * @static
   */


  var getSkipOffset = function getSkipOffset(ad) {
    var creativeElement = ad && getLinearCreative(ad);
    var linearElement = creativeElement && get(creativeElement, 'Linear');
    var skipoffset = linearElement && getAttribute(linearElement, 'skipoffset');

    if (skipoffset) {
      return parseOffset(skipoffset);
    }

    return null;
  };

  var getLinearContent = function getLinearContent(xml) {
    var linearRegex = /<Linear([\s\S]*)<\/Linear/gm;
    var result = linearRegex.exec(xml);
    return result && result[1];
  };

  var getAdParametersContent = function getAdParametersContent(xml) {
    var paramsRegex = /<AdParameters[\s\w="]*>([\s\S]*)<\/AdParameters>/gm;
    var result = paramsRegex.exec(xml);
    return result && result[1].replace(/[\n\s]*<!\[CDATA\[[\n\s]*/, '').replace(/[\n\s]*\]\]>[\n\s]*$/, '') // unescape nested CDATA
    .replace(/\]\]\]\]><!\[CDATA\[>/, ']]>').trim();
  };

  var getXmlEncodedValue = function getXmlEncodedValue(xml) {
    var xmlEncodedRegex = /<AdParameters[\s]*xmlEncoded="(.*?)">/gmi;
    var result = xmlEncodedRegex.exec(xml);
    return Boolean(result) && result[1] === 'true';
  };
  /**
   * Gets the creative data.
   *
   * @function
   * @param {string} xml - VAST XML text.
   * @returns {Object} - with `AdParameters` as they come in the XML and a flag `xmlEncoded` to indicate if the ad parameters are xml encoded.
   * @static
   */


  var getCreativeData = function getCreativeData(xml) {
    var linearContent = getLinearContent(xml);
    var AdParameters = linearContent && getAdParametersContent(linearContent);
    var xmlEncoded = linearContent && getXmlEncodedValue(linearContent);
    return {
      AdParameters: AdParameters,
      xmlEncoded: xmlEncoded
    };
  };

  var index =
  /*#__PURE__*/
  Object.freeze({
    getAds: getAds,
    getVastErrorURI: getVastErrorURI,
    getPodAdSequence: getPodAdSequence,
    isPodAd: isPodAd,
    hasAdPod: hasAdPod,
    isAdPod: isAdPod,
    getFirstAd: getFirstAd,
    isWrapper: isWrapper,
    isInline: isInline,
    getVASTAdTagURI: getVASTAdTagURI,
    getWrapperOptions: getWrapperOptions,
    getAdErrorURI: getAdErrorURI,
    getImpressionUri: getImpressionUri,
    getMediaFiles: getMediaFiles,
    getInteractiveCreativeFiles: getInteractiveCreativeFiles,
    getInteractiveFiles: getInteractiveFiles,
    getClickThrough: getClickThrough,
    getClickTracking: getClickTracking,
    getCustomClick: getCustomClick,
    getSkipOffset: getSkipOffset,
    getCreativeData: getCreativeData,
    getIcons: getIcons,
    getLinearTrackingEvents: getLinearTrackingEvents,
    getNonLinearTrackingEvents: getNonLinearTrackingEvents
  });

  var toUpperKeys = function toUpperKeys(map) {
    var upperKeysMap = {};
    Object.keys(map).forEach(function (key) {
      upperKeysMap[key.toUpperCase()] = map[key];
    });
    return upperKeysMap;
  };
  /**
   * Parses the passed macro with the passed data and returns the resulting parsed Macro.
   * If no CACHEBUSTING property is passed in the data it will generate a random one on its own.
   * If no TIMESTAMP property is passed in the data it will generate a one on its own.
   *
   * @ignore
   * @param {string} macro - The string macro to be parsed.
   * @param {Object} data - The data used by the macro.
   * @returns {string} - The parsed macro.
   * @static
   */


  var parseMacro = function parseMacro(macro) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var parsedMacro = macro;
    var macroData = toUpperKeys(data);

    if (!Boolean(macroData.CACHEBUSTING)) {
      macroData.CACHEBUSTING = Math.round(Math.random() * 1.0e+10);
    }

    if (!Boolean(macroData.TIMESTAMP)) {
      macroData.TIMESTAMP = new Date().toISOString();
    }

    Object.keys(macroData).forEach(function (key) {
      var value = encodeURIComponent(macroData[key]);
      parsedMacro = parsedMacro.replace(new RegExp('\\[' + key + '\\]', 'gm'), value);
    });
    return parsedMacro;
  };
  /**
   * Creates a tracking image with the passed URL macro.
   *
   * @global
   * @typedef pixelTracker
   * @type TrackerFn
   * @name pixelTracker
   * @param {string} URLMacro - URL Macro that need to be tracked.
   * @param {Object} data - Data Object with the macros's variables.
   * @returns {HTMLImageElement} - Image element whose source is the parsed URL Macro.
   * @static
   */


  var pixelTracker = function pixelTracker(URLMacro, data) {
    var img = new Image();
    img.src = parseMacro(URLMacro, data);
    return img;
  };
  /**
   * Tracks an error.
   *
   * @ignore
   * @param {VastChain} vastChain - the ad VAST Chain.
   * @param {Object} options - Options Map. The allowed properties are:
   * @param {Object} [options.logger] - Optional logger instance.
   *                                    Must comply to the [Console interface](https://developer.mozilla.org/es/docs/Web/API/Console).
   *                                    Defaults to console.
   * @param {tracker} [options.tracker] - optional tracker to use for the actual tracking. Defaults to the pixel tracker.
   * @param {string} [options.errorCode] - error code. Needed if we are tracking an error.
   */


  var trackError = function trackError(vastChain, _ref) {
    var errorCode = _ref.errorCode,
        _ref$tracker = _ref.tracker,
        tracker = _ref$tracker === undefined ? pixelTracker : _ref$tracker;
    vastChain.forEach(function (_ref2) {
      var ad = _ref2.ad,
          parsedXML = _ref2.parsedXML;
      var errorURI = getAdErrorURI(ad) || getVastErrorURI(parsedXML);

      if (Boolean(errorURI)) {
        tracker(errorURI, {
          errorCode: errorCode
        });
      }
    });
  };

  var trackIconView = function trackIconView(vastChain, _ref) {
    var data = _ref.data,
        _ref$tracker = _ref.tracker,
        tracker = _ref$tracker === undefined ? pixelTracker : _ref$tracker;
    var iconViewTracking = data.iconViewTracking;

    if (Array.isArray(iconViewTracking)) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = iconViewTracking[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var trackUrl = _step.value;
          tracker(trackUrl, _extends$1({}, data));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  };

  var trackIconClick = function trackIconClick(vastChain, _ref) {
    var data = _ref.data,
        _ref$tracker = _ref.tracker,
        tracker = _ref$tracker === undefined ? pixelTracker : _ref$tracker;
    var iconClickTracking = data.iconClickTracking;

    if (Array.isArray(iconClickTracking)) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = iconClickTracking[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var trackUrl = _step.value;
          tracker(trackUrl, _extends$1({}, data));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  };

  var trackProgress = function trackProgress(vastChain, _ref) {
    var data = _ref.data,
        _ref$tracker = _ref.tracker,
        tracker = _ref$tracker === undefined ? pixelTracker : _ref$tracker;
    var progressUri = data.progressUri;

    if (Boolean(progressUri)) {
      tracker(progressUri, _extends$1({}, data));
    }
  };

  var createVastEventTracker = function createVastEventTracker(vastChainSelector) {
    return function (vastChain, _ref) {
      var data = _ref.data,
          _ref$tracker = _ref.tracker,
          tracker = _ref$tracker === undefined ? pixelTracker : _ref$tracker;
      vastChain.forEach(function (_ref2) {
        var ad = _ref2.ad;
        var value = vastChainSelector(ad);

        if (Boolean(value)) {
          switch (true) {
            case typeof value === 'string':
              {
                tracker(value, data);
                break;
              }

            case Array.isArray(value):
              {
                value.map(function (_ref3) {
                  var uri = _ref3.uri;
                  return tracker(uri, data);
                });
                break;
              }
          }
        }
      });
    };
  };

  var _linearTrackers;

  var clickTrackingSelector = function clickTrackingSelector(ad) {
    var trackingURIs = [];
    var clickTrackings = getClickTracking(ad);
    var customClicks = getCustomClick(ad);
    /* istanbul ignore else */

    if (Array.isArray(clickTrackings) && clickTrackings.length > 0) {
      trackingURIs.push.apply(trackingURIs, toConsumableArray(clickTrackings.map(function (uri) {
        return {
          uri: uri
        };
      })));
    }
    /* istanbul ignore else */


    if (Array.isArray(customClicks) && customClicks.length > 0) {
      trackingURIs.push.apply(trackingURIs, toConsumableArray(customClicks.map(function (uri) {
        return {
          uri: uri
        };
      })));
    }

    return trackingURIs;
  };

  var linearTrackingEventSelector = function linearTrackingEventSelector(event) {
    return function (ad) {
      return getLinearTrackingEvents(ad, event);
    };
  };

  var linearTrackers = (_linearTrackers = {}, defineProperty(_linearTrackers, clickThrough, createVastEventTracker(clickTrackingSelector)), defineProperty(_linearTrackers, closeLinear, createVastEventTracker(linearTrackingEventSelector(closeLinear))), defineProperty(_linearTrackers, complete, createVastEventTracker(linearTrackingEventSelector(complete))), defineProperty(_linearTrackers, error, trackError), defineProperty(_linearTrackers, exitFullscreen, createVastEventTracker(linearTrackingEventSelector(exitFullscreen))), defineProperty(_linearTrackers, firstQuartile, createVastEventTracker(linearTrackingEventSelector(firstQuartile))), defineProperty(_linearTrackers, fullscreen, createVastEventTracker(linearTrackingEventSelector(fullscreen))), defineProperty(_linearTrackers, iconClick, trackIconClick), defineProperty(_linearTrackers, iconView, trackIconView), defineProperty(_linearTrackers, impression, createVastEventTracker(getImpressionUri)), defineProperty(_linearTrackers, midpoint, createVastEventTracker(linearTrackingEventSelector(midpoint))), defineProperty(_linearTrackers, mute, createVastEventTracker(linearTrackingEventSelector(mute))), defineProperty(_linearTrackers, pause, createVastEventTracker(linearTrackingEventSelector(pause))), defineProperty(_linearTrackers, playerCollapse, createVastEventTracker(linearTrackingEventSelector(playerCollapse))), defineProperty(_linearTrackers, playerExpand, createVastEventTracker(linearTrackingEventSelector(playerExpand))), defineProperty(_linearTrackers, progress, trackProgress), defineProperty(_linearTrackers, resume, createVastEventTracker(linearTrackingEventSelector(resume))), defineProperty(_linearTrackers, rewind, createVastEventTracker(linearTrackingEventSelector(rewind))), defineProperty(_linearTrackers, skip, createVastEventTracker(linearTrackingEventSelector(skip))), defineProperty(_linearTrackers, start, createVastEventTracker(linearTrackingEventSelector(start))), defineProperty(_linearTrackers, thirdQuartile, createVastEventTracker(linearTrackingEventSelector(thirdQuartile))), defineProperty(_linearTrackers, unmute, createVastEventTracker(linearTrackingEventSelector(unmute))), _linearTrackers);
  /**
   * Tracks the passed linear event.
   *
   * @ignore
   * @param {string} event - name of the linear event we need to track. @see LinearEvents
   * @param {VastChain} vastChain - the ad VAST Chain.
   * @param {Object} options - Options Map. The allowed properties are:
   * @param {Object} [options.logger] - Optional logger instance.
   *                                    Must comply to the [Console interface](https://developer.mozilla.org/es/docs/Web/API/Console).
   *                                    Defaults to console.
   * @param {Object} [options.data] - additional data for the URL macro. See [VAST specification]{@link https://www.iab.com/guidelines/digital-video-ad-serving-template-vast-4-0/}
   * @param {tracker} [options.tracker] - optional tracker to use for the actual tracking. Defaults to the pixel tracker.
   * @param {string} [options.errorCode] - error code. Needed if we are tracking an error.
   */

  var trackLinearEvent = function trackLinearEvent(event, vastChain, _ref) {
    var data = _ref.data,
        errorCode = _ref.errorCode,
        _ref$tracker = _ref.tracker,
        tracker = _ref$tracker === undefined ? pixelTracker : _ref$tracker,
        _ref$logger = _ref.logger,
        logger = _ref$logger === undefined ? console : _ref$logger;
    var linearTracker = linearTrackers[event];

    if (linearTracker) {
      linearTracker(vastChain, {
        data: _extends$1({}, data, {
          errorCode: errorCode
        }),
        errorCode: errorCode,
        tracker: tracker
      });
    } else {
      logger.error('Event \'' + event + '\' cannot be tracked');
    }
  };

  var _linearTrackers$1;

  var trackingEventSelector = function trackingEventSelector(event) {
    return function (ad) {
      return getNonLinearTrackingEvents(ad, event);
    };
  };

  var linearTrackers$1 = (_linearTrackers$1 = {}, defineProperty(_linearTrackers$1, acceptInvitation, createVastEventTracker(trackingEventSelector(acceptInvitation))), defineProperty(_linearTrackers$1, adCollapse, createVastEventTracker(trackingEventSelector(adCollapse))), defineProperty(_linearTrackers$1, close, createVastEventTracker(trackingEventSelector(close))), defineProperty(_linearTrackers$1, creativeView, createVastEventTracker(trackingEventSelector(creativeView))), _linearTrackers$1);
  /**
   * Tracks the passed non linear event.
   *
   * @ignore
   * @param {string} event - name of the linear event we need to track. @see LinearEvents
   * @param {VastChain} vastChain - the ad VAST Chain.
   * @param {Object} options - Options Map. The allowed properties are:
   * @param {Object} [options.logger] - Optional logger instance.
   *                                    Must comply to the [Console interface](https://developer.mozilla.org/es/docs/Web/API/Console).
   *                                    Defaults to console.
   * @param {Object} [options.data] - additional data for the URL macro. See [VAST specification]{@link https://www.iab.com/guidelines/digital-video-ad-serving-template-vast-4-0/}
   * @param {tracker} [options.tracker] - optional tracker to use for the actual tracking. Defaults to the pixel tracker.
   */

  var trackNonLinearEvent = function trackNonLinearEvent(event, vastChain, _ref) {
    var data = _ref.data,
        _ref$tracker = _ref.tracker,
        tracker = _ref$tracker === undefined ? pixelTracker : _ref$tracker,
        _ref$logger = _ref.logger,
        logger = _ref$logger === undefined ? console : _ref$logger;
    var linearTracker = linearTrackers$1[event];

    if (linearTracker) {
      linearTracker(vastChain, {
        data: _extends$1({}, data),
        tracker: tracker
      });
    } else {
      logger.error('Event \'' + event + '\' cannot be tracked');
    }
  };
  /**
   * Loads the script source.
   *
   * @ignore
   * @param {string} src - The script source.
   * @param {Object} options - The allowed options are:
   *                           type: Defaults to 'text/javascript'.
   *                           async<Boolean> : if "true" the "async" attribute is added to the new script. Defaults to false.
   *                           defer<Boolean> : if "true" the "defer" attribute is added to the new script. Defaults to false.
   *                           placeholder: Element that should contain the script. Defaults to the parentNode of the currentScript or
   *                                        if missing to document.head .
   */


  var loadScript$1 = function loadScript(src) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$async = _ref.async,
        async = _ref$async === undefined ? false : _ref$async,
        _ref$defer = _ref.defer,
        defer = _ref$defer === undefined ? false : _ref$defer,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'text/javascript' : _ref$type,
        placeholder = _ref.placeholder;

    if (!src) {
      throw new TypeError('Missing required "src" parameter');
    }

    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      var scriptPlaceholder = placeholder;
      script.type = type;
      script.async = async;
      script.defer = defer;

      script.onerror = function () {
        return reject(new URIError('The script ' + src + ' is not accessible.'));
      };

      script.onload = function () {
        return resolve(script);
      };

      if (!scriptPlaceholder) {
        scriptPlaceholder = document.currentScript ?
        /* istanbul ignore next */
        document.currentScript.parentNode : document.head;
      }

      script.src = src;
      scriptPlaceholder.appendChild(script);
    });
  };

  var createAdVideoElement = function createAdVideoElement() {
    var contentDocument = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    var video = contentDocument.createElement('VIDEO');
    video.style.width = '100%';
    video.style.height = '100%';
    return video;
  };

  var createAdContainer = function createAdContainer() {
    var adContainer = document.createElement('DIV');
    adContainer.classList.add('mol-video-ad-container');
    adContainer.style.width = '100%';
    adContainer.style.height = '100%';
    return adContainer;
  };

  var getContentDocument = function getContentDocument(iframeElement) {
    return iframeElement.contentDocument ||
    /* istanbul ignore next */
    iframeElement.contentWindow && iframeElement.contentWindow.document;
  };

  var getOrigin = function getOrigin() {
    var location = window.location;
    /* istanbul ignore else */

    if (location.origin) {
      return location.origin;
    } else {
      return location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
    }
  };

  var supported = 'srcdoc' in document.createElement('iframe');

  var supportsSrcdoc = function supportsSrcdoc() {
    return supported;
  };

  var iframeContent = function iframeContent(id, targetOrigin) {
    return '<!DOCTYPE html>\n<html>\n  <head><meta charset=\'UTF-8\'></head>\n  <body style=\'margin:0;padding:0\'>\n  <script type=\'text/javascript\'>window.parent.postMessage(\'' + id + '_ready\', \'' + targetOrigin + '\');</script>\n  </body>\n</html>';
  };

  var createBaseIframe = function createBaseIframe() {
    var iframe = document.createElement('IFRAME');
    iframe.sandbox = 'allow-forms allow-popups allow-scripts allow-same-origin';
    iframe.style.margin = '0';
    iframe.style.padding = '0';
    iframe.style.border = 'none';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.position = 'absolute';
    return iframe;
  };

  var createIframe = function createIframe(placeholder, id) {
    return new Promise(function (resolve, reject) {
      var content = iframeContent(id, getOrigin());
      var iframe = void 0;
      /*
        NOTE: favor about:blank instead of srcdoc because some browsers
      */

      try {
        iframe = createBaseIframe();
        iframe.src = 'about:blank';
        placeholder.appendChild(iframe);
        getContentDocument(iframe).write(content);
      } catch (error) {
        placeholder.removeChild(iframe);

        if (supportsSrcdoc()) {
          iframe = createBaseIframe();
          iframe.src = 'about:srcdoc';
          iframe.srcdoc = content;
          placeholder.appendChild(iframe);
        } else {
          reject(error);
        }
      }

      var handleMessage = function handleMessage(_ref) {
        var data = _ref.data;
        /* istanbul ignore else */

        if (data === id + '_ready') {
          window.removeEventListener('message', handleMessage);
          resolve(iframe);
        }
      };

      window.addEventListener('message', handleMessage, false);
    });
  };
  /**
   * unique will create a unique string every time is called, sequentially and namespaced
   *
   * @ignore
   * @param {string} namespace
   */


  var unique = function unique(namespace) {
    var count = -1;
    return function () {
      return namespace + '_' + ++count;
    };
  };

  var nextId = unique('videoAdContainer');
  var hidden = Symbol('hidden');
  /**
   * @class
   * @alias VideoAdContainer
   * @description This class provides everything necessary to contain and create a video ad within a given placeholder Element.
   */

  var VideoAdContainer = function () {
    /**
     * Creates a VideoAdContainer.
     *
     * @param {HTMLDivElement} placeholder - DIV that will contain the ad.
     * @param {HTMLVideoElement} [videoElement] - optional videoElement that will be used to play the ad.
     */
    function VideoAdContainer(placeholder) {
      var videoElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      classCallCheck(this, VideoAdContainer);
      this[hidden] = {
        destroyed: false,
        iframe: null,
        readyPromise: null
      };

      if (!(placeholder instanceof Element)) {
        throw new TypeError('placeholder is not an Element');
      }

      this[hidden].id = nextId();
      this.element = createAdContainer();
      this.executionContext = null;
      this.isOriginalVideoElement = Boolean(videoElement);

      if (videoElement) {
        this.videoElement = videoElement;
      } else {
        this.videoElement = createAdVideoElement();
        this.element.appendChild(this.videoElement);
      }

      placeholder.appendChild(this.element);
    }
    /**
     * Adds the passed script to the ad container.
     *
     * @param {string} src - script source uri.
     * @param {Object} options - Options map.
     * @param {string} options.type - Defaults to 'text/javascript'.
     * @param {boolean} options.async - if "true" the "async" attribute is added to the new script. Defaults to false.
     * @param {boolean} options.defer - if "true" the "defer" attribute is added to the new script. Defaults to true.
     */


    createClass(VideoAdContainer, [{
      key: 'addScript',
      value: function () {
        var _ref = asyncToGenerator(
        /*#__PURE__*/
        regenerator.mark(function _callee(src) {
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var placeholder;
          return regenerator.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!this.isDestroyed()) {
                    _context.next = 2;
                    break;
                  }

                  throw new Error('VideoAdContainer has been destroyed');

                case 2:
                  if (this[hidden].iframe) {
                    _context.next = 7;
                    break;
                  }

                  _context.next = 5;
                  return createIframe(this.element, this[hidden].id);

                case 5:
                  this[hidden].iframe = _context.sent;
                  this.executionContext = this[hidden].iframe.contentWindow;

                case 7:
                  placeholder = getContentDocument(this[hidden].iframe).body;
                  return _context.abrupt('return', loadScript$1(src, _extends$1({
                    placeholder: placeholder
                  }, options)));

                case 9:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function addScript(_x2) {
          return _ref.apply(this, arguments);
        }

        return addScript;
      }()
      /**
       * Destroys the VideoAdContainer.
       */

    }, {
      key: 'destroy',
      value: function destroy() {
        this.element.parentNode.removeChild(this.element);
        this[hidden].destroyed = true;
      }
      /**
       * Checks if the container is destroyed.
       *
       * @returns {boolean} - true if the container is destroyed and false otherwise.
       */

    }, {
      key: 'isDestroyed',
      value: function isDestroyed() {
        return this[hidden].destroyed;
      }
    }]);
    return VideoAdContainer;
  }();
  /**
   * @function
   * @description VideoAdContainer factory method. Returns a VideoAdContainer instance that will contain the video ad.
   *
   * @ignore
   * @static
   * @param {HTMLElement} placeholder - Placeholder element that will contain the video ad.
   * @param {HTMLVideoElement} [videoElement] - optional videoElement that will be used to play the ad.
   *
   * @returns {VideoAdContainer} - Returns a `VideoAdContainer` instance.
   */


  var createVideoAdContainer = function createVideoAdContainer(placeholder, videoElement) {
    if (!placeholder) {
      throw new TypeError('placeholder is required');
    }

    return new VideoAdContainer(placeholder, videoElement);
  };
  /* eslint-disable id-match*/


  var guessMimeType = function guessMimeType(src) {
    var mimeMap = {
      '3gp': 'video/3gpp',
      avi: 'video/x-msvideo',
      flv: 'video/x-flv',
      m3u8: 'application/x-mpegURL',
      m4v: 'video/mp4',
      mov: 'video/quicktime',
      mp4: 'video/mp4',
      mpd: 'application/dash+xml',
      ogv: 'video/ogg',
      ts: 'video/MP2T',
      webm: 'video/webm',
      wmv: 'video/x-ms-wmv'
    };
    var match = src.match(/\.([^./?]+)(\?[^/]+)?$/i);
    var ext = match && match[1];
    return mimeMap[ext] || 'video/' + ext;
  };

  var canPlay = function canPlay(videoElement, mediaFile) {
    var src = mediaFile.src,
        type = mediaFile.type;
    return videoElement.canPlayType(type || guessMimeType(src));
  };

  var sortMediaByBestFit = function sortMediaByBestFit(mediaFiles, screenRect) {
    var screenWidth = screenRect.width;

    var compareTo = function compareTo(mediaFileA, mediaFileB) {
      var deltaA = Math.abs(screenWidth - (mediaFileA.width || 0));
      var deltaB = Math.abs(screenWidth - (mediaFileB.width || 0));
      return deltaA - deltaB;
    };

    return mediaFiles.slice(0).sort(compareTo);
  };

  var findBestMedia = function findBestMedia(inlineAd, videoElement, container) {
    var screenRect = container.getBoundingClientRect();
    var mediaFiles = getMediaFiles(inlineAd);

    if (mediaFiles) {
      var supportedMediaFiles = mediaFiles.filter(function (mediaFile) {
        return canPlay(videoElement, mediaFile);
      });
      var sortedMediaFiles = sortMediaByBestFit(supportedMediaFiles, screenRect);
      return sortedMediaFiles[0];
    }

    return null;
  };

  var once$1 = function once(element, eventName, listener) {
    var handler = function handler() {
      element.removeEventListener(eventName, handler);
      return listener.apply(undefined, arguments);
    };

    element.addEventListener(eventName, handler);
    return function () {
      element.removeEventListener(eventName, handler);
    };
  };

  var progress$1 = linearEvents.progress;

  var getProgressEvents = function getProgressEvents(vastChain) {
    return vastChain.map(function (_ref) {
      var ad = _ref.ad;
      return ad;
    }).reduce(function (accumulated, ad) {
      var events = getLinearTrackingEvents(ad, progress$1) || [];
      return [].concat(toConsumableArray(accumulated), toConsumableArray(events));
    }, []).map(function (_ref2) {
      var offset = _ref2.offset,
          uri = _ref2.uri;
      return {
        offset: offset,
        uri: uri
      };
    });
  };

  var safeCallback = function safeCallback(callback, logger) {
    return function () {
      try {
        // eslint-disable-next-line callback-return, promise/prefer-await-to-callbacks
        callback.apply(undefined, arguments);
      } catch (error) {
        if (logger) {
          logger.error(error);
        }
      }
    };
  };
  /* eslint-disable promise/prefer-await-to-callbacks, callback-return */


  var fullscreenElement = function fullscreenElement() {
    return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement || null;
  };

  var fullscreen$1 = linearEvents.fullscreen,
      exitFullscreen$1 = linearEvents.exitFullscreen,
      playerCollapse$1 = linearEvents.playerCollapse,
      playerExpand$1 = linearEvents.playerExpand;

  var onFullscreenChange = function onFullscreenChange(_ref, callback) {
    var videoElement = _ref.videoElement;
    var fullscreenEvtNames = ['webkitfullscreenchange', 'mozfullscreenchange', 'fullscreenchange', 'MSFullscreenChange'];
    var fullscreenOn = false;

    var fullscreenchangeHandler = function fullscreenchangeHandler() {
      if (fullscreenElement() === videoElement) {
        fullscreenOn = true;
        callback(playerExpand$1);
        callback(fullscreen$1);
      } else if (fullscreenOn) {
        fullscreenOn = false;
        callback(playerCollapse$1);
        callback(exitFullscreen$1);
      }
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = fullscreenEvtNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var event = _step.value;
        document.addEventListener(event, fullscreenchangeHandler);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return function () {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = fullscreenEvtNames[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _event = _step2.value;
          document.removeEventListener(_event, fullscreenchangeHandler);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    };
  };
  /* eslint-disable promise/prefer-await-to-callbacks, callback-return */


  var pause$1 = linearEvents.pause,
      resume$1 = linearEvents.resume;

  var onPlayPause = function onPlayPause(_ref, callback) {
    var videoElement = _ref.videoElement;
    var started = false;
    var paused = true;

    var playHandler = function playHandler() {
      if (!started) {
        started = true;
        paused = false;
      } else if (paused) {
        paused = false;
        callback(resume$1);
      }
    };

    var pauseHandler = function pauseHandler() {
      if (!paused) {
        paused = true;
        callback(pause$1);
      }
    };

    videoElement.addEventListener('play', playHandler);
    videoElement.addEventListener('pause', pauseHandler);
    return function () {
      videoElement.removeEventListener('play', playHandler);
      videoElement.removeEventListener('pause', pauseHandler);
    };
  };
  /* eslint-disable promise/prefer-await-to-callbacks, callback-return */


  var rewind$1 = linearEvents.rewind;

  var onRewind = function onRewind(_ref, callback) {
    var videoElement = _ref.videoElement;
    var currentTime = videoElement.currentTime;

    var timeupdateHandler = function timeupdateHandler() {
      var delta = videoElement.currentTime - currentTime;

      if (delta < 0 && Math.abs(delta) >= 1) {
        callback(rewind$1);
      }

      currentTime = videoElement.currentTime;
    };

    videoElement.addEventListener('timeupdate', timeupdateHandler);
    return function () {
      videoElement.removeEventListener('timeupdate', timeupdateHandler);
    };
  };
  /* eslint-disable callback-return, promise/prefer-await-to-callbacks */


  var skip$1 = linearEvents.skip;

  var createDefaultSkipControl = function createDefaultSkipControl() {
    var skipBtn = document.createElement('BUTTON');
    skipBtn.classList.add('mol-vast-skip-control');
    skipBtn.type = 'button';
    skipBtn.innerHTML = 'skip';
    skipBtn.style.position = 'absolute';
    skipBtn.style.bottom = '15px';
    skipBtn.style.right = '15px';
    return skipBtn;
  };

  var onSkip = function onSkip(videoAdContainer, callback) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        skipoffset = _ref.skipoffset,
        _ref$createSkipContro = _ref.createSkipControl,
        createSkipControl = _ref$createSkipContro === undefined ? createDefaultSkipControl : _ref$createSkipContro;

    if (!Boolean(skipoffset)) {
      return function () {};
    }

    var skipControl = void 0;
    var videoElement = videoAdContainer.videoElement,
        element = videoAdContainer.element;

    var skipHandler = function skipHandler() {
      var currentTimeMs = videoElement.currentTime * 1000;

      if (!Boolean(skipControl) && currentTimeMs >= skipoffset) {
        skipControl = createSkipControl();

        skipControl.onclick = function (event) {
          if (Event.prototype.stopPropagation !== undefined) {
            event.stopPropagation();
          }

          callback(skip$1);
          return false;
        };

        element.appendChild(skipControl);
        videoElement.removeEventListener('timeupdate', skipHandler);
      }
    };

    videoElement.addEventListener('timeupdate', skipHandler);
    return function () {
      videoElement.removeEventListener('timeupdate', skipHandler);

      if (Boolean(skipControl)) {
        element.removeChild(skipControl);
      }
    };
  };
  /* eslint-disable promise/prefer-await-to-callbacks, callback-return */


  var error$1 = linearEvents.error;

  var onError = function onError(_ref, callback) {
    var videoElement = _ref.videoElement;

    var errorHandler = function errorHandler() {
      callback(error$1, videoElement.error);
    };

    videoElement.addEventListener('error', errorHandler);
    return function () {
      videoElement.removeEventListener('error', errorHandler);
    };
  };
  /**
   * Fires when the adUnit's volume has changed.
   *
   * @event VideoAdUnit#volumeChanged
   */


  var volumeChanged = 'volumeChanged';
  /**
   * Fires when the adUnit's has finished.
   *
   * @event VideoAdUnit#finish
   */

  var finish = 'finish';
  /**
   * fires on ad progress.
   *
   * @event VideoAdUnit#adProgress
   */

  var adProgress = 'adProgress';
  /* eslint-disable promise/prefer-await-to-callbacks, callback-return */

  var complete$1 = linearEvents.complete,
      firstQuartile$1 = linearEvents.firstQuartile,
      midpoint$1 = linearEvents.midpoint,
      start$1 = linearEvents.start,
      thirdQuartile$1 = linearEvents.thirdQuartile;

  var percentageProgress = function percentageProgress(currentTime, duration) {
    return currentTime * 100 / duration;
  };

  var isPassFirstQuartile = function isPassFirstQuartile(currentTime, duration) {
    return percentageProgress(currentTime, duration) >= 25;
  };

  var isPassMidPoint = function isPassMidPoint(currentTime, duration) {
    return percentageProgress(currentTime, duration) >= 50;
  };

  var isPassThirdQuartile = function isPassThirdQuartile(currentTime, duration) {
    return percentageProgress(currentTime, duration) >= 75;
  };

  var isCompleted = function isCompleted(currentTime, duration) {
    return percentageProgress(currentTime, duration) >= 99;
  }; // TODO: implement logic to track `timeSpentViewing` linear event


  var onTimeUpdate = function onTimeUpdate(_ref, callback) {
    var videoElement = _ref.videoElement;
    var started = false;
    var passFirstQuartile = false;
    var passMidPoint = false;
    var passThirdQuartile = false;
    var completed = false; // eslint-disable-next-line complexity

    var timeupdateHandler = function timeupdateHandler() {
      var duration = videoElement.duration;
      var currentTime = videoElement.currentTime;

      if (!started && currentTime > 0) {
        started = true;
        callback(start$1);
      } else if (!passFirstQuartile) {
        if (isPassFirstQuartile(currentTime, duration)) {
          passFirstQuartile = true;
          callback(firstQuartile$1);
        }
      } else if (!passMidPoint) {
        if (isPassMidPoint(currentTime, duration)) {
          passMidPoint = true;
          callback(midpoint$1);
        }
      } else if (!passThirdQuartile) {
        if (isPassThirdQuartile(currentTime, duration)) {
          passThirdQuartile = true;
          callback(thirdQuartile$1);
        }
      } else if (!completed) {
        if (isCompleted(currentTime, duration)) {
          completed = true;
          callback(complete$1);
        }
      }

      callback(adProgress);
    };

    var endedHandler = function endedHandler() {
      var duration = videoElement.duration;
      var currentTime = videoElement.currentTime;

      if (!completed && isCompleted(currentTime, duration)) {
        completed = true;
        callback(complete$1);
      }

      videoElement.removeEventListener('ended', endedHandler);
      videoElement.removeEventListener('timeupdate', timeupdateHandler);
    };

    videoElement.addEventListener('timeupdate', timeupdateHandler);
    videoElement.addEventListener('ended', endedHandler);
    return function () {
      videoElement.removeEventListener('timeupdate', timeupdateHandler);
      videoElement.removeEventListener('ended', endedHandler);
    };
  };
  /* eslint-disable promise/prefer-await-to-callbacks, callback-return */


  var mute$1 = linearEvents.mute,
      unmute$1 = linearEvents.unmute;

  var isMuted = function isMuted(videoElement) {
    return videoElement.muted || videoElement.volume === 0;
  };

  var onVolumeChange = function onVolumeChange(_ref, callback) {
    var videoElement = _ref.videoElement;
    var wasMuted = isMuted(videoElement);

    var volumechangeHandler = function volumechangeHandler() {
      callback(volumeChanged);

      if (wasMuted && !isMuted(videoElement)) {
        callback(unmute$1);
      } else if (!wasMuted && isMuted(videoElement)) {
        callback(mute$1);
      }

      wasMuted = isMuted(videoElement);
    };

    videoElement.addEventListener('volumechange', volumechangeHandler);
    return function () {
      videoElement.removeEventListener('volumechange', volumechangeHandler);
    };
  };
  /* eslint-disable promise/prefer-await-to-callbacks, callback-return */


  var impression$1 = linearEvents.impression;

  var onImpression = function onImpression(_ref, callback) {
    var videoElement = _ref.videoElement;

    var impressionHandler = function impressionHandler() {
      var currentTime = videoElement.currentTime;

      if (currentTime >= 2) {
        callback(impression$1);
        videoElement.removeEventListener('timeupdate', impressionHandler);
      }
    };

    videoElement.addEventListener('timeupdate', impressionHandler);
    return function () {
      videoElement.removeEventListener('timeupdate', impressionHandler);
    };
  };

  var toFixedDigits = function toFixedDigits(num, digits) {
    var formattedNum = String(num);

    while (formattedNum.length < digits) {
      formattedNum = '0' + formattedNum;
    }

    return formattedNum;
  };

  var formatProgress = function formatProgress(progress) {
    var hours = Math.floor(progress / (60 * 60 * 1000));
    var minutes = Math.floor(progress / (60 * 1000) % 60);
    var seconds = Math.floor(progress / 1000 % 60);
    var ms = progress % 1000;
    return toFixedDigits(hours, 2) + ':' + toFixedDigits(minutes, 2) + ':' + toFixedDigits(seconds, 2) + '.' + toFixedDigits(ms, 3);
  };
  /* eslint-disable promise/prefer-await-to-callbacks, callback-return */


  var progress$2 = linearEvents.progress;

  var secondsToMilliseconds = function secondsToMilliseconds(seconds) {
    return seconds * 1000;
  };

  var isPercentage$1 = function isPercentage(offset) {
    var percentageRegex = /^\d+(\.\d+)?%$/g;
    return percentageRegex.test(offset) && !isNaN(parseFloat(offset));
  };

  var isValid = function isValid(_ref) {
    var offset = _ref.offset,
        uri = _ref.uri;
    var offsetIsValid = typeof offset === 'number' || isPercentage$1(offset);
    var uriIsValid = typeof uri === 'string' && uri.length > 0;
    return offsetIsValid && uriIsValid;
  };

  var offsetToMs = function offsetToMs(offset, durationInMs) {
    if (typeof offset === 'number') {
      return offset;
    }

    return parseFloat(offset) / 100 * durationInMs;
  };

  var onProgress = function onProgress(_ref2, callback) {
    var videoElement = _ref2.videoElement;

    var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref3$progressEvents = _ref3.progressEvents,
        progressEvents = _ref3$progressEvents === undefined ? [] : _ref3$progressEvents;

    var duration = videoElement.duration;
    var durationInMs = secondsToMilliseconds(duration);
    var playedMs = 0;
    var previousCurrentTime = secondsToMilliseconds(videoElement.currentTime);
    var pendingEvents = progressEvents.filter(isValid).map(function (_ref4) {
      var offset = _ref4.offset,
          uri = _ref4.uri;
      return {
        offset: offsetToMs(offset, durationInMs),
        uri: uri
      };
    });

    var progressHandler = function progressHandler() {
      var currentTime = videoElement.currentTime;
      var delta = Math.abs(currentTime - previousCurrentTime);
      playedMs += secondsToMilliseconds(delta);
      previousCurrentTime = currentTime;

      var _pendingEvents$reduce = pendingEvents.reduce(function (accumulator, event) {
        var offset = event.offset;

        if (playedMs >= offset) {
          accumulator.toCall.push(event);
        } else {
          accumulator.stillPending.push(event);
        }

        return accumulator;
      }, {
        stillPending: [],
        toCall: []
      }),
          stillPending = _pendingEvents$reduce.stillPending,
          toCall = _pendingEvents$reduce.toCall;

      pendingEvents = stillPending;
      toCall.forEach(function (_ref5) {
        var uri = _ref5.uri;
        callback(progress$2, {
          contentplayhead: formatProgress(playedMs),
          progressUri: uri
        });
      });

      if (pendingEvents.length === 0) {
        videoElement.removeEventListener('timeupdate', progressHandler);
      }
    };

    if (pendingEvents.length > 0) {
      videoElement.addEventListener('timeupdate', progressHandler);
    }

    return function () {
      videoElement.removeEventListener('timeupdate', progressHandler);
    };
  };
  /* eslint-disable callback-return, promise/prefer-await-to-callbacks */


  var clickThrough$1 = linearEvents.clickThrough;

  var onClickThrough = function onClickThrough(_ref, callback) {
    var videoElement = _ref.videoElement,
        element = _ref.element;

    var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        clickThroughUrl = _ref2.clickThroughUrl;

    var placeholder = element || videoElement.parentNode;
    var anchor = document.createElement('A');
    anchor.classList.add('mol-vast-clickthrough');
    anchor.style.width = '100%';
    anchor.style.height = '100%';
    anchor.style.position = 'absolute';
    anchor.style.left = 0;
    anchor.style.top = 0;

    if (clickThroughUrl) {
      anchor.href = clickThroughUrl;
      anchor.target = '_blank';
    }

    anchor.onclick = function (event) {
      if (Event.prototype.stopPropagation !== undefined) {
        event.stopPropagation();
      }

      if (videoElement.paused) {
        videoElement.play();
      } else {
        videoElement.pause();
        callback(clickThrough$1);
      }
    };

    placeholder.appendChild(anchor);
    return function () {
      return placeholder.removeChild(anchor);
    };
  };
  /* eslint-disable import/max-dependencies */


  var handlers = [onClickThrough, onError, onFullscreenChange, onImpression, onPlayPause, onProgress, onRewind, onSkip, onTimeUpdate, onVolumeChange];
  /* eslint-disable promise/prefer-await-to-callbacks */

  var setupMetricHandlers = function setupMetricHandlers(_ref, callback) {
    var vastChain = _ref.vastChain,
        videoAdContainer = _ref.videoAdContainer,
        hooks = _ref.hooks;
    var inlineAd = vastChain[0].ad;
    var skipoffset = getSkipOffset(inlineAd);
    var clickThroughUrl = getClickThrough(inlineAd);
    var progressEvents = getProgressEvents(vastChain);

    var data = _extends$1({
      clickThroughUrl: clickThroughUrl,
      progressEvents: progressEvents,
      skipoffset: skipoffset
    }, hooks);

    var stopHandlersFns = handlers.map(function (handler) {
      return safeCallback(handler(videoAdContainer, callback, data));
    });
    return function () {
      return stopHandlersFns.forEach(function (disconnect) {
        return disconnect();
      });
    };
  };

  var updateMedia = function updateMedia(videoElement, media) {
    return new Promise(function (resolve) {
      var state = {
        currentTime: videoElement.currentTime,
        playing: !videoElement.paused
      };

      if (state.playing) {
        videoElement.pause();
      }

      videoElement.src = media.src;
      videoElement.load();
      once$1(videoElement, 'loadeddata', function () {
        videoElement.currentTime = state.currentTime;

        if (state.playing) {
          videoElement.play();
        }

        resolve();
      });
    });
  };
  /**
   * lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="npm" -o ./`
   * Copyright jQuery Foundation and other contributors <https://jquery.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   */

  /** Used as the `TypeError` message for "Functions" methods. */


  var FUNC_ERROR_TEXT = 'Expected a function';
  /** Used as references for various `Number` constants. */

  var NAN = 0 / 0;
  /** `Object#toString` result references. */

  var symbolTag = '[object Symbol]';
  /** Used to match leading and trailing whitespace. */

  var reTrim = /^\s+|\s+$/g;
  /** Used to detect bad signed hexadecimal string values. */

  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
  /** Used to detect binary string values. */

  var reIsBinary = /^0b[01]+$/i;
  /** Used to detect octal string values. */

  var reIsOctal = /^0o[0-7]+$/i;
  /** Built-in method references without a dependency on `root`. */

  var freeParseInt = parseInt;
  /** Detect free variable `global` from Node.js. */

  var freeGlobal = _typeof(commonjsGlobal$1) == 'object' && commonjsGlobal$1 && commonjsGlobal$1.Object === Object && commonjsGlobal$1;
  /** Detect free variable `self`. */

  var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;
  /** Used as a reference to the global object. */

  var root = freeGlobal || freeSelf || Function('return this')();
  /** Used for built-in method references. */

  var objectProto = Object.prototype;
  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */

  var objectToString = objectProto.toString;
  /* Built-in method references for those with the same name as other `lodash` methods. */

  var nativeMax = Math.max,
      nativeMin = Math.min;
  /**
   * Gets the timestamp of the number of milliseconds that have elapsed since
   * the Unix epoch (1 January 1970 00:00:00 UTC).
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Date
   * @returns {number} Returns the timestamp.
   * @example
   *
   * _.defer(function(stamp) {
   *   console.log(_.now() - stamp);
   * }, _.now());
   * // => Logs the number of milliseconds it took for the deferred invocation.
   */

  var now = function now() {
    return root.Date.now();
  };
  /**
   * Creates a debounced function that delays invoking `func` until after `wait`
   * milliseconds have elapsed since the last time the debounced function was
   * invoked. The debounced function comes with a `cancel` method to cancel
   * delayed `func` invocations and a `flush` method to immediately invoke them.
   * Provide `options` to indicate whether `func` should be invoked on the
   * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
   * with the last arguments provided to the debounced function. Subsequent
   * calls to the debounced function return the result of the last `func`
   * invocation.
   *
   * **Note:** If `leading` and `trailing` options are `true`, `func` is
   * invoked on the trailing edge of the timeout only if the debounced function
   * is invoked more than once during the `wait` timeout.
   *
   * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
   * until to the next tick, similar to `setTimeout` with a timeout of `0`.
   *
   * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
   * for details over the differences between `_.debounce` and `_.throttle`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to debounce.
   * @param {number} [wait=0] The number of milliseconds to delay.
   * @param {Object} [options={}] The options object.
   * @param {boolean} [options.leading=false]
   *  Specify invoking on the leading edge of the timeout.
   * @param {number} [options.maxWait]
   *  The maximum time `func` is allowed to be delayed before it's invoked.
   * @param {boolean} [options.trailing=true]
   *  Specify invoking on the trailing edge of the timeout.
   * @returns {Function} Returns the new debounced function.
   * @example
   *
   * // Avoid costly calculations while the window size is in flux.
   * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
   *
   * // Invoke `sendMail` when clicked, debouncing subsequent calls.
   * jQuery(element).on('click', _.debounce(sendMail, 300, {
   *   'leading': true,
   *   'trailing': false
   * }));
   *
   * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
   * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
   * var source = new EventSource('/stream');
   * jQuery(source).on('message', debounced);
   *
   * // Cancel the trailing debounced invocation.
   * jQuery(window).on('popstate', debounced.cancel);
   */


  function debounce(func, wait, options) {
    var lastArgs,
        lastThis,
        maxWait,
        result,
        timerId,
        lastCallTime,
        lastInvokeTime = 0,
        leading = false,
        maxing = false,
        trailing = true;

    if (typeof func != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT);
    }

    wait = toNumber(wait) || 0;

    if (isObject$2(options)) {
      leading = !!options.leading;
      maxing = 'maxWait' in options;
      maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
      trailing = 'trailing' in options ? !!options.trailing : trailing;
    }

    function invokeFunc(time) {
      var args = lastArgs,
          thisArg = lastThis;
      lastArgs = lastThis = undefined;
      lastInvokeTime = time;
      result = func.apply(thisArg, args);
      return result;
    }

    function leadingEdge(time) {
      // Reset any `maxWait` timer.
      lastInvokeTime = time; // Start the timer for the trailing edge.

      timerId = setTimeout(timerExpired, wait); // Invoke the leading edge.

      return leading ? invokeFunc(time) : result;
    }

    function remainingWait(time) {
      var timeSinceLastCall = time - lastCallTime,
          timeSinceLastInvoke = time - lastInvokeTime,
          result = wait - timeSinceLastCall;
      return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }

    function shouldInvoke(time) {
      var timeSinceLastCall = time - lastCallTime,
          timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
      // trailing edge, the system time has gone backwards and we're treating
      // it as the trailing edge, or we've hit the `maxWait` limit.

      return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }

    function timerExpired() {
      var time = now();

      if (shouldInvoke(time)) {
        return trailingEdge(time);
      } // Restart the timer.


      timerId = setTimeout(timerExpired, remainingWait(time));
    }

    function trailingEdge(time) {
      timerId = undefined; // Only invoke if we have `lastArgs` which means `func` has been
      // debounced at least once.

      if (trailing && lastArgs) {
        return invokeFunc(time);
      }

      lastArgs = lastThis = undefined;
      return result;
    }

    function cancel() {
      if (timerId !== undefined) {
        clearTimeout(timerId);
      }

      lastInvokeTime = 0;
      lastArgs = lastCallTime = lastThis = timerId = undefined;
    }

    function flush() {
      return timerId === undefined ? result : trailingEdge(now());
    }

    function debounced() {
      var time = now(),
          isInvoking = shouldInvoke(time);
      lastArgs = arguments;
      lastThis = this;
      lastCallTime = time;

      if (isInvoking) {
        if (timerId === undefined) {
          return leadingEdge(lastCallTime);
        }

        if (maxing) {
          // Handle invocations in a tight loop.
          timerId = setTimeout(timerExpired, wait);
          return invokeFunc(lastCallTime);
        }
      }

      if (timerId === undefined) {
        timerId = setTimeout(timerExpired, wait);
      }

      return result;
    }

    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
  }
  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */


  function isObject$2(value) {
    var type = _typeof(value);

    return !!value && (type == 'object' || type == 'function');
  }
  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */


  function isObjectLike(value) {
    return !!value && _typeof(value) == 'object';
  }
  /**
   * Checks if `value` is classified as a `Symbol` primitive or object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
   * @example
   *
   * _.isSymbol(Symbol.iterator);
   * // => true
   *
   * _.isSymbol('abc');
   * // => false
   */


  function isSymbol(value) {
    return _typeof(value) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
  }
  /**
   * Converts `value` to a number.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to process.
   * @returns {number} Returns the number.
   * @example
   *
   * _.toNumber(3.2);
   * // => 3.2
   *
   * _.toNumber(Number.MIN_VALUE);
   * // => 5e-324
   *
   * _.toNumber(Infinity);
   * // => Infinity
   *
   * _.toNumber('3.2');
   * // => 3.2
   */


  function toNumber(value) {
    if (typeof value == 'number') {
      return value;
    }

    if (isSymbol(value)) {
      return NAN;
    }

    if (isObject$2(value)) {
      var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
      value = isObject$2(other) ? other + '' : other;
    }

    if (typeof value != 'string') {
      return value === 0 ? value : +value;
    }

    value = value.replace(reTrim, '');
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
  }

  var lodash_debounce = debounce;
  var MutationObserver$1 = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
  /* eslint-disable promise/prefer-await-to-callbacks */

  var validate = function validate(target, callback) {
    if (!(target instanceof Element)) {
      throw new TypeError('Target is not an Element node');
    }

    if (!(callback instanceof Function)) {
      throw new TypeError('Callback is not a function');
    }
  };

  var noop$1 = function noop() {};

  var sizeMutationAttrs = ['style', 'clientWidth', 'clientHeight'];

  var createResizeMO = function createResizeMO(target, callback) {
    var observer = new MutationObserver$1(function (mutations) {
      for (var index = 0; index < mutations.length; index++) {
        var attributeName = mutations[index].attributeName;

        if (sizeMutationAttrs.includes(attributeName)) {
          // eslint-disable-next-line callback-return
          callback();
        }
      }
    });
    observer.observe(target, {
      attributes: true,
      characterData: false,
      childList: true
    });
    return observer;
  };

  var mutationHandlers = Symbol('mutationHandlers');
  var observerKey = Symbol('mutationObserver');

  var onMutation = function onMutation(target, callback) {
    if (!target[mutationHandlers]) {
      target[mutationHandlers] = [];

      var execHandlers = function execHandlers() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        if (target[mutationHandlers]) {
          target[mutationHandlers].forEach(function (handler) {
            return handler.apply(undefined, args);
          });
        }
      };

      target[observerKey] = createResizeMO(target, execHandlers);
    }

    target[mutationHandlers].push(callback);
    return function () {
      target[mutationHandlers] = target[mutationHandlers].filter(function (handler) {
        return handler !== callback;
      });

      if (target[mutationHandlers].length === 0) {
        target[observerKey].disconnect();
        delete target[mutationHandlers];
        delete target[observerKey];
      }
    };
  };

  var createResizeObjElement = function createResizeObjElement(callback) {
    var obj = document.createElement('object'); // eslint-disable-next-line max-len

    obj.setAttribute('style', 'display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; pointer-events: none; z-index: -1;');

    obj.onload = function () {
      if (this.contentWindow) {
        this.contentWindow.addEventListener('resize', callback);
      }
    };

    obj.type = 'text/html';
    obj.data = 'about:blank';
    return obj;
  };

  var resizeHandlers = Symbol('resizeHandlers');
  var resizeObject = Symbol('resizeObj'); // Original code http://www.backalleycoder.com/2013/03/18/cross-browser-event-based-element-resize-detection/

  var onResize = function onResize(target, callback) {
    if (!target[resizeHandlers]) {
      target[resizeHandlers] = [];

      var execHandlers = function execHandlers() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        if (target[resizeHandlers]) {
          target[resizeHandlers].forEach(function (handler) {
            return handler.apply(undefined, args);
          });
        }
      };

      target[resizeObject] = createResizeObjElement(execHandlers);

      if (getComputedStyle(target).position === 'static') {
        target.style.position = 'relative';
      }

      target.appendChild(target[resizeObject]);
    }

    target[resizeHandlers].push(callback);
    return function () {
      target[resizeHandlers] = target[resizeHandlers].filter(function (handler) {
        return handler !== callback;
      });

      if (target[resizeHandlers].length === 0) {
        target.removeChild(target[resizeObject]);
        delete target[resizeHandlers];
        delete target[resizeObject];
      }
    };
  };

  var onElementResize = function onElementResize(target, callback) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$threshold = _ref.threshold,
        threshold = _ref$threshold === undefined ? 20 : _ref$threshold;

    validate(target, callback);

    var makeSizeId = function makeSizeId(_ref2) {
      var style = _ref2.style,
          clientHeight = _ref2.clientHeight,
          clientWidth = _ref2.clientWidth;
      return [style.width, style.height, clientWidth, clientHeight].join('.');
    };

    var lastSize = makeSizeId(target);

    var checkElementSize = function checkElementSize() {
      var currentSize = makeSizeId(target);

      if (currentSize !== lastSize) {
        lastSize = currentSize; // eslint-disable-next-line callback-return

        callback();
      }
    };

    var checkElementHandler = lodash_debounce(checkElementSize, threshold);
    var stopObservingMutations = Boolean(MutationObserver$1) ? onMutation(target, checkElementHandler) : noop$1;
    var stopListeningToResize = onResize(target, checkElementHandler);
    return function () {
      stopObservingMutations();
      stopListeningToResize();
    };
  };

  var isElementVisible = function isElementVisible(element) {
    var viewabilityOffsetFraction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    var _element$getBoundingC = element.getBoundingClientRect(),
        height = _element$getBoundingC.height,
        width = _element$getBoundingC.width,
        top = _element$getBoundingC.top,
        right = _element$getBoundingC.right,
        bottom = _element$getBoundingC.bottom,
        left = _element$getBoundingC.left;

    if (!height || !width) {
      return false;
    }

    var verticalOffset = height * (1 - viewabilityOffsetFraction);
    var horizontalOffset = width * (1 - viewabilityOffsetFraction);
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    return !document.hidden && top + verticalOffset >= 0 && bottom - verticalOffset <= viewportHeight && left + horizontalOffset >= 0 && right - horizontalOffset <= viewportWidth;
  };
  /* eslint-disable promise/prefer-await-to-callbacks */


  var elementEntries = [];

  var checkIsVisible = function checkIsVisible(entry) {
    var element = entry.element,
        callback = entry.callback,
        lastInViewport = entry.lastInViewport,
        viewportOffset = entry.viewportOffset;
    var isInViewport = isElementVisible(element, viewportOffset);

    if (isInViewport !== lastInViewport) {
      entry.lastInViewport = isInViewport; // eslint-disable-next-line callback-return

      callback(isInViewport);
    }
  };

  var checkVisibility = function checkVisibility() {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = elementEntries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var entry = _step.value;
        checkIsVisible(entry);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  };

  var validate$1 = function validate(target, callback) {
    if (!(target instanceof Element)) {
      throw new TypeError('Target is not an Element node');
    }

    if (!(callback instanceof Function)) {
      throw new TypeError('Callback is not a function');
    }
  };

  var onElementVisibilityChange = function onElementVisibilityChange(target, callback) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$threshold = _ref.threshold,
        threshold = _ref$threshold === undefined ? 100 : _ref$threshold,
        _ref$scrollableElemen = _ref.scrollableElement,
        scrollableElement = _ref$scrollableElemen === undefined ? window : _ref$scrollableElemen,
        _ref$viewabilityOffse = _ref.viewabilityOffset,
        viewabilityOffset = _ref$viewabilityOffse === undefined ? 0.4 : _ref$viewabilityOffse;

    validate$1(target, callback);
    var viewportEventHandler = threshold > 0 ? lodash_debounce(checkVisibility) : checkVisibility;
    var entry = {
      callback: callback,
      element: target,
      lastInViewport: false,
      scrollableElement: scrollableElement,
      viewabilityOffset: viewabilityOffset
    };
    checkIsVisible(entry);
    elementEntries.push(entry);
    scrollableElement.addEventListener('scroll', viewportEventHandler);

    if (elementEntries.length === 1) {
      window.addEventListener('resize', viewportEventHandler);
      window.addEventListener('orientationchange', viewportEventHandler);
      document.addEventListener('visibilitychange', viewportEventHandler);
    }

    return function () {
      elementEntries = elementEntries.filter(function (elementEntry) {
        return elementEntry !== entry;
      });

      if (elementEntries.length === 0) {
        window.removeEventListener('resize', viewportEventHandler);
        window.removeEventListener('orientationchange', viewportEventHandler);
        document.removeEventListener('visibilitychange', viewportEventHandler);
      }

      if (elementEntries.every(function (elementEntry) {
        return elementEntry.scrollableElement !== scrollableElement;
      })) {
        scrollableElement.removeEventListener('scroll', viewportEventHandler);
      }
    };
  };

  var preventManualProgress = function preventManualProgress(videoElement) {
    // IOS video clock is very unreliable and we need a 3 seconds threshold to ensure that the user forwarded/rewound the ad
    var PROGRESS_THRESHOLD = 3;
    var previousTime = 0;
    var skipAttempts = 0;

    var preventAdSkip = function preventAdSkip() {
      // Ignore ended event if the Ad time was not 'near' the end
      // and revert time to the previous 'valid' time
      if (videoElement.duration - previousTime > PROGRESS_THRESHOLD) {
        // this reduces the video jitter if the IOS skip button is pressed
        videoElement.pause(); // we need to trigger the play to put the video element back in a valid state

        videoElement.play();
        videoElement.currentTime = previousTime;
      }
    };

    var preventAdSeek = function preventAdSeek() {
      var currentTime = videoElement.currentTime;
      var progressDelta = Math.abs(currentTime - previousTime);

      if (progressDelta > PROGRESS_THRESHOLD) {
        skipAttempts += 1;

        if (skipAttempts >= 2) {
          videoElement.pause();
        }

        videoElement.currentTime = previousTime;
      } else {
        previousTime = currentTime;
      }
    };

    videoElement.addEventListener('timeupdate', preventAdSeek);
    videoElement.addEventListener('ended', preventAdSkip);
    return function () {
      videoElement.removeEventListener('timeupdate', preventAdSeek);
      videoElement.removeEventListener('ended', preventAdSkip);
    };
  };
  /* eslint-disable filenames/match-exported */

  /**
   * @class
   * @description Subset of  node's [Emitter class]{@link https://nodejs.org/api/events.html#events_class_eventemitter}
   * @param {Object} logger - Optional logger instance. Must comply to the [Console interface]{@link https://developer.mozilla.org/es/docs/Web/API/Console}.
   */


  var Emitter = function () {
    function Emitter(logger) {
      classCallCheck(this, Emitter);
      this.evts = {};
      this.logger = logger || console;
    }
    /**
     * Adds the listener function to the end of the listeners array for the event named eventName.
     *
     * @param {string} eventName - The name of the event.
     * @param {Function} listener - Listener fn that handles the evt.
     * @returns {Emitter} - The Emitter instance.
     */


    createClass(Emitter, [{
      key: "on",
      value: function on(eventName, listener) {
        var evts = this.evts;
        var evtListeners = evts[eventName] || (evts[eventName] = []);
        evtListeners.push(listener);
        return this;
      }
      /**
       * Removes the specified listener from the listener array for the event named eventName.
       *
       * @param {string} eventName - The name of the event.
       * @param {Function} listener - Listener fn that handles the evt.
       * @returns {Emitter} - The Emitter instance.
       */

    }, {
      key: "removeListener",
      value: function removeListener(eventName, listener) {
        var evts = this.evts;
        var evtListeners = evts[eventName] || (evts[eventName] = []);
        evts[eventName] = evtListeners.filter(function (eListener) {
          return eListener !== listener && eListener._ !== listener;
        });
        return this;
      }
      /**
       * Removes all listeners, or those of the specified eventName.
       *
       * @param {string} eventName - The name of the event. Optional if omitted all listeners will be removed.
       * @returns {Emitter} - The Emitter instance.
       */

    }, {
      key: "removeAllListeners",
      value: function removeAllListeners(eventName) {
        if (eventName) {
          this.evts[eventName] = null;
        } else {
          this.evts = {};
        }

        return this;
      }
      /**
       * Adds a one time listener function for the event named eventName. The next time eventName is triggered,
       * this listener is removed and then invoked.
       *
       * @param {string} eventName - The name of the event.
       * @param {Function} listener - Listener fn that handles the evt.
       * @returns {Emitter} - The Emitter instance.
       */

    }, {
      key: "once",
      value: function once(eventName, listener) {
        var _this = this;

        var handler = function handler() {
          _this.removeListener(eventName, handler);

          listener.apply(undefined, arguments);
        };

        handler._ = listener;
        return this.on(eventName, handler);
      }
      /**
       * Synchronously calls each of the listeners registered for the event named eventName, in the order they were registered,
       * passing the supplied arguments to each.
       *
       * @param {string} eventName - The name of the event.
       * @returns {boolean} - Returns true if the event had listeners, false otherwise.
       */

    }, {
      key: "emit",
      value: function emit(eventName) {
        var _this2 = this;

        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var evts = this.evts;
        var evtListeners = evts[eventName] || (evts[eventName] = []);
        var hasListeners = evtListeners.length > 0;
        evtListeners.forEach(function (handler) {
          try {
            handler.apply(undefined, args);
          } catch (error) {
            _this2.logger.error(error, error.stack);
          }
        });
        return hasListeners;
      }
    }]);
    return Emitter;
  }();

  var getResource = function getResource() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        staticResource = _ref.staticResource,
        htmlResource = _ref.htmlResource,
        iFrameResource = _ref.iFrameResource;

    return staticResource || htmlResource || iFrameResource;
  };

  var UNKNOWN = 'UNKNOWN';

  var uniqBy = function uniqBy(array, uniqValue) {
    var seen = {};
    return array.filter(function (item) {
      var key = uniqValue(item);

      if (seen.hasOwnProperty(key)) {
        return false;
      }

      seen[key] = true;
      return true;
    });
  };

  var uniqByResource = function uniqByResource(icons) {
    return uniqBy(icons, getResource);
  };

  var groupIconsByProgram = function groupIconsByProgram(icons) {
    return icons.reduce(function (accumulator, icon) {
      var _icon$program = icon.program,
          program = _icon$program === undefined ? UNKNOWN : _icon$program;

      if (!accumulator[program]) {
        accumulator[program] = [];
      }

      accumulator[program].push(icon);
      return accumulator;
    }, {});
  };

  var sortIconByBestPxratio = function sortIconByBestPxratio(icons) {
    var devicePixelRatio = window.devicePixelRatio || 0;

    var compareTo = function compareTo(iconA, iconB) {
      var deltaA = Math.abs(devicePixelRatio - (iconA.pxratio || 0));
      var deltaB = Math.abs(devicePixelRatio - (iconB.pxratio || 0));
      return deltaA - deltaB;
    };

    return icons.slice(0).sort(compareTo);
  };

  var chooseByPxRatio = function chooseByPxRatio(icons) {
    if (icons.length === 1) {
      return icons[0];
    }

    return sortIconByBestPxratio(icons)[0];
  };

  var chooseIcons = function chooseIcons(icons) {
    var byProgram = groupIconsByProgram(icons);
    var programs = Object.keys(byProgram);
    return programs.reduce(function (accumulator, program) {
      if (program === UNKNOWN) {
        return [].concat(toConsumableArray(accumulator), toConsumableArray(byProgram[UNKNOWN]));
      }

      return [].concat(toConsumableArray(accumulator), [chooseByPxRatio(byProgram[program])]);
    }, []);
  };

  var retrieveIcons = function retrieveIcons(vastChain) {
    var ads = vastChain.map(function (_ref) {
      var ad = _ref.ad;
      return ad;
    });
    var icons = ads.reduce(function (accumulator, ad) {
      return [].concat(toConsumableArray(accumulator), toConsumableArray(getIcons(ad) || []));
    }, []);

    if (icons.length > 0) {
      var uniqIcons = uniqByResource(icons);
      return chooseIcons(uniqIcons);
    }

    return null;
  };

  var Deferred = function Deferred() {
    var _this = this;

    classCallCheck(this, Deferred);
    this.promise = new Promise(function (resolve, reject) {
      _this.resolve = resolve;
      _this.reject = reject;
    });
  };

  var waitFor = function waitFor(element, event) {
    var pending = true;

    var _ref = new Deferred(),
        promise = _ref.promise,
        reject = _ref.reject,
        resolve = _ref.resolve;

    var cancelOnce = once$1(element, event, function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      pending = false;
      resolve(args);
    });

    var cancel = function cancel() {
      if (pending) {
        pending = false;
        cancelOnce();
        reject(new Error('waitFor was canceled'));
      }
    };

    return {
      cancel: cancel,
      promise: promise
    };
  };

  (function (self) {
    if (self.fetch) {
      return;
    }

    var support = {
      searchParams: 'URLSearchParams' in self,
      iterable: 'Symbol' in self && 'iterator' in Symbol,
      blob: 'FileReader' in self && 'Blob' in self && function () {
        try {
          new Blob();
          return true;
        } catch (e) {
          return false;
        }
      }(),
      formData: 'FormData' in self,
      arrayBuffer: 'ArrayBuffer' in self
    };

    if (support.arrayBuffer) {
      var viewClasses = ['[object Int8Array]', '[object Uint8Array]', '[object Uint8ClampedArray]', '[object Int16Array]', '[object Uint16Array]', '[object Int32Array]', '[object Uint32Array]', '[object Float32Array]', '[object Float64Array]'];

      var isDataView = function isDataView(obj) {
        return obj && DataView.prototype.isPrototypeOf(obj);
      };

      var isArrayBufferView = ArrayBuffer.isView || function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
      };
    }

    function normalizeName(name) {
      if (typeof name !== 'string') {
        name = String(name);
      }

      if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
      }

      return name.toLowerCase();
    }

    function normalizeValue(value) {
      if (typeof value !== 'string') {
        value = String(value);
      }

      return value;
    } // Build a destructive iterator for the value list


    function iteratorFor(items) {
      var iterator = {
        next: function next() {
          var value = items.shift();
          return {
            done: value === undefined,
            value: value
          };
        }
      };

      if (support.iterable) {
        iterator[Symbol.iterator] = function () {
          return iterator;
        };
      }

      return iterator;
    }

    function Headers(headers) {
      this.map = {};

      if (headers instanceof Headers) {
        headers.forEach(function (value, name) {
          this.append(name, value);
        }, this);
      } else if (Array.isArray(headers)) {
        headers.forEach(function (header) {
          this.append(header[0], header[1]);
        }, this);
      } else if (headers) {
        Object.getOwnPropertyNames(headers).forEach(function (name) {
          this.append(name, headers[name]);
        }, this);
      }
    }

    Headers.prototype.append = function (name, value) {
      name = normalizeName(name);
      value = normalizeValue(value);
      var oldValue = this.map[name];
      this.map[name] = oldValue ? oldValue + ',' + value : value;
    };

    Headers.prototype['delete'] = function (name) {
      delete this.map[normalizeName(name)];
    };

    Headers.prototype.get = function (name) {
      name = normalizeName(name);
      return this.has(name) ? this.map[name] : null;
    };

    Headers.prototype.has = function (name) {
      return this.map.hasOwnProperty(normalizeName(name));
    };

    Headers.prototype.set = function (name, value) {
      this.map[normalizeName(name)] = normalizeValue(value);
    };

    Headers.prototype.forEach = function (callback, thisArg) {
      for (var name in this.map) {
        if (this.map.hasOwnProperty(name)) {
          callback.call(thisArg, this.map[name], name, this);
        }
      }
    };

    Headers.prototype.keys = function () {
      var items = [];
      this.forEach(function (value, name) {
        items.push(name);
      });
      return iteratorFor(items);
    };

    Headers.prototype.values = function () {
      var items = [];
      this.forEach(function (value) {
        items.push(value);
      });
      return iteratorFor(items);
    };

    Headers.prototype.entries = function () {
      var items = [];
      this.forEach(function (value, name) {
        items.push([name, value]);
      });
      return iteratorFor(items);
    };

    if (support.iterable) {
      Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
    }

    function consumed(body) {
      if (body.bodyUsed) {
        return Promise.reject(new TypeError('Already read'));
      }

      body.bodyUsed = true;
    }

    function fileReaderReady(reader) {
      return new Promise(function (resolve, reject) {
        reader.onload = function () {
          resolve(reader.result);
        };

        reader.onerror = function () {
          reject(reader.error);
        };
      });
    }

    function readBlobAsArrayBuffer(blob) {
      var reader = new FileReader();
      var promise = fileReaderReady(reader);
      reader.readAsArrayBuffer(blob);
      return promise;
    }

    function readBlobAsText(blob) {
      var reader = new FileReader();
      var promise = fileReaderReady(reader);
      reader.readAsText(blob);
      return promise;
    }

    function readArrayBufferAsText(buf) {
      var view = new Uint8Array(buf);
      var chars = new Array(view.length);

      for (var i = 0; i < view.length; i++) {
        chars[i] = String.fromCharCode(view[i]);
      }

      return chars.join('');
    }

    function bufferClone(buf) {
      if (buf.slice) {
        return buf.slice(0);
      } else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
      }
    }

    function Body() {
      this.bodyUsed = false;

      this._initBody = function (body) {
        this._bodyInit = body;

        if (!body) {
          this._bodyText = '';
        } else if (typeof body === 'string') {
          this._bodyText = body;
        } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
          this._bodyBlob = body;
        } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
          this._bodyFormData = body;
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this._bodyText = body.toString();
        } else if (support.arrayBuffer && support.blob && isDataView(body)) {
          this._bodyArrayBuffer = bufferClone(body.buffer); // IE 10-11 can't handle a DataView body.

          this._bodyInit = new Blob([this._bodyArrayBuffer]);
        } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
          this._bodyArrayBuffer = bufferClone(body);
        } else {
          throw new Error('unsupported BodyInit type');
        }

        if (!this.headers.get('content-type')) {
          if (typeof body === 'string') {
            this.headers.set('content-type', 'text/plain;charset=UTF-8');
          } else if (this._bodyBlob && this._bodyBlob.type) {
            this.headers.set('content-type', this._bodyBlob.type);
          } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
            this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
          }
        }
      };

      if (support.blob) {
        this.blob = function () {
          var rejected = consumed(this);

          if (rejected) {
            return rejected;
          }

          if (this._bodyBlob) {
            return Promise.resolve(this._bodyBlob);
          } else if (this._bodyArrayBuffer) {
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          } else if (this._bodyFormData) {
            throw new Error('could not read FormData body as blob');
          } else {
            return Promise.resolve(new Blob([this._bodyText]));
          }
        };

        this.arrayBuffer = function () {
          if (this._bodyArrayBuffer) {
            return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
          } else {
            return this.blob().then(readBlobAsArrayBuffer);
          }
        };
      }

      this.text = function () {
        var rejected = consumed(this);

        if (rejected) {
          return rejected;
        }

        if (this._bodyBlob) {
          return readBlobAsText(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as text');
        } else {
          return Promise.resolve(this._bodyText);
        }
      };

      if (support.formData) {
        this.formData = function () {
          return this.text().then(decode);
        };
      }

      this.json = function () {
        return this.text().then(JSON.parse);
      };

      return this;
    } // HTTP methods whose capitalization should be normalized


    var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

    function normalizeMethod(method) {
      var upcased = method.toUpperCase();
      return methods.indexOf(upcased) > -1 ? upcased : method;
    }

    function Request(input, options) {
      options = options || {};
      var body = options.body;

      if (input instanceof Request) {
        if (input.bodyUsed) {
          throw new TypeError('Already read');
        }

        this.url = input.url;
        this.credentials = input.credentials;

        if (!options.headers) {
          this.headers = new Headers(input.headers);
        }

        this.method = input.method;
        this.mode = input.mode;

        if (!body && input._bodyInit != null) {
          body = input._bodyInit;
          input.bodyUsed = true;
        }
      } else {
        this.url = String(input);
      }

      this.credentials = options.credentials || this.credentials || 'omit';

      if (options.headers || !this.headers) {
        this.headers = new Headers(options.headers);
      }

      this.method = normalizeMethod(options.method || this.method || 'GET');
      this.mode = options.mode || this.mode || null;
      this.referrer = null;

      if ((this.method === 'GET' || this.method === 'HEAD') && body) {
        throw new TypeError('Body not allowed for GET or HEAD requests');
      }

      this._initBody(body);
    }

    Request.prototype.clone = function () {
      return new Request(this, {
        body: this._bodyInit
      });
    };

    function decode(body) {
      var form = new FormData();
      body.trim().split('&').forEach(function (bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
      return form;
    }

    function parseHeaders(rawHeaders) {
      var headers = new Headers(); // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
      // https://tools.ietf.org/html/rfc7230#section-3.2

      var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
      preProcessedHeaders.split(/\r?\n/).forEach(function (line) {
        var parts = line.split(':');
        var key = parts.shift().trim();

        if (key) {
          var value = parts.join(':').trim();
          headers.append(key, value);
        }
      });
      return headers;
    }

    Body.call(Request.prototype);

    function Response(bodyInit, options) {
      if (!options) {
        options = {};
      }

      this.type = 'default';
      this.status = options.status === undefined ? 200 : options.status;
      this.ok = this.status >= 200 && this.status < 300;
      this.statusText = 'statusText' in options ? options.statusText : 'OK';
      this.headers = new Headers(options.headers);
      this.url = options.url || '';

      this._initBody(bodyInit);
    }

    Body.call(Response.prototype);

    Response.prototype.clone = function () {
      return new Response(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new Headers(this.headers),
        url: this.url
      });
    };

    Response.error = function () {
      var response = new Response(null, {
        status: 0,
        statusText: ''
      });
      response.type = 'error';
      return response;
    };

    var redirectStatuses = [301, 302, 303, 307, 308];

    Response.redirect = function (url, status) {
      if (redirectStatuses.indexOf(status) === -1) {
        throw new RangeError('Invalid status code');
      }

      return new Response(null, {
        status: status,
        headers: {
          location: url
        }
      });
    };

    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;

    self.fetch = function (input, init) {
      return new Promise(function (resolve, reject) {
        var request = new Request(input, init);
        var xhr = new XMLHttpRequest();

        xhr.onload = function () {
          var options = {
            status: xhr.status,
            statusText: xhr.statusText,
            headers: parseHeaders(xhr.getAllResponseHeaders() || '')
          };
          options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
          var body = 'response' in xhr ? xhr.response : xhr.responseText;
          resolve(new Response(body, options));
        };

        xhr.onerror = function () {
          reject(new TypeError('Network request failed'));
        };

        xhr.ontimeout = function () {
          reject(new TypeError('Network request failed'));
        };

        xhr.open(request.method, request.url, true);

        if (request.credentials === 'include') {
          xhr.withCredentials = true;
        } else if (request.credentials === 'omit') {
          xhr.withCredentials = false;
        }

        if ('responseType' in xhr && support.blob) {
          xhr.responseType = 'blob';
        }

        request.headers.forEach(function (value, name) {
          xhr.setRequestHeader(name, value);
        });
        xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
      });
    };

    self.fetch.polyfill = true;
  })(typeof self !== 'undefined' ? self : undefined);

  var _this = undefined;

  var isValidContentType = function isValidContentType(contentType) {
    var normalisedCT = contentType.toLowerCase();
    return ['text/plain', 'text/html'].some(function (allowedType) {
      return normalisedCT.includes(allowedType);
    });
  };

  var fetchHtml = function () {
    var _ref = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(endpoint) {
      var response, contentType, error, _error;

      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch(endpoint);

            case 2:
              response = _context.sent;
              contentType = response.headers.get('Content-Type');

              if (!(response.status >= 400)) {
                _context.next = 8;
                break;
              }

              error = new Error(response.statusText);
              error.response = response;
              throw error;

            case 8:
              if (isValidContentType(contentType)) {
                _context.next = 12;
                break;
              }

              _error = new Error('fetchHtml error, invalid Content-Type ' + contentType);
              _error.response = response;
              throw _error;

            case 12:
              return _context.abrupt('return', response.text());

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function fetchHtml(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var createHtmlResource = function createHtmlResource(src, _ref) {
    var document = _ref.document,
        data = _ref.data;
    var height = data.height,
        width = data.width;
    var divElement = document.createElement('DIV');

    if (width) {
      divElement.style.width = width + 'px';
    }

    if (height) {
      divElement.style.height = height + 'px';
    }

    fetchHtml(src) // eslint-disable-next-line promise/always-return, promise/prefer-await-to-then
    .then(function (html) {
      divElement.innerHTML = html;
      divElement.dispatchEvent(new CustomEvent('load'));
    }).catch(function () {
      divElement.dispatchEvent(new CustomEvent('error'));
    });
    return divElement;
  };

  var createIframeResource = function createIframeResource(src, _ref) {
    var document = _ref.document,
        data = _ref.data;
    var height = data.height,
        width = data.width;
    var iframeElement = document.createElement('IFRAME');
    iframeElement.src = src;
    iframeElement.sandbox = 'allow-forms allow-popups allow-scripts';

    if (width) {
      iframeElement.width = width;
    }

    if (height) {
      iframeElement.height = height;
    }

    iframeElement.src = src;
    iframeElement.frameBorder = 0;
    iframeElement.style.border = 'none';
    return iframeElement;
  };

  var createStaticResource = function createStaticResource(src, _ref) {
    var document = _ref.document,
        data = _ref.data;
    var height = data.height,
        width = data.width;
    var img = document.createElement('IMG');

    if (width) {
      img.width = width;
    }

    if (height) {
      img.height = height;
    }

    img.src = src;
    return img;
  };

  var createResource = function createResource(document, data) {
    var staticResource = data.staticResource,
        htmlResource = data.htmlResource,
        iFrameResource = data.iFrameResource;

    if (Boolean(staticResource)) {
      return createStaticResource(staticResource, {
        data: data,
        document: document
      });
    }

    if (Boolean(htmlResource)) {
      return createHtmlResource(htmlResource, {
        data: data,
        document: document
      });
    }

    return createIframeResource(iFrameResource, {
      data: data,
      document: document
    });
  };
  /* eslint-disable promise/prefer-await-to-then, promise/always-return */


  var noop$1$1 = function noop() {};

  var loadResource = function loadResource(icon, _ref) {
    var document = _ref.document,
        placeholder = _ref.placeholder;
    return new Promise(function (resolve, reject) {
      try {
        var resourceElement = createResource(document, icon);
        var resourceErrorWait = waitFor(resourceElement, 'error');
        var resourceLoadWait = waitFor(resourceElement, 'load');

        var cleanUp = function cleanUp() {
          if (placeholder.contains(resourceElement)) {
            placeholder.removeChild(resourceElement);
            resourceElement.style.zIndex = 0;
          }
        };

        resourceErrorWait.promise.then(function () {
          resourceLoadWait.cancel();
          cleanUp();
          reject(new Error('Error loading resource'));
        }).catch(noop$1$1);
        resourceLoadWait.promise.then(function () {
          resourceErrorWait.cancel();
          cleanUp();
          resolve(resourceElement);
        }).catch(noop$1$1); // Some browsers will not load the resource if they are not added to the DOM

        resourceElement.style.zIndex = -9999;
        placeholder.appendChild(resourceElement);
      } catch (error) {
        reject(error);
      }
    });
  };

  var isCustomXposition = function isCustomXposition(xPosition) {
    return !['left', 'right'].includes(String(xPosition).toLowerCase());
  };

  var isCustomYPosition = function isCustomYPosition(yPosition) {
    return !['top', 'bottom'].includes(String(yPosition).toLowerCase());
  };

  var calculateIconLeft = function calculateIconLeft(dynamicPos, iconWidth, drawnIcons, phWidth) {
    var drawnIconsWidth = drawnIcons.reduce(function (accumulator, icon) {
      return accumulator + icon.width + 1;
    }, 0);

    if (dynamicPos === 'left') {
      return drawnIconsWidth;
    }

    return phWidth - drawnIconsWidth - iconWidth;
  };

  var calculateIconTop = function calculateIconTop(dynamicPos, iconHeight, phHeight) {
    if (dynamicPos === 'top') {
      return 0;
    }

    return phHeight - iconHeight;
  };

  var updateIcon = function updateIcon(icon, iconElement, _ref) {
    var drawnIcons = _ref.drawnIcons,
        placeholder = _ref.placeholder;
    var oldSignature = icon.signature;
    var rect = iconElement.getBoundingClientRect();
    var phRect = placeholder.getBoundingClientRect();
    var width = icon.width || rect.width;
    var height = icon.height || rect.height;
    var xPosition = icon.xPosition || 'right';
    var yPosition = icon.yPosition || 'top';
    var left = void 0;
    var top = void 0;

    if (isCustomXposition(xPosition)) {
      left = xPosition;
    } else {
      var icons = drawnIcons.filter(function (dIcon) {
        return dIcon.xPosition === xPosition && dIcon.yPosition === yPosition;
      });
      left = calculateIconLeft(xPosition, width, icons, phRect.width);
    }

    if (isCustomYPosition(yPosition)) {
      top = yPosition;
    } else {
      top = calculateIconTop(yPosition, height, phRect.height);
    }

    var signature = left + '-' + top + '_' + width + 'x' + height;
    return Object.assign(icon, {
      height: height,
      left: left,
      signature: signature,
      top: top,
      updated: oldSignature !== signature,
      width: width
    });
  };
  /* eslint-disable no-shadow */


  var calculateArea = function calculateArea(_ref) {
    var height = _ref.height,
        width = _ref.width;
    return height * width;
  };

  var hasSpace = function hasSpace(newIcon, config) {
    var drawnIcons = config.drawnIcons,
        placeholder = config.placeholder;
    var placeholderArea = calculateArea(placeholder.getBoundingClientRect());
    var iconArea = calculateArea(newIcon);
    var usedIconsArea = drawnIcons.reduce(function (accumulator, icon) {
      return accumulator + calculateArea(icon);
    }, 0);
    return iconArea + usedIconsArea <= placeholderArea * 0.35;
  };

  var withinBoundaries = function withinBoundaries(newIcon, _ref2) {
    var placeholder = _ref2.placeholder;
    var phRect = placeholder.getBoundingClientRect();
    return newIcon.left >= 0 && newIcon.left + newIcon.width <= phRect.width && newIcon.top >= 0 && newIcon.top + newIcon.height <= phRect.height;
  };

  var right = function right(_ref3) {
    var left = _ref3.left,
        width = _ref3.width;
    return left + width;
  };

  var left = function left(_ref4) {
    var left = _ref4.left;
    return left;
  };

  var top = function top(_ref5) {
    var top = _ref5.top;
    return top;
  };

  var bottom = function bottom(_ref6) {
    var top = _ref6.top,
        height = _ref6.height;
    return top + height;
  };

  var overlap = function overlap(newIcon, drawnIcon) {
    if (left(newIcon) > right(drawnIcon) || right(newIcon) < left(drawnIcon) || bottom(newIcon) < top(drawnIcon) || top(newIcon) > bottom(drawnIcon)) {
      return false;
    }

    return true;
  };

  var withoutOverlaps = function withoutOverlaps(newIcon, _ref7) {
    var drawnIcons = _ref7.drawnIcons;
    return !drawnIcons.some(function (drawnIcon) {
      return overlap(newIcon, drawnIcon);
    });
  };

  var canBeRendered = function canBeRendered(newIcon, config) {
    var thereIsSpace = hasSpace(newIcon, config);
    var isWithinTheContentArea = withinBoundaries(newIcon, config);
    var doesNotOverlap = withoutOverlaps(newIcon, config);
    return thereIsSpace && isWithinTheContentArea && doesNotOverlap;
  };

  var _this$1 = undefined;

  var noop$2 = function noop() {};

  var wrapWithClickThrough = function wrapWithClickThrough(iconElement, icon) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$onIconClick = _ref.onIconClick,
        onIconClick = _ref$onIconClick === undefined ? noop$2 : _ref$onIconClick;

    var anchor = document.createElement('A');

    if (icon.iconClickthrough) {
      anchor.href = icon.iconClickthrough;
      anchor.target = '_blank';
    } // NOTE: if iframe icon disable pointer events so that clickThrough and click tracking work


    if (Boolean(icon.iFrameResource)) {
      iconElement.style.pointerEvents = 'none';
    }

    anchor.onclick = function (event) {
      if (Event.prototype.stopPropagation !== undefined) {
        event.stopPropagation();
      }

      onIconClick(icon);
    };

    anchor.appendChild(iconElement);
    return anchor;
  };

  var createIcon = function () {
    var _ref2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(icon, config) {
      var iconResource;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (icon.element) {
                _context.next = 9;
                break;
              }

              _context.next = 3;
              return loadResource(icon, config);

            case 3:
              iconResource = _context.sent;
              iconResource.width = '100%';
              iconResource.height = '100%';
              iconResource.style.height = '100%';
              iconResource.style.width = '100%';
              icon.element = wrapWithClickThrough(iconResource, icon, config);

            case 9:
              return _context.abrupt('return', icon.element);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this$1);
    }));

    return function createIcon(_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  var updateIconElement = function updateIconElement(iconElement, icon) {
    var height = icon.height,
        width = icon.width,
        left = icon.left,
        top = icon.top,
        yPosition = icon.yPosition;
    iconElement.height = height;
    iconElement.width = width;
    iconElement.style.position = 'absolute';
    iconElement.style.left = left + 'px'; // NOTE: This if is a bit odd but some browser don't calculate the placeholder height pixel perfect and,
    //       setting the top of the icon will change the size of the icon's placeholder this if prevents that situation

    if (yPosition === 'bottom') {
      iconElement.style.bottom = '0';
    } else {
      iconElement.style.top = top + 'px';
    }

    iconElement.style.height = height + 'px';
    iconElement.style.width = width + 'px';
    return iconElement;
  };

  var renderIcon = function () {
    var _ref3 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(icon, config) {
      var placeholder, iconElement, updatedIcon;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              placeholder = config.placeholder;
              _context2.next = 3;
              return createIcon(icon, config);

            case 3:
              iconElement = _context2.sent;
              updatedIcon = updateIcon(icon, iconElement, config);

              if (!canBeRendered(updatedIcon, config)) {
                _context2.next = 9;
                break;
              }

              if (!iconElement.parentNode || icon.updated) {
                placeholder.appendChild(updateIconElement(iconElement, updatedIcon));
              }

              _context2.next = 11;
              break;

            case 9:
              if (iconElement.parentNode) {
                iconElement.parentNode.removeChild(iconElement);
              }

              throw new Error('Icon can\'t be rendered');

            case 11:
              return _context2.abrupt('return', updatedIcon);

            case 12:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this$1);
    }));

    return function renderIcon(_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();

  var canBeShown = function canBeShown(icon, videoElement) {
    var currentTimeInMs = videoElement.currentTime * 1000;
    var videoDurationInMs = videoElement.duration * 1000;
    var offset = icon.offset || 0;
    var duration = icon.duration || videoDurationInMs;
    return offset <= currentTimeInMs && currentTimeInMs - offset <= duration;
  };
  /* eslint-disable promise/prefer-await-to-then */


  var renderIcons = function renderIcons(icons, _ref) {
    var onIconClick = _ref.onIconClick,
        videoAdContainer = _ref.videoAdContainer,
        logger = _ref.logger;
    var element = videoAdContainer.element,
        videoElement = videoAdContainer.videoElement;
    var drawnIcons = [];

    var _icons$reduce = icons.reduce(function (accumulator, icon) {
      if (canBeShown(icon, videoElement)) {
        accumulator.iconsToShow.push(icon);
      } else {
        accumulator.otherIcons.push(icon);
      }

      return accumulator;
    }, {
      iconsToShow: [],
      otherIcons: []
    }),
        iconsToShow = _icons$reduce.iconsToShow,
        otherIcons = _icons$reduce.otherIcons;

    otherIcons.forEach(function (_ref2) {
      var iconElement = _ref2.element;

      if (iconElement && iconElement.parentNode) {
        iconElement.parentNode.removeChild(iconElement);
      }
    });
    return iconsToShow.reduce(function (promise, icon) {
      return promise.then(function () {
        return renderIcon(icon, {
          document: document,
          drawnIcons: drawnIcons,
          onIconClick: onIconClick,
          placeholder: element
        });
      }).then(function (renderedIcon) {
        return drawnIcons.push(renderedIcon);
      }).catch(function (error) {
        return logger.log(error);
      });
    }, Promise.resolve(drawnIcons)).then(function () {
      return drawnIcons;
    });
  };

  var _this$2 = undefined;
  var firstRenderPending = Symbol('firstRenderPending');

  var noop$3 = function noop() {};

  var _hasPendingIconRedraws = function _hasPendingIconRedraws(icons, videoElement) {
    var currentTimeInMs = videoElement.currentTime * 1000;
    var videoDurationInMs = videoElement.duration * 1000;
    var iconsPendingToRedraw = icons.filter(function (icon) {
      return !icon.offset || icon.offset < currentTimeInMs;
    });
    var iconsPendingToBeRemoved = icons.filter(function (icon) {
      return icon.duration && icon.duration < videoDurationInMs;
    });
    return iconsPendingToRedraw.length > 0 || iconsPendingToBeRemoved.length > 0;
  };

  var removeDrawnIcons = function removeDrawnIcons(icons) {
    return icons.filter(function (_ref) {
      var element = _ref.element;
      return Boolean(element) && Boolean(element.parentNode);
    }).forEach(function (_ref2) {
      var element = _ref2.element;
      return element.parentNode.removeChild(element);
    });
  };

  var addIcons = function addIcons(icons) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var videoAdContainer = _ref3.videoAdContainer,
        _ref3$onIconView = _ref3.onIconView,
        onIconView = _ref3$onIconView === undefined ? noop$3 : _ref3$onIconView,
        _ref3$onIconClick = _ref3.onIconClick,
        onIconClick = _ref3$onIconClick === undefined ? noop$3 : _ref3$onIconClick,
        rest = objectWithoutProperties(_ref3, ['videoAdContainer', 'onIconView', 'onIconClick']);
    var videoElement = videoAdContainer.videoElement,
        element = videoAdContainer.element;

    var drawIcons = function () {
      var _ref4 = asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee() {
        var drawnIcons;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return renderIcons(icons, _extends$1({
                  onIconClick: onIconClick,
                  videoAdContainer: videoAdContainer
                }, rest));

              case 2:
                drawnIcons = _context.sent;
                element.dispatchEvent(new CustomEvent('iconsDrawn'));
                drawnIcons.forEach(function (icon) {
                  if (icon[firstRenderPending]) {
                    onIconView(icon);
                    icon[firstRenderPending] = false;
                  }
                });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this$2);
      }));

      return function drawIcons() {
        return _ref4.apply(this, arguments);
      };
    }();

    icons.forEach(function (icon) {
      icon[firstRenderPending] = true;
    });
    return {
      drawIcons: drawIcons,
      hasPendingIconRedraws: function hasPendingIconRedraws() {
        return _hasPendingIconRedraws(icons, videoElement);
      },
      removeIcons: function removeIcons() {
        return removeDrawnIcons(icons);
      }
    };
  };

  var viewmode = function viewmode(width, height) {
    var isFullscreen = width + 100 > innerWidth && height + 100 > innerHeight;

    if (isFullscreen) {
      return 'fullscreen';
    }

    if (width < 400) {
      return 'thumbnail';
    }

    return 'normal';
  };

  var start$2 = linearEvents.start,
      iconClick$1 = linearEvents.iconClick,
      iconView$1 = linearEvents.iconView; // eslint-disable-next-line id-match

  var _protected = Symbol('_protected');
  /**
   * @class
   * @extends Emitter
   * @alias VideoAdUnit
   * @implements LinearEvents
   * @description This class provides shared logic among all the ad units.
   */


  var VideoAdUnit = function (_Emitter) {
    inherits(VideoAdUnit, _Emitter);
    /**
     * Creates a {@link VideoAdUnit}.
     *
     * @param {VastChain} vastChain - The {@link VastChain} with all the {@link VastResponse}
     * @param {VideoAdContainer} videoAdContainer - container instance to place the ad
     * @param {Object} [options] - Options Map. The allowed properties are:
     * @param {Console} [options.logger] - Optional logger instance. Must comply to the [Console interface]{@link https://developer.mozilla.org/es/docs/Web/API/Console}.
     * Defaults to `window.console`
     * @param {boolean} [options.viewability] - if true it will pause the ad whenever is not visible for the viewer.
     * Defaults to `false`
     * @param {boolean} [options.responsive] - if true it will resize the ad unit whenever the ad container changes sizes
     * Defaults to `false`
     */

    /** If an error occurs it will contain the reference to the error otherwise it will be bull */

    function VideoAdUnit(vastChain, videoAdContainer) {
      var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref$viewability = _ref.viewability,
          viewability = _ref$viewability === undefined ? false : _ref$viewability,
          _ref$responsive = _ref.responsive,
          responsive = _ref$responsive === undefined ? false : _ref$responsive,
          _ref$logger = _ref.logger,
          logger = _ref$logger === undefined ? console : _ref$logger;

      classCallCheck(this, VideoAdUnit);

      var _this = possibleConstructorReturn(this, (VideoAdUnit.__proto__ || Object.getPrototypeOf(VideoAdUnit)).call(this, logger));

      _this[_protected] = {
        finish: function finish$$1() {
          _this[_protected].finished = true;

          _this[_protected].onFinishCallbacks.forEach(function (callback) {
            return callback();
          });

          _this.emit(finish, {
            adUnit: _this,
            type: finish
          });
        },
        finished: false,
        onErrorCallbacks: [],
        onFinishCallbacks: [],
        started: false,
        throwIfCalled: function throwIfCalled() {
          throw new Error('VideoAdUnit method must be implemented on child class');
        },
        throwIfFinished: function throwIfFinished() {
          if (_this.isFinished()) {
            throw new Error('VideoAdUnit is finished');
          }
        }
      };
      _this.type = null;
      _this.error = null;
      _this.errorCode = null;
      var onFinishCallbacks = _this[_protected].onFinishCallbacks;
      /** Reference to the {@link VastChain} used to load the ad. */

      _this.vastChain = vastChain;
      /** Reference to the {@link VideoAdContainer} that contains the ad. */

      _this.videoAdContainer = videoAdContainer;
      /** Array of {@link VastIcon} definitions to display from the passed {@link VastChain} or null if there are no icons.*/

      _this.icons = retrieveIcons(vastChain);
      onFinishCallbacks.push(preventManualProgress(_this.videoAdContainer.videoElement));

      if (_this.icons) {
        var _addIcons = addIcons(_this.icons, {
          logger: logger,
          onIconClick: function onIconClick(icon) {
            return _this.emit(iconClick$1, {
              adUnit: _this,
              data: icon,
              type: iconClick$1
            });
          },
          onIconView: function onIconView(icon) {
            return _this.emit(iconView$1, {
              adUnit: _this,
              data: icon,
              type: iconView$1
            });
          },
          videoAdContainer: videoAdContainer
        }),
            drawIcons = _addIcons.drawIcons,
            hasPendingIconRedraws = _addIcons.hasPendingIconRedraws,
            removeIcons = _addIcons.removeIcons;

        _this[_protected].drawIcons = drawIcons;
        _this[_protected].removeIcons = removeIcons;
        _this[_protected].hasPendingIconRedraws = hasPendingIconRedraws;
        onFinishCallbacks.push(removeIcons);
      }

      if (viewability) {
        _this.once(start$2, function () {
          var unsubscribe = onElementVisibilityChange(_this.videoAdContainer.element, function (visible) {
            if (_this.isFinished()) {
              return;
            }

            if (visible) {
              _this.resume();
            } else {
              _this.pause();
            }
          });
          onFinishCallbacks.push(unsubscribe);
        });
      }

      if (responsive) {
        _this.once(start$2, function () {
          var element = _this.videoAdContainer.element;
          _this[_protected].size = {
            height: element.clientHeight,
            viewmode: viewmode(element.clientWidth, element.clientHeight),
            width: element.clientWidth
          };
          var unsubscribe = onElementResize(element, function () {
            if (_this.isFinished()) {
              return;
            }

            var prevSize = _this[_protected].size;
            var height = element.clientHeight;
            var width = element.clientWidth;

            if (height !== prevSize.height || width !== prevSize.width) {
              _this.resize(width, height, viewmode(width, height));
            }
          });
          onFinishCallbacks.push(unsubscribe);
        });
      }

      return _this;
    }
    /*
     * Starts the ad unit.
     *
     * @throws if called twice.
     * @throws if ad unit is finished.
     */

    /** If an error occurs it will contain the Vast Error code of the error */

    /** Ad unit type */


    createClass(VideoAdUnit, [{
      key: 'start',
      value: function start() {
        this[_protected].throwIfCalled();
      }
      /**
       * Resumes a previously paused ad unit.
       *
       * @throws if ad unit is not started.
       * @throws if ad unit is finished.
       */

    }, {
      key: 'resume',
      value: function resume() {
        this[_protected].throwIfCalled();
      }
      /**
       * Pauses the ad unit.
       *
       * @throws if ad unit is not started.
       * @throws if ad unit is finished.
       */

    }, {
      key: 'pause',
      value: function pause() {
        this[_protected].throwIfCalled();
      }
      /**
       * Sets the volume of the ad unit.
       *
       * @throws if ad unit is not started.
       * @throws if ad unit is finished.
       *
       * @param {number} volume - must be a value between 0 and 1;
       */
      // eslint-disable-next-line no-unused-vars

    }, {
      key: 'setVolume',
      value: function setVolume(volume) {
        this[_protected].throwIfCalled();
      }
      /**
       * Gets the volume of the ad unit.
       *
       * @throws if ad unit is not started.
       * @throws if ad unit is finished.
       *
       * @returns {number} - the volume of the ad unit.
       */

    }, {
      key: 'getVolume',
      value: function getVolume() {
        this[_protected].throwIfCalled();
      }
      /**
       * Cancels the ad unit.
       *
       * @throws if ad unit is finished.
       */

    }, {
      key: 'cancel',
      value: function cancel() {
        this[_protected].throwIfCalled();
      }
      /**
       * Returns the duration of the ad Creative or 0 if there is no creative.
       *
       * @returns {number} - the duration of the ad unit.
       */

    }, {
      key: 'duration',
      value: function duration() {
        this[_protected].throwIfCalled();
      }
      /**
       * Returns true if the ad is paused and false otherwise
       */

    }, {
      key: 'paused',
      value: function paused() {
        this[_protected].throwIfCalled();
      }
      /**
       * Returns the current time of the ad Creative or 0 if there is no creative.
       *
       * @returns {number} - the current time of the ad unit.
       */

    }, {
      key: 'currentTime',
      value: function currentTime() {
        this[_protected].throwIfCalled();
      }
      /**
       * Register a callback function that will be called whenever the ad finishes. No matter if it was finished because de ad ended, or cancelled or there was an error playing the ad.
       *
       * @throws if ad unit is finished.
       *
       * @param {Function} callback - will be called once the ad unit finished
       */

    }, {
      key: 'onFinish',
      value: function onFinish(callback) {
        if (typeof callback !== 'function') {
          throw new TypeError('Expected a callback function');
        }

        this[_protected].onFinishCallbacks.push(safeCallback(callback, this.logger));
      }
      /**
       * Register a callback function that will be called if there is an error while running the ad.
       *
       * @throws if ad unit is finished.
       *
       * @param {Function} callback - will be called on ad unit error passing the Error instance  and an object with the adUnit and the  {@link VastChain}.
       */

    }, {
      key: 'onError',
      value: function onError(callback) {
        if (typeof callback !== 'function') {
          throw new TypeError('Expected a callback function');
        }

        this[_protected].onErrorCallbacks.push(safeCallback(callback, this.logger));
      }
      /**
       * @returns {boolean} - true if the ad unit is finished and false otherwise
       */

    }, {
      key: 'isFinished',
      value: function isFinished() {
        return this[_protected].finished;
      }
      /**
       * @returns {boolean} - true if the ad unit has started and false otherwise
       */

    }, {
      key: 'isStarted',
      value: function isStarted() {
        return this[_protected].started;
      }
      /**
       * This method resizes the ad unit to fit the available space in the passed {@link VideoAdContainer}
       *
       * @throws if ad unit is not started.
       * @throws if ad unit is finished.
       *
       * @returns {Promise} - that resolves once the unit was resized
       */

    }, {
      key: 'resize',
      value: function () {
        var _ref2 = asyncToGenerator(
        /*#__PURE__*/
        regenerator.mark(function _callee(width, height, mode) {
          return regenerator.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  this[_protected].size = {
                    height: height,
                    viewmode: mode,
                    width: width
                  };

                  if (!(this.isStarted() && !this.isFinished() && this.icons)) {
                    _context.next = 6;
                    break;
                  }

                  _context.next = 4;
                  return this[_protected].removeIcons();

                case 4:
                  _context.next = 6;
                  return this[_protected].drawIcons();

                case 6:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function resize(_x2, _x3, _x4) {
          return _ref2.apply(this, arguments);
        }

        return resize;
      }()
    }]);
    return VideoAdUnit;
  }(Emitter);

  var complete$2 = linearEvents.complete,
      errorEvt = linearEvents.error,
      skip$2 = linearEvents.skip; // eslint-disable-next-line id-match

  var _private = Symbol('_private');
  /**
   * @class
   * @extends VideoAdUnit
   * @alias VastAdUnit
   * @implements LinearEvents
   * @description This class provides everything necessary to run a Vast ad.
   */


  var VastAdUnit = function (_VideoAdUnit) {
    inherits(VastAdUnit, _VideoAdUnit);
    /**
     * Creates a {VastAdUnit}.
     *
     * @param {VastChain} vastChain - The {@link VastChain} with all the {@link VastResponse}
     * @param {VideoAdContainer} videoAdContainer - container instance to place the ad
     * @param {Object} [options] - Options Map. The allowed properties are:
     * @param {Console} [options.logger] - Optional logger instance. Must comply to the [Console interface]{@link https://developer.mozilla.org/es/docs/Web/API/Console}.
     * Defaults to `window.console`
     * @param {Object} [options.hooks] - Optional map with hooks to configure the behaviour of the ad.
     * @param {Function} [options.hooks.createSkipControl] - If provided it will be called to generate the skip control. Must return a clickable [HTMLElement](https://developer.mozilla.org/es/docs/Web/API/HTMLElement) that is detached from the DOM.
     * @param {boolean} [options.viewability] - if true it will pause the ad whenever is not visible for the viewer.
     * Defaults to `false`
     * @param {boolean} [options.responsive] - if true it will resize the ad unit whenever the ad container changes sizes.
     * Defaults to `false`
     */

    function VastAdUnit(vastChain, videoAdContainer) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      classCallCheck(this, VastAdUnit);

      var _this = possibleConstructorReturn(this, (VastAdUnit.__proto__ || Object.getPrototypeOf(VastAdUnit)).call(this, vastChain, videoAdContainer, options));

      _this[_private] = {
        handleMetric: function handleMetric(event, data) {
          switch (event) {
            case complete$2:
              {
                _this[_protected].finish();

                break;
              }

            case errorEvt:
              {
                _this.error = data;
                _this.errorCode = _this.error && _this.error.code ? _this.error.code : 405;

                _this[_protected].onErrorCallbacks.forEach(function (callback) {
                  return callback(_this.error, {
                    adUnit: _this,
                    vastChain: _this.vastChain
                  });
                });

                _this[_protected].finish();

                break;
              }

            case skip$2:
              {
                _this.cancel();

                break;
              }
          }

          _this.emit(event, {
            adUnit: _this,
            type: event
          });
        }
      };
      _this.assetUri = null;
      _this.type = 'VAST';
      var onFinishCallbacks = _this[_protected].onFinishCallbacks;
      var handleMetric = _this[_private].handleMetric;
      _this.hooks = options.hooks || {};
      var removeMetricHandlers = setupMetricHandlers({
        hooks: _this.hooks,
        vastChain: _this.vastChain,
        videoAdContainer: _this.videoAdContainer
      }, handleMetric);
      onFinishCallbacks.push(removeMetricHandlers);
      return _this;
    }
    /**
     * Starts the ad unit.
     *
     * @throws if called twice.
     * @throws if ad unit is finished.
     */

    /** Ad unit type. Will be `VAST` for VastAdUnit */


    createClass(VastAdUnit, [{
      key: 'start',
      value: function () {
        var _ref = asyncToGenerator(
        /*#__PURE__*/
        regenerator.mark(function _callee2() {
          var _this2 = this;

          var inlineAd, _videoAdContainer, videoElement, element, media, drawIcons, adUnitError;

          return regenerator.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  this[_protected].throwIfFinished();

                  if (!this.isStarted()) {
                    _context2.next = 3;
                    break;
                  }

                  throw new Error('VastAdUnit already started');

                case 3:
                  inlineAd = this.vastChain[0].ad;
                  _videoAdContainer = this.videoAdContainer, videoElement = _videoAdContainer.videoElement, element = _videoAdContainer.element;
                  media = findBestMedia(inlineAd, videoElement, element);

                  if (!Boolean(media)) {
                    _context2.next = 16;
                    break;
                  }

                  if (!this.icons) {
                    _context2.next = 11;
                    break;
                  }

                  drawIcons = function () {
                    var _ref2 = asyncToGenerator(
                    /*#__PURE__*/
                    regenerator.mark(function _callee() {
                      return regenerator.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              if (!_this2.isFinished()) {
                                _context.next = 2;
                                break;
                              }

                              return _context.abrupt('return');

                            case 2:
                              _context.next = 4;
                              return _this2[_protected].drawIcons();

                            case 4:
                              if (_this2[_protected].hasPendingIconRedraws() && !_this2.isFinished()) {
                                once$1(videoElement, 'timeupdate', drawIcons);
                              }

                            case 5:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this2);
                    }));

                    return function drawIcons() {
                      return _ref2.apply(this, arguments);
                    };
                  }();

                  _context2.next = 11;
                  return drawIcons();

                case 11:
                  videoElement.src = media.src;
                  this.assetUri = media.src;
                  videoElement.play();
                  _context2.next = 19;
                  break;

                case 16:
                  adUnitError = new Error('Can\'t find a suitable media to play');
                  adUnitError.code = 403;

                  this[_private].handleMetric(errorEvt, adUnitError);

                case 19:
                  this[_protected].started = true;

                case 20:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function start() {
          return _ref.apply(this, arguments);
        }

        return start;
      }()
      /**
       * Resumes a previously paused ad unit.
       *
       * @throws if ad unit is not started.
       * @throws if ad unit is finished.
       */

    }, {
      key: 'resume',
      value: function resume() {
        this.videoAdContainer.videoElement.play();
      }
      /**
       * Pauses the ad unit.
       *
       * @throws if ad unit is not started.
       * @throws if ad unit is finished.
       */

    }, {
      key: 'pause',
      value: function pause() {
        this.videoAdContainer.videoElement.pause();
      }
      /**
       * Returns true if the ad is paused and false otherwise
       */

    }, {
      key: 'paused',
      value: function paused() {
        return this.videoAdContainer.videoElement.paused;
      }
      /**
       * Sets the volume of the ad unit.
       *
       * @throws if ad unit is not started.
       * @throws if ad unit is finished.
       *
       * @param {number} volume - must be a value between 0 and 1;
       */

    }, {
      key: 'setVolume',
      value: function setVolume(volume) {
        this.videoAdContainer.videoElement.volume = volume;
      }
      /**
       * Gets the volume of the ad unit.
       *
       * @throws if ad unit is not started.
       * @throws if ad unit is finished.
       *
       * @returns {number} - the volume of the ad unit.
       */

    }, {
      key: 'getVolume',
      value: function getVolume() {
        return this.videoAdContainer.videoElement.volume;
      }
      /**
       * Cancels the ad unit.
       *
       * @throws if ad unit is finished.
       */

    }, {
      key: 'cancel',
      value: function cancel() {
        this[_protected].throwIfFinished();

        this.videoAdContainer.videoElement.pause();

        this[_protected].finish();
      }
      /**
       * Returns the duration of the ad Creative or 0 if there is no creative.
       *
       * @returns {number} - the duration of the ad unit.
       */

    }, {
      key: 'duration',
      value: function duration() {
        if (!this.isStarted()) {
          return 0;
        }

        return this.videoAdContainer.videoElement.duration;
      }
      /**
       * Returns the current time of the ad Creative or 0 if there is no creative.
       *
       * @returns {number} - the current time of the ad unit.
       */

    }, {
      key: 'currentTime',
      value: function currentTime() {
        if (!this.isStarted()) {
          return 0;
        }

        return this.videoAdContainer.videoElement.currentTime;
      }
      /**
       * This method resizes the ad unit to fit the available space in the passed {@link VideoAdContainer}
       *
       * @param width {number} - the new width of the ad container.
       * @param height {number} - the new height of the ad container.
       * @param viewmode {string} - fullscreen | normal | thumbnail
       * @returns {Promise} - that resolves once the unit was resized
       */

    }, {
      key: 'resize',
      value: function () {
        var _ref3 = asyncToGenerator(
        /*#__PURE__*/
        regenerator.mark(function _callee3(width, height, viewmode) {
          var inlineAd, _videoAdContainer2, videoElement, element, media;

          return regenerator.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return get$1(VastAdUnit.prototype.__proto__ || Object.getPrototypeOf(VastAdUnit.prototype), 'resize', this).call(this, width, height, viewmode);

                case 2:
                  if (this.isStarted() && !this.isFinished()) {
                    inlineAd = this.vastChain[0].ad;
                    _videoAdContainer2 = this.videoAdContainer, videoElement = _videoAdContainer2.videoElement, element = _videoAdContainer2.element;
                    media = findBestMedia(inlineAd, videoElement, element);

                    if (Boolean(media) && videoElement.src !== media.src) {
                      updateMedia(videoElement, media);
                    }
                  }

                case 3:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function resize(_x2, _x3, _x4) {
          return _ref3.apply(this, arguments);
        }

        return resize;
      }()
    }]);
    return VastAdUnit;
  }(VideoAdUnit);

  var SUPPORTED_MIMETYPES = ['text/javascript', 'text/javascript1.0', 'text/javascript1.2', 'text/javascript1.4', 'text/jscript', 'application/javascript', 'application/x-javascript', 'text/ecmascript', 'text/ecmascript1.0', 'text/ecmascript1.2', 'text/ecmascript1.4', 'text/livescript', 'application/ecmascript', 'application/x-ecmascript'];

  var isSupported = function isSupported(_ref) {
    var type = _ref.type;
    return SUPPORTED_MIMETYPES.some(function (mimetype) {
      return mimetype === type;
    });
  };

  var _this$3 = undefined;

  var loadCreative = function () {
    var _ref = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(vastChain, videoAdContainer) {
      var creative, src, type, context;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              creative = (getInteractiveFiles(vastChain[0].ad) || []).filter(isSupported)[0];

              if (creative) {
                _context.next = 3;
                break;
              }

              throw new TypeError('VastChain does not contain a supported vpaid creative');

            case 3:
              src = creative.src, type = creative.type;
              _context.next = 6;
              return videoAdContainer.addScript(src, {
                type: type
              });

            case 6:
              context = videoAdContainer.executionContext;
              return _context.abrupt('return', context.getVPAIDAd());

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this$3);
    }));

    return function loadCreative(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var handshakeVersion = 'handshakeVersion';
  var resizeAd = 'resizeAd';
  var startAd = 'startAd';
  var stopAd = 'stopAd';
  var pauseAd = 'pauseAd';
  var resumeAd = 'resumeAd';
  var getAdRemainingTime = 'getAdRemainingTime';
  var getAdDuration = 'getAdDuration';
  var getAdVolume = 'getAdVolume';
  var getAdIcons = 'getAdIcons';
  var setAdVolume = 'setAdVolume';
  var adLoaded = 'AdLoaded';
  var adStarted = 'AdStarted';
  var adStopped = 'AdStopped';
  var adSkipped = 'AdSkipped';
  var adSkippableStateChange = 'AdSkippableStateChange';
  var adSizeChange = 'AdSizeChange';
  var adLinearChange = 'AdLinearChange';
  var adDurationChange = 'AdDurationChange';
  var adExpandedChange = 'AdExpandedChange';
  var adRemainingTimeChange = 'AdRemainingTimeChange';
  var adVolumeChange = 'AdVolumeChange';
  var adImpression = 'AdImpression';
  var adVideoStart = 'AdVideoStart';
  var adVideoFirstQuartile = 'AdVideoFirstQuartile';
  var adVideoMidpoint = 'AdVideoMidpoint';
  var adVideoThirdQuartile = 'AdVideoThirdQuartile';
  var adVideoComplete = 'AdVideoComplete';
  var adClickThru = 'AdClickThru';
  var adInteraction = 'AdInteraction';
  var adUserAcceptInvitation = 'AdUserAcceptInvitation';
  var adUserMinimize = 'AdUserMinimize';
  var adUserClose = 'AdUserClose';
  var adPaused = 'AdPaused';
  var adPlaying = 'AdPlaying';
  var adLog = 'AdLog';
  var adError = 'AdError';
  var EVENTS = [adLoaded, adStarted, adStopped, adSkipped, adSkippableStateChange, adSizeChange, adLinearChange, adDurationChange, adExpandedChange, adRemainingTimeChange, adVolumeChange, adImpression, adVideoStart, adVideoFirstQuartile, adVideoMidpoint, adVideoThirdQuartile, adVideoComplete, adClickThru, adInteraction, adUserAcceptInvitation, adUserMinimize, adUserClose, adPaused, adPlaying, adLog, adError];

  var waitFor$1 = function waitFor(creativeAd, event, timeout) {
    return new Promise(function (resolve, reject) {
      // eslint-disable-next-line prefer-const
      var timeoutId = void 0;

      var handler = function handler() {
        if (typeof timeout === 'number') {
          clearTimeout(timeoutId);
        }

        creativeAd.unsubscribe(handler, event);
        resolve();
      };

      if (typeof timeout === 'number') {
        timeoutId = setTimeout(function () {
          creativeAd.unsubscribe(handler, event);
          reject(new Error('Timeout waiting for event \'' + event + '\''));
        }, timeout);
      }

      creativeAd.subscribe(handler, event);
    });
  };

  var callAndWait = function callAndWait(creativeAd, method, event) {
    for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      args[_key - 3] = arguments[_key];
    }

    var waitPromise = waitFor$1(creativeAd, event, 5000);
    creativeAd[method].apply(creativeAd, args);
    return waitPromise;
  };

  var major = function major(version) {
    var parts = version.split('.');
    return parseInt(parts[0], 10);
  };

  var isSupported$1 = function isSupported(supportedVersion, creativeVersion) {
    var creativeMajorNum = major(creativeVersion);

    if (creativeMajorNum < 1) {
      return false;
    }

    return creativeMajorNum <= major(supportedVersion);
  };

  var handshake = function handshake(creative, supportedVersion) {
    var creativeVersion = creative[handshakeVersion](supportedVersion);

    if (!isSupported$1(supportedVersion, creativeVersion)) {
      throw new Error('Creative Version \'' + creativeVersion + '\' not supported');
    }

    return creativeVersion;
  };

  var createSlot = function createSlot(placeholder, width, height) {
    var slot = document.createElement('DIV');
    Object.assign(slot.style, {
      border: '0px',
      cursor: 'pointer',
      height: height + 'px',
      left: '0px',
      margin: '0px',
      padding: '0px',
      position: 'absolute',
      top: '0px',
      width: width + 'px'
    });
    placeholder.appendChild(slot);
    return slot;
  };

  var initAd$1 = function initAd(creativeAd, videoAdContainer, vastChain) {
    var placeholder = videoAdContainer.element;

    var _placeholder$getBound = placeholder.getBoundingClientRect(),
        width = _placeholder$getBound.width,
        height = _placeholder$getBound.height;

    var mode = viewmode(width, height);
    var desiredBitrate = -1;
    var environmentVars = {
      slot: createSlot(placeholder, width, height),
      videoSlot: videoAdContainer.videoElement,
      videoSlotCanAutoPlay: videoAdContainer.isOriginalVideoElement
    };
    var creativeData = getCreativeData(vastChain[0].XML);
    creativeAd.initAd(width, height, mode, desiredBitrate, creativeData, environmentVars);
  };

  var complete$3 = linearEvents.complete,
      mute$2 = linearEvents.mute,
      unmute$2 = linearEvents.unmute,
      skip$3 = linearEvents.skip,
      start$3 = linearEvents.start,
      firstQuartile$2 = linearEvents.firstQuartile,
      pause$2 = linearEvents.pause,
      resume$2 = linearEvents.resume,
      impression$2 = linearEvents.impression,
      midpoint$2 = linearEvents.midpoint,
      thirdQuartile$2 = linearEvents.thirdQuartile,
      clickThrough$2 = linearEvents.clickThrough,
      errorEvt$1 = linearEvents.error,
      closeLinear$1 = linearEvents.closeLinear; // NOTE some ads only allow one handler per event and we need to subscribe to the adLoaded to know the creative is loaded.

  var VPAID_EVENTS = EVENTS.filter(function (event) {
    return event !== adLoaded;
  }); // eslint-disable-next-line id-match

  var _private$1 = Symbol('_private');

  var vpaidGeneralError = function vpaidGeneralError(payload) {
    var error$$1 = payload instanceof Error ? payload : new Error('VPAID general error');

    if (!error$$1.code) {
      error$$1.code = 901;
    }

    return error$$1;
  };
  /**
   * @class
   * @alias VpaidAdUnit
   * @extends VideoAdUnit
   * @implements NonLinearEvents
   * @implements LinearEvents
   * @description This class provides everything necessary to run a Vpaid ad.
   */


  var VpaidAdUnit = function (_VideoAdUnit) {
    inherits(VpaidAdUnit, _VideoAdUnit);
    /**
     * Creates a {VpaidAdUnit}.
     *
     * @param {VastChain} vastChain - The {@link VastChain} with all the {@link VastResponse}
     * @param {VideoAdContainer} videoAdContainer - container instance to place the ad
     * @param {Object} [options] - Options Map. The allowed properties are:
     * @param {Console} [options.logger] - Optional logger instance. Must comply to the [Console interface]{@link https://developer.mozilla.org/es/docs/Web/API/Console}.
     * Defaults to `window.console`
     * @param {boolean} [options.viewability] - if true it will pause the ad whenever is not visible for the viewer.
     * Defaults to `false`
     * @param {boolean} [options.responsive] - if true it will resize the ad unit whenever the ad container changes sizes
     * Defaults to `false`
     * Defaults to `window.console`
     */

    /** Ad unit type. Will be `VPAID` for VpaidAdUnit */

    function VpaidAdUnit(vastChain, videoAdContainer) {
      var _evtHandler;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      classCallCheck(this, VpaidAdUnit);

      var _this = possibleConstructorReturn(this, (VpaidAdUnit.__proto__ || Object.getPrototypeOf(VpaidAdUnit)).call(this, vastChain, videoAdContainer, options));

      _this[_private$1] = {
        evtHandler: (_evtHandler = {}, defineProperty(_evtHandler, adClickThru, function (url, id, playerHandles) {
          if (playerHandles) {
            if (_this.paused()) {
              _this.resume();
            } else {
              var clickThroughUrl = typeof url === 'string' && url.length > 0 ? url : getClickThrough(_this.vastChain[0].ad);

              _this.pause();

              window.open(clickThroughUrl, '_blank');
            }
          }

          _this.emit(clickThrough$2, {
            adUnit: _this,
            type: clickThrough$2
          });
        }), defineProperty(_evtHandler, adDurationChange, function () {
          _this.emit(adProgress, {
            adUnit: _this,
            type: adProgress
          });
        }), defineProperty(_evtHandler, adError, function (payload) {
          _this.error = vpaidGeneralError(payload);
          _this.errorCode = _this.error.code;

          _this[_protected].onErrorCallbacks.forEach(function (callback) {
            return callback(_this.error, {
              adUnit: _this,
              vastChain: _this.vastChain
            });
          });

          _this[_protected].finish();

          _this.emit(errorEvt$1, {
            adUnit: _this,
            type: errorEvt$1
          });
        }), defineProperty(_evtHandler, adImpression, function () {
          // NOTE: some ads forget to trigger the adVideoStart event. :(
          if (!_this[_private$1].videoStart) {
            _this[_private$1].handleVpaidEvt(adVideoStart);
          }

          _this.emit(impression$2, {
            adUnit: _this,
            type: impression$2
          });
        }), defineProperty(_evtHandler, adPaused, function () {
          _this[_private$1].paused = true;

          _this.emit(pause$2, {
            adUnit: _this,
            type: pause$2
          });
        }), defineProperty(_evtHandler, adPlaying, function () {
          _this[_private$1].paused = false;

          _this.emit(resume$2, {
            adUnit: _this,
            type: resume$2
          });
        }), defineProperty(_evtHandler, adRemainingTimeChange, function () {
          _this.emit(adProgress, {
            adUnit: _this,
            type: adProgress
          });
        }), defineProperty(_evtHandler, adSkipped, function () {
          _this.cancel();

          _this.emit(skip$3, {
            adUnit: _this,
            type: skip$3
          });
        }), defineProperty(_evtHandler, adStarted, function () {
          _this.emit(creativeView, {
            adUnit: _this,
            type: creativeView
          });
        }), defineProperty(_evtHandler, adStopped, function () {
          _this.emit(adStopped, {
            adUnit: _this,
            type: adStopped
          });

          _this[_protected].finish();
        }), defineProperty(_evtHandler, adUserAcceptInvitation, function () {
          _this.emit(acceptInvitation, {
            adUnit: _this,
            type: acceptInvitation
          });
        }), defineProperty(_evtHandler, adUserClose, function () {
          _this.emit(closeLinear$1, {
            adUnit: _this,
            type: closeLinear$1
          });

          _this[_protected].finish();
        }), defineProperty(_evtHandler, adUserMinimize, function () {
          _this.emit(adCollapse, {
            adUnit: _this,
            type: adCollapse
          });
        }), defineProperty(_evtHandler, adVideoComplete, function () {
          _this.emit(complete$3, {
            adUnit: _this,
            type: complete$3
          });

          _this[_protected].finish();
        }), defineProperty(_evtHandler, adVideoFirstQuartile, function () {
          _this.emit(firstQuartile$2, {
            adUnit: _this,
            type: firstQuartile$2
          });
        }), defineProperty(_evtHandler, adVideoMidpoint, function () {
          _this.emit(midpoint$2, {
            adUnit: _this,
            type: midpoint$2
          });
        }), defineProperty(_evtHandler, adVideoStart, function () {
          if (!_this[_private$1].videoStart) {
            _this[_private$1].videoStart = true;
            _this[_private$1].paused = false;

            _this.emit(start$3, {
              adUnit: _this,
              type: start$3
            });
          }
        }), defineProperty(_evtHandler, adVideoThirdQuartile, function () {
          _this.emit(thirdQuartile$2, {
            adUnit: _this,
            type: thirdQuartile$2
          });
        }), defineProperty(_evtHandler, adVolumeChange, function () {
          var volume = _this.getVolume();

          _this.emit(volumeChanged, {
            adUnit: _this,
            type: volumeChanged
          });

          if (volume === 0 && !_this[_private$1].muted) {
            _this[_private$1].muted = true;

            _this.emit(mute$2, {
              adUnit: _this,
              type: mute$2
            });
          }

          if (volume > 0 && _this[_private$1].muted) {
            _this[_private$1].muted = false;

            _this.emit(unmute$2, {
              adUnit: _this,
              type: unmute$2
            });
          }
        }), _evtHandler),
        handleVpaidEvt: function handleVpaidEvt(event) {
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          var handler = _this[_private$1].evtHandler[event];

          if (handler) {
            handler.apply(undefined, args);
          }

          _this.emit(event, {
            adUnit: _this,
            type: event
          });
        },
        muted: false,
        paused: true
      };
      _this.type = 'VPAID';
      _this.creativeAd = null;
      _this[_private$1].loadCreativePromise = loadCreative(vastChain, videoAdContainer);
      return _this;
    }
    /**
     * Starts the ad unit.
     *
     * @throws if called twice.
     * @throws if ad unit is finished.
     */

    /** Reference to the Vpaid Creative ad unit. Will be null before the ad unit starts. */


    createClass(VpaidAdUnit, [{
      key: 'start',
      value: function () {
        var _ref = asyncToGenerator(
        /*#__PURE__*/
        regenerator.mark(function _callee2() {
          var _this2 = this;

          var adLoadedPromise, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, creativeEvt, videoElement, drawIcons;

          return regenerator.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  this[_protected].throwIfFinished();

                  if (!this.isStarted()) {
                    _context2.next = 3;
                    break;
                  }

                  throw new Error('VpaidAdUnit already started');

                case 3:
                  _context2.prev = 3;
                  _context2.next = 6;
                  return this[_private$1].loadCreativePromise;

                case 6:
                  this.creativeAd = _context2.sent;
                  adLoadedPromise = waitFor$1(this.creativeAd, adLoaded);
                  _iteratorNormalCompletion = true;
                  _didIteratorError = false;
                  _iteratorError = undefined;
                  _context2.prev = 11;

                  for (_iterator = VPAID_EVENTS[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    creativeEvt = _step.value;
                    this.creativeAd.subscribe(this[_private$1].handleVpaidEvt.bind(this, creativeEvt), creativeEvt);
                  }

                  _context2.next = 19;
                  break;

                case 15:
                  _context2.prev = 15;
                  _context2.t0 = _context2['catch'](11);
                  _didIteratorError = true;
                  _iteratorError = _context2.t0;

                case 19:
                  _context2.prev = 19;
                  _context2.prev = 20;

                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }

                case 22:
                  _context2.prev = 22;

                  if (!_didIteratorError) {
                    _context2.next = 25;
                    break;
                  }

                  throw _iteratorError;

                case 25:
                  return _context2.finish(22);

                case 26:
                  return _context2.finish(19);

                case 27:
                  if (this.creativeAd[getAdIcons] && !this.creativeAd[getAdIcons]()) {
                    this.icons = null;
                  }

                  handshake(this.creativeAd, '2.0');
                  initAd$1(this.creativeAd, this.videoAdContainer, this.vastChain);
                  _context2.next = 32;
                  return adLoadedPromise;

                case 32:
                  if (this.videoAdContainer.isDestroyed()) {
                    _context2.next = 48;
                    break;
                  }

                  _context2.prev = 33;
                  videoElement = this.videoAdContainer.videoElement;

                  if (videoElement.muted) {
                    this[_private$1].muted = true;
                    this.setVolume(0);
                  } else {
                    this.setVolume(videoElement.volume);
                  }

                  _context2.next = 38;
                  return callAndWait(this.creativeAd, startAd, adStarted);

                case 38:
                  if (!this.icons) {
                    _context2.next = 42;
                    break;
                  }

                  drawIcons = function () {
                    var _ref2 = asyncToGenerator(
                    /*#__PURE__*/
                    regenerator.mark(function _callee() {
                      return regenerator.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              if (!_this2.isFinished()) {
                                _context.next = 2;
                                break;
                              }

                              return _context.abrupt('return');

                            case 2:
                              _context.next = 4;
                              return _this2[_protected].drawIcons();

                            case 4:
                              if (_this2[_protected].hasPendingIconRedraws() && !_this2.isFinished()) {
                                setTimeout(drawIcons, 500);
                              }

                            case 5:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this2);
                    }));

                    return function drawIcons() {
                      return _ref2.apply(this, arguments);
                    };
                  }();

                  _context2.next = 42;
                  return drawIcons();

                case 42:
                  this[_protected].started = true;
                  _context2.next = 48;
                  break;

                case 45:
                  _context2.prev = 45;
                  _context2.t1 = _context2['catch'](33);
                  this.cancel();

                case 48:
                  return _context2.abrupt('return', this);

                case 51:
                  _context2.prev = 51;
                  _context2.t2 = _context2['catch'](3);

                  this[_private$1].handleVpaidEvt(adError, _context2.t2);

                  throw _context2.t2;

                case 55:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[3, 51], [11, 15, 19, 27], [20,, 22, 26], [33, 45]]);
        }));

        function start$$1() {
          return _ref.apply(this, arguments);
        }

        return start$$1;
      }()
      /**
       * Resumes a previously paused ad unit.
       *
       * @throws if ad unit is not started.
       * @throws if ad unit is finished.
       */

    }, {
      key: 'resume',
      value: function resume$$1() {
        this.creativeAd[resumeAd]();
      }
      /**
       * Pauses the ad unit.
       *
       * @throws if ad unit is not started.
       * @throws if ad unit is finished.
       */

    }, {
      key: 'pause',
      value: function pause$$1() {
        this.creativeAd[pauseAd]();
      }
      /**
       * Returns true if the ad is paused and false otherwise
       */

    }, {
      key: 'paused',
      value: function paused() {
        return this.isFinished() || this[_private$1].paused;
      }
      /**
       * Sets the volume of the ad unit.
       *
       * @throws if ad unit is not started.
       * @throws if ad unit is finished.
       *
       * @param {number} volume - must be a value between 0 and 1;
       */

    }, {
      key: 'setVolume',
      value: function setVolume(volume) {
        this.creativeAd[setAdVolume](volume);
      }
      /**
       * Gets the volume of the ad unit.
       *
       * @throws if ad unit is not started.
       * @throws if ad unit is finished.
       *
       * @returns {number} - the volume of the ad unit.
       */

    }, {
      key: 'getVolume',
      value: function getVolume() {
        return this.creativeAd[getAdVolume]();
      }
      /**
       * Cancels the ad unit.
       *
       * @throws if ad unit is finished.
       */

    }, {
      key: 'cancel',
      value: function () {
        var _ref3 = asyncToGenerator(
        /*#__PURE__*/
        regenerator.mark(function _callee3() {
          var adStoppedPromise;
          return regenerator.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  this[_protected].throwIfFinished();

                  _context3.prev = 1;
                  adStoppedPromise = waitFor$1(this.creativeAd, adStopped, 3000);
                  this.creativeAd[stopAd]();
                  _context3.next = 6;
                  return adStoppedPromise;

                case 6:
                  _context3.next = 11;
                  break;

                case 8:
                  _context3.prev = 8;
                  _context3.t0 = _context3['catch'](1);

                  this[_protected].finish();

                case 11:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, this, [[1, 8]]);
        }));

        function cancel() {
          return _ref3.apply(this, arguments);
        }

        return cancel;
      }()
      /**
       * Returns the duration of the ad Creative or 0 if there is no creative.
       *
       * Note: if the user has engaged with the ad, the duration becomes unknown and it will return 0;
       *
       * @returns {number} - the duration of the ad unit.
       */

    }, {
      key: 'duration',
      value: function duration() {
        if (!this.creativeAd) {
          return 0;
        }

        var duration = this.creativeAd[getAdDuration]();

        if (duration < 0) {
          return 0;
        }

        return duration;
      }
      /**
       * Returns the current time of the ad Creative or 0 if there is no creative.
       *
       * Note: if the user has engaged with the ad, the currentTime becomes unknown and it will return 0;
       *
       * @returns {number} - the current time of the ad unit.
       */

    }, {
      key: 'currentTime',
      value: function currentTime() {
        if (!this.creativeAd) {
          return 0;
        }

        var remainingTime = this.creativeAd[getAdRemainingTime]();

        if (remainingTime < 0) {
          return 0;
        }

        return this.duration() - remainingTime;
      }
      /**
       * This method resizes the ad unit to fit the available space in the passed {@link VideoAdContainer}
       *
       * @throws if ad unit is not started.
       * @throws if ad unit is finished.
       *
       * @returns {Promise} - that resolves once the unit was resized
       */

    }, {
      key: 'resize',
      value: function () {
        var _ref4 = asyncToGenerator(
        /*#__PURE__*/
        regenerator.mark(function _callee4(width, height, viewmode) {
          return regenerator.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return get$1(VpaidAdUnit.prototype.__proto__ || Object.getPrototypeOf(VpaidAdUnit.prototype), 'resize', this).call(this, width, height, viewmode);

                case 2:
                  return _context4.abrupt('return', callAndWait(this.creativeAd, resizeAd, adSizeChange, width, height, viewmode));

                case 3:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function resize(_x2, _x3, _x4) {
          return _ref4.apply(this, arguments);
        }

        return resize;
      }()
    }]);
    return VpaidAdUnit;
  }(VideoAdUnit);

  var createVideoAdUnit = function createVideoAdUnit(vastChain, videoAdContainer, options) {
    var tracker = options.tracker,
        type = options.type;
    var adUnit = type === 'VPAID' ? new VpaidAdUnit(vastChain, videoAdContainer, options) : new VastAdUnit(vastChain, videoAdContainer, options);
    Object.values(linearEvents).forEach(function (linearEvent) {
      return adUnit.on(linearEvent, function (event) {
        var evtType = event.type,
            data = event.data;
        var payload = {
          data: data,
          errorCode: adUnit.errorCode,
          tracker: tracker
        };
        trackLinearEvent(evtType, vastChain, payload);
      });
    });
    Object.values(nonLinearEvents).forEach(function (nonLinearEvent) {
      return adUnit.on(nonLinearEvent, function (event) {
        var payload = {
          data: event.data,
          tracker: tracker
        };
        trackNonLinearEvent(event.type, vastChain, payload);
      });
    });
    return adUnit;
  };

  var _this$4 = undefined;

  var validate$2 = function validate(vastChain, videoAdContainer) {
    if (!Array.isArray(vastChain) || vastChain.length === 0) {
      throw new TypeError('Invalid vastChain');
    }

    if (!(videoAdContainer instanceof VideoAdContainer)) {
      throw new TypeError('Invalid VideoAdContainer');
    }
  };

  var hasVpaidCreative = function hasVpaidCreative(ad) {
    return Boolean(getInteractiveFiles(ad));
  };

  var hasVastCreative = function hasVastCreative(ad, videoElement) {
    var mediaFiles = getMediaFiles(ad);

    if (mediaFiles) {
      return mediaFiles.some(function (mediaFile) {
        return canPlay(videoElement, mediaFile);
      });
    }

    return false;
  };

  var startAdUnit = function startAdUnit(adUnit, _ref) {
    var onAdReady = _ref.onAdReady;
    return new Promise(function (resolve, reject) {
      var createRejectHandler = function createRejectHandler(event) {
        return function () {
          return reject(new Error('Ad unit start rejected due to event \'' + event + '\''));
        };
      };

      adUnit.onError(reject);
      adUnit.on(start, function () {
        return resolve(adUnit);
      });
      adUnit.on(adUserClose, createRejectHandler(adUserClose));
      adUnit.on(closeLinear, createRejectHandler(closeLinear));
      adUnit.on(adStopped, createRejectHandler(adStopped));
      onAdReady(adUnit);
      adUnit.start();
    });
  };

  var tryToStartVpaidAd = function tryToStartVpaidAd(vastChain, videoAdContainer, options) {
    if (!hasVpaidCreative(vastChain[0].ad)) {
      throw new Error('No valid creative found in the passed VAST chain');
    }

    var adUnit = createVideoAdUnit(vastChain, videoAdContainer, _extends$1({}, options, {
      type: 'VPAID'
    }));
    return startAdUnit(adUnit, options);
  };

  var startVastAd = function startVastAd(vastChain, videoAdContainer, options) {
    var adUnit = createVideoAdUnit(vastChain, videoAdContainer, _extends$1({}, options, {
      type: 'VAST'
    }));
    return startAdUnit(adUnit, options);
  };

  var startVideoAd = function () {
    var _ref2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(vastChain, videoAdContainer, options) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              validate$2(vastChain, videoAdContainer);
              _context.prev = 1;
              _context.next = 4;
              return tryToStartVpaidAd(vastChain, videoAdContainer, options);

            case 4:
              return _context.abrupt('return', _context.sent);

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](1);

              if (!hasVastCreative(vastChain[0].ad, videoAdContainer.videoElement)) {
                _context.next = 11;
                break;
              }

              return _context.abrupt('return', startVastAd(vastChain, videoAdContainer, options));

            case 11:
              throw _context.t0;

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this$4, [[1, 7]]);
    }));

    return function startVideoAd(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  var _this$5 = undefined;
  /**
   * Will try to start video ad in the passed {@link VastChain} and return the started VideoAdUnit.
   *
   * @memberof module:@mailonline/video-ad-sdk
   * @static
   * @throws if there is an error starting the ad or it times out (by throw I mean that it will reject promise with the error).
   * @param {VastChain} vastChain - The {@link VastChain} with all the {@link VastResponse}s.
   * @param {HTMLElement} placeholder - placeholder element that will contain the video ad.
   * @param {Object} [options] - Options Map. The allowed properties are:
   * @param {runWaterfall~onAdReady} options.onAdReady - will be called once the ad is ready with the ad unit.
   * @param {HTMLVideoElement} [options.videoElement] - optional videoElement that will be used to play the ad.
   * @param {Console} [options.logger] - Optional logger instance. Must comply to the [Console interface]{@link https://developer.mozilla.org/es/docs/Web/API/Console}.
   * Defaults to `window.console`
   * @param {boolean} [options.viewability] - if true it will pause the ad whenever is not visible for the viewer.
   * Defaults to `false`
   * @param {boolean} [options.responsive] - if true it will resize the ad unit whenever the ad container changes sizes.
   * Defaults to `false`
   * @param {number} [options.timeout] - timeout number in milliseconds. If set, the video ad will time out if it doesn't start within the specified time.
   * @param {TrackerFn} [options.tracker] - If provided it will be used to track the VAST events instead of the default {@link pixelTracker}.
   * @param {Object} [options.hooks] - Optional map with hooks to configure the behaviour of the ad.
   * @param {Function} [options.hooks.createSkipControl] - If provided it will be called to generate the skip control. Must return a clickable [HTMLElement](https://developer.mozilla.org/es/docs/Web/API/HTMLElement) that is detached from the DOM.
   * @returns {Promise.<VastAdUnit|VpaidAdUnit>} - The video ad unit.
   */

  var run = function () {
    var _ref = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(vastChain, placeholder, options) {
      var videoAdContainer, timeout, adUnitPromise, timedOut, timeoutId, timeoutPromise, adUnit;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              videoAdContainer = void 0;
              _context.prev = 1;
              timeout = options.timeout;
              videoAdContainer = createVideoAdContainer(placeholder, options.videoElement);
              adUnitPromise = startVideoAd(vastChain, videoAdContainer, options);

              if (typeof timeout === 'number') {
                timedOut = false;
                timeoutId = void 0;
                timeoutPromise = new Promise(function (resolve, reject) {
                  timeoutId = setTimeout(function () {
                    var tracker = options.tracker;
                    trackError(vastChain, {
                      errorCode: 402,
                      tracker: tracker
                    });
                    timedOut = true;
                    reject(new Error('Timeout while starting the ad'));
                  }, options.timeout);
                });
                adUnitPromise = Promise.race([// eslint-disable-next-line promise/prefer-await-to-then
                adUnitPromise.then(function (newAdUnit) {
                  if (timedOut) {
                    if (newAdUnit.isStarted()) {
                      newAdUnit.cancel();
                    }
                  } else {
                    clearTimeout(timeoutId);
                  }

                  return newAdUnit;
                }), timeoutPromise]);
              }

              _context.next = 8;
              return adUnitPromise;

            case 8:
              adUnit = _context.sent;
              adUnit.onFinish(function () {
                videoAdContainer.destroy();
              });
              return _context.abrupt('return', adUnit);

            case 13:
              _context.prev = 13;
              _context.t0 = _context['catch'](1);

              if (videoAdContainer) {
                videoAdContainer.destroy();
              }

              throw _context.t0;

            case 17:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this$5, [[1, 13]]);
    }));

    return function run(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();

  var _this$6 = undefined;

  var fetch$1$1 = function () {
    var _ref = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(endpoint) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var defaults$$1, fetchOptions, response, error;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              defaults$$1 = {
                credentials: 'include'
              };
              fetchOptions = Object.assign({}, defaults$$1, options);
              _context.next = 4;
              return window.fetch(endpoint, fetchOptions);

            case 4:
              response = _context.sent;

              if (!(response.status >= 400)) {
                _context.next = 9;
                break;
              }

              error = new Error(response.statusText);
              error.response = response;
              throw error;

            case 9:
              return _context.abrupt('return', response);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this$6);
    }));

    return function fetch(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var requested = Symbol('requested');

  var markAdAsRequested = function markAdAsRequested(ad) {
    ad[requested] = true;
  };

  var hasAdBeenRequested = function hasAdBeenRequested(ad) {
    return Boolean(ad[requested]);
  };

  var _this$7 = undefined;

  var validateChain = function validateChain(vastChain, _ref) {
    var _ref$wrapperLimit = _ref.wrapperLimit,
        wrapperLimit = _ref$wrapperLimit === undefined ? 5 : _ref$wrapperLimit;

    if (vastChain.length > wrapperLimit) {
      var error = new Error('Wrapper Limit reached');
      error.code = 304;
      throw error;
    }
  };

  var fetchAdXML = function () {
    var _ref2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(adTag, options) {
      var response, XML;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch$1$1(adTag, options);

            case 3:
              response = _context.sent;
              _context.next = 6;
              return response.text();

            case 6:
              XML = _context.sent;
              return _context.abrupt('return', XML);

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](0);
              _context.t0.code = 502;
              throw _context.t0;

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this$7, [[0, 10]]);
    }));

    return function fetchAdXML(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var parseVastXml = function parseVastXml(xml) {
    try {
      return parseXml(xml);
    } catch (error) {
      error.code = 100;
      throw error;
    }
  };

  var getAd = function getAd(parsedXML) {
    try {
      var ad = getFirstAd(parsedXML);

      if (Boolean(ad)) {
        markAdAsRequested(ad);
        return ad;
      }

      throw new Error('No Ad');
    } catch (error) {
      error.code = 303;
      throw error;
    }
  };

  var validateResponse = function validateResponse(_ref3, _ref4) {
    var ad = _ref3.ad,
        parsedXML = _ref3.parsedXML;
    var _ref4$allowMultipleAd = _ref4.allowMultipleAds,
        allowMultipleAds = _ref4$allowMultipleAd === undefined ? true : _ref4$allowMultipleAd,
        _ref4$followAdditiona = _ref4.followAdditionalWrappers,
        followAdditionalWrappers = _ref4$followAdditiona === undefined ? true : _ref4$followAdditiona;

    if (!isWrapper(ad) && !isInline(ad)) {
      var error = new Error('Invalid VAST, ad contains neither Wrapper nor Inline');
      error.code = 101;
      throw error;
    }

    if (hasAdPod(parsedXML) && !allowMultipleAds) {
      var _error = new Error('Multiple ads are not allowed');

      _error.code = 203;
      throw _error;
    }

    if (isWrapper(ad) && !followAdditionalWrappers) {
      var _error2 = new Error('To follow additional wrappers is not allowed');

      _error2.code = 200;
      throw _error2;
    }
  };

  var getOptions = function getOptions(vastChain, options) {
    var parentAd = vastChain[0];
    var parentAdIsWrapper = Boolean(parentAd) && isWrapper(parentAd.ad);
    var wrapperOptions = parentAdIsWrapper ? getWrapperOptions(parentAd.ad) : {};
    return _extends$1({}, wrapperOptions, options);
  }; // eslint-disable-next-line jsdoc/check-tag-names

  /**
   * @function requestAd
   *
   * @memberof module:@mailonline/video-ad-sdk
   * @async
   * @static
   * @description Request the ad using the passed ad tag and returns an array with the [VAST responses]{@link VastResponse} needed to get an inline ad.
   *
   * @param {string} adTag - The VAST ad tag request url.
   * @param {Object} options - Options Map. The allowed properties are:
   * @param {number} [options.wrapperLimit] - Sets the maximum number of wrappers allowed in the {@link VastChain}.
   *  Defaults to `5`.
   * @param {boolean} [options.AllowMultipleAds] - Boolean to indicate whether adPods are allowed or not.
   *  Defaults to `true`.
   * @param {number} [options.timeout] - timeout number in milliseconds. If set, the request will timeout if it is not fulfilled before the specified time.
   * @param {VastChain} [vastChain] - Optional vastChain with the previous VAST responses.
   * @returns {Promise.<VastChain>} - Returns a Promise that will resolve with a VastChain with the newest VAST response at the beginning of the array.
   * If the {@link VastChain} had an error. The first VAST response of the array will contain an error and an errorCode entry.
   */


  var requestAd = function () {
    var _ref5 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(adTag, options) {
      var vastChain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var VASTAdResponse, opts, epoch, timeout, fetchPromise;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              VASTAdResponse = {
                ad: null,
                errorCode: null,
                parsedXML: null,
                requestTag: adTag,
                XML: null
              };
              opts = void 0;
              epoch = void 0;
              timeout = void 0;
              _context2.prev = 4;
              opts = getOptions(vastChain, options);
              validateChain(vastChain, opts);
              fetchPromise = fetchAdXML(adTag, opts);

              if (typeof opts.timeout === 'number') {
                timeout = opts.timeout;
                epoch = Date.now();
                fetchPromise = Promise.race([fetchPromise, new Promise(function (resolve, reject) {
                  setTimeout(function () {
                    var error = new Error('RequestAd timeout');
                    error.code = 301;
                    reject(error);
                  }, timeout);
                })]);
              }

              _context2.next = 11;
              return fetchPromise;

            case 11:
              VASTAdResponse.XML = _context2.sent;
              VASTAdResponse.parsedXML = parseVastXml(VASTAdResponse.XML);
              VASTAdResponse.ad = getAd(VASTAdResponse.parsedXML);
              validateResponse(VASTAdResponse, opts);

              if (!isWrapper(VASTAdResponse.ad)) {
                _context2.next = 18;
                break;
              }

              if (epoch) {
                timeout -= Date.now() - epoch;
              }

              return _context2.abrupt('return', requestAd(getVASTAdTagURI(VASTAdResponse.ad), _extends$1({}, opts, {
                timeout: timeout
              }), [VASTAdResponse].concat(toConsumableArray(vastChain))));

            case 18:
              return _context2.abrupt('return', [VASTAdResponse].concat(toConsumableArray(vastChain)));

            case 21:
              _context2.prev = 21;
              _context2.t0 = _context2['catch'](4);
              /* istanbul ignore if */

              if (!Number.isInteger(_context2.t0.code)) {
                _context2.t0.code = 900;
              }

              VASTAdResponse.errorCode = _context2.t0.code;
              VASTAdResponse.error = _context2.t0;
              return _context2.abrupt('return', [VASTAdResponse].concat(toConsumableArray(vastChain)));

            case 27:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this$7, [[4, 21]]);
    }));

    return function requestAd(_x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }();

  var getNextPod = function getNextPod(currentPod, ads) {
    var nextPodSequence = getPodAdSequence(currentPod) + 1;
    return ads.find(function (ad) {
      return getPodAdSequence(ad) === nextPodSequence;
    }) || null;
  };

  var getNextAd = function getNextAd(_ref, _ref2) {
    var ad = _ref.ad,
        parsedXML = _ref.parsedXML;
    var _ref2$fallbackOnNoAd = _ref2.fallbackOnNoAd,
        fallbackOnNoAd = _ref2$fallbackOnNoAd === undefined ? true : _ref2$fallbackOnNoAd,
        _ref2$useAdBuffet = _ref2.useAdBuffet,
        useAdBuffet = _ref2$useAdBuffet === undefined ? false : _ref2$useAdBuffet;
    var ads = getAds(parsedXML);
    var availableAds = ads.filter(function (adDefinition) {
      return !hasAdBeenRequested(adDefinition);
    });
    var nextAd = null;

    if (hasAdPod(parsedXML)) {
      if (useAdBuffet) {
        nextAd = availableAds.filter(function (adDefinition) {
          return !isPodAd(adDefinition);
        })[0];
      }

      if (!nextAd) {
        nextAd = getNextPod(ad, availableAds);
      }
    } else if (availableAds.length > 0 && fallbackOnNoAd) {
      nextAd = availableAds[0];
    }

    return nextAd;
  };

  var validateChain$1 = function validateChain(VastChain) {
    if (!Array.isArray(VastChain)) {
      throw new TypeError('Invalid VAST chain');
    }

    if (VastChain.length === 0) {
      throw new Error('No next ad to request');
    }
  }; // eslint-disable-next-line jsdoc/check-tag-names

  /**
   * @function requestNextAd
   *
   * @memberof module:@mailonline/video-ad-sdk
   * @async
   * @static
   * @description Requests the next ad in the VAST Chain.
   *
   * @param {VastChain} VastChain - Array of {@link VastResponse}.
   * @param {Object} options - Options Map. The allowed properties are:
   * @param {number} [options.wrapperLimit] - Sets the maximum number of wrappers allowed in the vastChain.
   *  Defaults to `5`.
   * @param {boolean} [options.AllowMultipleAds] - Boolean to indicate whether adPods are allowed or not.
   *  Defaults to `true`.
   * @param {tracker} [options.track] - optional function to track whatever errors occur during the loading.
   *  Defaults to `@mailonline/video-ad-tracker` track method.
   * @param {boolean} [options.useAdBuffet] - Specifies whether to use buffet ads from an ad pod if possible.
   *    If no buffet ad is available it will return the next ad in ad pod sequence.
   *    Set it to true if an ad from an adPod failed and you want to replace it with an ad from the ad buffet.
   *    Defaults to `false`.
   * @param {boolean} [options.fallbackOnNoAd] - tells the video player to select an ad from any stand-alone ads available.
   *    Note: if the {@link VastChain} contains an adPod this property will be ignored.
   *    Defaults to `true`.
   * @param {number} [options.timeout] - timeout number in milliseconds. If set, the request will timeout if it is not fulfilled before the specified time.
   *
   * @returns {Promise.<VastChain>}  - Returns a Promise that will resolve with a VastChain with the newest VAST response at the beginning of the array.
   * If the {@link VastChain} had an error. The first VAST response of the array will contain an error and an errorCode entry.
   */


  var requestNextAd = function requestNextAd(VastChain, options) {
    validateChain$1(VastChain);
    var vastResponse = VastChain[0];
    var nextAd = getNextAd(vastResponse, options);

    if (Boolean(nextAd)) {
      var newVastResponse = Object.assign({}, vastResponse, {
        ad: nextAd
      });
      var newVastChain = [newVastResponse].concat(toConsumableArray(VastChain.slice(1)));
      markAdAsRequested(nextAd);

      if (isWrapper(nextAd)) {
        return requestAd(getVASTAdTagURI(nextAd), options, newVastChain);
      }

      return Promise.resolve(newVastChain);
    }

    return requestNextAd(VastChain.slice(1), options);
  };

  var _this$8 = undefined;

  var isVpaid = function isVpaid(vastChain) {
    return Boolean(getInteractiveFiles(vastChain[0].ad));
  };

  var validateVastChain = function validateVastChain(vastChain, options) {
    if (!vastChain || vastChain.length === 0) {
      throw new Error('Invalid VastChain');
    }

    var lastVastResponse = vastChain[0];

    if (!options.vpaidEnabled && isVpaid(vastChain)) {
      var error = new Error('VPAID ads are not supported by the current player');
      error.code = 200;
      lastVastResponse.errorCode = 200;
      lastVastResponse.error = error;
    }

    if (Boolean(lastVastResponse.error)) {
      throw lastVastResponse.error;
    }

    if (options.hooks && typeof options.hooks.validateVastResponse === 'function') {
      options.hooks.validateVastResponse(vastChain);
    }
  };

  var getErrorCode = function getErrorCode(vastChain, error) {
    return vastChain && vastChain[0] && vastChain[0].errorCode || error.code;
  };

  var transformVastResponse = function transformVastResponse(vastChain, _ref) {
    var hooks = _ref.hooks;

    if (hooks && typeof hooks.transformVastResponse === 'function') {
      return hooks.transformVastResponse(vastChain);
    }

    return vastChain;
  }; // eslint-disable-next-line complexity


  var waterfall = function () {
    var _ref2 = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(fetchVastChain, placeholder, options, isCanceled) {
      var vastChain, runEpoch, adUnit, opts, onAdStart, onError, onRunFinish, newEpoch, errorCode, tracker;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              vastChain = void 0;
              runEpoch = void 0;
              adUnit = void 0;
              opts = _extends$1({}, options);
              onAdStart = opts.onAdStart, onError = opts.onError, onRunFinish = opts.onRunFinish;
              _context.prev = 5;

              if (typeof opts.timeout === 'number') {
                runEpoch = Date.now();
              }

              _context.next = 9;
              return fetchVastChain();

            case 9:
              vastChain = _context.sent;

              if (!isCanceled()) {
                _context.next = 13;
                break;
              }

              onRunFinish();
              return _context.abrupt('return');

            case 13:
              if (runEpoch) {
                newEpoch = Date.now();
                opts.timeout -= newEpoch - runEpoch;
                runEpoch = newEpoch;
              }

              validateVastChain(vastChain, opts);
              _context.next = 17;
              return run(transformVastResponse(vastChain, opts), placeholder, _extends$1({}, opts));

            case 17:
              adUnit = _context.sent;

              if (!isCanceled()) {
                _context.next = 22;
                break;
              }

              adUnit.cancel();
              onRunFinish();
              return _context.abrupt('return');

            case 22:
              adUnit.onError(onError);
              adUnit.onFinish(onRunFinish);
              onAdStart(adUnit);
              _context.next = 38;
              break;

            case 27:
              _context.prev = 27;
              _context.t0 = _context['catch'](5);
              errorCode = getErrorCode(vastChain, _context.t0);

              if (Boolean(errorCode)) {
                tracker = options.tracker;
                trackError(vastChain, {
                  errorCode: errorCode,
                  tracker: tracker
                });
              }

              onError(_context.t0, {
                adUnit: adUnit,
                vastChain: vastChain
              });

              if (!(vastChain && !isCanceled())) {
                _context.next = 37;
                break;
              }

              if (runEpoch) {
                opts.timeout -= Date.now() - runEpoch;
              }

              if (!(!runEpoch || opts.timeout > 0)) {
                _context.next = 37;
                break;
              }

              waterfall(function () {
                return requestNextAd(vastChain, opts);
              }, placeholder, _extends$1({}, opts), isCanceled);
              return _context.abrupt('return');

            case 37:
              onRunFinish();

            case 38:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this$8, [[5, 27]]);
    }));

    return function waterfall(_x, _x2, _x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();

  var Ads =
  /*#__PURE__*/
  function () {
    /**
     *
     * @param {Plyr} player
     */
    function Ads(player) {
      var _this = this;

      _classCallCheck(this, Ads);

      this.player = player;
      this.active = {};
      this.config = player.config.ads;
      this.events = {};
      this.responses = {};
      this.elements = {
        container: null
      };
      this.initialized = false;
      this.playing = false;
      this.loaded = false;
      this.countdownTimer = null;
      this.managerPromise = new Promise(function (res, rej) {
        _this.on('loaded', res);

        _this.on('error', rej);
      });

      if (this.enabled) {
        this.load();
      }
    }

    _createClass(Ads, [{
      key: "load",

      /**
       * Готовит рекламный модуль
       */
      value: function load() {
        if (this.enabled) {
          this.spawnContainer();
          this.config.sources = this.config.sources.filter(function (_ref) {
            var enabled = _ref.enabled;
            return enabled;
          });
          this.status = 'инициализация рекламы';
          this.trigger('loaded');
        }
      }
      /**
       * Создаём контейнеры
       */

    }, {
      key: "spawnContainer",
      value: function spawnContainer() {
        var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        if (this.enabled) {
          if (force || !is$1.element(this.elements.container)) {
            if (is$1.element(this.elements.container)) {
              this.elements.container.remove();
            }

            this.elements.container = createElement('div', {
              class: this.player.config.classNames.ads
            });
            this.player.elements.container.appendChild(this.elements.container);
          }
        }
      }
      /**
       *
       */

    }, {
      key: "requestAds",
      value: function requestAds() {
        var _this2 = this;

        if (this.enabled) {
          this.status = 'инициализация рекламы'; // делаем запросы ко всем

          var requests = this.config.sources.map(
          /*#__PURE__*/
          function () {
            var _ref2 = _asyncToGenerator(
            /*#__PURE__*/
            regeneratorRuntime.mark(function _callee(src, i) {
              var response;
              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;
                      _context.t0 = _objectSpread;
                      _context.next = 4;
                      return requestAd(src.url, {
                        AllowMultipleAds: false,
                        timeout: _this2.config.timeout
                      });

                    case 4:
                      _context.t1 = _context.sent;
                      _context.t2 = {};
                      _context.t3 = i - 1;
                      _context.t4 = {
                        chains: _context.t1,
                        used: false,
                        unit: _context.t2,
                        index: _context.t3
                      };
                      _context.t5 = src;
                      response = (0, _context.t0)(_context.t4, _context.t5);
                      return _context.abrupt("return", response);

                    case 13:
                      _context.prev = 13;
                      _context.t6 = _context["catch"](0);

                      _this2.player.debug.warn("AD: source get for ".concat(src.url, " error:"), _context.t6);

                      return _context.abrupt("return", false);

                    case 17:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, null, [[0, 13]]);
            }));

            return function (_x, _x2) {
              return _ref2.apply(this, arguments);
            };
          }());
          Promise.all(requests).then(function (responses) {
            _this2.responses = responses.filter(function (res) {
              return is$1.object(res);
            }) // отсеиваем ошибки при запросе
            .filter(function (res) {
              return !res.chains[0].errorCode;
            }) // отсеиваем ошибки рекламы
            .sort(function (_ref3, _ref4) {
              var x = _ref3.index;
              var i = _ref4.index;
              return x - i;
            }) // сортируем по индексу
            .map(function (x, i) {
              return _objectSpread({
                timeout: _this2.config.timeout
              }, x, {
                index: i
              });
            }); // исправляем индексы согласно ключам и добавляем таймаут если его нет

            if (is$1.empty(_this2.responses)) {
              _this2.initialized = true;

              if (is$1.empty(responses.filter(function (x) {
                return x === true;
              }))) {
                _this2.onAdError(new Error('No ads, everything blocked'), false);

                triggerEvent.call(_this2.player, _this2.player.media, 'adsblocked');
              } else {
                _this2.onAdError(new Error("AD: Responses chain is empty, all ads have errors: ".concat(responses)));
              }

              return;
            } // получает неиспользованную рекламу


            _this2.rotateNextAd();

            triggerEvent.call(_this2.player, _this2.player.media, 'adsloaded'); // ad is ready

            _this2.loaded = true; // play

            _this2.play();
          }).catch(function () {
            _this2.trigger('error');
          });
        }
      }
      /**
       * Получает следующую неиспользованную рекламу
       */

    }, {
      key: "rotateNextAd",
      value: function rotateNextAd() {
        this.status = 'поиск рекламы'; // получаем неиспользованные источники

        var unused = this.responses.filter(function (_ref5) {
          var used = _ref5.used;
          return !used;
        }); // если неиспользованных источников не осталось

        if (is$1.empty(unused)) {
          return false;
        } // eslint-disable-next-line prefer-destructuring


        this.active = unused[0]; // отмечаем как использованную

        this.responses[unused[0].index].used = true; // возвращаем

        return this.active;
      }
    }, {
      key: "play",
      value: function play() {
        var _this3 = this;

        if (!this.loaded) {
          this.pauseContent();
          this.requestAds();
          return;
        }

        var container = this.elements.container;

        if (!this.managerPromise) {
          this.resumeContent();
        }

        this.managerPromise.then(function () {
          if (!_this3.initialized) {
            run(_this3.active.chains, container, {
              timeout: _this3.active.timeout,
              responsive: true,
              onAdReady: function onAdReady(unit) {
                _this3.status = 'загрузка рекламы';
                _this3.active.unit = unit; // fire content loaded event

                triggerEvent.call(_this3.player, _this3.player.media, 'adscontentloaded');
              }
            }).then(function (unit) {
              _this3.initialized = true;
              _this3.status = 'показ рекламы';
              unit.setVolume(_this3.player.volume);
              unit.on('finish', function () {
                _this3.cancel();

                _this3.pollCountdown();

                triggerEvent.call(_this3.player, _this3.player.media, 'adscomplete');
              });

              _this3.pollCountdown(true); // Fire event


              triggerEvent.call(_this3.player, _this3.player.media, 'adstarted');
            }).catch(function (e) {
              _this3.player.debug.warn('AD: error, trying to get next ad', e);

              _this3.status = 'поиск другой рекламы';

              if (!_this3.rotateNextAd()) {
                _this3.player.debug.warn('AD: There is no unused ads now, destroying.');

                _this3.initialized = true;

                _this3.onAdError(e);

                return;
              }

              _this3.player.debug.warn('AD: playing next ad');

              _this3.play();
            });
          }
        }).catch(function () {});
      }
      /**
       * Update the ad countdown
       * @param {boolean} start
       */

    }, {
      key: "pollCountdown",
      value: function pollCountdown() {
        var _this4 = this;

        var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        if (!start) {
          clearInterval(this.countdownTimer);
          this.elements.container.removeAttribute('data-badge-text');
          this.elements.container.removeAttribute('data-badge-hover-text');
          return;
        }

        var update = function update() {
          var remainingTime = _this4.active.unit.duration() - _this4.active.unit.currentTime();

          var time = remainingTime >= 45 ? 'подождите' : formatTime(Math.max(remainingTime, 0));
          var label = "".concat(i18n.get('advertisement', _this4.player.config), " - ").concat(time);
          var labelHover = "".concat(i18n.get('adexplanation', _this4.player.config), " - ").concat(time);

          _this4.elements.container.setAttribute('data-badge-text', label);

          _this4.elements.container.setAttribute('data-badge-hover-text', labelHover);
        };

        this.countdownTimer = setInterval(update, 100);
      }
    }, {
      key: "resumeContent",

      /**
       * Resume our video
       */
      value: function resumeContent() {
        this.status = 'приятного просмотра'; // Hide the advertisement container

        this.elements.container.style.zIndex = ''; // Ad is stopped

        this.playing = false; // Play our video

        if (this.player.currentTime < this.player.duration) {
          this.player.play();
        }
      }
      /**
       * Pause our video
       */

    }, {
      key: "pauseContent",
      value: function pauseContent() {
        // Show the advertisement container
        this.elements.container.style.zIndex = 3; // Ad is playing.

        this.playing = true; // Pause our video.

        this.player.pause();
      }
      /**
       *
       * @param {string} event
       * @param  {...any} args
       */

    }, {
      key: "trigger",
      value: function trigger(event) {
        var _this5 = this;

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var handlers = this.events[event];

        if (is$1.array(handlers)) {
          handlers.forEach(function (handler) {
            if (is$1.function(handler)) {
              handler.apply(_this5, args);
            }
          });
        }
      }
      /**
       *
       * @param {string} event Тип события
       * @param {function} callback Действие при срабатывания события
       */

    }, {
      key: "on",
      value: function on$$1(event, callback) {
        if (!is$1.array(this.events[event])) {
          this.events[event] = [];
        }

        this.events[event].push(callback);
        return this;
      }
    }, {
      key: "onAdError",
      value: function onAdError(e) {
        var fire = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        this.player.debug.error('Ads error:', e);

        if (fire) {
          // Fire event
          triggerEvent.call(this.player, this.player.media, 'adserror');
        }

        this.cancel();
      }
    }, {
      key: "cancel",
      value: function cancel() {
        if (this.initialized && Object.prototype.hasOwnProperty.call(this.active, 'unit') && Object.prototype.hasOwnProperty.call(this.active.unit, 'cancel')) {
          this.player.debug.log('Ad is initialized, destroying...');
          this.active.unit.cancel().catch(function () {});
        }

        this.resumeContent();
        this.player.debug.log('Ad is canceled');
        this.trigger('error');
      }
    }, {
      key: "enabled",
      get: function get() {
        return this.player.isHTML5 && this.player.isVideo && this.player.config.ads.enabled && !is$1.empty(this.config) && is$1.array(this.config.sources);
      }
    }, {
      key: "status",
      get: function get() {
        return this.elements.container.getAttribute('data-loading-text');
      },
      set: function set(value) {
        this.elements.container.setAttribute('data-loading-text', value.toLowerCase());
      }
    }]);

    return Ads;
  }();

  var parseVtt = function parseVtt(vttDataString) {
    var processedList = [];
    var frames = vttDataString.split(/\r\n\r\n|\n\n|\r\r/);
    frames.forEach(function (frame) {
      var result = {};
      var lines = frame.split(/\r\n|\n|\r/);
      lines.forEach(function (line) {
        if (!is$1.number(result.startTime)) {
          // The line with start and end times on it is the first line of interest
          var matchTimes = line.match(/([0-9]{2}):([0-9]{2}):([0-9]{2}).([0-9]{2,3})( ?--> ?)([0-9]{2}):([0-9]{2}):([0-9]{2}).([0-9]{2,3})/); // Note that this currently ignores caption formatting directives that are optionally on the end of this line - fine for non-captions VTT

          if (matchTimes) {
            result.startTime = Number(matchTimes[1]) * 60 * 60 + Number(matchTimes[2]) * 60 + Number(matchTimes[3]) + Number("0.".concat(matchTimes[4]));
            result.endTime = Number(matchTimes[6]) * 60 * 60 + Number(matchTimes[7]) * 60 + Number(matchTimes[8]) + Number("0.".concat(matchTimes[9]));
          }
        } else if (!is$1.empty(line.trim()) && is$1.empty(result.text)) {
          // If we already have the startTime, then we're definitely up to the text line(s)
          var lineSplit = line.trim().split('#xywh=');

          var _lineSplit = _slicedToArray(lineSplit, 1);

          result.text = _lineSplit[0];

          // If there's content in lineSplit[1], then we have sprites. If not, then it's just one frame per image
          if (lineSplit[1]) {
            var _lineSplit$1$split = lineSplit[1].split(',');

            var _lineSplit$1$split2 = _slicedToArray(_lineSplit$1$split, 4);

            result.x = _lineSplit$1$split2[0];
            result.y = _lineSplit$1$split2[1];
            result.w = _lineSplit$1$split2[2];
            result.h = _lineSplit$1$split2[3];
          }
        }
      });

      if (result.text) {
        processedList.push(result);
      }
    });
    return processedList;
  };
  /**
   * Preview thumbnails for seek hover and scrubbing
   * Seeking: Hover over the seek bar (desktop only): shows a small preview container above the seek bar
   * Scrubbing: Click and drag the seek bar (desktop and mobile): shows the preview image over the entire video, as if the video is scrubbing at very high speed
   *
   * Notes:
   * - Thumbs are set via JS settings on Plyr init, not HTML5 'track' property. Using the track property would be a bit gross, because it doesn't support custom 'kinds'. kind=metadata might be used for something else, and we want to allow multiple thumbnails tracks. Tracks must have a unique combination of 'kind' and 'label'. We would have to do something like kind=metadata,label=thumbnails1 / kind=metadata,label=thumbnails2. Square peg, round hole
   * - VTT info: the image URL is relative to the VTT, not the current document. But if the url starts with a slash, it will naturally be relative to the current domain. https://support.jwplayer.com/articles/how-to-add-preview-thumbnails
   * - This implementation uses multiple separate img elements. Other implementations use background-image on one element. This would be nice and simple, but Firefox and Safari have flickering issues with replacing backgrounds of larger images. It seems that YouTube perhaps only avoids this because they don't have the option for high-res previews (even the fullscreen ones, when mousedown/seeking). Images appear over the top of each other, and previous ones are discarded once the new ones have been rendered
   */


  var PreviewThumbnails =
  /*#__PURE__*/
  function () {
    /**
     * PreviewThumbnails constructor.
     * @param {Plyr} player
     * @return {PreviewThumbnails}
     */
    function PreviewThumbnails(player) {
      _classCallCheck(this, PreviewThumbnails);

      this.player = player;
      this.thumbnails = [];
      this.loaded = false;
      this.lastMouseMoveTime = Date.now();
      this.mouseDown = false;
      this.loadedImages = [];
      this.elements = {
        thumb: {},
        scrubbing: {}
      };
      this.load();
    }

    _createClass(PreviewThumbnails, [{
      key: "load",
      value: function load() {
        var _this = this;

        // Togglethe regular seek tooltip
        if (this.player.elements.display.seekTooltip) {
          this.player.elements.display.seekTooltip.hidden = this.enabled;
        }

        if (!this.enabled) {
          return;
        }

        this.getThumbnails().then(function () {
          // Render DOM elements
          _this.render(); // Check to see if thumb container size was specified manually in CSS


          _this.determineContainerAutoSizing();

          _this.loaded = true;
        });
      } // Download VTT files and parse them

    }, {
      key: "getThumbnails",
      value: function getThumbnails() {
        var _this2 = this;

        return new Promise(function (resolve) {
          var src = _this2.player.config.previewThumbnails.src;

          if (is$1.empty(src)) {
            throw new Error('Missing previewThumbnails.src config attribute');
          } // If string, convert into single-element list


          var urls = is$1.string(src) ? [src] : src; // Loop through each src URL. Download and process the VTT file, storing the resulting data in this.thumbnails

          var promises = urls.map(function (u) {
            return _this2.getThumbnail(u);
          });
          Promise.all(promises).then(function () {
            // Sort smallest to biggest (e.g., [120p, 480p, 1080p])
            _this2.thumbnails.sort(function (x, y) {
              return x.height - y.height;
            });

            _this2.player.debug.log('Preview thumbnails', _this2.thumbnails);

            resolve();
          });
        });
      } // Process individual VTT file

    }, {
      key: "getThumbnail",
      value: function getThumbnail(url) {
        var _this3 = this;

        return new Promise(function (resolve) {
          fetch$1(url).then(function (response) {
            var thumbnail = {
              frames: parseVtt(response),
              height: null,
              urlPrefix: ''
            }; // If the URLs don't start with '/', then we need to set their relative path to be the location of the VTT file
            // If the URLs do start with '/', then they obviously don't need a prefix, so it will remain blank

            if (!thumbnail.frames[0].text.startsWith('/')) {
              thumbnail.urlPrefix = url.substring(0, url.lastIndexOf('/') + 1);
            } // Download the first frame, so that we can determine/set the height of this thumbnailsDef


            var tempImage = new Image();

            tempImage.onload = function () {
              thumbnail.height = tempImage.naturalHeight;
              thumbnail.width = tempImage.naturalWidth;

              _this3.thumbnails.push(thumbnail);

              resolve();
            };

            tempImage.src = thumbnail.frames[0].text;
          });
        });
      }
    }, {
      key: "startMove",
      value: function startMove(event) {
        if (!this.loaded) {
          return;
        }

        if (!is$1.event(event) || !['touchmove', 'mousemove'].includes(event.type)) {
          return;
        } // Wait until media has a duration


        if (!this.player.media.duration) {
          return;
        }

        if (event.type === 'touchmove') {
          // Calculate seek hover position as approx video seconds
          this.seekTime = this.player.media.duration * (this.player.elements.inputs.seek.value / 100);
        } else {
          // Calculate seek hover position as approx video seconds
          var clientRect = this.player.elements.progress.getBoundingClientRect();
          var percentage = 100 / clientRect.width * (event.pageX - clientRect.left);
          this.seekTime = this.player.media.duration * (percentage / 100);

          if (this.seekTime < 0) {
            // The mousemove fires for 10+px out to the left
            this.seekTime = 0;
          }

          if (this.seekTime > this.player.media.duration - 1) {
            // Took 1 second off the duration for safety, because different players can disagree on the real duration of a video
            this.seekTime = this.player.media.duration - 1;
          }

          this.mousePosX = event.pageX; // Set time text inside image container

          this.elements.thumb.time.innerText = formatTime(this.seekTime);
        } // Download and show image


        this.showImageAtCurrentTime();
      }
    }, {
      key: "endMove",
      value: function endMove() {
        this.toggleThumbContainer(false, true);
      }
    }, {
      key: "startScrubbing",
      value: function startScrubbing(event) {
        // Only act on left mouse button (0), or touch device (event.button is false)
        if (event.button === false || event.button === 0) {
          this.mouseDown = true; // Wait until media has a duration

          if (this.player.media.duration) {
            this.toggleScrubbingContainer(true);
            this.toggleThumbContainer(false, true); // Download and show image

            this.showImageAtCurrentTime();
          }
        }
      }
    }, {
      key: "endScrubbing",
      value: function endScrubbing() {
        var _this4 = this;

        this.mouseDown = false; // Hide scrubbing preview. But wait until the video has successfully seeked before hiding the scrubbing preview

        if (Math.ceil(this.lastTime) === Math.ceil(this.player.media.currentTime)) {
          // The video was already seeked/loaded at the chosen time - hide immediately
          this.toggleScrubbingContainer(false);
        } else {
          // The video hasn't seeked yet. Wait for that
          once.call(this.player, this.player.media, 'timeupdate', function () {
            // Re-check mousedown - we might have already started scrubbing again
            if (!_this4.mouseDown) {
              _this4.toggleScrubbingContainer(false);
            }
          });
        }
      }
      /**
       * Setup hooks for Plyr and window events
       */

    }, {
      key: "listeners",
      value: function listeners() {
        var _this5 = this;

        // Hide thumbnail preview - on mouse click, mouse leave (in listeners.js for now), and video play/seek. All four are required, e.g., for buffering
        this.player.on('play', function () {
          _this5.toggleThumbContainer(false, true);
        });
        this.player.on('seeked', function () {
          _this5.toggleThumbContainer(false);
        });
        this.player.on('timeupdate', function () {
          _this5.lastTime = _this5.player.media.currentTime;
        });
      }
      /**
       * Create HTML elements for image containers
       */

    }, {
      key: "render",
      value: function render() {
        // Create HTML element: plyr__preview-thumbnail-container
        this.elements.thumb.container = createElement('div', {
          class: this.player.config.classNames.previewThumbnails.thumbContainer
        }); // Wrapper for the image for styling

        this.elements.thumb.imageContainer = createElement('div', {
          class: this.player.config.classNames.previewThumbnails.imageContainer
        });
        this.elements.thumb.container.appendChild(this.elements.thumb.imageContainer); // Create HTML element, parent+span: time text (e.g., 01:32:00)

        var timeContainer = createElement('div', {
          class: this.player.config.classNames.previewThumbnails.timeContainer
        });
        this.elements.thumb.time = createElement('span', {}, '00:00');
        timeContainer.appendChild(this.elements.thumb.time);
        this.elements.thumb.container.appendChild(timeContainer); // Inject the whole thumb

        this.player.elements.progress.appendChild(this.elements.thumb.container); // Create HTML element: plyr__preview-scrubbing-container

        this.elements.scrubbing.container = createElement('div', {
          class: this.player.config.classNames.previewThumbnails.scrubbingContainer
        });
        this.player.elements.wrapper.appendChild(this.elements.scrubbing.container);
      }
    }, {
      key: "showImageAtCurrentTime",
      value: function showImageAtCurrentTime() {
        var _this6 = this;

        if (this.mouseDown) {
          this.setScrubbingContainerSize();
        } else {
          this.setThumbContainerSizeAndPos();
        } // Find the desired thumbnail index
        // TODO: Handle a video longer than the thumbs where thumbNum is null


        var thumbNum = this.thumbnails[0].frames.findIndex(function (frame) {
          return _this6.seekTime >= frame.startTime && _this6.seekTime <= frame.endTime;
        });
        var hasThumb = thumbNum >= 0;
        var qualityIndex = 0; // Show the thumb container if we're not scrubbing

        if (!this.mouseDown) {
          this.toggleThumbContainer(hasThumb);
        } // No matching thumb found


        if (!hasThumb) {
          return;
        } // Check to see if we've already downloaded higher quality versions of this image


        this.thumbnails.forEach(function (thumbnail, index) {
          if (_this6.loadedImages.includes(thumbnail.frames[thumbNum].text)) {
            qualityIndex = index;
          }
        }); // Only proceed if either thumbnum or thumbfilename has changed

        if (thumbNum !== this.showingThumb) {
          this.showingThumb = thumbNum;
          this.loadImage(qualityIndex);
        }
      } // Show the image that's currently specified in this.showingThumb

    }, {
      key: "loadImage",
      value: function loadImage() {
        var _this7 = this;

        var qualityIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var thumbNum = this.showingThumb;
        var thumbnail = this.thumbnails[qualityIndex];
        var urlPrefix = thumbnail.urlPrefix;
        var frame = thumbnail.frames[thumbNum];
        var thumbFilename = thumbnail.frames[thumbNum].text;
        var thumbUrl = thumbFilename;

        if (!this.currentImageElement || this.currentImageElement.dataset.filename !== thumbFilename) {
          // If we're already loading a previous image, remove its onload handler - we don't want it to load after this one
          // Only do this if not using sprites. Without sprites we really want to show as many images as possible, as a best-effort
          if (this.loadingImage && this.usingSprites) {
            this.loadingImage.onload = null;
          } // We're building and adding a new image. In other implementations of similar functionality (YouTube), background image
          // is instead used. But this causes issues with larger images in Firefox and Safari - switching between background
          // images causes a flicker. Putting a new image over the top does not


          var previewImage = new Image();
          previewImage.src = thumbUrl;
          previewImage.dataset.index = thumbNum;
          previewImage.dataset.filename = thumbFilename;
          this.showingThumbFilename = thumbFilename;
          this.player.debug.log("Loading image: ".concat(thumbUrl)); // For some reason, passing the named function directly causes it to execute immediately. So I've wrapped it in an anonymous function...

          previewImage.onload = function () {
            return _this7.showImage(previewImage, frame, qualityIndex, thumbNum, thumbFilename, true);
          };

          this.loadingImage = previewImage;
          this.removeOldImages(previewImage);
        } else {
          // Update the existing image
          this.showImage(this.currentImageElement, frame, qualityIndex, thumbNum, thumbFilename, false);
          this.currentImageElement.dataset.index = thumbNum;
          this.removeOldImages(this.currentImageElement);
        }
      }
    }, {
      key: "showImage",
      value: function showImage(previewImage, frame, qualityIndex, thumbNum, thumbFilename) {
        var newImage = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
        this.player.debug.log("Showing thumb: ".concat(thumbFilename, ". num: ").concat(thumbNum, ". qual: ").concat(qualityIndex, ". newimg: ").concat(newImage));
        this.setImageSizeAndOffset(previewImage, frame);

        if (newImage) {
          this.currentImageContainer.appendChild(previewImage);
          this.currentImageElement = previewImage;

          if (!this.loadedImages.includes(thumbFilename)) {
            this.loadedImages.push(thumbFilename);
          }
        } // Preload images before and after the current one
        // Show higher quality of the same frame
        // Each step here has a short time delay, and only continues if still hovering/seeking the same spot. This is to protect slow connections from overloading


        this.preloadNearby(thumbNum, true).then(this.preloadNearby(thumbNum, false)).then(this.getHigherQuality(qualityIndex, previewImage, frame, thumbFilename));
      } // Remove all preview images that aren't the designated current image

    }, {
      key: "removeOldImages",
      value: function removeOldImages(currentImage) {
        var _this8 = this;

        // Get a list of all images, convert it from a DOM list to an array
        Array.from(this.currentImageContainer.children).forEach(function (image) {
          if (image.tagName.toLowerCase() !== 'img') {
            return;
          }

          var removeDelay = _this8.usingSprites ? 500 : 1000;

          if (image.dataset.index !== currentImage.dataset.index && !image.dataset.deleting) {
            // Wait 200ms, as the new image can take some time to show on certain browsers (even though it was downloaded before showing). This will prevent flicker, and show some generosity towards slower clients
            // First set attribute 'deleting' to prevent multi-handling of this on repeat firing of this function
            image.dataset.deleting = true; // This has to be set before the timeout - to prevent issues switching between hover and scrub

            var currentImageContainer = _this8.currentImageContainer;
            setTimeout(function () {
              currentImageContainer.removeChild(image);

              _this8.player.debug.log("Removing thumb: ".concat(image.dataset.filename));
            }, removeDelay);
          }
        });
      } // Preload images before and after the current one. Only if the user is still hovering/seeking the same frame
      // This will only preload the lowest quality

    }, {
      key: "preloadNearby",
      value: function preloadNearby(thumbNum) {
        var _this9 = this;

        var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        return new Promise(function (resolve) {
          setTimeout(function () {
            var oldThumbFilename = _this9.thumbnails[0].frames[thumbNum].text;

            if (_this9.showingThumbFilename === oldThumbFilename) {
              // Find the nearest thumbs with different filenames. Sometimes it'll be the next index, but in the case of sprites, it might be 100+ away
              var thumbnailsClone;

              if (forward) {
                thumbnailsClone = _this9.thumbnails[0].frames.slice(thumbNum);
              } else {
                thumbnailsClone = _this9.thumbnails[0].frames.slice(0, thumbNum).reverse();
              }

              var foundOne = false;
              thumbnailsClone.forEach(function (frame) {
                var newThumbFilename = frame.text;

                if (newThumbFilename !== oldThumbFilename) {
                  // Found one with a different filename. Make sure it hasn't already been loaded on this page visit
                  if (!_this9.loadedImages.includes(newThumbFilename)) {
                    foundOne = true;

                    _this9.player.debug.log("Preloading thumb filename: ".concat(newThumbFilename));

                    var urlPrefix = _this9.thumbnails[0].urlPrefix;
                    var thumbURL = urlPrefix + newThumbFilename;
                    var previewImage = new Image();
                    previewImage.src = thumbURL;

                    previewImage.onload = function () {
                      _this9.player.debug.log("Preloaded thumb filename: ".concat(newThumbFilename));

                      if (!_this9.loadedImages.includes(newThumbFilename)) _this9.loadedImages.push(newThumbFilename); // We don't resolve until the thumb is loaded

                      resolve();
                    };
                  }
                }
              }); // If there are none to preload then we want to resolve immediately

              if (!foundOne) {
                resolve();
              }
            }
          }, 300);
        });
      } // If user has been hovering current image for half a second, look for a higher quality one

    }, {
      key: "getHigherQuality",
      value: function getHigherQuality(currentQualityIndex, previewImage, frame, thumbFilename) {
        var _this10 = this;

        if (currentQualityIndex < this.thumbnails.length - 1) {
          // Only use the higher quality version if it's going to look any better - if the current thumb is of a lower pixel density than the thumbnail container
          var previewImageHeight = previewImage.naturalHeight;

          if (this.usingSprites) {
            previewImageHeight = frame.h;
          }

          if (previewImageHeight < this.thumbContainerHeight) {
            // Recurse back to the loadImage function - show a higher quality one, but only if the viewer is on this frame for a while
            setTimeout(function () {
              // Make sure the mouse hasn't already moved on and started hovering at another image
              if (_this10.showingThumbFilename === thumbFilename) {
                _this10.player.debug.log("Showing higher quality thumb for: ".concat(thumbFilename));

                _this10.loadImage(currentQualityIndex + 1);
              }
            }, 300);
          }
        }
      }
    }, {
      key: "toggleThumbContainer",
      value: function toggleThumbContainer() {
        var toggle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var clearShowing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var className = this.player.config.classNames.previewThumbnails.thumbContainerShown;
        this.elements.thumb.container.classList.toggle(className, toggle);

        if (!toggle && clearShowing) {
          this.showingThumb = null;
          this.showingThumbFilename = null;
        }
      }
    }, {
      key: "toggleScrubbingContainer",
      value: function toggleScrubbingContainer() {
        var toggle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var className = this.player.config.classNames.previewThumbnails.scrubbingContainerShown;
        this.elements.scrubbing.container.classList.toggle(className, toggle);

        if (!toggle) {
          this.showingThumb = null;
          this.showingThumbFilename = null;
        }
      }
    }, {
      key: "determineContainerAutoSizing",
      value: function determineContainerAutoSizing() {
        if (this.elements.thumb.imageContainer.clientHeight > 20) {
          // This will prevent auto sizing in this.setThumbContainerSizeAndPos()
          this.sizeSpecifiedInCSS = true;
        }
      } // Set the size to be about a quarter of the size of video. Unless option dynamicSize === false, in which case it needs to be set in CSS

    }, {
      key: "setThumbContainerSizeAndPos",
      value: function setThumbContainerSizeAndPos() {
        if (!this.sizeSpecifiedInCSS) {
          var thumbWidth = Math.floor(this.thumbContainerHeight * this.thumbAspectRatio);
          this.elements.thumb.imageContainer.style.height = "".concat(this.thumbContainerHeight, "px");
          this.elements.thumb.imageContainer.style.width = "".concat(thumbWidth, "px");
        }

        this.setThumbContainerPos();
      }
    }, {
      key: "setThumbContainerPos",
      value: function setThumbContainerPos() {
        var seekbarRect = this.player.elements.progress.getBoundingClientRect();
        var plyrRect = this.player.elements.container.getBoundingClientRect();
        var container = this.elements.thumb.container; // Find the lowest and highest desired left-position, so we don't slide out the side of the video container

        var minVal = plyrRect.left - seekbarRect.left + 10;
        var maxVal = plyrRect.right - seekbarRect.left - container.clientWidth - 10; // Set preview container position to: mousepos, minus seekbar.left, minus half of previewContainer.clientWidth

        var previewPos = this.mousePosX - seekbarRect.left - container.clientWidth / 2;

        if (previewPos < minVal) {
          previewPos = minVal;
        }

        if (previewPos > maxVal) {
          previewPos = maxVal;
        }

        container.style.left = "".concat(previewPos, "px");
      } // Can't use 100% width, in case the video is a different aspect ratio to the video container

    }, {
      key: "setScrubbingContainerSize",
      value: function setScrubbingContainerSize() {
        this.elements.scrubbing.container.style.width = "".concat(this.player.media.clientWidth, "px"); // Can't use media.clientHeight - html5 video goes big and does black bars above and below

        this.elements.scrubbing.container.style.height = "".concat(this.player.media.clientWidth / this.thumbAspectRatio, "px");
      } // Sprites need to be offset to the correct location

    }, {
      key: "setImageSizeAndOffset",
      value: function setImageSizeAndOffset(previewImage, frame) {
        if (!this.usingSprites) {
          return;
        } // Find difference between height and preview container height


        var multiplier = this.thumbContainerHeight / frame.h;
        previewImage.style.height = "".concat(Math.floor(previewImage.naturalHeight * multiplier), "px");
        previewImage.style.width = "".concat(Math.floor(previewImage.naturalWidth * multiplier), "px");
        previewImage.style.left = "-".concat(frame.x * multiplier, "px");
        previewImage.style.top = "-".concat(frame.y * multiplier, "px");
      }
    }, {
      key: "enabled",
      get: function get() {
        return this.player.isHTML5 && this.player.isVideo && this.player.config.previewThumbnails.enabled;
      }
    }, {
      key: "currentImageContainer",
      get: function get() {
        if (this.mouseDown) {
          return this.elements.scrubbing.container;
        }

        return this.elements.thumb.imageContainer;
      }
    }, {
      key: "usingSprites",
      get: function get() {
        return Object.keys(this.thumbnails[0].frames[0]).includes('w');
      }
    }, {
      key: "thumbAspectRatio",
      get: function get() {
        if (this.usingSprites) {
          return this.thumbnails[0].frames[0].w / this.thumbnails[0].frames[0].h;
        }

        return this.thumbnails[0].width / this.thumbnails[0].height;
      }
    }, {
      key: "thumbContainerHeight",
      get: function get() {
        if (this.mouseDown) {
          // Can't use media.clientHeight - HTML5 video goes big and does black bars above and below
          return Math.floor(this.player.media.clientWidth / this.thumbAspectRatio);
        }

        if (is$1.number(this.player.config.previewHeight)) {
          return this.player.config.previewHeight;
        }

        return Math.floor(this.player.media.clientWidth / this.thumbAspectRatio / 4);
      }
    }, {
      key: "currentImageElement",
      get: function get() {
        if (this.mouseDown) {
          return this.currentScrubbingImageElement;
        }

        return this.currentThumbnailImageElement;
      },
      set: function set(element) {
        if (this.mouseDown) {
          this.currentScrubbingImageElement = element;
        } else {
          this.currentThumbnailImageElement = element;
        }
      }
    }]);

    return PreviewThumbnails;
  }();

  var source = {
    // Add elements to HTML5 media (source, tracks, etc)
    insertElements: function insertElements(type, attributes) {
      var _this = this;

      if (is$1.string(attributes)) {
        insertElement(type, this.media, {
          src: attributes
        });
      } else if (is$1.array(attributes)) {
        attributes.forEach(function (attribute) {
          insertElement(type, _this.media, attribute);
        });
      }
    },
    // Update source
    // Sources are not checked for support so be careful
    change: function change(input) {
      var _this2 = this;

      if (!getDeep(input, 'sources.length')) {
        this.debug.warn('Invalid source format');
        return;
      } // Cancel current network requests


      html5.cancelRequests.call(this); // Destroy instance and re-setup

      this.destroy.call(this, function () {
        // Reset quality options
        _this2.options.quality = []; // Remove elements

        removeElement(_this2.media);
        _this2.media = null; // Reset class name

        if (is$1.element(_this2.elements.container)) {
          _this2.elements.container.removeAttribute('class');
        } // Set the type and provider


        var sources = input.sources,
            type = input.type;

        var _sources = _slicedToArray(sources, 1),
            _sources$ = _sources[0],
            _sources$$provider = _sources$.provider,
            provider = _sources$$provider === void 0 ? providers.html5 : _sources$$provider,
            src = _sources$.src;

        var tagName = provider === 'html5' ? type : 'div';
        var attributes = provider === 'html5' ? {} : {
          src: src
        };
        Object.assign(_this2, {
          provider: provider,
          type: type,
          // Check for support
          supported: support.check(type, provider, _this2.config.playsinline),
          // Create new element
          media: createElement(tagName, attributes)
        }); // Inject the new element

        _this2.elements.container.appendChild(_this2.media); // Autoplay the new source?


        if (is$1.boolean(input.autoplay)) {
          _this2.config.autoplay = input.autoplay;
        } // Set attributes for audio and video


        if (_this2.isHTML5) {
          if (_this2.config.crossorigin) {
            _this2.media.setAttribute('crossorigin', '');
          }

          if (_this2.config.autoplay) {
            _this2.media.setAttribute('autoplay', '');
          }

          if (!is$1.empty(input.poster)) {
            _this2.poster = input.poster;
          }

          if (_this2.config.loop.active) {
            _this2.media.setAttribute('loop', '');
          }

          if (_this2.config.muted) {
            _this2.media.setAttribute('muted', '');
          }

          if (_this2.config.playsinline) {
            _this2.media.setAttribute('playsinline', '');
          }
        } // Restore class hook


        ui.addStyleHook.call(_this2); // Set new sources for html5

        if (_this2.isHTML5) {
          source.insertElements.call(_this2, 'source', sources);
        } // Set video title


        _this2.config.title = input.title; // Set up from scratch

        media.setup.call(_this2); // HTML5 stuff

        if (_this2.isHTML5) {
          // Setup captions
          if (Object.keys(input).includes('tracks')) {
            source.insertElements.call(_this2, 'track', input.tracks);
          }
        } // If HTML5 or embed but not fully supported, setupInterface and call ready now


        if (_this2.isHTML5 || _this2.isEmbed && !_this2.supported.ui) {
          // Setup interface
          ui.build.call(_this2);
        } // Load HTML5 sources


        if (_this2.isHTML5) {
          _this2.media.load();
        } // Reload thumbnails


        if (_this2.previewThumbnails) {
          _this2.previewThumbnails.load();
        } // Update the fullscreen support


        _this2.fullscreen.update();
      }, true);
    }
  };

  // TODO: Use a WeakMap for private globals
  // const globals = new WeakMap();
  // Plyr instance

  var Plyr =
  /*#__PURE__*/
  function () {
    function Plyr(target, options) {
      var _this = this;

      _classCallCheck(this, Plyr);

      this.timers = {}; // State

      this.ready = false;
      this.loading = false;
      this.failed = false; // Touch device

      this.touch = support.touch; // Set the media element

      this.media = target; // String selector passed

      if (is$1.string(this.media)) {
        this.media = document.querySelectorAll(this.media);
      } // jQuery, NodeList or Array passed, use first element


      if (window.jQuery && this.media instanceof jQuery || is$1.nodeList(this.media) || is$1.array(this.media)) {
        // eslint-disable-next-line
        this.media = this.media[0];
      } // Set config


      this.config = extend({}, configs, Plyr.defaults, options || {}, function () {
        try {
          return JSON.parse(_this.media.getAttribute('data-plyr-config'));
        } catch (e) {
          return {};
        }
      }()); // Elements cache

      this.elements = {
        container: null,
        captions: null,
        buttons: {},
        display: {},
        progress: {},
        inputs: {},
        settings: {
          popup: null,
          menu: null,
          panels: {},
          buttons: {}
        }
      }; // Captions

      this.captions = {
        active: null,
        currentTrack: -1,
        meta: new WeakMap()
      }; // Fullscreen

      this.fullscreen = {
        active: false
      }; // Options

      this.options = {
        speed: [],
        quality: [],
        qualityAction: {}
      }; // Debugging
      // TODO: move to globals

      this.debug = new Console(this.config.debug); // Log config options and support

      this.debug.log('Config', this.config);
      this.debug.log('Support', support); // We need an element to setup

      if (is$1.nullOrUndefined(this.media) || !is$1.element(this.media)) {
        this.debug.error('Setup failed: no suitable element passed');
        return;
      } // Bail if the element is initialized


      if (this.media.plyr) {
        this.debug.warn('Target already setup');
        return;
      } // Bail if not enabled


      if (!this.config.enabled) {
        this.debug.error('Setup failed: disabled by config');
        return;
      } // Bail if disabled or no basic support
      // You may want to disable certain UAs etc


      if (!support.check().api) {
        this.debug.error('Setup failed: no support');
        return;
      } // Cache original element state for .destroy()


      var clone = this.media.cloneNode(true);
      clone.autoplay = false;
      this.elements.original = clone; // Set media type based on tag or data attribute
      // Supported: video, audio, vimeo, youtube

      var type = this.media.tagName.toLowerCase(); // Embed properties

      var iframe = null;
      var url = null; // Different setup based on type

      switch (type) {
        case 'div':
          // Find the frame
          iframe = this.media.querySelector('iframe'); // <iframe> type

          if (is$1.element(iframe)) {
            // Detect provider
            url = parseUrl(iframe.getAttribute('src'));
            this.provider = getProviderByUrl(url.toString()); // Rework elements

            this.elements.container = this.media;
            this.media = iframe; // Reset classname

            this.elements.container.className = ''; // Get attributes from URL and set config

            if (url.search.length) {
              var truthy = ['1', 'true'];

              if (truthy.includes(url.searchParams.get('autoplay'))) {
                this.config.autoplay = true;
              }

              if (truthy.includes(url.searchParams.get('loop'))) {
                this.config.loop.active = true;
              } // TODO: replace fullscreen.iosNative with this playsinline config option
              // YouTube requires the playsinline in the URL


              if (this.isYouTube) {
                this.config.playsinline = truthy.includes(url.searchParams.get('playsinline'));
                this.config.youtube.hl = url.searchParams.get('hl'); // TODO: Should this be setting language?
              } else {
                this.config.playsinline = true;
              }
            }
          } else {
            // <div> with attributes
            this.provider = this.media.getAttribute(this.config.attributes.embed.provider); // Remove attribute

            this.media.removeAttribute(this.config.attributes.embed.provider);
          } // Unsupported or missing provider


          if (is$1.empty(this.provider) || !Object.keys(providers).includes(this.provider)) {
            this.debug.error('Setup failed: Invalid provider');
            return;
          } // Audio will come later for external providers


          this.type = types.video;
          break;

        case 'video':
        case 'audio':
          this.type = type;
          this.provider = providers.html5; // Get config from attributes

          if (this.media.hasAttribute('crossorigin')) {
            this.config.crossorigin = true;
          }

          if (this.media.hasAttribute('autoplay')) {
            this.config.autoplay = true;
          }

          if (this.media.hasAttribute('playsinline') || this.media.hasAttribute('webkit-playsinline')) {
            this.config.playsinline = true;
          }

          if (this.media.hasAttribute('muted')) {
            this.config.muted = true;
          }

          if (this.media.hasAttribute('loop')) {
            this.config.loop.active = true;
          }

          break;

        default:
          this.debug.error('Setup failed: unsupported type');
          return;
      } // Check for support again but with type


      this.supported = support.check(this.type, this.provider, this.config.playsinline); // If no support for even API, bail

      if (!this.supported.api) {
        this.debug.error('Setup failed: no support');
        return;
      }

      this.eventListeners = []; // Create listeners

      this.listeners = new Listeners(this); // Setup local storage for user settings

      this.storage = new Storage(this); // Store reference

      this.media.plyr = this; // Wrap media

      if (!is$1.element(this.elements.container)) {
        this.elements.container = createElement('div', {
          tabindex: 0
        });
        wrap(this.media, this.elements.container);
      } // Add style hook


      ui.addStyleHook.call(this); // Setup media

      media.setup.call(this); // Listen for events if debugging

      if (this.config.debug) {
        on.call(this, this.elements.container, this.config.events.join(' ').replace('timeupdate', ''), function (event) {
          _this.debug.log("event: ".concat(event.type));
        });
      } // Setup interface
      // If embed but not fully supported, build interface now to avoid flash of controls


      if (this.isHTML5 || this.isEmbed && !this.supported.ui) {
        ui.build.call(this);
      } // Container listeners


      this.listeners.container(); // Global listeners

      this.listeners.global(); // Setup fullscreen

      this.fullscreen = new Fullscreen(this); // Setup ads if provided

      if (this.config.ads.enabled) {
        this.ads = new Ads(this);
      } // Autoplay if required


      if (this.config.autoplay) {
        this.play();
      } // Seek time will be recorded (in listeners.js) so we can prevent hiding controls for a few seconds after seek


      this.lastSeekTime = 0; // Setup preview thumbnails if enabled

      if (this.config.previewThumbnails.enabled) {
        this.previewThumbnails = new PreviewThumbnails(this);
      }
    } // ---------------------------------------
    // API
    // ---------------------------------------

    /**
     * Types and provider helpers
     */


    _createClass(Plyr, [{
      key: "play",

      /**
       * Play the media, or play the advertisement (if they are not blocked)
       */
      value: function play() {
        var _this2 = this;

        if (!is$1.function(this.media.play)) {
          return null;
        } // Intecept play with ads


        if (this.ads && this.ads.enabled) {
          this.ads.managerPromise.then(function () {
            return _this2.ads.play();
          }).catch(function () {
            return _this2.media.play();
          });
        } // Return the promise (for HTML5)


        return this.media.play();
      }
      /**
       * Pause the media
       */

    }, {
      key: "pause",
      value: function pause() {
        if (!this.playing || !is$1.function(this.media.pause)) {
          return;
        }

        this.media.pause();
      }
      /**
       * Get playing state
       */

    }, {
      key: "togglePlay",

      /**
       * Toggle playback based on current status
       * @param {Boolean} input
       */
      value: function togglePlay(input) {
        // Toggle based on current state if nothing passed
        var toggle = is$1.boolean(input) ? input : !this.playing;

        if (toggle) {
          this.play();
        } else {
          this.pause();
        }
      }
      /**
       * Stop playback
       */

    }, {
      key: "stop",
      value: function stop() {
        if (this.isHTML5) {
          this.pause();
          this.restart();
        } else if (is$1.function(this.media.stop)) {
          this.media.stop();
        }
      }
      /**
       * Restart playback
       */

    }, {
      key: "restart",
      value: function restart() {
        this.currentTime = 0;
      }
      /**
       * Rewind
       * @param {Number} seekTime - how far to rewind in seconds. Defaults to the config.seekTime
       */

    }, {
      key: "rewind",
      value: function rewind(seekTime) {
        this.currentTime = this.currentTime - (is$1.number(seekTime) ? seekTime : this.config.seekTime);
      }
      /**
       * Fast forward
       * @param {Number} seekTime - how far to fast forward in seconds. Defaults to the config.seekTime
       */

    }, {
      key: "forward",
      value: function forward(seekTime) {
        this.currentTime = this.currentTime + (is$1.number(seekTime) ? seekTime : this.config.seekTime);
      }
      /**
       * Skip opening
       */

    }, {
      key: "skipOpening",
      value: function skipOpening() {
        this.forward(this.config.openingSeekTime);
      }
      /**
       * Seek to a time
       * @param {Number} input - where to seek to in seconds. Defaults to 0 (the start)
       */

    }, {
      key: "increaseVolume",

      /**
       * Increase volume
       * @param {Boolean} step - How much to decrease by (between 0 and 1)
       */
      value: function increaseVolume(step) {
        var volume = this.media.muted ? 0 : this.volume;
        this.volume = volume + (is$1.number(step) ? step : 0);
      }
      /**
       * Decrease volume
       * @param {Boolean} step - How much to decrease by (between 0 and 1)
       */

    }, {
      key: "decreaseVolume",
      value: function decreaseVolume(step) {
        this.increaseVolume(-step);
      }
      /**
       * Set muted state
       * @param {Boolean} mute
       */

    }, {
      key: "addQuality",

      /**
       * Add new quality with callback
       * @param {Number} label
       * @param {Function} callback
       */
      value: function addQuality(label, callback) {
        this.debug.log("Pushing new quality: ".concat(label));
        var quality = closest(this.config.quality.options, label);
        this.debug.log("Found closest value to quality: ".concat(label, " -> ").concat(quality));
        this.options.qualityAction = _objectSpread({}, this.options.qualityAction, _defineProperty({}, quality, callback));
        this.options.quality.push(quality);
      }
      /**
       * Re-renders quality menu
       */

    }, {
      key: "renderQualityMenu",
      value: function renderQualityMenu() {
        if (this.options.quality.length <= 0) {
          this.debug.warn('Only one quality is available, skip re-rendering');
        }

        this.debug.log('Rendering quality menu in settings');
        controls.setQualityMenu.call(this, this.options.quality); // auto quality

        if (this.options.quality.indexOf(0) >= 0) {
          this.quality = 0;
          return;
        } // if auto quality is not available


        var quality = this.config.quality.default;

        if (this.options.quality.indexOf(quality) >= 0) {
          this.quality = quality;
        } else {
          // get highest quality
          // eslint-disable-next-line prefer-destructuring
          this.quality = this.options.quality[0];
        }
      }
      /**
       * Set playback quality
       * Currently HTML5 & YouTube only
       * @param {Number} input - Quality level
       */

    }, {
      key: "toggleCaptions",

      /**
       * Toggle captions
       * @param {Boolean} input - Whether to enable captions
       */
      value: function toggleCaptions(input) {
        captions.toggle.call(this, input, false);
      }
      /**
       * Set the caption track by index
       * @param {Number} - Caption index
       */

    }, {
      key: "airplay",

      /**
       * Trigger the airplay dialog
       * TODO: update player with state, support, enabled
       */
      value: function airplay() {
        // Show dialog if supported
        if (support.airplay) {
          this.media.webkitShowPlaybackTargetPicker();
        }
      }
      /**
       * Toggle the player controls
       * @param {Boolean} [toggle] - Whether to show the controls
       */

    }, {
      key: "toggleControls",
      value: function toggleControls(toggle) {
        // Don't toggle if missing UI support or if it's audio
        if (this.supported.ui && !this.isAudio) {
          // Get state before change
          var isHidden = hasClass(this.elements.container, this.config.classNames.hideControls); // Negate the argument if not undefined since adding the class to hides the controls

          var force = typeof toggle === 'undefined' ? undefined : !toggle; // Apply and get updated state

          var hiding = toggleClass(this.elements.container, this.config.classNames.hideControls, force); // Close menu

          if (hiding && this.config.controls.includes('settings') && !is$1.empty(this.config.settings)) {
            controls.toggleMenu.call(this, false);
          } // Trigger event on change


          if (hiding !== isHidden) {
            var eventName = hiding ? 'controlshidden' : 'controlsshown';
            triggerEvent.call(this, this.media, eventName);
          }

          return !hiding;
        }

        return false;
      }
      /**
       * Add event listeners
       * @param {String} event - Event type
       * @param {Function} callback - Callback for when event occurs
       */

    }, {
      key: "on",
      value: function on$$1(event, callback) {
        on.call(this, this.elements.container, event, callback);
      }
      /**
       * Add event listeners once
       * @param {String} event - Event type
       * @param {Function} callback - Callback for when event occurs
       */

    }, {
      key: "once",
      value: function once$$1(event, callback) {
        once.call(this, this.elements.container, event, callback);
      }
      /**
       * Remove event listeners
       * @param {String} event - Event type
       * @param {Function} callback - Callback for when event occurs
       */

    }, {
      key: "off",
      value: function off$$1(event, callback) {
        off(this.elements.container, event, callback);
      }
      /**
       * Destroy an instance
       * Event listeners are removed when elements are removed
       * http://stackoverflow.com/questions/12528049/if-a-dom-element-is-removed-are-its-listeners-also-removed-from-memory
       * @param {Function} callback - Callback for when destroy is complete
       * @param {Boolean} soft - Whether it's a soft destroy (for source changes etc)
       */

    }, {
      key: "destroy",
      value: function destroy(callback) {
        var _this3 = this;

        var soft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (!this.ready) {
          return;
        }

        var done = function done() {
          // Reset overflow (incase destroyed while in fullscreen)
          document.body.style.overflow = ''; // GC for embed

          _this3.embed = null; // If it's a soft destroy, make minimal changes

          if (soft) {
            if (Object.keys(_this3.elements).length) {
              // Remove elements
              removeElement(_this3.elements.buttons.play);
              removeElement(_this3.elements.captions);
              removeElement(_this3.elements.controls);
              removeElement(_this3.elements.wrapper); // Clear for GC

              _this3.elements.buttons.play = null;
              _this3.elements.captions = null;
              _this3.elements.controls = null;
              _this3.elements.wrapper = null;
            } // Callback


            if (is$1.function(callback)) {
              callback();
            }
          } else {
            // Unbind listeners
            unbindListeners.call(_this3); // Replace the container with the original element provided

            replaceElement(_this3.elements.original, _this3.elements.container); // Event

            triggerEvent.call(_this3, _this3.elements.original, 'destroyed', true); // Callback

            if (is$1.function(callback)) {
              callback.call(_this3.elements.original);
            } // Reset state


            _this3.ready = false; // Clear for garbage collection

            setTimeout(function () {
              _this3.elements = null;
              _this3.media = null;
            }, 200);
          }
        }; // Stop playback


        this.stop(); // Provider specific stuff

        if (this.isHTML5) {
          // Clear timeout
          clearTimeout(this.timers.loading); // Restore native video controls

          ui.toggleNativeControls.call(this, true); // Clean up

          done();
        } else if (this.isYouTube) {
          // Clear timers
          clearInterval(this.timers.buffering);
          clearInterval(this.timers.playing); // Destroy YouTube API

          if (this.embed !== null && is$1.function(this.embed.destroy)) {
            this.embed.destroy();
          } // Clean up


          done();
        } else if (this.isVimeo) {
          // Destroy Vimeo API
          // then clean up (wait, to prevent postmessage errors)
          if (this.embed !== null) {
            this.embed.unload().then(done);
          } // Vimeo does not always return


          setTimeout(done, 200);
        }
      }
      /**
       * Check for support for a mime type (HTML5 only)
       * @param {String} type - Mime type
       */

    }, {
      key: "supports",
      value: function supports(type) {
        return support.mime.call(this, type);
      }
      /**
       * Check for support
       * @param {String} type - Player type (audio/video)
       * @param {String} provider - Provider (html5/youtube/vimeo)
       * @param {Boolean} inline - Where player has `playsinline` sttribute
       */

    }, {
      key: "isHTML5",
      get: function get() {
        return Boolean(this.provider === providers.html5);
      }
    }, {
      key: "isEmbed",
      get: function get() {
        return Boolean(this.isYouTube || this.isVimeo);
      }
    }, {
      key: "isYouTube",
      get: function get() {
        return Boolean(this.provider === providers.youtube);
      }
    }, {
      key: "isVimeo",
      get: function get() {
        return Boolean(this.provider === providers.vimeo);
      }
    }, {
      key: "isVideo",
      get: function get() {
        return Boolean(this.type === types.video);
      }
    }, {
      key: "isAudio",
      get: function get() {
        return Boolean(this.type === types.audio);
      }
    }, {
      key: "playing",
      get: function get() {
        return Boolean(this.ready && !this.paused && !this.ended);
      }
      /**
       * Get paused state
       */

    }, {
      key: "paused",
      get: function get() {
        return Boolean(this.media.paused);
      }
      /**
       * Get stopped state
       */

    }, {
      key: "stopped",
      get: function get() {
        return Boolean(this.paused && this.currentTime === 0);
      }
      /**
       * Get ended state
       */

    }, {
      key: "ended",
      get: function get() {
        return Boolean(this.media.ended);
      }
    }, {
      key: "currentTime",
      set: function set(input) {
        // Bail if media duration isn't available yet
        if (!this.duration) {
          return;
        } // Validate input


        var inputIsValid = is$1.number(input) && input > 0; // Set

        this.media.currentTime = inputIsValid ? Math.min(input, this.duration) : 0; // Logging

        this.debug.log("Seeking to ".concat(this.currentTime, " seconds"));
      }
      /**
       * Get current time
       */
      ,
      get: function get() {
        return Number(this.media.currentTime);
      }
      /**
       * Get buffered
       */

    }, {
      key: "buffered",
      get: function get() {
        var buffered = this.media.buffered; // YouTube / Vimeo return a float between 0-1

        if (is$1.number(buffered)) {
          return buffered;
        } // HTML5
        // TODO: Handle buffered chunks of the media
        // (i.e. seek to another section buffers only that section)


        if (Object.prototype.hasOwnProperty.call(this.config.buffer, 'exec') && is$1.function(this.config.buffer.exec)) {
          return this.config.buffer.exec.call(this, buffered, this.duration);
        }

        if (buffered && buffered.length && this.duration > 0) {
          return buffered.end(buffered.length - this.config.buffer.type) / this.duration;
        }

        return 0;
      }
      /**
       * Get seeking status
       */

    }, {
      key: "seeking",
      get: function get() {
        return Boolean(this.media.seeking);
      }
      /**
       * Get the duration of the current media
       */

    }, {
      key: "duration",
      get: function get() {
        // Faux duration set via config
        var fauxDuration = parseFloat(this.config.duration); // Media duration can be NaN or Infinity before the media has loaded

        var realDuration = (this.media || {}).duration;
        var duration = !is$1.number(realDuration) || realDuration === Infinity ? 0 : realDuration; // If config duration is funky, use regular duration

        return fauxDuration || duration;
      }
      /**
       * Set the player volume
       * @param {Number} value - must be between 0 and 1. Defaults to the value from local storage and config.volume if not set in storage
       */

    }, {
      key: "volume",
      set: function set(value) {
        var volume = value;
        var max = 1;
        var min = 0;

        if (is$1.string(volume)) {
          volume = Number(volume);
        } // Load volume from storage if no value specified


        if (!is$1.number(volume)) {
          volume = this.storage.get('volume');
        } // Use config if all else fails


        if (!is$1.number(volume)) {
          volume = this.config.volume;
        } // Maximum is volumeMax


        if (volume > max) {
          volume = max;
        } // Minimum is volumeMin


        if (volume < min) {
          volume = min;
        } // Update config


        this.config.volume = volume; // Set the player volume

        this.media.volume = volume; // If muted, and we're increasing volume manually, reset muted state

        if (!is$1.empty(value) && this.muted && volume > 0) {
          this.muted = false;
        }
      }
      /**
       * Get the current player volume
       */
      ,
      get: function get() {
        return Number(this.media.volume);
      }
    }, {
      key: "muted",
      set: function set(mute) {
        var toggle = mute; // Load muted state from storage

        if (!is$1.boolean(toggle)) {
          toggle = this.storage.get('muted');
        } // Use config if all else fails


        if (!is$1.boolean(toggle)) {
          toggle = this.config.muted;
        } // Update config


        this.config.muted = toggle; // Set mute on the player

        this.media.muted = toggle;
      }
      /**
       * Get current muted state
       */
      ,
      get: function get() {
        return Boolean(this.media.muted);
      }
      /**
       * Check if the media has audio
       */

    }, {
      key: "hasAudio",
      get: function get() {
        // Assume yes for all non HTML5 (as we can't tell...)
        if (!this.isHTML5) {
          return true;
        }

        if (this.isAudio) {
          return true;
        } // Get audio tracks


        return Boolean(this.media.mozHasAudio) || Boolean(this.media.webkitAudioDecodedByteCount) || Boolean(this.media.audioTracks && this.media.audioTracks.length);
      }
      /**
       * Set playback speed
       * @param {Number} speed - the speed of playback (0.5-2.0)
       */

    }, {
      key: "speed",
      set: function set(input) {
        var speed = null;

        if (is$1.number(input)) {
          speed = input;
        }

        if (!is$1.number(speed)) {
          speed = this.storage.get('speed');
        }

        if (!is$1.number(speed)) {
          speed = this.config.speed.selected;
        } // Set min/max


        if (speed < 0.1) {
          speed = 0.1;
        }

        if (speed > 2.0) {
          speed = 2.0;
        }

        if (!this.config.speed.options.includes(speed)) {
          this.debug.warn("Unsupported speed (".concat(speed, ")"));
          return;
        } // Update config


        this.config.speed.selected = speed; // Set media speed

        this.media.playbackRate = speed;
      }
      /**
       * Get current playback speed
       */
      ,
      get: function get() {
        return Number(this.media.playbackRate);
      }
    }, {
      key: "quality",
      set: function set(input) {
        var config = this.config.quality;
        var options = this.options.quality;

        if (!options.length) {
          return;
        }

        var quality = [!is$1.empty(input) && Number(input), this.storage.get('quality'), config.selected, config.default].find(is$1.number);
        var updateStorage = true;

        if (!options.includes(quality)) {
          var value = closest(options, quality);
          this.debug.warn("Unsupported quality option: ".concat(quality, ", using ").concat(value, " instead"));
          quality = value; // Don't update storage if quality is not supported

          updateStorage = false;
        } // Update config


        config.selected = quality; // Set quality

        if (Object.prototype.hasOwnProperty.call(this.options.qualityAction, quality) && is$1.function(this.options.qualityAction[quality])) {
          // Fire callback function
          this.options.qualityAction[quality](); // Trigger change event

          triggerEvent.call(this, this.media, 'qualitychange', false, {
            quality: input
          });
        } else {
          this.media.quality = quality;
        } // Save to storage


        if (updateStorage) {
          this.storage.set({
            quality: quality
          });
        }
      }
      /**
       * Get current quality level
       */
      ,
      get: function get() {
        return this.media.quality;
      }
      /**
       * Toggle loop
       * TODO: Finish fancy new logic. Set the indicator on load as user may pass loop as config
       * @param {Boolean} input - Whether to loop or not
       */

    }, {
      key: "loop",
      set: function set(input) {
        var toggle = is$1.boolean(input) ? input : this.config.loop.active;
        this.config.loop.active = toggle;
        this.media.loop = toggle; // Set default to be a true toggle

        /* const type = ['start', 'end', 'all', 'none', 'toggle'].includes(input) ? input : 'toggle';
         switch (type) {
            case 'start':
                if (this.config.loop.end && this.config.loop.end <= this.currentTime) {
                    this.config.loop.end = null;
                }
                this.config.loop.start = this.currentTime;
                // this.config.loop.indicator.start = this.elements.display.played.value;
                break;
             case 'end':
                if (this.config.loop.start >= this.currentTime) {
                    return this;
                }
                this.config.loop.end = this.currentTime;
                // this.config.loop.indicator.end = this.elements.display.played.value;
                break;
             case 'all':
                this.config.loop.start = 0;
                this.config.loop.end = this.duration - 2;
                this.config.loop.indicator.start = 0;
                this.config.loop.indicator.end = 100;
                break;
             case 'toggle':
                if (this.config.loop.active) {
                    this.config.loop.start = 0;
                    this.config.loop.end = null;
                } else {
                    this.config.loop.start = 0;
                    this.config.loop.end = this.duration - 2;
                }
                break;
             default:
                this.config.loop.start = 0;
                this.config.loop.end = null;
                break;
        } */
      }
      /**
       * Get current loop state
       */
      ,
      get: function get() {
        return Boolean(this.media.loop);
      }
      /**
       * Set new media source
       * @param {Object} input - The new source object (see docs)
       */

    }, {
      key: "source",
      set: function set(input) {
        source.change.call(this, input);
      }
      /**
       * Get current source
       */
      ,
      get: function get() {
        return this.media.currentSrc;
      }
      /**
       * Get a download URL (either source or custom)
       */

    }, {
      key: "download",
      get: function get() {
        var download = this.config.urls.download;
        return is$1.url(download) ? download : this.source;
      }
      /**
       * Set the poster image for a video
       * @param {String} input - the URL for the new poster image
       */

    }, {
      key: "poster",
      set: function set(input) {
        if (!this.isVideo) {
          this.debug.warn('Poster can only be set for video');
          return;
        }

        ui.setPoster.call(this, input, false).catch(function () {});
      }
      /**
       * Get the current poster image
       */
      ,
      get: function get() {
        if (!this.isVideo) {
          return null;
        }

        return this.media.getAttribute('poster');
      }
      /**
       * Set the autoplay state
       * @param {Boolean} input - Whether to autoplay or not
       */

    }, {
      key: "autoplay",
      set: function set(input) {
        var toggle = is$1.boolean(input) ? input : this.config.autoplay;
        this.config.autoplay = toggle;
      }
      /**
       * Get the current autoplay state
       */
      ,
      get: function get() {
        return Boolean(this.config.autoplay);
      }
    }, {
      key: "currentTrack",
      set: function set(input) {
        captions.set.call(this, input, false);
      }
      /**
       * Get the current caption track index (-1 if disabled)
       */
      ,
      get: function get() {
        var _this$captions = this.captions,
            toggled = _this$captions.toggled,
            currentTrack = _this$captions.currentTrack;
        return toggled ? currentTrack : -1;
      }
      /**
       * Set the wanted language for captions
       * Since tracks can be added later it won't update the actual caption track until there is a matching track
       * @param {String} - Two character ISO language code (e.g. EN, FR, PT, etc)
       */

    }, {
      key: "language",
      set: function set(input) {
        captions.setLanguage.call(this, input, false);
      }
      /**
       * Get the current track's language
       */
      ,
      get: function get() {
        return (captions.getCurrentTrack.call(this) || {}).language;
      }
      /**
       * Toggle picture-in-picture playback on WebKit/MacOS
       * TODO: update player with state, support, enabled
       * TODO: detect outside changes
       */

    }, {
      key: "pip",
      set: function set(input) {
        // Bail if no support
        if (!support.pip) {
          return;
        } // Toggle based on current state if not passed


        var toggle = is$1.boolean(input) ? input : !this.pip; // Toggle based on current state
        // Safari

        if (is$1.function(this.media.webkitSetPresentationMode)) {
          this.media.webkitSetPresentationMode(toggle ? pip.active : pip.inactive);
        } // Chrome


        if (is$1.function(this.media.requestPictureInPicture)) {
          if (!this.pip && toggle) {
            this.media.requestPictureInPicture();
          } else if (this.pip && !toggle) {
            document.exitPictureInPicture();
          }
        }
      }
      /**
       * Get the current picture-in-picture state
       */
      ,
      get: function get() {
        if (!support.pip) {
          return null;
        } // Safari


        if (!is$1.empty(this.media.webkitPresentationMode)) {
          return this.media.webkitPresentationMode === pip.active;
        } // Chrome


        return this.media === document.pictureInPictureElement;
      }
    }], [{
      key: "supported",
      value: function supported(type, provider, inline) {
        return support.check(type, provider, inline);
      }
      /**
       * Load an SVG sprite into the page
       * @param {String} url - URL for the SVG sprite
       * @param {String} [id] - Unique ID
       */

    }, {
      key: "loadSprite",
      value: function loadSprite$$1(url, id) {
        return loadSprite(url, id);
      }
      /**
       * Setup multiple instances
       * @param {*} selector
       * @param {Object} options
       */

    }, {
      key: "setup",
      value: function setup(selector) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var targets = null;

        if (is$1.string(selector)) {
          targets = Array.from(document.querySelectorAll(selector));
        } else if (is$1.nodeList(selector)) {
          targets = Array.from(selector);
        } else if (is$1.array(selector)) {
          targets = selector.filter(is$1.element);
        }

        if (is$1.empty(targets)) {
          return null;
        }

        return targets.map(function (t) {
          return new Plyr(t, options);
        });
      }
    }]);

    return Plyr;
  }();

  Plyr.defaults = cloneDeep(configs);

  return Plyr;

})));
